/*!
 * Celemony Javascript Tools v1.7.4
 * Copyright 2017 mackoy consulting. All rights reserved.
 * @Author Benjamin Menzel <bmenzel@mackoy.de>
 */
var CMY =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	   'use strict';
	
	
	
	// NOTE:
	// 1. Currently the fonts are commented out; There MAY be cases where you want the font-styles to be embedded
	// in that case we should configure webpack to produce two outputs (one package with fonts, one without)
	// require('./styles/fonts.less');
	//
	// 2. Styles are commented out currently, as they are only needed for the demo page (currently)
	// require('./styles/main.less');
	
	
	   // INITIALIZERS
	   var videos = __webpack_require__(28);
	   var audio = __webpack_require__(26);
	   var images = __webpack_require__(33);
	
	   module.exports = {
	     AssetCoreClient: __webpack_require__(5),
	     Overlay: __webpack_require__(10),
	     jq3: __webpack_require__(2),
	
	     imagesLoaded: __webpack_require__(6),
	     imagesLoadedOrDimSet: __webpack_require__(32),
	     settings: __webpack_require__(4),
	
	     imageFromData: images.imageFromData,
	     bgImageFromData: images.bgImageFromData,
	     audioFromData: audio.fromData,
	     videoFromData: videos.videoFromData,
	     videoWithOverlay: videos.videoWithOverlay,
	     smartmovieFromUrl: videos.smartmovieFromUrl
	   };
	
	}());


/***/ },
/* 1 */
/***/ function(module, exports) {

	(function () {
	  'use strict';
	
	  module.exports = {
	    undefOrNull: function undefOrNull(obj){
	      return (typeof obj=="undefined" || obj===null);
	    },
	    getDppx: function getDppx(){ // will return either 1 or 2
	      var dppx = window.devicePixelRatio || 1;
	      // if dppx is greater than 2, we reset it to 2 as higher values are not supported by AssetCore
	      dppx = dppx>2 ? 2 : dppx;
	      // if dppx is greater than 1, but less than 2 (float-value) we reset it to 1 as float-values are also not supported by AssetCore
	      dppx = dppx>1 && dppx<2 ? 1 : dppx;
	      return dppx;
	    }
	  };
	
	  // shims
	  // String endsWith
	  if (typeof String.prototype.endsWith !== 'function') {
	      String.prototype.endsWith = function(suffix) {
	          return this.indexOf(suffix, this.length - suffix.length) !== -1;
	      };
	  }
	
	  //String includes
	  if (!String.prototype.includes) {
	    String.prototype.includes = function(search, start) {
	      if (typeof start !== 'number') {
	        start = 0;
	      }
	
	      if (start + search.length > this.length) {
	        return false;
	      } else {
	        return this.indexOf(search, start) !== -1;
	      }
	    };
	  }
	
	  // String startsWith
	  if (!String.prototype.startsWith) {
	    String.prototype.startsWith = function(searchString, position) {
	      position = position || 0;
	      return this.indexOf(searchString, position) === position;
	    };
	  }
	
	  // String capitalizeFirstLetter
	  if (!String.prototype.capitalizeFirstLetter) {
	    String.prototype.capitalizeFirstLetter = function() {
	      return this.charAt(0).toUpperCase() + this.slice(1);
	    };
	  }
	
	
	  //Array includes
	  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
	  if (!Array.prototype.includes) {
	    Object.defineProperty(Array.prototype, 'includes', {
	      value: function(searchElement, fromIndex) {
	
	        // 1. Let O be ? ToObject(this value).
	        if (this === null) {
	          throw new TypeError('"this" is null or not defined');
	        }
	
	        var o = Object(this);
	
	        // 2. Let len be ? ToLength(? Get(O, "length")).
	        var len = o.length >>> 0;
	
	        // 3. If len is 0, return false.
	        if (len === 0) {
	          return false;
	        }
	
	        // 4. Let n be ? ToInteger(fromIndex).
	        //    (If fromIndex is undefined, this step produces the value 0.)
	        var n = fromIndex | 0;
	
	        // 5. If n ≥ 0, then
	        //  a. Let k be n.
	        // 6. Else n < 0,
	        //  a. Let k be len + n.
	        //  b. If k < 0, let k be 0.
	        var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
	
	        // 7. Repeat, while k < len
	        while (k < len) {
	          // a. Let elementK be the result of ? Get(O, ! ToString(k)).
	          // b. If SameValueZero(searchElement, elementK) is true, return true.
	          // c. Increase k by 1.
	          // NOTE: === provides the correct "SameValueZero" comparison needed here.
	          if (o[k] === searchElement) {
	            return true;
	          }
	          k++;
	        }
	
	        // 8. Return false
	        return false;
	      }
	    });
	  }
	
	}());


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.1.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2016-09-22T22:30Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	
	
		function DOMEval( code, doc ) {
			doc = doc || document;
	
			var script = doc.createElement( "script" );
	
			script.text = code;
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.1.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// As of jQuery 3.0, isNumeric is limited to
			// strings and numbers (primitives or objects)
			// that can be coerced to finite numbers (gh-2662)
			var type = jQuery.type( obj );
			return ( type === "number" || type === "string" ) &&
	
				// parseFloat NaNs numeric-cast false positives ("")
				// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
				// subtraction forces infinities to NaN
				!isNaN( obj - parseFloat( obj ) );
		},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android <=2.3 only (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE <=9 - 11, Edge 12 - 13
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Simple selector that can be filtered directly, removing non-Elements
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}
	
		// Complex selector, compare the two sets, removing non-Elements
		qualifier = jQuery.filter( qualifier, elements );
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Support: Android 4.0 only
				// Strict mode functions invoked without .call/.apply get global-object context
				resolve.call( undefined, value );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.call( undefined, value );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( jQuery.isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ jQuery.camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ jQuery.camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( jQuery.camelCase );
				} else {
					key = jQuery.camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && jQuery.nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: jQuery.isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	function manipulationTarget( elem, content ) {
		if ( jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return elem.getElementsByTagName( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			div.style.cssText =
				"box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		jQuery.extend( support, {
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
				computeStyleTests();
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// Support: IE <=9 only
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i,
			val = 0;
	
		// If we already have the right measurement, avoid augmentation
		if ( extra === ( isBorderBox ? "border" : "content" ) ) {
			i = 4;
	
		// Otherwise initialize for horizontal or vertical properties
		} else {
			i = name === "width" ? 1 : 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var val,
			valueIsBorderBox = true,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Support: IE <=11 only
		// Running getBoundingClientRect on a disconnected node
		// in IE throws an error.
		if ( elem.getClientRects().length ) {
			val = elem.getBoundingClientRect()[ name ];
		}
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function raf() {
		if ( timerId ) {
			window.requestAnimationFrame( raf );
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 13
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off or if document is hidden
		if ( jQuery.fx.off || document.hidden ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.requestAnimationFrame ?
				window.requestAnimationFrame( raf ) :
				window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		if ( window.cancelAnimationFrame ) {
			window.cancelAnimationFrame( timerId );
		} else {
			window.clearInterval( timerId );
		}
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnothtmlwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = jQuery.isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( jQuery.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 13
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( jQuery.isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win, rect, doc,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			rect = elem.getBoundingClientRect();
	
			// Make sure element is not hidden (display: none)
			if ( rect.width || rect.height ) {
				doc = elem.ownerDocument;
				win = getWindow( doc );
				docElem = doc.documentElement;
	
				return {
					top: rect.top + win.pageYOffset - docElem.clientTop,
					left: rect.left + win.pageXOffset - docElem.clientLeft
				};
			}
	
			// Return zeros for disconnected and hidden elements (gh-2310)
			return rect;
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset = {
					top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
					left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
				};
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	jQuery.parseJSON = JSON.parse;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	
	return jQuery;
	} );


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	  'use strict';
	
	  var helper = __webpack_require__(1);
	  var settings = __webpack_require__(4);
	
	  module.exports = Logger;
	  function Logger(prefix){
	    this.prefix = prefix;
	    this._debugEnabled = true; //debugging is always enabled at first as you have to explicitely enable debug output for all instances via settings.enableDebugging();
	  }
	
	  Logger.prototype = {
	
	    _getColorString: function _getColorString(){
	      return this._getColorStringForColor(this.color);
	    },
	    _getColorStringForColor: function _getColorStringForColor(color){
	      var str = "color:";
	      if (helper.undefOrNull(color)){
	        str += "#005500";
	      } else {
	        str += color;
	      }
	      str += ";";
	      return str;
	    },
	    _doLog: function _doLog(type, extraPrefixObject, message, obj){
	      if (!settings.getIgnoredLoggers().includes(this.prefix)){
	        var params = [];
	        if (helper.undefOrNull(this.prefix) && helper.undefOrNull(extraPrefixObject)){
	          params.push(message);
	        } else {
	          var styles = [];
	
	          var prefixedMessage = "";
	          if (!helper.undefOrNull(this.prefix)){
	            prefixedMessage += "%c" + this.prefix;
	            styles.push(this._getColorString());
	          }
	          if (!helper.undefOrNull(extraPrefixObject)){
	            if (prefixedMessage.length>0){
	              prefixedMessage += " ";
	            }
	            prefixedMessage += "%c" + extraPrefixObject.text;
	            styles.push(extraPrefixObject.style);
	          }
	          prefixedMessage += ":%c " + message;
	          styles.push('color: blue;'); //message color = blue
	
	          params.push(prefixedMessage);
	          params = params.concat(styles); //blue=debug
	        }
	        // obj is always last
	        if (!helper.undefOrNull(obj)){
	          params.push(obj);
	        }
	
	        if (type == 'debug' || type == 'deprecation'){
	          console.debug.apply(this, params);
	        } else if (type == 'error'){
	          console.error.apply(this, params);
	        } else if (type == 'log'){
	          console.log.apply(this, params);
	        } else if (type == 'info'){
	          console.info.apply(this, params);
	        } else if (type == 'warn'){
	          console.warn.apply(this, params);
	        } else {
	          throw "not yet supported";
	        }
	      }
	    },
	    deprecation: function deprecation(message, obj){
	      if (settings.deprecationWarningsEnabled()){
	        this._doLog("deprecation", {text: "DEPRECATED", style: "color:red; font-weight: bold;"}, message, obj);
	      }
	      return this;
	    },
	    debug: function debug(message, obj){
	      if (this.debuggingEnabled()){
	        this._doLog("debug", null, message, obj);
	      }
	      return this;
	    },
	    error: function error(message, obj){
	      this._doLog("error", null, message, obj);
	      return this;
	    },
	    warn: function warn(message, obj){
	      this._doLog("warn", null, message, obj);
	      return this;
	    },
	    info: function info(message, obj){
	      this._doLog("info", null, message, obj);
	      return this;
	    },
	    log: function log(message, obj){
	      this._doLog("log", null, message, obj);
	      return this;
	    },
	    setPrefix: function setPrefix(prefix){
	      this.prefix = prefix;
	      return this;
	    },
	    setColor: function setColor(color){
	      this.color = color;
	      return this;
	    },
	    setDebug: function setDebug(bool){
	      this._debugEnabled = bool;
	      return this;
	    },
	    debuggingEnabled: function debuggingEnabled(){
	      if (this._debugEnabled){
	        return settings.debuggingEnabled();
	      } else {
	        return false;
	      }
	    },
	  };
	
	
	}());


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	  'use strict';
	
	  var logger = function(){ return new (__webpack_require__(3))("SETTINGS").setColor("#585565"); }; // we need to use a function here to prevent circular dependencies
	  var helper = __webpack_require__(1);
	  var jwplayer = __webpack_require__(12);
	  var debug = false;
	  var deprecationWarnings = true;
	  var curLang;
	  var fallbackLang = 'en';
	  var ignoredLoggers = [];
	  // init the current language form html-lang-attribute
	  setLanguageFromHtmlLang();
	
	
	  function setLanguageFromHtmlLang(){
	    curLang = getLanguageFromHtmlLang();
	  }
	  function getLanguageFromHtmlLang(){
	    var lang = document.documentElement.lang;
	    return lang;
	  }
	
	  module.exports = {
	
	    /*********************
	    *     Debugging      *
	    **********************/
	
	    debuggingEnabled: function debuggingEnabled(){
	      return debug;
	    },
	    enableDebugging: function enableDebugging(){
	      debug = true;
	      logger().debug("Debugging enabled");
	      return this;
	    },
	    disableDebugging: function disableDebugging(){
	      logger().debug("Disabling Debugging...");
	      debug = false;
	      return this;
	    },
	    deprecationWarningsEnabled: function deprecationWarningsEnabled(){
	      return deprecationWarnings;
	    },
	    enableDeprecationWarnings: function enableDeprecationWarnings(){
	      deprecationWarnings = true;
	      logger().debug("Deprecation Warnings enabled");
	      return this;
	    },
	    disableDeprecationWarnings: function disableDeprecationWarnings(){
	      logger().debug("Disabled Deprecation Warnings");
	      deprecationWarnings = false;
	      return this;
	    },
	    disableLoggingFor: function disableLoggingFor(identifier){
	      logger().debug("disabling logging for ", identifier);
	      if (identifier instanceof Array){
	        ignoredLoggers = ignoredLoggers.concat(identifier);
	      } else if (identifier instanceof String) {
	        ignoredLoggers.push(identifier);
	      } else {
	        throw "unsupported type";
	      }
	      return this;
	    },
	    getIgnoredLoggers: function getIgnoredLoggers(){
	      return ignoredLoggers;
	    },
	
	
	    /*********************
	    *        I18N        *
	    **********************/
	
	    setCurrentLanguage: function setCurrentLanguage(lang){
	      if (helper.undefOrNull(lang)){
	        return;
	      }
	      lang = lang.toLowerCase().trim();
	      logger().debug("setting current language to: ", lang);
	      curLang = lang;
	      return this;
	    },
	    currentLanguage: function currentLanguage(){
	      if (helper.undefOrNull(curLang)){
	        var fbLang = this.fallbackLanguage();
	        logger().debug("currentLanguage has not been set! Using fallbackLanguage: ", fbLang);
	        return fbLang;
	      }
	      return curLang;
	    },
	    getLanguageFromHtmlLang: getLanguageFromHtmlLang,
	    setLanguageFromHtmlLang: setLanguageFromHtmlLang,
	    fallbackLanguage: function fallbackLanguage(){
	      if (helper.undefOrNull(fallbackLang)){
	        return 'en';
	      }
	      return fallbackLang;
	    },
	    setFallbackLanguage: function setFallbackLanguage(lang){
	      if (helper.undefOrNull(lang)){
	        throw "You cannot set the fallback language to '"+lang+"'! A Fallback language must always be defined! Maybe you wanted to call setCurrentLanguage()?";
	      }
	      lang = lang.toLowerCase().trim();
	      logger().debug("setting fallback language to: ", lang);
	      fallbackLang = lang;
	      return this;
	    },
	
	    /*********************
	    *     AssetCore      *
	    **********************/
	
	    getAssetCoreBaseUrl: function getAssetCoreBaseUrl(){
	      return this.assetCoreBaseUrl;
	    },
	    setAssetCoreBaseUrl: function setAssetCoreBaseUrl(url){
	      if (helper.undefOrNull(url)){
	        throw "You cannot set the AssetCore Base URL to '"+url+"'! The url has to be correct!";
	      }
	      if (!url.endsWith('/')){
	        url = url + "/";
	      }
	      logger().debug("AssetCore Base URL set to: ", url);
	      this.assetCoreBaseUrl = url;
	      return this;
	    },
	    getAssetCoreBackendApiSuffix: function getAssetCoreBackendApiSuffix(){
	      return this.assetCoreBackendApiSuffix;
	    },
	    setAssetCoreBackendApiSuffix: function setAssetCoreBackendApiSuffix(suffix){
	      if (helper.undefOrNull(suffix)){
	        throw "You cannot set the AssetCore Backend Suffix to '"+suffix+"'! The suffix has to be correct!";
	      }
	      logger().debug("AssetCore Base Backend Suffix set to: ", suffix);
	      this.assetCoreBackendApiSuffix = suffix;
	      return this;
	    },
	
	
	    /*********************
	    *      JWPlayer      *
	    **********************/
	
	    setJwPlayerKey: function setJwPlayerKey(key){
	      if (helper.undefOrNull(key)){
	        throw "'"+key+"' is not a correct value for jwPlayer key!";
	      }
	      if (helper.undefOrNull(window.jwplayer)){
	        window.jwplayer = jwplayer;
	      }
	      window.jwplayer.key = key;
	      logger().debug("jwplayer.key has been set to ", key);
	      return this;
	    },
	    getJwPlayerKey: function getJwPlayerKey(){
	      if (helper.undefOrNull(window.jwplayer.key)){
	        logger().error("Cannot play Video with JWPlayer! Key has not been set!");
	      }
	      return window.jwplayer.key;
	    }
	
	
	  };
	
	}());


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	   'use strict';
	
	   module.exports = AssetCoreClient;
	   var logger = new (__webpack_require__(3))("AssetCoreClient").setColor("rgb(214, 106, 37)").setDebug(true);
	   var helper = __webpack_require__(1);
	   var acHelper = __webpack_require__(7);
	   var settings = __webpack_require__(4);
	   var jquery = __webpack_require__(2);
	
	   var paths = {
	     detailsForCode: function(code){
	       return 'Asset/info?code=' + code;
	     }
	   };
	
	   function AssetCoreClient(baseUrl){
	     if (helper.undefOrNull(baseUrl)){
	        baseUrl = settings.getAssetCoreBaseUrl();
	     } else {
	       settings.setAssetCoreBaseUrl(baseUrl);
	     }
	     logger.debug("Initialising AssetCoreClient with baseUrl '"+baseUrl+"'");
	     if (helper.undefOrNull(baseUrl)){
	       throw "AssetCoreClient: baseUrl must be set (is "+baseUrl+")!";
	     }
	     this.baseUrl = baseUrl;
	   }
	
	   AssetCoreClient.prototype = {
	     getMediaPromise: function getMediaPromise(mediaCodeOrUrl){
	       var deferred = jquery.Deferred();
	       var promise = deferred.promise();
	       if (helper.undefOrNull(mediaCodeOrUrl)){
	         deferred.resolve(null);
	       } else {
	         // urls: ../a.jpg, ./a.jpg, /a.jpg, http://www.xyz.de/a.jpg, https://www.xyz.de/a.jpg BUT NOT if it matches the code regex
	         var isUrl = (mediaCodeOrUrl.startsWith("http") || mediaCodeOrUrl.startsWith(".") || mediaCodeOrUrl.startsWith("/"));
	         var containsAssetCode = acHelper.getCodeRegex().test(mediaCodeOrUrl);
	         var isPosterUrl = isUrl && mediaCodeOrUrl.indexOf('poster=true')>0;
	
	         if (isUrl && (!containsAssetCode || isPosterUrl)){
	           logger.debug("Media is URL: ", mediaCodeOrUrl);
	           deferred.resolve(mediaCodeOrUrl);
	         } else {
	           logger.debug("Media is AssetCoreMedia: ", mediaCodeOrUrl);
	           promise = this.detailsForCode(mediaCodeOrUrl);
	         }
	
	       }
	
	       return promise;
	     },
	     _detailsForCode: function _detailsForCode(code){
	       code = acHelper.getCode(code);
	       var url = this._getAssetCoreUrl(paths.detailsForCode(code));
	       var deferred = jquery.Deferred();
	
	       jquery.get(url).done(function(details, statusText, xhr){
	         deferred.resolve( acHelper.fromDetailJson(details) );
	       }).fail(function(xhr, textStatus, errorThrown){
	         if (xhr.status==404){
	            logger.debug("assetInfo failed: asset with code not found");
	            deferred.reject("An Asset with Code '"+code+"' could not be found!");
	         } else {
	            if (typeof data != "undefined" && data !== null){
	              logger.debug("assetInfo failed: ", data.statusText);
	              deferred.reject("Error getting details for code '"+code+"' from url '"+url+"': " + data.statusText);
	            } else {
	              logger.debug("assetInfo failed");
	              deferred.reject("Error getting details for code '"+code+"' from url '"+url+"'");
	            }
	         }
	       });
	
	       return deferred.promise();
	     },
	     _getAssetCoreUrl: function _getAssetCoreUrl(path){
	       var pathSep = "/";
	       var base = this.baseUrl;
	       var url;
	       if (base.endsWith(pathSep) && path.startsWith(pathSep)){
	         url = base.substring(0, base.length-1) + path;
	       } else if (!base.endsWith(pathSep) && !path.startsWith(pathSep)){
	         url = base + pathSep + path;
	       } else {
	         url = base + path;
	       }
	       return base + path;
	     },
	     detailsForCode: function detailsForCode(code){
	       return this._detailsForCode(code);
	     }
	  };
	
	
	}());


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * imagesLoaded v4.1.1
	 * JavaScript is all like "You images are done yet or what?"
	 * MIT License
	 */
	
	( function( window, factory ) { 'use strict';
	  // universal module definition
	
	  /*global define: false, module: false, require: false */
	
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(19)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter ) {
	      return factory( window, EvEmitter );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('ev-emitter')
	    );
	  } else {
	    // browser global
	    window.imagesLoaded = factory(
	      window,
	      window.EvEmitter
	    );
	  }
	
	})( window,
	
	// --------------------------  factory -------------------------- //
	
	function factory( window, EvEmitter ) {
	
	'use strict';
	
	var $ = window.jQuery;
	var console = window.console;
	
	// -------------------------- helpers -------------------------- //
	
	// extend objects
	function extend( a, b ) {
	  for ( var prop in b ) {
	    a[ prop ] = b[ prop ];
	  }
	  return a;
	}
	
	// turn element or nodeList into an array
	function makeArray( obj ) {
	  var ary = [];
	  if ( Array.isArray( obj ) ) {
	    // use object if already an array
	    ary = obj;
	  } else if ( typeof obj.length == 'number' ) {
	    // convert nodeList to array
	    for ( var i=0; i < obj.length; i++ ) {
	      ary.push( obj[i] );
	    }
	  } else {
	    // array of single index
	    ary.push( obj );
	  }
	  return ary;
	}
	
	// -------------------------- imagesLoaded -------------------------- //
	
	/**
	 * @param {Array, Element, NodeList, String} elem
	 * @param {Object or Function} options - if function, use as callback
	 * @param {Function} onAlways - callback function
	 */
	function ImagesLoaded( elem, options, onAlways ) {
	  // coerce ImagesLoaded() without new, to be new ImagesLoaded()
	  if ( !( this instanceof ImagesLoaded ) ) {
	    return new ImagesLoaded( elem, options, onAlways );
	  }
	  // use elem as selector string
	  if ( typeof elem == 'string' ) {
	    elem = document.querySelectorAll( elem );
	  }
	
	  this.elements = makeArray( elem );
	  this.options = extend( {}, this.options );
	
	  if ( typeof options == 'function' ) {
	    onAlways = options;
	  } else {
	    extend( this.options, options );
	  }
	
	  if ( onAlways ) {
	    this.on( 'always', onAlways );
	  }
	
	  this.getImages();
	
	  if ( $ ) {
	    // add jQuery Deferred object
	    this.jqDeferred = new $.Deferred();
	  }
	
	  // HACK check async to allow time to bind listeners
	  setTimeout( function() {
	    this.check();
	  }.bind( this ));
	}
	
	ImagesLoaded.prototype = Object.create( EvEmitter.prototype );
	
	ImagesLoaded.prototype.options = {};
	
	ImagesLoaded.prototype.getImages = function() {
	  this.images = [];
	
	  // filter & find items if we have an item selector
	  this.elements.forEach( this.addElementImages, this );
	};
	
	/**
	 * @param {Node} element
	 */
	ImagesLoaded.prototype.addElementImages = function( elem ) {
	  // filter siblings
	  if ( elem.nodeName == 'IMG' ) {
	    this.addImage( elem );
	  }
	  // get background image on element
	  if ( this.options.background === true ) {
	    this.addElementBackgroundImages( elem );
	  }
	
	  // find children
	  // no non-element nodes, #143
	  var nodeType = elem.nodeType;
	  if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
	    return;
	  }
	  var childImgs = elem.querySelectorAll('img');
	  // concat childElems to filterFound array
	  for ( var i=0; i < childImgs.length; i++ ) {
	    var img = childImgs[i];
	    this.addImage( img );
	  }
	
	  // get child background images
	  if ( typeof this.options.background == 'string' ) {
	    var children = elem.querySelectorAll( this.options.background );
	    for ( i=0; i < children.length; i++ ) {
	      var child = children[i];
	      this.addElementBackgroundImages( child );
	    }
	  }
	};
	
	var elementNodeTypes = {
	  1: true,
	  9: true,
	  11: true
	};
	
	ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
	  var style = getComputedStyle( elem );
	  if ( !style ) {
	    // Firefox returns null if in a hidden iframe https://bugzil.la/548397
	    return;
	  }
	  // get url inside url("...")
	  var reURL = /url\((['"])?(.*?)\1\)/gi;
	  var matches = reURL.exec( style.backgroundImage );
	  while ( matches !== null ) {
	    var url = matches && matches[2];
	    if ( url ) {
	      this.addBackground( url, elem );
	    }
	    matches = reURL.exec( style.backgroundImage );
	  }
	};
	
	/**
	 * @param {Image} img
	 */
	ImagesLoaded.prototype.addImage = function( img ) {
	  var loadingImage = new LoadingImage( img );
	  this.images.push( loadingImage );
	};
	
	ImagesLoaded.prototype.addBackground = function( url, elem ) {
	  var background = new Background( url, elem );
	  this.images.push( background );
	};
	
	ImagesLoaded.prototype.check = function() {
	  var _this = this;
	  this.progressedCount = 0;
	  this.hasAnyBroken = false;
	  // complete if no images
	  if ( !this.images.length ) {
	    this.complete();
	    return;
	  }
	
	  function onProgress( image, elem, message ) {
	    // HACK - Chrome triggers event before object properties have changed. #83
	    setTimeout( function() {
	      _this.progress( image, elem, message );
	    });
	  }
	
	  this.images.forEach( function( loadingImage ) {
	    loadingImage.once( 'progress', onProgress );
	    loadingImage.check();
	  });
	};
	
	ImagesLoaded.prototype.progress = function( image, elem, message ) {
	  this.progressedCount++;
	  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
	  // progress event
	  this.emitEvent( 'progress', [ this, image, elem ] );
	  if ( this.jqDeferred && this.jqDeferred.notify ) {
	    this.jqDeferred.notify( this, image );
	  }
	  // check if completed
	  if ( this.progressedCount == this.images.length ) {
	    this.complete();
	  }
	
	  if ( this.options.debug && console ) {
	    console.log( 'progress: ' + message, image, elem );
	  }
	};
	
	ImagesLoaded.prototype.complete = function() {
	  var eventName = this.hasAnyBroken ? 'fail' : 'done';
	  this.isComplete = true;
	  this.emitEvent( eventName, [ this ] );
	  this.emitEvent( 'always', [ this ] );
	  if ( this.jqDeferred ) {
	    var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
	    this.jqDeferred[ jqMethod ]( this );
	  }
	};
	
	// --------------------------  -------------------------- //
	
	function LoadingImage( img ) {
	  this.img = img;
	}
	
	LoadingImage.prototype = Object.create( EvEmitter.prototype );
	
	LoadingImage.prototype.check = function() {
	  // If complete is true and browser supports natural sizes,
	  // try to check for image status manually.
	  var isComplete = this.getIsImageComplete();
	  if ( isComplete ) {
	    // report based on naturalWidth
	    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
	    return;
	  }
	
	  // If none of the checks above matched, simulate loading on detached element.
	  this.proxyImage = new Image();
	  this.proxyImage.addEventListener( 'load', this );
	  this.proxyImage.addEventListener( 'error', this );
	  // bind to image as well for Firefox. #191
	  this.img.addEventListener( 'load', this );
	  this.img.addEventListener( 'error', this );
	  this.proxyImage.src = this.img.src;
	};
	
	LoadingImage.prototype.getIsImageComplete = function() {
	  return this.img.complete && this.img.naturalWidth !== undefined;
	};
	
	LoadingImage.prototype.confirm = function( isLoaded, message ) {
	  this.isLoaded = isLoaded;
	  this.emitEvent( 'progress', [ this, this.img, message ] );
	};
	
	// ----- events ----- //
	
	// trigger specified handler for event type
	LoadingImage.prototype.handleEvent = function( event ) {
	  var method = 'on' + event.type;
	  if ( this[ method ] ) {
	    this[ method ]( event );
	  }
	};
	
	LoadingImage.prototype.onload = function() {
	  this.confirm( true, 'onload' );
	  this.unbindEvents();
	};
	
	LoadingImage.prototype.onerror = function() {
	  this.confirm( false, 'onerror' );
	  this.unbindEvents();
	};
	
	LoadingImage.prototype.unbindEvents = function() {
	  this.proxyImage.removeEventListener( 'load', this );
	  this.proxyImage.removeEventListener( 'error', this );
	  this.img.removeEventListener( 'load', this );
	  this.img.removeEventListener( 'error', this );
	};
	
	// -------------------------- Background -------------------------- //
	
	function Background( url, element ) {
	  this.url = url;
	  this.element = element;
	  this.img = new Image();
	}
	
	// inherit LoadingImage prototype
	Background.prototype = Object.create( LoadingImage.prototype );
	
	Background.prototype.check = function() {
	  this.img.addEventListener( 'load', this );
	  this.img.addEventListener( 'error', this );
	  this.img.src = this.url;
	  // check if image is already complete
	  var isComplete = this.getIsImageComplete();
	  if ( isComplete ) {
	    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
	    this.unbindEvents();
	  }
	};
	
	Background.prototype.unbindEvents = function() {
	  this.img.removeEventListener( 'load', this );
	  this.img.removeEventListener( 'error', this );
	};
	
	Background.prototype.confirm = function( isLoaded, message ) {
	  this.isLoaded = isLoaded;
	  this.emitEvent( 'progress', [ this, this.element, message ] );
	};
	
	// -------------------------- jQuery -------------------------- //
	
	ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
	  jQuery = jQuery || window.jQuery;
	  if ( !jQuery ) {
	    return;
	  }
	  // set local variable
	  $ = jQuery;
	  // $().imagesLoaded()
	  $.fn.imagesLoaded = function( options, callback ) {
	    var instance = new ImagesLoaded( this, options, callback );
	    return instance.jqDeferred.promise( $(this) );
	  };
	};
	// try making plugin
	ImagesLoaded.makeJQueryPlugin();
	
	// --------------------------  -------------------------- //
	
	return ImagesLoaded;
	
	});


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	   'use strict';
	
	   var logger = new (__webpack_require__(3))("AssetCoreHelper").setColor("rgb(214, 106, 37)").setDebug(true);
	   var helper = __webpack_require__(1);
	   var settings = __webpack_require__(4);
	   var ACImage = __webpack_require__(24);
	   var ACAudio = __webpack_require__(23);
	   var ACVideo = __webpack_require__(9);
	
	   module.exports = {
	      getCode: function getCode(codeOrUrlWithCode){
	        if (codeOrUrlWithCode.startsWith('http') && codeOrUrlWithCode.includes("celemony") && codeOrUrlWithCode.includes("/code/")){ //legacy; is full assetcore url containing code
	          var legacyUrl = codeOrUrlWithCode;
	          codeOrUrlWithCode = legacyUrl.replace( this.getCodeRegex(), "$1" );
	          logger.deprecation("resolved code '"+codeOrUrlWithCode+"' via legacy url '"+legacyUrl+"'! Note that you should only pass the code, not the whole url!");
	        }
	        return codeOrUrlWithCode;
	      },
	      fromDetailJson: function fromDetailJson(detailJson){
	         if (helper.undefOrNull(detailJson)){
	           throw "Could not instantiate AssetCoreMedia. Detail-JSON was " + detailJson;
	         }
	         if (detailJson.type == "image"){
	           return new ACImage(detailJson);
	         } else if (detailJson.type == "video" || detailJson.type == "smartmovie"){
	           return new ACVideo(detailJson);
	         } else if (detailJson.type == "audio"){
	           return new ACAudio(detailJson);
	         } else {
	           throw "unsupported media type '"+detailJson.type+"'";
	         }
	       },
	      getCodeRegex: function getCodeRegex(){
	        return /^https?:\/\/.*\/code\/([\w\-\.]*)((\?|\&).*)?/g;
	      },
	      generateMediaData: function generateMediaData(type, quality, provider, url){
	        var acMediaData = {
	          type: type,
	          code: "none",
	          languages: {}
	        };
	        acMediaData.languages[ settings.currentLanguage() ] = {
	          defaultQuality: quality,
	          qualities: {}
	        };
	        acMediaData.languages[ settings.currentLanguage() ].qualities[ quality ] = {
	          provider: provider,
	          detail: {
	            url: url
	          }
	        };
	        return acMediaData;
	      }
	  };
	
	
	
	}());


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	   'use strict';
	
	   module.exports = AssetCoreMedia;
	   var helper = __webpack_require__(1);
	   var logger = new (__webpack_require__(3))("AssetCoreMedia").setColor("gold");
	   var settings = __webpack_require__(4);
	
	  function AssetCoreMedia(detailJson){
	    this.json = detailJson;
	  }
	
	  AssetCoreMedia.prototype = {
	    _languageDetails: function _languageDetails(){
	      function firstKey(obj) {
	        for(var key in obj)
	          return key;
	      }
	
	      if (helper.undefOrNull(this.json) || helper.undefOrNull(this.json.languages) || this.json.languages.length <= 0){
	          throw "AssetCoreMedia: incorrect json: " + this.json;
	      }
	      var curLang = settings.currentLanguage();
	      var fallbackLang = settings.fallbackLanguage();
	      var langData = this.json.languages[curLang];
	      if (helper.undefOrNull(langData) && curLang!=fallbackLang){
	        logger.debug("using fallback language for details: ", fallbackLang);
	        langData = this.json.languages[fallbackLang];
	      }
	      if (helper.undefOrNull(langData)){
	        var firstLang = firstKey(this.json.languages);
	        logger.debug("using first available language '"+firstLang+"' for details (no default '"+curLang+"' or fallback '"+fallbackLang+"' available!): ", firstLang);
	        langData = this.json.languages[firstLang];
	      }
	      if (helper.undefOrNull(langData)){
	        throw "AssetCoreMedia: No language-details found in JSON; Neither for currentLanguage ('"+curLang+"') nor for fallbackLanguage ('"+fallbackLang+"')!";
	      }
	
	      return langData;
	    },
	    provider: function provider(qualityName){
	      var q = null;
	      if (helper.undefOrNull(qualityName)){
	        q = this._languageDetails().qualities[this.defaultQualityName()];
	      } else {
	        q = this._languageDetails().qualities[qualityName];
	      }
	      if (helper.undefOrNull(q)){
	        return null;
	      } else {
	        return q.provider;
	      }
	    },
	    defaultQualityName: function defaultQualityName(){
	      return this._languageDetails().defaultQuality;
	    },
	    type: function type(){
	      return this.json.type;
	    },
	    _defaultQuality: function _defaultQuality(){
	      return this._getQuality(this.defaultQualityName());
	    },
	    _getQuality: function getQuality(qName){
	      var q = this._languageDetails().qualities[qName];
	      if (helper.undefOrNull(q)){
	        return null;
	      } else {
	        return q;
	      }
	    }
	  };
	
	}());


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	   'use strict';
	
	   module.exports = AssetCoreVideo;
	   var AssetCoreMedia = __webpack_require__(8);
	   var helper = __webpack_require__(1);
	   var logger = new (__webpack_require__(3))("ACMediaVideo").setColor("darkgoldenrod").setDebug(true);
	
	  function AssetCoreVideo(detailJson){
	    logger.debug("creating AssetCoreVideo from json:", detailJson);
	    AssetCoreMedia.call(this, detailJson); // call super constructor.
	  }
	
	  // subclass extends superclass
	  AssetCoreVideo.prototype = Object.create(AssetCoreMedia.prototype);
	  AssetCoreVideo.prototype.constructor = AssetCoreMedia;
	
	  // if quality is not set (e.g. null or undefined) it is tried to use jwPlayers defaultQuality if a quality is needed for this provider
	  AssetCoreVideo.prototype._qualityDetails = function(qualityName){
	    if (helper.undefOrNull(qualityName)){
	      qualityName = this._languageDetails().defaultQuality;
	      if (helper.undefOrNull(qualityName)){
	        throw "Current Video cannot return qualities without defining a qualityName; AssetCore response did not contain a default qualityName!";
	      }
	    }
	
	    var quality = helper.undefOrNull(this._languageDetails().qualities[qualityName]) ? this._languageDetails().qualities[this._languageDetails().defaultQuality] : this._languageDetails().qualities[qualityName];
	    return quality.detail;
	  };
	
	  // if quality is not set (e.g. null or undefined) it is tried to use jwPlayers defaultQuality if a quality is needed for this provider
	  AssetCoreVideo.prototype.width = function(qualityName){
	    return this._qualityDetails(qualityName).width;
	  };
	
	  // if quality is not set (e.g. null or undefined) it is tried to use jwPlayers defaultQuality if a quality is needed for this provider
	  AssetCoreVideo.prototype.height = function(qualityName){
	    return this._qualityDetails(qualityName).height;
	  };
	
	  AssetCoreVideo.prototype.ratio = function(qualityName){
	    var height = this.height(qualityName);
	    var width = this.width(qualityName);
	    return width / height;
	  };
	
	  AssetCoreVideo.prototype.qualities = function(){
	    var keys = [];
	    for(var k in this._languageDetails().qualities) keys.push(k);
	    return keys;
	  };
	
	  AssetCoreVideo.prototype.qualityUrl = function(qualityName){
	    var quality = this._qualityDetails(qualityName);
	    if (!helper.undefOrNull(quality)){
	      return quality.url;
	    }
	    return null;
	  };
	
	  AssetCoreVideo.prototype.useYoutube = function(){
	    return this.provider() == "youtube";
	  };
	
	  AssetCoreVideo.prototype.useJwplayer = function(){
	    return this.type() == "video" && this.provider() != "youtube";
	  };
	
	  AssetCoreVideo.prototype.isSmartMovie = function(){
	    return this.type() == "smartmovie";
	  };
	
	  AssetCoreVideo.prototype.hasPreviewFrameUrl = function(qualityName){
	    var url = this.previewFrameUrl(qualityName);
	    return !helper.undefOrNull(url);
	  };
	
	  AssetCoreVideo.prototype.previewFrameUrl = function(qualityName){
	    return this._qualityDetails(qualityName).previewFrameUrl;
	  };
	
	  AssetCoreVideo.prototype.reference = function(qualityName){
	    if (!this.useYoutube()){
	        throw "Only Youtube Videos have a reference! This video is of type '"+this.json.provider+"'!";
	    } else {
	      return this._qualityDetails(qualityName).reference;
	    }
	  };
	
	  // if quality is not set (e.g. null or undefined) it is tried to use jwPlayers defaultQuality if a quality is needed for this provider
	  AssetCoreVideo.prototype.url = function(qualityName){
	    var langDet = this._languageDetails();
	    if (!helper.undefOrNull(langDet.url)){
	      return langDet.url;
	    } else {
	      return this._qualityDetails(qualityName).url;
	    }
	  };
	
	  AssetCoreVideo.prototype.durationMs = function(){
	    return this._defaultQuality().detail.durationMs;
	  };
	
	}());


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	   'use strict';
	   //var logger = new (require('../helpers/logger.js'))("Overlay").setColor("DimGray");
	   var helper = __webpack_require__(1);
	   __webpack_require__(34);
	   var jQuery = __webpack_require__(2);
	   __webpack_require__(22); //add jQuery.browser for jQuery versions newer than v1.8
	   __webpack_require__(20);
	   __webpack_require__(21);
	
	
	   module.exports = Overlay;
	
	   var defaultOptions = {
	     dom: {
	       id: "cmy-overlay",
	       class: "cmy-overlay",
	       moreClasses: "",
	       parentSelector: "body",
	       closeButtonClass: "btn-close btn-close-overlay",
	       showClose: true,
	       fixed: true,
	       closeOnClick: true
	     },
	     mask: {
	       color: '#000000',
	       loadSpeed: 800,
	       opacity: 0.7
	     }
	   };
	
	   function Overlay(content, options, removalCallback){
	     this.setContent(typeof content=="undefined" ? null : content);
	     this.options = jQuery.extend(true, {}, defaultOptions);
	     this.modifyOptionsWith(options);
	     this.removalCallbacks = [];
	     if (typeof removalCallback!="undefined" && removalCallback !== null){
	       this.addRemovalCallback(removalCallback);
	     }
	     this.enableAutoCenter();
	   }
	
	   Overlay.prototype = {
	     /*********************
	      * 'PRIVATE' Methods *
	      *********************/
	     _getGeneratedDom: function _getGeneratedDom(){
	       var content = this.content === null ? jQuery("<span></span>") : this.content;
	       var $main = jQuery("<div class='"+this.options.dom.class+" "+this.options.dom.moreClasses+"' id='"+this.options.dom.id+"'></div>");
	       if (!helper.undefOrNull(content)){
	         $main.append(content);
	       }
	       if (this.options.dom.showClose){
	         var overlayId = this.options.dom.id;
	         var $close = jQuery("<a class='"+this.options.dom.closeButtonClass+"-wrapper cmy-close'><div class='"+this.options.dom.closeButtonClass+"' id='close-"+overlayId+"-overlay'>X</div></a>");
	         $close.click(function(){
	          jQuery("#"+overlayId).overlay().close();
	         });
	         $main.prepend($close);
	       } else {
	         $main.children("a.close").remove();
	       }
	       return $main;
	     },
	     _onClose: function _onClose(){
	       jQuery("#"+this.options.dom.id).remove();
	       var callbacks = this.removalCallbacks;
	       if (!helper.undefOrNull(this.__resizeFunction)){
	         jQuery(window).off('resize', this.__resizeFunction);
	       }
	       for (var i=0; i<this.removalCallbacks.length; i++){
	         var cb = callbacks[i];
	         cb(this);
	       }
	     },
	     _onResize: function _onResize(){
	       this.centerContent();
	     },
	     /*********************
	      * 'PUBLIC'  Methods *
	      *********************/
	     enableAutoCenter: function enableAutoCenter(){
	       var self = this;
	       this.__resizeFunction = function(){ self._onResize(); };
	       jQuery(window).on('resize', this.__resizeFunction);
	     },
	     disableAutoCenter: function disableAutoCenter(){
	       jQuery(window).off('resize', this.__resizeFunction);
	     },
	     position: function position(){
	       //NOTE: as this._instance.position(); would return incorrect values on Safari <= 9, we currently use the CSS values here
	       //return this._instance.position();
	       if (helper.undefOrNull(this._instance)){
	         return { top: 0, left: 0 };
	       }
	
	       var top = parseInt(this._instance.css("top"));
	       top = isNaN(top) ? 0 : top;
	       var marginTop = parseInt(this._instance.css("marginTop"));
	       marginTop = isNaN(marginTop) ? 0 : marginTop;
	       var allTop = top+marginTop;
	
	       var left = parseInt(this._instance.css("left"));
	       left = isNaN(left) ? 0 : left;
	       var marginLeft = parseInt(this._instance.css("marginLeft"));
	       marginLeft = isNaN(marginLeft) ? 0 : marginLeft;
	       var allLeft = left+marginLeft;
	
	       var pos = {
	         top: allTop,
	         left: allLeft
	       };
	
	       return pos;
	     },
	     getLeftPos: function getLeftPos(){
	       if (this.posLeftPx !== null){
	         return this.posLeftPx;
	       } else if (this.content instanceof jQuery){
	         var middle = jQuery(window).width()/2;
	         var contentWidth = this.content.width()/2;
	         var left = middle - contentWidth;
	         return left;
	       } else {
	         return 0;
	       }
	     },
	     setLeftPos: function setLeftPos(leftPos){
	       if (!helper.undefOrNull(leftPos) && !isNaN(leftPos)){
	         this.posLeftPx = leftPos;
	         jQuery(this._instance).css({ left: leftPos+'px' });
	         if (isNaN(leftPos) && typeof leftPos == "string" && !leftPos.endsWith('px')){
	           throw "leftPos is not a valid value: " + leftPos;
	         }
	       } else {
	         logger.warn("leftPos was set to a non numeric value; Enabling autocenter");
	         this.enableAutoCenter();
	       }
	     },
	     centerContent: function(){
	       var middle = jQuery(window).width()/2;
	       var contentWidth = this.content.width();
	       var left = middle - contentWidth/2;
	       this.setLeftPos(left);
	       return this;
	     },
	     show: function show(){
	       var $el = this._getGeneratedDom();
	       var self = this;
	       jQuery(this.options.dom.parentSelector).prepend($el);
	       this._instance = $el.overlay({
	     		mask: this.options.mask,
	     		left: this.getLeftPos()+"px",
	     		load: true,
	        fixed: this.options.dom.fixed,
	        closeOnClick: this.options.dom.closeOnClick,
	     		onClose: function() { self._onClose(); },
	        close: $el.children("#close-"+this.options.dom.id+"-overlay").parent()
	     	 });
	       if (helper.undefOrNull(this.posLeftPx)){
	         this.centerContent();
	       }
	       return this;
	     },
	     remove: function remove(){
	       if (!helper.undefOrNull(this._instance)){
	         jQuery("#"+this.options.dom.id).overlay().close();
	       }
	     },
	     setContent: function setContent(newContent){
	       if (!helper.undefOrNull(newContent) && typeof newContent == "string"){
	         throw "Strings as content are not allowed; Please pass a DOM Element (native or jQuery)!";
	       }
	       this.content = jQuery(newContent);
	       /*
	       if (helper.undefOrNull(this.posLeftPx)){
	         this.getLeftPos(_getGeneratedDom());
	       }
	       */
	       return this;
	     },
	     getContent: function getContent(){
	       return this.content;
	     },
	     resizeContent: function resizeContent(newWidth, newHeight, doCenter){
	       if (!helper.undefOrNull(newWidth)){
	         jQuery(this._instance).css({ width: newWidth+'px' });
	         jQuery(this.content).css({ width: newWidth+'px' });
	       }
	       if (!helper.undefOrNull(newHeight)){
	         jQuery(this._instance).css({ height: newHeight+'px' });
	         jQuery(this.content).css({ height: newHeight+'px' });
	       }
	       if (!helper.undefOrNull(doCenter)){
	         centerContent();
	       }
	     },
	     setRemovalCallback: function setRemovalCallback(callback){
	       if (typeof callback !== "function"){
	         throw "given Callback is not a function";
	       }
	       this.removalCallbacks.length = 0;
	       this.addRemovalCallback(callback);
	       return this;
	     },
	     addRemovalCallback: function addRemovalCallback(callback){
	       if (typeof callback !== "function"){
	         throw "given Callback is not a function";
	       }
	       this.removalCallbacks.push(callback);
	       return this;
	     },
	     removeRemovalCallback: function removeRemovalCallback(callback){
	       var idx = this.removalCallbacks.indexOf(callback);
	       this.removalCallbacks.splice(idx, 1);
	       return this;
	     },
	     modifyOptionsWith: function modifyOptionsWith(optionsObject){
	       if (typeof optionsObject == "undefined" || optionsObject === null){
	         return;
	       }
	       jQuery.extend( true, this.options, optionsObject );
	       return this;
	     },
	     height: function height(){
	       return this._instance.height();
	     },
	     width: function width(){
	       return this._instance.width();
	     },
	     getCloseButton: function getCloseButton(){
	       if (this.options.dom.showClose){
	         return this._instance.find("#close-"+this.options.dom.id+"-overlay").parent();
	       }
	       return null;
	     }
	   };
	}).call(this);


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	Information on subclasses:
	
	Subclasses MAY set these properties:
	this.overlayId = 'abc'                      - sets the overlay id to 'abc' (default: none)
	**/
	(function(){
	  'use strict';
	
	  var helper = __webpack_require__(1);
	  var $ = __webpack_require__(2);
	  var imagesLoaded = __webpack_require__(6);
	  imagesLoaded.makeJQueryPlugin( $ );
	  var logger = new (__webpack_require__(3))("Generic VideoPlayer").setColor("#de7ddd").setDebug(true);
	  var Overlay = __webpack_require__(10);
	
	  module.exports = VideoPlayer;
	
	  var defaultOptions = {
	    posterSize: 'cover',
	    overlayAutoScale: true,
	    forcePosterDimensions: false,
	    omitPosterElement: false,
	    inheritMaxWidthFrom: null // one may define a selector like ("#main"); The elements width is used to set the maxWidth for the videoContainer (inline videos only); listens to window.onResize
	  };
	
	  function VideoPlayer(mediaInstance, inline, container, posterImageUrlOrMedia, defaultQuality, defaultsOverride, options, playButtonImage, playButtonHoverImage){
	    var self = this;
	    this.media = mediaInstance;
	    this.inline = inline;
	    this.options = jQuery.extend(true, {}, defaultOptions);
	    this.defaultQuality = defaultQuality;
	    this.baseContainer = $(container);
	    this.baseContainer.data("cmy-videoplayer", this);
	    if (!helper.undefOrNull(defaultsOverride)){
	      this.modifyOptionsWith(defaultsOverride);
	    }
	    if (!helper.undefOrNull(options)){
	      this.modifyOptionsWith(options);
	    }
	
	    this.poster = posterImageUrlOrMedia;
	
	    var plyId = "ply-" + new Date().getTime(); //jwPlayer needs individual IDs to be able to display more than one instance at a time
	    this._containerId = plyId;
	    if (inline){
	      this.container = $(container);
	      if (helper.undefOrNull(this.container.attr("id"))){ //if the element has no id, use the generated one to be able to display more than one instance at a time
	        this.container.attr("id", plyId);
	      } else {
	        this._containerId = this.container.attr("id").replace("#","");
	      }
	    }
	
	    // check if we should inherit the max width from a configured Element
	    if (!helper.undefOrNull(self.options.inheritMaxWidthFrom) && $(self.options.inheritMaxWidthFrom).length>0){
	      //TODO: Check; Do we need to clean-up the onResize event on unload?
	      self.inheritContainerWidth(false);
	      $(window).on('resize', function(){ self.inheritContainerWidth(false, self); });
	    }
	
	    if (!helper.undefOrNull(playButtonImage)){
	      this._addPlayButton(playButtonImage, playButtonHoverImage);
	    }
	
	    logger.debug("initting VideoPlayer with options (overlay: "+(!inline)+", overlayAutoscale: "+(this.options.overlayAutoScale)+", poster: "+((helper.undefOrNull(posterImageUrlOrMedia) || helper.undefOrNull(posterImageUrlOrMedia.json))?posterImageUrlOrMedia:posterImageUrlOrMedia.json.code)+", playButton: "+playButtonImage+", provider: "+this.media.provider()+"); baseContainer: ", this.baseContainer);
	  }
	
	  VideoPlayer.prototype = {
	    _play: function _play(){
	      throw "You either called _play() on the SuperClass or your SubClass does not implement the _play()-Method! This is unsupported!";
	    },
	    _onClose: function _onClose(){
	      if (!helper.undefOrNull(this.__resizeFunction)){
	        $(window).off('resize', this.__resizeFunction);
	      }
	      for (var prop in this) {
	        if (this.hasOwnProperty(prop)) {
	          logger.debug("setting null: "+prop);
	          prop = null;
	        }
	      }
	    },
	    _onResize: function _onResize(){
	      var self = this;
	
	      var doResize = function doResize(self, givenWidth, givenHeight, newWidth, newHeight){
	        var width = typeof newWidth != "undefined" && newWidth !== null ? newWidth : givenWidth;
	        var height = typeof newHeight != "undefined" && newHeight !== null ? newHeight : givenHeight;
	        var viewHeight = $(window).height();
	        var viewWidth = $(window).width();
	        var posTop = self.overlay.position().top;
	        var ratio = height / width;
	        var closeButtonWidth = self.overlay.getCloseButton() !== null ? (self.overlay.getCloseButton().width()-parseInt(self.overlay.getCloseButton().css('right'))) : 0;
	        var viewIsLessHigh = viewHeight < (posTop + height);
	        var viewIsLessWide = viewWidth < (width+closeButtonWidth*2);
	          //do actual resizing
	        if (viewIsLessHigh){
	          newHeight = viewHeight-posTop;
	          newWidth = newHeight / ratio;
	          doResize(self, givenWidth, givenHeight, newWidth, newHeight);
	          return;
	        } else if (viewIsLessWide){
	          newWidth = viewWidth - closeButtonWidth*2;
	          newHeight = newWidth * ratio;
	          doResize(self, givenWidth, givenHeight, newWidth, newHeight);
	          return;
	        }
	        self.overlay.resizeContent(width, height);
	        self.resizeForOverlay(width, height); // call child function
	      };
	
	      if (!this.inline && this.options.overlayAutoScale){
	        doResize(this, this.media.width(this.defaultQuality), this.media.height(this.defaultQuality));
	      }
	    },
	    _addPlayButton: function(url, hoverUrl){
	      if (!helper.undefOrNull(url)){
	        var container = this.baseContainer;
	
	        var conPos = container.css('position');
	        if (conPos == 'static' || !conPos.length){
	          container.css('position', 'relative');
	        }
	
	        var $btn = $("<img src='"+url+"' />");
	
	
	        /*
	         * TODO: FIXME: When prepending the button
	         * the container looses its css width and height properties somehow
	         * (we do not know why, yet);
	         *
	         * So for a temporary fix, we read those values, check if they're validateForm
	         * and set them again after the button was prepended
	         */
	        var width = container.css("width");
	        var height = container.css("height");
	        container.prepend($btn);
	        if (width.endsWith("px") && height.endsWith("px")){
	          container.css({width: width, height: height});
	        }
	
	        if (!helper.undefOrNull(hoverUrl)){
	          container.hover(function(){
	            $btn.attr("src", hoverUrl);
	          }, function(){
	            $btn.attr("src", url);
	          });
	        }
	
	        $btn.imagesLoaded(function(){
	          $btn.css({
	            position : 'absolute',
	            left : '50%',
	            top : '50%',
	            marginLeft : -$btn.outerWidth()/2,
	            marginTop : -$btn.outerHeight()/2
	          });
	        });
	
	      }
	    },
	    posterUrl: function posterUrl(){
	      var poster = this.poster;
	      if (helper.undefOrNull(poster)){
	        return null;
	      }
	
	      var url;
	      if (poster.constructor.name == "String" || typeof poster == "string"){ //2nd clause is needed for IE
	        logger.debug("Poster is URL: ", poster);
	        url = poster;
	      } else { // NOTE: using constructor.name may return incorrect results in minified javascripts! (e.g. 'AssetCoreMedia'=='t')
	          url = poster.dppxUrl();
	      }
	
	      return url;
	    },
	    _initPoster: function _initPoster(){
	      var poster = this.poster;
	      if (helper.undefOrNull(poster)){
	        return;
	      }
	
	      var self = this;
	      var url = this.posterUrl();
	
	      var container = this.baseContainer instanceof jQuery ? this.baseContainer : $(this.baseContainer);
	      container.css({
	        backgroundImage:'url('+url+')',
	        backgroundSize:this.options.posterSize,
	        backgroundRepeat: 'no-repeat',
	        backgroundPosition: 'center center',
	        cursor: 'pointer'
	      });
	
	      if (container.width() <= 0 || container.height() <= 0 || this.options.forcePosterDimensions){
	        logger.debug("forcing poster dimensions on", container);
	        if (helper.undefOrNull(poster.width)){ //is url
	          container.imagesLoaded({ background: true }, function(ldr){
	            if (ldr.images.length >= 1){
	              var image = ldr.images[0];
	              container.css({
	                width: image.img.width,
	                height: image.img.height
	              });
	            }
	          });
	        } else {
	          container.css({
	            width: poster.width(),
	            height: poster.height()
	          });
	        }
	        self.inheritContainerWidth(false, self);
	      }
	
	      logger.debug("poster '"+url+"' was set on container" + (this.options.forcePosterDimensions?" with forced poster-dimensions":""), container);
	      container.click(function(){
	        self._play();
	      });
	    },
	    hasPoster: function hasPoster(){
	      return !helper.undefOrNull(this.poster);
	    },
	    inheritContainerWidth: function inheritContainerWidth(enlarge, thisInstance){ //thisInstance is used for callbacks that otherwise would set this=window
	      var self = helper.undefOrNull(thisInstance) ? this : thisInstance;
	      if (helper.undefOrNull(this.options) || helper.undefOrNull(this.options.inheritMaxWidthFrom)){
	        return;
	      }
	      var $el = $(this.options.inheritMaxWidthFrom);
	      if (helper.undefOrNull($el)){
	        logger.debug("wont' inherit container width as $el with selector ("+this.options.inheritMaxWidthFrom+") was not found");
	      } else {
	        var elWidth = $el.width();
	        if (elWidth > 0){
	          var ratio = this.media.ratio();
	          if (!isNaN(ratio)){
	            var height = elWidth / ratio;
	            if ((height <= this.media.height(this.defaultQuality) && elWidth <= this.media.width(this.defaultQuality)) || enlarge){
	              self.resizeForInheritation(elWidth, height);
	              return [elWidth, height];
	            } else {
	              self.resizeForInheritation(self.media.width(self.defaultQuality), self.media.height(self.defaultQuality));
	              return null;
	            }
	          }
	        }
	        return null;
	      }
	    },
	    resizeForInheritation: function resizeForInheritation(width, height){
	      logger.error("You either called resizeForInheritation() on the SuperClass or your SubClass does not implement the resizeForInheritation()-Method! This is unsupported!");
	    },
	    resizeForOverlay: function resizeForOverlay(width, height){
	      logger.error("You either called resizeForOverlay() on the SuperClass or your SubClass does not implement the resizeForOverlay()-Method! This is unsupported!");
	    },
	    resize: function resize(width, height){
	      logger.error("You either called resize() on the SuperClass or your SubClass does not implement the resize()-Method! This is unsupported!");
	    },
	    play: function play(){
	      var self = this;
	      var container = this.container;
	
	      if (!this.inline){
	        this.container = $("<div id='"+this._containerId+"'></div>");
	        container = this.container;
	
	        container.css({ width: this.media.width(this.defaultQuality), height: this.media.height(this.defaultQuality) });
	
	        this.overlay = new Overlay(container).show();
	        if (!helper.undefOrNull(this.overlayId)){
	          container.attr("id", this.overlayId);
	        }
	        this.overlay.addRemovalCallback(function(){
	          self._onClose();
	        });
	      }
	
	      this._play(container);
	
	      if (!this.inline && this.options.overlayAutoScale){
	        // call resize once to fit the player into the browser window on init
	        self._onResize();
	        self.overlay.centerContent();
	
	        this.__resizeFunction = function(){ self._onResize(); };
	        $(window).on('resize', self.__resizeFunction);
	      }
	    },
	    getMedia: function getMedia(){
	      return this.media;
	    },
	    getContainer: function getContainer(){
	      return document.getElementById(this._containerId);
	    },
	    modifyOptionsWith: function modifyOptionsWith(optionsObject){
	      if (helper.undefOrNull(optionsObject) || $.isEmptyObject(optionsObject)){
	        return;
	      }
	      $.extend( true, this.options, optionsObject );
	      return this;
	    }
	  };
	
	}());


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.jwplayer=t():e.jwplayer=t()}(this,function(){return function(e){function t(n){if(i[n])return i[n].exports;var o=i[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n=window.webpackJsonpjwplayer;window.webpackJsonpjwplayer=function(i,r){for(var a,s,l=0,c=[];l<i.length;l++)s=i[l],o[s]&&c.push.apply(c,o[s]),o[s]=0;for(a in r)e[a]=r[a];for(n&&n(i,r);c.length;)c.shift().call(null,t)};var i={},o={0:0};return t.e=function(e,n){if(0===o[e])return n.call(null,t);if(void 0!==o[e])o[e].push(n);else{o[e]=[n];var i=document.getElementsByTagName("head")[0],r=document.createElement("script");r.type="text/javascript",r.charset="utf-8",r.async=!0,r.src=t.p+""+({1:"provider.caterpillar",2:"provider.shaka",3:"provider.cast",4:"provider.html5",5:"provider.flash",6:"provider.youtube",7:"polyfills.vttcue",8:"polyfills.vttrenderer",9:"polyfills.promise",10:"polyfills.base64",11:"vttparser"}[e]||e)+".js",i.appendChild(r)}},t.m=e,t.c=i,t.p="",t(0)}([function(e,t,n){e.exports=n(213)},function(e,t,n){var i,o;i=[],o=function(){var e={},t=Array.prototype,n=Object.prototype,i=Function.prototype,o=t.slice,r=t.concat,a=n.toString,s=n.hasOwnProperty,l=t.map,c=t.reduce,u=t.forEach,d=t.filter,p=t.every,h=t.some,f=t.indexOf,g=Array.isArray,m=Object.keys,v=i.bind,w=function(e){return e instanceof w?e:this instanceof w?void 0:new w(e)},y=w.each=w.forEach=function(t,n,i){if(null==t)return t;if(u&&t.forEach===u)t.forEach(n,i);else if(t.length===+t.length){for(var o=0,r=t.length;o<r;o++)if(n.call(i,t[o],o,t)===e)return}else for(var a=w.keys(t),o=0,r=a.length;o<r;o++)if(n.call(i,t[a[o]],a[o],t)===e)return;return t};w.map=w.collect=function(e,t,n){var i=[];return null==e?i:l&&e.map===l?e.map(t,n):(y(e,function(e,o,r){i.push(t.call(n,e,o,r))}),i)};var j="Reduce of empty array with no initial value";w.reduce=w.foldl=w.inject=function(e,t,n,i){var o=arguments.length>2;if(null==e&&(e=[]),c&&e.reduce===c)return i&&(t=w.bind(t,i)),o?e.reduce(t,n):e.reduce(t);if(y(e,function(e,r,a){o?n=t.call(i,n,e,r,a):(n=e,o=!0)}),!o)throw new TypeError(j);return n},w.find=w.detect=function(e,t,n){var i;return b(e,function(e,o,r){if(t.call(n,e,o,r))return i=e,!0}),i},w.filter=w.select=function(e,t,n){var i=[];return null==e?i:d&&e.filter===d?e.filter(t,n):(y(e,function(e,o,r){t.call(n,e,o,r)&&i.push(e)}),i)},w.reject=function(e,t,n){return w.filter(e,function(e,i,o){return!t.call(n,e,i,o)},n)},w.compact=function(e){return w.filter(e,w.identity)},w.every=w.all=function(t,n,i){n||(n=w.identity);var o=!0;return null==t?o:p&&t.every===p?t.every(n,i):(y(t,function(t,r,a){if(!(o=o&&n.call(i,t,r,a)))return e}),!!o)};var b=w.some=w.any=function(t,n,i){n||(n=w.identity);var o=!1;return null==t?o:h&&t.some===h?t.some(n,i):(y(t,function(t,r,a){if(o||(o=n.call(i,t,r,a)))return e}),!!o)};w.size=function(e){return null==e?0:e.length===+e.length?e.length:w.keys(e).length},w.last=function(e,t,n){if(null!=e)return null==t||n?e[e.length-1]:o.call(e,Math.max(e.length-t,0))},w.after=function(e,t){return function(){if(--e<1)return t.apply(this,arguments)}},w.before=function(e,t){var n;return function(){return--e>0&&(n=t.apply(this,arguments)),e<=1&&(t=null),n}};var E=function(e){return null==e?w.identity:w.isFunction(e)?e:w.property(e)},k=function(e){return function(t,n,i){var o={};return n=E(n),y(t,function(r,a){var s=n.call(i,r,a,t);e(o,s,r)}),o}};w.groupBy=k(function(e,t,n){w.has(e,t)?e[t].push(n):e[t]=[n]}),w.indexBy=k(function(e,t,n){e[t]=n}),w.sortedIndex=function(e,t,n,i){n=E(n);for(var o=n.call(i,t),r=0,a=e.length;r<a;){var s=r+a>>>1;n.call(i,e[s])<o?r=s+1:a=s}return r};var b=w.some=w.any=function(t,n,i){n||(n=w.identity);var o=!1;return null==t?o:h&&t.some===h?t.some(n,i):(y(t,function(t,r,a){if(o||(o=n.call(i,t,r,a)))return e}),!!o)};w.contains=w.include=function(e,t){return null!=e&&(e.length!==+e.length&&(e=w.values(e)),w.indexOf(e,t)>=0)},w.pluck=function(e,t){return w.map(e,w.property(t))},w.where=function(e,t){return w.filter(e,w.matches(t))},w.findWhere=function(e,t){return w.find(e,w.matches(t))},w.max=function(e,t,n){if(!t&&w.isArray(e)&&e[0]===+e[0]&&e.length<65535)return Math.max.apply(Math,e);var i=-(1/0),o=-(1/0);return y(e,function(e,r,a){var s=t?t.call(n,e,r,a):e;s>o&&(i=e,o=s)}),i},w.difference=function(e){var n=r.apply(t,o.call(arguments,1));return w.filter(e,function(e){return!w.contains(n,e)})},w.without=function(e){return w.difference(e,o.call(arguments,1))},w.indexOf=function(e,t,n){if(null==e)return-1;var i=0,o=e.length;if(n){if("number"!=typeof n)return i=w.sortedIndex(e,t),e[i]===t?i:-1;i=n<0?Math.max(0,o+n):n}if(f&&e.indexOf===f)return e.indexOf(t,n);for(;i<o;i++)if(e[i]===t)return i;return-1};var L=function(){};w.bind=function(e,t){var n,i;if(v&&e.bind===v)return v.apply(e,o.call(arguments,1));if(!w.isFunction(e))throw new TypeError;return n=o.call(arguments,2),i=function(){if(!(this instanceof i))return e.apply(t,n.concat(o.call(arguments)));L.prototype=e.prototype;var r=new L;L.prototype=null;var a=e.apply(r,n.concat(o.call(arguments)));return Object(a)===a?a:r}},w.partial=function(e){var t=o.call(arguments,1);return function(){for(var n=0,i=t.slice(),o=0,r=i.length;o<r;o++)i[o]===w&&(i[o]=arguments[n++]);for(;n<arguments.length;)i.push(arguments[n++]);return e.apply(this,i)}},w.once=w.partial(w.before,2),w.memoize=function(e,t){var n={};return t||(t=w.identity),function(){var i=t.apply(this,arguments);return w.has(n,i)?n[i]:n[i]=e.apply(this,arguments)}},w.delay=function(e,t){var n=o.call(arguments,2);return setTimeout(function(){return e.apply(null,n)},t)},w.defer=function(e){return w.delay.apply(w,[e,1].concat(o.call(arguments,1)))},w.throttle=function(e,t,n){var i,o,r,a=null,s=0;n||(n={});var l=function(){s=n.leading===!1?0:w.now(),a=null,r=e.apply(i,o),i=o=null};return function(){var c=w.now();s||n.leading!==!1||(s=c);var u=t-(c-s);return i=this,o=arguments,u<=0?(clearTimeout(a),a=null,s=c,r=e.apply(i,o),i=o=null):a||n.trailing===!1||(a=setTimeout(l,u)),r}},w.keys=function(e){if(!w.isObject(e))return[];if(m)return m(e);var t=[];for(var n in e)w.has(e,n)&&t.push(n);return t},w.invert=function(e){for(var t={},n=w.keys(e),i=0,o=n.length;i<o;i++)t[e[n[i]]]=n[i];return t},w.defaults=function(e){return y(o.call(arguments,1),function(t){if(t)for(var n in t)void 0===e[n]&&(e[n]=t[n])}),e},w.extend=function(e){return y(o.call(arguments,1),function(t){if(t)for(var n in t)e[n]=t[n]}),e},w.pick=function(e){var n={},i=r.apply(t,o.call(arguments,1));return y(i,function(t){t in e&&(n[t]=e[t])}),n},w.omit=function(e){var n={},i=r.apply(t,o.call(arguments,1));for(var a in e)w.contains(i,a)||(n[a]=e[a]);return n},w.clone=function(e){return w.isObject(e)?w.isArray(e)?e.slice():w.extend({},e):e},w.isArray=g||function(e){return"[object Array]"==a.call(e)},w.isObject=function(e){return e===Object(e)},y(["Arguments","Function","String","Number","Date","RegExp"],function(e){w["is"+e]=function(t){return a.call(t)=="[object "+e+"]"}}),w.isArguments(arguments)||(w.isArguments=function(e){return!(!e||!w.has(e,"callee"))}),w.isFunction=function(e){return"function"==typeof e},w.isFinite=function(e){return isFinite(e)&&!isNaN(parseFloat(e))},w.isNaN=function(e){return w.isNumber(e)&&e!=+e},w.isBoolean=function(e){return e===!0||e===!1||"[object Boolean]"==a.call(e)},w.isNull=function(e){return null===e},w.isUndefined=function(e){return void 0===e},w.has=function(e,t){return s.call(e,t)},w.identity=function(e){return e},w.constant=function(e){return function(){return e}},w.property=function(e){return function(t){return t[e]}},w.propertyOf=function(e){return null==e?function(){}:function(t){return e[t]}},w.matches=function(e){return function(t){if(t===e)return!0;for(var n in e)if(e[n]!==t[n])return!1;return!0}},w.now=Date.now||function(){return(new Date).getTime()},w.result=function(e,t){if(null!=e){var n=e[t];return w.isFunction(n)?n.call(e):n}};var A=0;return w.uniqueId=function(e){var t=++A+"";return e?e+t:t},w}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(8),n(1),n(44),n(77),n(29),n(45),n(21),n(76),n(46),n(79),n(184)],o=function(e,t,n,i,o,r,a,s,l,c,u){var d={};return d.log=function(){window.console&&("object"==typeof console.log?console.log(Array.prototype.slice.call(arguments,0)):console.log.apply(console,arguments))},d.between=function(e,t,n){return Math.max(Math.min(e,n),t)},d.foreach=function(e,t){var n,i;for(n in e)"function"===d.typeOf(e.hasOwnProperty)?e.hasOwnProperty(n)&&(i=e[n],t(n,i)):(i=e[n],t(n,i))},d.indexOf=t.indexOf,d.noop=function(){},d.seconds=e.seconds,d.prefix=e.prefix,d.suffix=e.suffix,t.extend(d,r,a,l,n,s,i,o,c,u),d}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1)],o=function(e){var t=[],n=t.slice,i={on:function(e,t,n){if(!r(this,"on",e,[t,n])||!t)return this;this._events||(this._events={});var i=this._events[e]||(this._events[e]=[]);return i.push({callback:t,context:n}),this},once:function(t,n,i){if(!r(this,"once",t,[n,i])||!n)return this;var o=this,a=e.once(function(){o.off(t,a),n.apply(this,arguments)});return a._callback=n,this.on(t,a,i)},off:function(t,n,i){var o,a,s,l,c,u,d,p;if(!this._events||!r(this,"off",t,[n,i]))return this;if(!t&&!n&&!i)return this._events=void 0,this;for(l=t?[t]:e.keys(this._events),c=0,u=l.length;c<u;c++)if(t=l[c],s=this._events[t]){if(this._events[t]=o=[],n||i)for(d=0,p=s.length;d<p;d++)a=s[d],(n&&n!==a.callback&&n!==a.callback._callback||i&&i!==a.context)&&o.push(a);o.length||delete this._events[t]}return this},trigger:function(e){if(!this._events)return this;var t=n.call(arguments,1);if(!r(this,"trigger",e,t))return this;var i=this._events[e],o=this._events.all;return i&&a(i,t,this),o&&a(o,arguments,this),this},triggerSafe:function(e){if(!this._events)return this;var t=n.call(arguments,1);if(!r(this,"trigger",e,t))return this;var i=this._events[e],o=this._events.all;return i&&s(i,t,this),o&&s(o,arguments,this),this}},o=/\s+/,r=function(e,t,n,i){if(!n)return!0;if("object"==typeof n){for(var r in n)e[t].apply(e,[r,n[r]].concat(i));return!1}if(o.test(n)){for(var a=n.split(o),s=0,l=a.length;s<l;s++)e[t].apply(e,[a[s]].concat(i));return!1}return!0},a=function(e,t,n){var i,o=-1,r=e.length,a=t[0],s=t[1],l=t[2];switch(t.length){case 0:for(;++o<r;)(i=e[o]).callback.call(i.context||n);return;case 1:for(;++o<r;)(i=e[o]).callback.call(i.context||n,a);return;case 2:for(;++o<r;)(i=e[o]).callback.call(i.context||n,a,s);return;case 3:for(;++o<r;)(i=e[o]).callback.call(i.context||n,a,s,l);return;default:for(;++o<r;)(i=e[o]).callback.apply(i.context||n,t);return}},s=function(e,t,n){for(var i,o=-1,r=e.length;++o<r;)try{(i=e[o]).callback.apply(i.context||n,t)}catch(a){}};return i}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[],o=function(){var e={DRAG:"drag",DRAG_START:"dragStart",DRAG_END:"dragEnd",CLICK:"click",DOUBLE_CLICK:"doubleClick",TAP:"tap",DOUBLE_TAP:"doubleTap",OVER:"over",MOVE:"move",OUT:"out"},t={COMPLETE:"complete",ERROR:"error",JWPLAYER_AD_CLICK:"adClick",JWPLAYER_AD_COMPANIONS:"adCompanions",JWPLAYER_AD_COMPLETE:"adComplete",JWPLAYER_AD_ERROR:"adError",JWPLAYER_AD_IMPRESSION:"adImpression",JWPLAYER_AD_META:"adMeta",JWPLAYER_AD_PAUSE:"adPause",JWPLAYER_AD_PLAY:"adPlay",JWPLAYER_AD_SKIPPED:"adSkipped",JWPLAYER_AD_TIME:"adTime",JWPLAYER_CAST_AD_CHANGED:"castAdChanged",JWPLAYER_MEDIA_COMPLETE:"complete",JWPLAYER_READY:"ready",JWPLAYER_MEDIA_SEEK:"seek",JWPLAYER_MEDIA_BEFOREPLAY:"beforePlay",JWPLAYER_MEDIA_BEFORECOMPLETE:"beforeComplete",JWPLAYER_MEDIA_BUFFER_FULL:"bufferFull",JWPLAYER_DISPLAY_CLICK:"displayClick",JWPLAYER_PLAYLIST_COMPLETE:"playlistComplete",JWPLAYER_CAST_SESSION:"cast",JWPLAYER_MEDIA_ERROR:"mediaError",JWPLAYER_MEDIA_FIRST_FRAME:"firstFrame",JWPLAYER_MEDIA_PLAY_ATTEMPT:"playAttempt",JWPLAYER_MEDIA_LOADED:"loaded",JWPLAYER_MEDIA_SEEKED:"seeked",JWPLAYER_SETUP_ERROR:"setupError",JWPLAYER_ERROR:"error",JWPLAYER_PLAYER_STATE:"state",JWPLAYER_CAST_AVAILABLE:"castAvailable",JWPLAYER_MEDIA_BUFFER:"bufferChange",JWPLAYER_MEDIA_TIME:"time",JWPLAYER_MEDIA_TYPE:"mediaType",JWPLAYER_MEDIA_VOLUME:"volume",JWPLAYER_MEDIA_MUTE:"mute",JWPLAYER_MEDIA_META:"meta",JWPLAYER_MEDIA_LEVELS:"levels",JWPLAYER_MEDIA_LEVEL_CHANGED:"levelsChanged",JWPLAYER_CONTROLS:"controls",JWPLAYER_FULLSCREEN:"fullscreen",JWPLAYER_RESIZE:"resize",JWPLAYER_PLAYLIST_ITEM:"playlistItem",JWPLAYER_PLAYLIST_LOADED:"playlist",JWPLAYER_AUDIO_TRACKS:"audioTracks",JWPLAYER_AUDIO_TRACK_CHANGED:"audioTrackChanged",JWPLAYER_LOGO_CLICK:"logoClick",JWPLAYER_CAPTIONS_LIST:"captionsList",JWPLAYER_CAPTIONS_CHANGED:"captionsChanged",JWPLAYER_PROVIDER_CHANGED:"providerChanged",JWPLAYER_PROVIDER_FIRST_FRAME:"providerFirstFrame",JWPLAYER_USER_ACTION:"userAction",JWPLAYER_PROVIDER_CLICK:"providerClick",JWPLAYER_VIEW_TAB_FOCUS:"tabFocus",JWPLAYER_CONTROLBAR_DRAGGING:"scrubbing",JWPLAYER_INSTREAM_CLICK:"instreamClick"};return t.touchEvents=e,t}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[],o=function(){return{BUFFERING:"buffering",IDLE:"idle",COMPLETE:"complete",PAUSED:"paused",PLAYING:"playing",ERROR:"error",LOADING:"loading",STALLED:"stalled"}}.apply(t,i),!(void 0!==o&&(e.exports=o))},,,function(e,t,n){var i,o;i=[n(1)],o=function(e){function t(e){return!!/[\(,]format=m3u8-/i.test(e)&&"m3u8"}var n=function(e){return e.replace(/^\s+|\s+$/g,"")},i=function(e,t,n){for(e=""+e,n=n||"0";e.length<t;)e=n+e;return e},o=function(e,t){for(var n=0;n<e.attributes.length;n++)if(e.attributes[n].name&&e.attributes[n].name.toLowerCase()===t.toLowerCase())return e.attributes[n].value.toString();return""},r=function(e){if(!e||"rtmp"===e.substr(0,4))return"";var n=t(e);return n?n:(e=e.split("?")[0].split("#")[0],e.lastIndexOf(".")>-1?e.substr(e.lastIndexOf(".")+1,e.length).toLowerCase():void 0)},a=function(e){var t=parseInt(e/3600),n=parseInt(e/60)%60,o=e%60;return i(t,2)+":"+i(n,2)+":"+i(o.toFixed(3),6)},s=function(t,n){if(e.isNumber(t))return t;t=t.replace(",",".");var i=t.split(":"),o=i.length,r=0;if("s"===t.slice(-1))r=parseFloat(t);else if("m"===t.slice(-1))r=60*parseFloat(t);else if("h"===t.slice(-1))r=3600*parseFloat(t);else if(o>1){var a=o-1;4===o&&(n&&(r=parseFloat(i[a])/n),a-=1),r+=parseFloat(i[a]),r+=60*parseFloat(i[a-1]),o>=3&&(r+=3600*parseFloat(i[a-2]))}else r=parseFloat(t);return r},l=function(t,n){return e.map(t,function(e){return n+e})},c=function(t,n){return e.map(t,function(e){return e+n})};return{trim:n,pad:i,xmlAttribute:o,extension:r,hms:a,seconds:s,suffix:c,prefix:l}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(3),n(4),n(1),n(2)],o=function(e,t,n,i){function o(e,t){return/touch/.test(e.type)?(e.originalEvent||e).changedTouches[0]["page"+t]:e["page"+t]}function r(e){var t=e||window.event;return e instanceof MouseEvent&&("which"in t?3===t.which:"button"in t&&2===t.button)}function a(e,t,n){var i;return i=t instanceof MouseEvent||!t.touches&&!t.changedTouches?t:t.touches&&t.touches.length?t.touches[0]:t.changedTouches[0],{type:e,target:t.target,currentTarget:n,pageX:i.pageX,pageY:i.pageY}}function s(e){(e instanceof MouseEvent||e instanceof window.TouchEvent)&&(e.preventManipulation&&e.preventManipulation(),e.cancelable&&e.preventDefault&&e.preventDefault())}var l=!n.isUndefined(window.PointerEvent),c=!l&&i.isMobile(),u=!l&&!c,d=i.isFF()&&i.isOSX(),p=function(e,i){function c(e){(u||l&&"touch"!==e.pointerType)&&v(t.touchEvents.OVER,e)}function p(e){(u||l&&"touch"!==e.pointerType)&&v(t.touchEvents.MOVE,e)}function h(n){(u||l&&"touch"!==n.pointerType&&!e.contains(document.elementFromPoint(n.x,n.y)))&&v(t.touchEvents.OUT,n)}function f(t){w=t.target,E=o(t,"X"),k=o(t,"Y"),r(t)||(l?t.isPrimary&&(i.preventScrolling&&(y=t.pointerId,e.setPointerCapture(y)),e.addEventListener("pointermove",g),e.addEventListener("pointercancel",m),e.addEventListener("pointerup",m)):u&&(document.addEventListener("mousemove",g),d&&"object"===t.target.nodeName.toLowerCase()?e.addEventListener("click",m):document.addEventListener("mouseup",m)),w.addEventListener("touchmove",g),w.addEventListener("touchcancel",m),w.addEventListener("touchend",m))}function g(e){var n=t.touchEvents,r=6;if(b)v(n.DRAG,e);else{var a=o(e,"X"),l=o(e,"Y"),c=a-E,u=l-k;c*c+u*u>r*r&&(v(n.DRAG_START,e),b=!0,v(n.DRAG,e))}i.preventScrolling&&s(e)}function m(n){var o=t.touchEvents;l?(i.preventScrolling&&e.releasePointerCapture(y),e.removeEventListener("pointermove",g),e.removeEventListener("pointercancel",m),e.removeEventListener("pointerup",m)):u&&(document.removeEventListener("mousemove",g),document.removeEventListener("mouseup",m)),w.removeEventListener("touchmove",g),w.removeEventListener("touchcancel",m),w.removeEventListener("touchend",m),b?v(o.DRAG_END,n):i.directSelect&&n.target!==e||n.type.indexOf("cancel")!==-1||(l&&n instanceof window.PointerEvent?"touch"===n.pointerType?v(o.TAP,n):v(o.CLICK,n):u?v(o.CLICK,n):(v(o.TAP,n),s(n))),w=null,b=!1}function v(e,o){var r;if(i.enableDoubleTap&&(e===t.touchEvents.CLICK||e===t.touchEvents.TAP))if(n.now()-L<A){var s=e===t.touchEvents.CLICK?t.touchEvents.DOUBLE_CLICK:t.touchEvents.DOUBLE_TAP;r=a(s,o,j),C.trigger(s,r),L=0}else L=n.now();r=a(e,o,j),C.trigger(e,r)}var w,y,j=e,b=!1,E=0,k=0,L=0,A=300;i=i||{},l?(e.addEventListener("pointerdown",f),i.useHover&&(e.addEventListener("pointerover",c),e.addEventListener("pointerout",h)),i.useMove&&e.addEventListener("pointermove",p)):u&&(e.addEventListener("mousedown",f),i.useHover&&(e.addEventListener("mouseover",c),e.addEventListener("mouseout",h)),i.useMove&&e.addEventListener("mousemove",p)),e.addEventListener("touchstart",f);var C=this;return this.triggerEvent=v,this.destroy=function(){e.removeEventListener("touchstart",f),e.removeEventListener("mousedown",f),w&&(w.removeEventListener("touchmove",g),w.removeEventListener("touchcancel",m),w.removeEventListener("touchend",m)),l&&(i.preventScrolling&&e.releasePointerCapture(y),e.removeEventListener("pointerover",c),e.removeEventListener("pointerdown",f),e.removeEventListener("pointermove",g),e.removeEventListener("pointermove",p),e.removeEventListener("pointercancel",m),e.removeEventListener("pointerout",h),e.removeEventListener("pointerup",m)),e.removeEventListener("click",m),e.removeEventListener("mouseover",c),e.removeEventListener("mousemove",p),e.removeEventListener("mouseout",h),document.removeEventListener("mousemove",g),document.removeEventListener("mouseup",m)},this};return n.extend(p.prototype,e),p}.apply(t,i),!(void 0!==o&&(e.exports=o))},,function(e,t,n){e.exports=n(142)["default"]},function(e,t){"use strict";function n(e){return u[e]}function i(e){for(var t=1;t<arguments.length;t++)for(var n in arguments[t])Object.prototype.hasOwnProperty.call(arguments[t],n)&&(e[n]=arguments[t][n]);return e}function o(e,t){for(var n=0,i=e.length;n<i;n++)if(e[n]===t)return n;return-1}function r(e){if("string"!=typeof e){if(e&&e.toHTML)return e.toHTML();if(null==e)return"";if(!e)return e+"";e=""+e}return p.test(e)?e.replace(d,n):e}function a(e){return!e&&0!==e||!(!g(e)||0!==e.length)}function s(e){var t=i({},e);return t._parent=e,t}function l(e,t){return e.path=t,e}function c(e,t){return(e?e+".":"")+t}t.__esModule=!0,t.extend=i,t.indexOf=o,t.escapeExpression=r,t.isEmpty=a,t.createFrame=s,t.blockParams=l,t.appendContextPath=c;var u={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;","=":"&#x3D;"},d=/[&<>"'`=]/g,p=/[&<>"'`=]/,h=Object.prototype.toString;t.toString=h;var f=function(e){return"function"==typeof e};f(/x/)&&(t.isFunction=f=function(e){return"function"==typeof e&&"[object Function]"===h.call(e)}),t.isFunction=f;var g=Array.isArray||function(e){return!(!e||"object"!=typeof e)&&"[object Array]"===h.call(e)};t.isArray=g},,function(e,t,n){var i,o;i=[n(8)],o=function(e){return{localName:function(e){return e?e.localName?e.localName:e.baseName?e.baseName:"":""},textContent:function(t){return t?t.textContent?e.trim(t.textContent):t.text?e.trim(t.text):"":""},getChildNode:function(e,t){return e.childNodes[t]},numChildren:function(e){return e.childNodes?e.childNodes.length:0}}}.apply(t,i),!(void 0!==o&&(e.exports=o))},,,,,function(e,t,n){var i,o;i=[n(2),n(8)],o=function(e,t){function n(e){var t={},n=e.split("\r\n");1===n.length&&(n=e.split("\n"));var o=1;if(n[0].indexOf(" --> ")>0&&(o=0),n.length>o+1&&n[o+1]){var r=n[o],a=r.indexOf(" --> ");a>0&&(t.begin=i(r.substr(0,a)),t.end=i(r.substr(a+5)),t.text=n.slice(o+1).join("\r\n"))}return t}var i=e.seconds;return function(e){var i=[];e=t.trim(e);var o=e.split("\r\n\r\n");1===o.length&&(o=e.split("\n\n"));for(var r=0;r<o.length;r++)if("WEBVTT"!==o[r]){var a=n(o[r]);a.text&&i.push(a)}return i}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(2),n(4),n(5),n(1)],o=function(e,t,n,i){var o=e.noop,r=i.constant(!1),a={supports:r,play:o,load:o,stop:o,volume:o,mute:o,seek:o,resize:o,remove:o,destroy:o,setVisibility:o,setFullscreen:r,getFullscreen:o,getContainer:o,setContainer:r,getName:o,getQualityLevels:o,getCurrentQuality:o,setCurrentQuality:o,getAudioTracks:o,getCurrentAudioTrack:o,setCurrentAudioTrack:o,checkComplete:o,setControls:o,attachMedia:o,detachMedia:o,setState:function(e){var i=this.state||n.IDLE;this.state=e,e!==i&&this.trigger(t.JWPLAYER_PLAYER_STATE,{newstate:e})},sendMediaType:function(e){var n=e[0].type,i="oga"===n||"aac"===n||"mp3"===n||"mpeg"===n||"vorbis"===n;this.trigger(t.JWPLAYER_MEDIA_TYPE,{mediaType:i?"audio":"video"})}};return a}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1)],o=function(e){var t={},n={TIT2:"title",TT2:"title",WXXX:"url",TPE1:"artist",TP1:"artist",TALB:"album",TAL:"album"};return t.utf8ArrayToStr=function(e,t){var n,i,o,r,a,s;for(n="",o=e.length,i=t||0;i<o;)if(r=e[i++],0!==r&&3!==r)switch(r>>4){case 0:case 1:case 2:case 3:case 4:case 5:case 6:case 7:n+=String.fromCharCode(r);break;case 12:case 13:a=e[i++],n+=String.fromCharCode((31&r)<<6|63&a);break;case 14:a=e[i++],s=e[i++],n+=String.fromCharCode((15&r)<<12|(63&a)<<6|(63&s)<<0)}return n},t.utf16BigEndianArrayToStr=function(e,t){var n,i,o;for(n="",o=e.length-1,i=t||0;i<o;)254===e[i]&&255===e[i+1]||(n+=String.fromCharCode((e[i]<<8)+e[i+1])),i+=2;return n},t.syncSafeInt=function(e){var n=t.arrayToInt(e);return 127&n|(32512&n)>>1|(8323072&n)>>2|(2130706432&n)>>3},t.arrayToInt=function(e){for(var t="0x",n=0;n<e.length;n++)t+=e[n].toString(16);return parseInt(t)},t.parseID3=function(i){return e.reduce(i,function(i,o){if(!("value"in o)&&"data"in o&&o.data instanceof ArrayBuffer){var r=o,a=new Uint8Array(r.data),s=a.length;o={value:{key:"",data:""}};for(var l=10;l<14&&l<a.length&&0!==a[l];)o.value.key+=String.fromCharCode(a[l]),l++;var c=19,u=a[c];3!==u&&0!==u||(u=a[++c],s--);var d=0;if(1!==u&&2!==u)for(var p=c+1;p<s;p++)if(0===a[p]){d=p-c;break}if(d>0){var h=t.utf8ArrayToStr(a.subarray(c,c+=d),0);if("PRIV"===o.value.key){if("com.apple.streaming.transportStreamTimestamp"===h){var f=1&t.syncSafeInt(a.subarray(c,c+=4)),g=t.syncSafeInt(a.subarray(c,c+=4));f&&(g+=4294967296),o.value.data=g}else o.value.data=t.utf8ArrayToStr(a,c+1);o.value.info=h}else o.value.info=h,o.value.data=t.utf8ArrayToStr(a,c+1)}else{var m=a[c];1===m||2===m?o.value.data=t.utf16BigEndianArrayToStr(a,c+1):o.value.data=t.utf8ArrayToStr(a,c+1)}}if(n.hasOwnProperty(o.value.key)&&(i[n[o.value.key]]=o.value.data),o.value.info){var v=i[o.value.key];e.isObject(v)||(v={},i[o.value.key]=v),v[o.value.info]=o.value.data}else i[o.value.key]=o.value.data;return i},{})},t}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(4),n(3),n(1)],o=function(e,t,n){var i={},o={NEW:0,LOADING:1,ERROR:2,COMPLETE:3},r=function(r,a){function s(t){u=o.ERROR,c.trigger(e.ERROR,t)}function l(t){u=o.COMPLETE,c.trigger(e.COMPLETE,t)}var c=n.extend(this,t),u=o.NEW;this.addEventListener=this.on,this.removeEventListener=this.off,this.makeStyleLink=function(e){var t=document.createElement("link");return t.type="text/css",t.rel="stylesheet",t.href=e,t},this.makeScriptTag=function(e){var t=document.createElement("script");return t.src=e,t},this.makeTag=a?this.makeStyleLink:this.makeScriptTag,this.load=function(){if(u===o.NEW){var t=i[r];if(t&&(u=t.getStatus(),u<2))return t.on(e.ERROR,s),void t.on(e.COMPLETE,l);var n=document.getElementsByTagName("head")[0]||document.documentElement,c=this.makeTag(r),d=!1;c.onload=c.onreadystatechange=function(e){d||this.readyState&&"loaded"!==this.readyState&&"complete"!==this.readyState||(d=!0,l(e),c.onload=c.onreadystatechange=null,n&&c.parentNode&&!a&&n.removeChild(c))},c.onerror=s,n.insertBefore(c,n.firstChild),u=o.LOADING,i[r]=this}},this.getStatus=function(){return u}};return r.loaderstatus=o,r}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1)],o=function(e){var t="free",n="premium",i="enterprise",o="platinum",r="ads",a="unlimited",s="trial",l={setup:[t,n,i,r,a,s,o],dash:[n,i,r,a,s,o],drm:[i,r,a,s],hls:[n,r,i,a,s,o],ads:[r,a,s,o,i],casting:[n,i,r,a,s,o],jwpsrv:[t,n,i,r,s,o]},c=function(t){return function(n){return e.contains(l[n],t)}};return c}.apply(t,i),!(void 0!==o&&(e.exports=o))},,,function(e,t){"use strict";function n(e,t){var o=t&&t.loc,r=void 0,a=void 0;o&&(r=o.start.line,a=o.start.column,e+=" - "+r+":"+a);for(var s=Error.prototype.constructor.call(this,e),l=0;l<i.length;l++)this[i[l]]=s[i[l]];Error.captureStackTrace&&Error.captureStackTrace(this,n),o&&(this.lineNumber=r,this.column=a)}t.__esModule=!0;var i=["description","fileName","lineNumber","message","name","number","stack"];n.prototype=new Error,t["default"]=n,e.exports=t["default"]},function(e,t,n){var i,o;i=[n(175),n(176),n(69),n(34)],o=function(e,t,n,i){var o={},r={},a=function(n,i){return r[n]=new e(new t(o),i),r[n]},s=function(e,t,r,a){var s=i.getPluginName(e);o[s]||(o[s]=new n(e)),o[s].registerPlugin(e,t,r,a)};return{loadPlugins:a,registerPlugin:s}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[],o=function(){return{repo:"http://ssl.p.jwpcdn.com/player/v/",SkinsIncluded:["seven"],SkinsLoadable:["beelden","bekle","five","glow","roundster","six","stormtrooper","vapor"],dvrSeekLimit:-25}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(8),n(85)],o=function(e,t){function n(e){e=e.split("-");for(var t=1;t<e.length;t++)e[t]=e[t].charAt(0).toUpperCase()+e[t].slice(1);return e.join("")}function i(t,n,i){if(""===n||void 0===n||null===n)return"";var o=i?" !important":"";return"string"==typeof n&&isNaN(n)?/png|gif|jpe?g/i.test(n)&&n.indexOf("url")<0?"url("+n+")":n+o:0===n||"z-index"===t||"opacity"===t?""+n+o:/color/i.test(t)?"#"+e.pad(n.toString(16).replace(/^0x/i,""),6)+o:Math.ceil(n)+"px"+o}var o=function(e,n,i){i=i||"all-players";var o="";if("object"==typeof n){var a=document.createElement("div");r(a,n),o="{"+a.style.cssText+"}"}else"string"==typeof n&&(o=n);t.style([[e,e+o]],i)},r=function(e,t){if(void 0!==e&&null!==e){void 0===e.length&&(e=[e]);var o,r={};for(o in t)r[o]=i(o,t[o]);for(var a=0;a<e.length;a++){var s,l=e[a];if(void 0!==l&&null!==l)for(o in r)s=n(o),l.style[s]!==r[o]&&(l.style[s]=r[o])}}},a=function(e,t){r(e,{transform:t,webkitTransform:t,msTransform:t,mozTransform:t,oTransform:t})},s=function(e,t){var n="rgb";e?(e=String(e).replace("#",""),3===e.length&&(e=e[0]+e[0]+e[1]+e[1]+e[2]+e[2])):e="000000";var i=[parseInt(e.substr(0,2),16),parseInt(e.substr(2,2),16),parseInt(e.substr(4,2),16)];return void 0!==t&&100!==t&&(n+="a",i.push(t/100)),n+"("+i.join(",")+")"};return{css:o,style:r,clearCss:t.clear,transform:a,hexToRgba:s}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(44)],o=function(e){return function(t){return t.indexOf("flash")===-1&&(e.isChrome()||e.isIOS()||e.isSafari()||e.isEdge())}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[],o=function(){return"7.6.1+commercial_v7-6-1.116.commercial.54b551.jwplayer.9a3f48.googima.258d99.vast.020d0f.analytics.213ba9.plugin-gapro.6c22bd.plugin-related.5992d3.plugin-sharing.135631"}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(78),n(2)],o=function(e,t){var n=e.extend({constructor:function(e,t,n){this.el=document.createElement("div"),this.el.className="jw-icon jw-icon-tooltip "+e+" jw-button-color jw-reset jw-hidden",t&&(this.el.setAttribute("tabindex","0"),this.el.setAttribute("role","button"),this.el.setAttribute("aria-label",t)),n===!0?this.el.setAttribute("aria-hidden","false"):this.el.setAttribute("aria-hidden","true"),this.container=document.createElement("div"),this.container.className="jw-overlay jw-reset",this.openClass="jw-open",this.componentType="tooltip",this.el.appendChild(this.container)},addContent:function(e){this.content&&this.removeContent(),this.content=e,this.container.appendChild(e)},removeContent:function(){this.content&&(this.container.removeChild(this.content),this.content=null)},hasContent:function(){return!!this.content},element:function(){return this.el},openTooltip:function(e){this.trigger("open-"+this.componentType,e,{isOpen:!0}),this.isOpen=!0,t.toggleClass(this.el,this.openClass,this.isOpen)},closeTooltip:function(e){this.trigger("close-"+this.componentType,e,{isOpen:!1}),this.isOpen=!1,t.toggleClass(this.el,this.openClass,this.isOpen)},toggleOpenState:function(e){this.isOpen?this.closeTooltip(e):this.openTooltip(e)}});return n}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(2),n(51),n(168),n(1),n(3),n(183),n(4),n(5)],o=function(e,t,n,i,o,r,a,s){var l=function(){function r(e,t){var n=i.extend({},t,{type:e});switch(e){case"flashThrottle":var o="resume"!==t.state;this.set("flashThrottle",o),this.set("flashBlocked",o);break;case"flashBlocked":return void this.set("flashBlocked",!0);case"flashUnblocked":return void this.set("flashBlocked",!1);case"volume":case"mute":return void this.set(e,t[e]);case a.JWPLAYER_MEDIA_TYPE:return void(this.mediaModel.get("mediaType")!==t.mediaType&&(this.mediaModel.set("mediaType",t.mediaType),this.mediaController.trigger(e,n)));case a.JWPLAYER_PLAYER_STATE:return void this.mediaModel.set("state",t.newstate);case a.JWPLAYER_MEDIA_BUFFER:this.set("buffer",t.bufferPercent);case a.JWPLAYER_MEDIA_META:var r=t.duration;i.isNumber(r)&&!i.isNaN(r)&&(this.mediaModel.set("duration",r),this.set("duration",r));break;case a.JWPLAYER_MEDIA_BUFFER_FULL:this.mediaModel.get("playAttempt")?this.playVideo():this.mediaModel.on("change:playAttempt",function(){this.playVideo()},this);break;case a.JWPLAYER_MEDIA_TIME:this.mediaModel.set("position",t.position),this.set("position",t.position),i.isNumber(t.duration)&&(this.mediaModel.set("duration",t.duration),this.set("duration",t.duration));break;case a.JWPLAYER_PROVIDER_CHANGED:this.set("provider",u.getName());break;case a.JWPLAYER_MEDIA_LEVELS:this.setQualityLevel(t.currentQuality,t.levels),this.mediaModel.set("levels",t.levels);break;case a.JWPLAYER_MEDIA_LEVEL_CHANGED:this.setQualityLevel(t.currentQuality,t.levels),this.persistQualityLevel(t.currentQuality,t.levels);break;case a.JWPLAYER_AUDIO_TRACKS:this.setCurrentAudioTrack(t.currentTrack,t.tracks),this.mediaModel.set("audioTracks",t.tracks);break;case a.JWPLAYER_AUDIO_TRACK_CHANGED:this.setCurrentAudioTrack(t.currentTrack,t.tracks);break;case"subtitlesTrackChanged":this.persistVideoSubtitleTrack(t.currentTrack,t.tracks);break;case"visualQuality":var s=i.extend({},t);this.mediaModel.set("visualQuality",s)}this.mediaController.trigger(e,n)}var l,u,d=this,p=e.noop;this.mediaController=i.extend({},o),this.mediaModel=new c,n.model(this),this.set("mediaModel",this.mediaModel),this.setup=function(t){return i.extend(this.attributes,t,{item:0,state:s.IDLE,flashBlocked:!1,fullscreen:!1,compactUI:!1,scrubbing:!1,duration:0,position:0,buffer:0}),e.isMobile()&&!t.mobileSdk&&this.set("autostart",!1),this.updateProviders(),this},this.getConfiguration=function(){return i.omit(this.clone(),["mediaModel"])},this.updateProviders=function(){l=new t(this.getConfiguration())},this.setQualityLevel=function(e,t){e>-1&&t.length>1&&"youtube"!==u.getName().name&&this.mediaModel.set("currentLevel",parseInt(e));
	},this.persistQualityLevel=function(e,t){var n=t[e]||{},i=n.label;this.set("qualityLabel",i)},this.setCurrentAudioTrack=function(e,t){e>-1&&t.length>0&&e<t.length&&this.mediaModel.set("currentAudioTrack",parseInt(e))},this.onMediaContainer=function(){var e=this.get("mediaContainer");p.setContainer(e)},this.changeVideoProvider=function(e){if(this.off("change:mediaContainer",this.onMediaContainer),u&&(u.off(null,null,this),u.getContainer()&&u.remove(),delete u.instreamMode),!e)return u=p=e,void this.set("provider",void 0);p=new e(d.get("id"),d.getConfiguration());var t=this.get("mediaContainer");t?p.setContainer(t):this.once("change:mediaContainer",this.onMediaContainer),this.set("provider",p.getName()),p.getName().name.indexOf("flash")===-1&&(this.set("flashThrottle",void 0),this.set("flashBlocked",!1)),u=p,u.volume(d.get("volume")),u.mute(d.get("mute")),u.on("all",r,this),this.get("instreamMode")===!0&&(u.instreamMode=!0)},this.destroy=function(){this.off(),u&&(u.off(null,null,this),u.destroy())},this.getVideo=function(){return u},this.setFullscreen=function(e){e=!!e,e!==d.get("fullscreen")&&d.set("fullscreen",e)},this.chooseProvider=function(e){return l.choose(e).provider},this.setItemIndex=function(e){var t=this.get("playlist");e=parseInt(e,10)||0,e=(e+t.length)%t.length,this.set("item",e),this.set("playlistItem",t[e]),this.setActiveItem(t[e])},this.setActiveItem=function(e){this.mediaModel.off(),this.mediaModel=new c,this.set("mediaModel",this.mediaModel),this.set("position",e.starttime||0),this.set("duration",e.duration||0),this.setProvider(e)},this.setProvider=function(e){var t=e&&e.sources&&e.sources[0];if(void 0!==t){var n=this.chooseProvider(t);n&&p instanceof n||d.changeVideoProvider(n),p&&(p.init&&p.init(e),this.trigger("itemReady",e))}},this.getProviders=function(){return l},this.resetProvider=function(){p=null},this.setVolume=function(e){e=Math.round(e),this.set("volume",e),u&&u.volume(e);var t=0===e;t!==this.get("mute")&&this.setMute(t)},this.setMute=function(t){if(e.exists(t)||(t=!this.get("mute")),this.set("mute",t),u&&u.mute(t),!t){var n=Math.max(10,this.get("volume"));this.setVolume(n)}},this.loadVideo=function(e){if(!e){var t=this.get("item");e=this.get("playlist")[t]}this.set("position",e.starttime||0),this.set("duration",e.duration||0),this.mediaModel.set("playAttempt",!0),this.mediaController.trigger(a.JWPLAYER_MEDIA_PLAY_ATTEMPT,{playReason:this.get("playReason")}),u.load(e)},this.stopVideo=function(){u&&u.stop()},this.playVideo=function(){u.play()},this.persistCaptionsTrack=function(){var e=this.get("captionsTrack");e?this.set("captionLabel",e.label):this.set("captionLabel","Off")},this.setVideoSubtitleTrack=function(e,t){this.set("captionsIndex",e),e&&t&&e<=t.length&&t[e-1].data&&this.set("captionsTrack",t[e-1]),u&&u.setSubtitlesTrack&&u.setSubtitlesTrack(e)},this.persistVideoSubtitleTrack=function(e,t){this.setVideoSubtitleTrack(e,t),this.persistCaptionsTrack()}},c=l.MediaModel=function(){this.set("state",s.IDLE)};return i.extend(l.prototype,r),i.extend(c.prototype,r),l}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(8)],o=function(e){var t={},n=t.pluginPathType={ABSOLUTE:0,RELATIVE:1,CDN:2};return t.getPluginPathType=function(t){if("string"==typeof t){t=t.split("?")[0];var i=t.indexOf("://");if(i>0)return n.ABSOLUTE;var o=t.indexOf("/"),r=e.extension(t);return!(i<0&&o<0)||r&&isNaN(r)?n.RELATIVE:n.CDN}},t.getPluginName=function(e){return e.replace(/^(.*\/)?([^-]*)-?.*\.(swf|js)$/,"$2")},t.getPluginVersion=function(e){return e.replace(/[^-]*-?([^\.]*).*$/,"$1")},t}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[],o=function(){var e=window.chrome,t={};return t.NS="urn:x-cast:com.longtailvideo.jwplayer",t.debug=!1,t.availability=null,t.available=function(n){n=n||t.availability;var i="available";return e&&e.cast&&e.cast.ReceiverAvailability&&(i=e.cast.ReceiverAvailability.AVAILABLE),n===i},t.log=function(){if(t.debug){var e=Array.prototype.slice.call(arguments,0);console.log.apply(console,e)}},t.error=function(){var e=Array.prototype.slice.call(arguments,0);console.error.apply(console,e)},t}.apply(t,i),!(void 0!==o&&(e.exports=o))},,,,,,,function(e,t,n){var i,o;i=[n(5)],o=function(e){function t(t){return t===e.COMPLETE||t===e.ERROR?e.IDLE:t}return function(e,n,i){if(n=t(n),i=t(i),n!==i){var o=n.replace(/(?:ing|d)$/,""),r={type:o,newstate:n,oldstate:i,reason:e.mediaModel.get("state")};"play"===o&&(r.playReason=e.get("playReason")),this.trigger(o,r)}}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1),n(68),n(174)],o=function(e,t,n){var i={sources:[],tracks:[]},o=function(o){o=o||{},e.isArray(o.tracks)||delete o.tracks;var r=e.extend({},i,o);e.isObject(r.sources)&&!e.isArray(r.sources)&&(r.sources=[t(r.sources)]),e.isArray(r.sources)&&0!==r.sources.length||(o.levels?r.sources=o.levels:r.sources=[t(o)]);for(var a=0;a<r.sources.length;a++){var s=r.sources[a];if(s){var l=s["default"];l?s["default"]="true"===l.toString():s["default"]=!1,r.sources[a].label||(r.sources[a].label=a.toString()),r.sources[a]=t(r.sources[a])}}return r.sources=e.compact(r.sources),e.isArray(r.tracks)||(r.tracks=[]),e.isArray(r.captions)&&(r.tracks=r.tracks.concat(r.captions),delete r.captions),r.tracks=e.compact(e.map(r.tracks,n)),r};return o}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1)],o=function(e){function t(e){return function(){return i(e)}}var n={},i=e.memoize(function(e){var t=navigator.userAgent.toLowerCase();return null!==t.match(e)}),o=n.isInt=function(e){return parseFloat(e)%1===0};n.isFlashSupported=function(){var e=n.flashVersion();return e&&e>=11.2},n.isFF=t(/firefox/i),n.isIPod=t(/iP(hone|od)/i),n.isIPad=t(/iPad/i),n.isSafari602=t(/Macintosh.*Mac OS X 10_8.*6\.0\.\d* Safari/i),n.isOSX=t(/Mac OS X/i),n.isEdge=t(/\sedge\/\d+/i);var r=n.isIETrident=function(e){return!!n.isEdge()||(e?(e=parseFloat(e).toFixed(1),i(new RegExp("trident/.+rv:\\s*"+e,"i"))):i(/trident/i))},a=n.isMSIE=function(e){return e?(e=parseFloat(e).toFixed(1),i(new RegExp("msie\\s*"+e,"i"))):i(/msie/i)},s=t(/chrome/i);n.isChrome=function(){return s()&&!n.isEdge()},n.isIE=function(e){return e?(e=parseFloat(e).toFixed(1),e>=11?r(e):a(e)):a()||r()},n.isSafari=function(){return i(/safari/i)&&!i(/chrome/i)&&!i(/chromium/i)&&!i(/android/i)};var l=n.isIOS=function(e){return i(e?new RegExp("iP(hone|ad|od).+\\s(OS\\s"+e+"|.*\\sVersion/"+e+")","i"):/iP(hone|ad|od)/i)};n.isAndroidNative=function(e){return c(e,!0)};var c=n.isAndroid=function(e,t){return!(t&&i(/chrome\/[123456789]/i)&&!i(/chrome\/18/))&&(e?(o(e)&&!/\./.test(e)&&(e=""+e+"."),i(new RegExp("Android\\s*"+e,"i"))):i(/Android/i))};return n.isMobile=function(){return l()||c()},n.isIframe=function(){return window.frameElement&&"IFRAME"===window.frameElement.nodeName},n.flashVersion=function(){if(n.isAndroid())return 0;var e,t=navigator.plugins;if(t&&(e=t["Shockwave Flash"],e&&e.description))return parseFloat(e.description.replace(/\D+(\d+\.?\d*).*/,"$1"));if("undefined"!=typeof window.ActiveXObject){try{if(e=new window.ActiveXObject("ShockwaveFlash.ShockwaveFlash"))return parseFloat(e.GetVariable("$version").split(" ")[1].replace(/\s*,\s*/,"."))}catch(i){return 0}return e}return 0},n}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1),n(46)],o=function(e,t){function n(e){return/^(?:(?:https?|file)\:)?\/\//.test(e)}function i(t){return e.some(t,function(e){return"parsererror"===e.nodeName})}var o={};return o.getAbsolutePath=function(e,i){if(t.exists(i)||(i=document.location.href),t.exists(e)){if(n(e))return e;var o,r=i.substring(0,i.indexOf("://")+3),a=i.substring(r.length,i.indexOf("/",r.length+1));if(0===e.indexOf("/"))o=e.split("/");else{var s=i.split("?")[0];s=s.substring(r.length+a.length+1,s.lastIndexOf("/")),o=s.split("/").concat(e.split("/"))}for(var l=[],c=0;c<o.length;c++)o[c]&&t.exists(o[c])&&"."!==o[c]&&(".."===o[c]?l.pop():l.push(o[c]));return r+a+"/"+l.join("/")}},o.getScriptPath=e.memoize(function(e){for(var t=document.getElementsByTagName("script"),n=0;n<t.length;n++){var i=t[n].src;if(i&&i.indexOf(e)>=0)return i.substr(0,i.indexOf(e))}return""}),o.parseXML=function(e){var t=null;try{"DOMParser"in window?(t=(new window.DOMParser).parseFromString(e,"text/xml"),(i(t.childNodes)||t.childNodes&&i(t.childNodes[0].childNodes))&&(t=null)):(t=new window.ActiveXObject("Microsoft.XMLDOM"),t.async="false",t.loadXML(e))}catch(n){}return t},o.serialize=function(e){if(void 0===e)return null;if("string"==typeof e&&e.length<6){var t=e.toLowerCase();if("true"===t)return!0;if("false"===t)return!1;if(!isNaN(Number(e))&&!isNaN(parseFloat(e)))return Number(e)}return e},o.parseDimension=function(e){return"string"==typeof e?""===e?0:e.lastIndexOf("%")>-1?e:parseInt(e.replace("px",""),10):e},o.timeFormat=function(t,n){if(t<=0&&!n||e.isNaN(parseInt(t)))return"00:00";var i=t<0?"-":"";t=Math.abs(t);var o=Math.floor(t/3600),r=Math.floor((t-3600*o)/60),a=Math.floor(t%60);return i+(o?o+":":"")+(r<10?"0":"")+r+":"+(a<10?"0":"")+a},o.adaptiveType=function(e){if(0!==e){var t=-120;if(e<=t)return"DVR";if(e<0||e===1/0)return"LIVE"}return"VOD"},o}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1)],o=function(e){var t={};return t.exists=function(e){switch(typeof e){case"string":return e.length>0;case"object":return null!==e;case"undefined":return!1}return!0},t.isHTTPS=function(){return 0===window.location.href.indexOf("https")},t.isRtmp=function(e,t){return 0===e.indexOf("rtmp")||"rtmp"===t},t.isYouTube=function(e,t){return"youtube"===t||/^(http|\/\/).*(youtube\.com|youtu\.be)\/.+/.test(e)},t.youTubeID=function(e){var t=/v[=\/]([^?&]*)|youtu\.be\/([^?]*)|^([\w-]*)$/i.exec(e);return t?t.slice(1).join("").replace("?",""):""},t.typeOf=function(t){if(null===t)return"null";var n=typeof t;return"object"===n&&e.isArray(t)?"array":n},t}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(78),n(9),n(140),n(2)],o=function(e,t,n,i){var o=e.extend({constructor:function(e,t){this.className=e+" jw-background-color jw-reset",this.orientation=t,this.dragStartListener=this.dragStart.bind(this),this.dragMoveListener=this.dragMove.bind(this),this.dragEndListener=this.dragEnd.bind(this),this.tapListener=this.tap.bind(this),this.setup()},setup:function(){var e={"default":this["default"],className:this.className,orientation:"jw-slider-"+this.orientation};this.el=i.createElement(n(e)),this.elementRail=this.el.getElementsByClassName("jw-slider-container")[0],this.elementBuffer=this.el.getElementsByClassName("jw-buffer")[0],this.elementProgress=this.el.getElementsByClassName("jw-progress")[0],this.elementThumb=this.el.getElementsByClassName("jw-knob")[0],this.userInteract=new t(this.element(),{preventScrolling:!0}),this.userInteract.on("dragStart",this.dragStartListener),this.userInteract.on("drag",this.dragMoveListener),this.userInteract.on("dragEnd",this.dragEndListener),this.userInteract.on("tap click",this.tapListener)},dragStart:function(){this.trigger("dragStart"),this.railBounds=i.bounds(this.elementRail)},dragEnd:function(e){this.dragMove(e),this.trigger("dragEnd")},dragMove:function(e){var t,n,o=this.railBounds=this.railBounds?this.railBounds:i.bounds(this.elementRail);"horizontal"===this.orientation?(t=e.pageX,n=t<o.left?0:t>o.right?100:100*i.between((t-o.left)/o.width,0,1)):(t=e.pageY,n=t>=o.bottom?0:t<=o.top?100:100*i.between((o.height-(t-o.top))/o.height,0,1));var r=this.limit(n);return this.render(r),this.update(r),!1},tap:function(e){this.railBounds=i.bounds(this.elementRail),this.dragMove(e)},limit:function(e){return e},update:function(e){this.trigger("update",{percentage:e})},render:function(e){e=Math.max(0,Math.min(e,100)),"horizontal"===this.orientation?(this.elementThumb.style.left=e+"%",this.elementProgress.style.width=e+"%"):(this.elementThumb.style.bottom=e+"%",this.elementProgress.style.height=e+"%")},updateBuffer:function(e){this.elementBuffer.style.width=e+"%"},element:function(){return this.el}});return o}.apply(t,i),!(void 0!==o&&(e.exports=o))},,function(e,t,n){var i,o;i=[n(1),n(23)],o=function(e,t){var n=[{configName:"clearkey",keyName:"org.w3.clearkey"},{configName:"widevine",keyName:"com.widevine.alpha"},{configName:"playready",keyName:"com.microsoft.playready"}],i=[],o={},r=function(t){var n=t.get("playlist");return!!t.get("drm")||e.some(n,function(t){return!!t.drm||e.some(t.sources,function(e){return!!e.drm})})},a=function(t){return u()?t():(e.forEach(n,function(e){var t=navigator.requestMediaKeySystemAccess(e.keyName,[{}]).then(function(){o[e.configName]=!0})["catch"](function(){o[e.configName]=!1});i.push(t)}),Promise.all(i).then(t))},s=function(){return!!navigator.requestMediaKeySystemAccess&&!!MediaKeySystemAccess.prototype.getConfiguration},l=function(e){return o[e]},c=function(t){u()||console.error('DRM only supported with "drm" block in initial setup.',t);var n=e.keys(t);return e.some(n,function(e){return l(e)})},u=function(){return!!i.length};return{containsDrm:r,probe:function(e,n){s()&&t(n)("drm")?a(e):e()},probed:u,anySupported:c,isSupported:l}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(44),n(23),n(1),n(179),n(49)],o=function(e,t,n,i,o){function r(i,r){if(e.isSafari())return!1;var a=t(r);if(!a("dash"))return!1;if(i.drm&&!o.anySupported(i.drm))return!1;var s=window.MediaSource;if(!window.HTMLVideoElement||!s)return!1;var l=!0;return i.mediaTypes&&(l=n.all(i.mediaTypes,function(e){return s.isTypeSupported(e)})),l&&("dash"===i.type||"mpd"===i.type||(i.file||"").indexOf("mpd-time-csf")>-1)}var a=n.find(i,n.matches({name:"flash"})),s=a.supports;a.supports=function(n,i){if(!e.isFlashSupported())return!1;var o=n&&n.type;if("hls"===o||"m3u8"===o){var r=t(i);return r("hls")}return s.apply(this,arguments)};var l=n.find(i,n.matches({name:"html5"})),c=l.supports;return l.supports=function(e,n){var i=c.apply(this,arguments);if(i&&e.drm){var o=t(n);return o("drm")}return i},i.push({name:"shaka",supports:r}),i.push({name:"caterpillar",supports:function(n,i){if(e.isChrome()&&!e.isMobile()){var o=n&&n.type,r=n&&n.file;if(r.indexOf(".m3u8")>-1||"hls"===o||"m3u8"===o){var a=t(i);return a("hls")}}}}),i}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(180),n(1),n(50)],o=function(e,t){var i,o=e.registerProvider,r=e.prototype.reorderProviders;return t.extend(e.loaders,{caterpillar:function(e){n.e(1,function(require){var t=n(88);t.setEdition&&t.setEdition(i),o(t),e(t)})},shaka:function(e){n.e(2,function(require){var t=n(90);o(t),e(t)})}}),t.extend(e.prototype,{reorderProviders:function(){if(r.apply(this),"flash"!==this.config.primary&&this.config.hlshtml===!0){var e=t.indexOf(this.providers,t.findWhere(this.providers,{name:"caterpillar"})),n=this.providers.splice(e,1)[0],i=t.indexOf(this.providers,t.findWhere(this.providers,{name:"flash"}));this.providers.splice(i,0,n)}},providerSupports:function(e,t){return i=this.config.edition,e.supports(t,i)}}),e}.apply(t,i),!(void 0!==o&&(e.exports=o))},,,,,,,,,,,,function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{"default":e}}function o(e,t,n){this.helpers=e||{},this.partials=t||{},this.decorators=n||{},l.registerDefaultHelpers(this),c.registerDefaultDecorators(this)}t.__esModule=!0,t.HandlebarsEnvironment=o;var r=n(12),a=n(26),s=i(a),l=n(145),c=n(143),u=n(153),d=i(u),p="4.0.5";t.VERSION=p;var h=7;t.COMPILER_REVISION=h;var f={1:"<= 1.0.rc.2",2:"== 1.0.0-rc.3",3:"== 1.0.0-rc.4",4:"== 1.x.x",5:"== 2.0.0-alpha.x",6:">= 2.0.0-beta.1",7:">= 4.0.0"};t.REVISION_CHANGES=f;var g="[object Object]";o.prototype={constructor:o,logger:d["default"],log:d["default"].log,registerHelper:function(e,t){if(r.toString.call(e)===g){if(t)throw new s["default"]("Arg not supported with multiple helpers");r.extend(this.helpers,e)}else this.helpers[e]=t},unregisterHelper:function(e){delete this.helpers[e]},registerPartial:function(e,t){if(r.toString.call(e)===g)r.extend(this.partials,e);else{if("undefined"==typeof t)throw new s["default"]('Attempting to register a partial called "'+e+'" as undefined');this.partials[e]=t}},unregisterPartial:function(e){delete this.partials[e]},registerDecorator:function(e,t){if(r.toString.call(e)===g){if(t)throw new s["default"]("Arg not supported with multiple decorators");r.extend(this.decorators,e)}else this.decorators[e]=t},unregisterDecorator:function(e){delete this.decorators[e]}};var m=d["default"].log;t.log=m,t.createFrame=r.createFrame,t.logger=d["default"]},function(e,t,n){var i,o;i=[n(2),n(1)],o=function(e,t){function i(n){t.each(n,function(t,i){n[i]=e.serialize(t)})}function o(e){return e.slice&&"px"===e.slice(-2)&&(e=e.slice(0,-2)),e}function r(t,n){if(n.toString().indexOf("%")===-1)return 0;if("string"!=typeof t||!e.exists(t))return 0;if(/^\d*\.?\d+%$/.test(t))return t;var i=t.indexOf(":");if(i===-1)return 0;var o=parseFloat(t.substr(0,i)),r=parseFloat(t.substr(i+1));return o<=0||r<=0?0:r/o*100+"%"}var a={autostart:!1,controls:!0,displaytitle:!0,displaydescription:!0,mobilecontrols:!1,repeat:!1,castAvailable:!1,skin:"seven",stretching:"uniform",mute:!1,volume:90,width:480,height:270,localization:{play:"Play",playback:"Start playback",pause:"Pause",volume:"Volume",prev:"Previous",next:"Next",cast:"Chromecast",fullscreen:"Fullscreen",playlist:"Playlist",hd:"Quality",cc:"Closed captions",audioTracks:"Audio tracks",replay:"Replay",buffer:"Loading",more:"More",liveBroadcast:"Live broadcast",loadingAd:"Loading ad"}},s=function(s,l){var c=l&&l.getAllItems(),u=t.extend({},(window.jwplayer||{}).defaults,c,s);i(u);var d=t.extend({},a,u);if("."===d.base&&(d.base=e.getScriptPath("jwplayer.js")),d.base=(d.base||e.loadFrom()).replace(/\/?$/,"/"),n.p=d.base,d.width=o(d.width),d.height=o(d.height),d.flashplayer=d.flashplayer||e.getScriptPath("jwplayer.js")+"jwplayer.flash.swf","http:"===window.location.protocol&&(d.flashplayer=d.flashplayer.replace("https","http")),d.aspectratio=r(d.aspectratio,d.width),t.isObject(d.skin)&&(d.skinUrl=d.skin.url,d.skinColorInactive=d.skin.inactive,d.skinColorActive=d.skin.active,d.skinColorBackground=d.skin.background,d.skin=t.isString(d.skin.name)?d.skin.name:a.skin),t.isString(d.skin)&&d.skin.indexOf(".xml")>0&&(console.log("JW Player does not support XML skins, please update your config"),d.skin=d.skin.replace(".xml","")),d.aspectratio||delete d.aspectratio,!d.playlist){var p=t.pick(d,["title","description","type","mediaid","image","file","sources","tracks","preload"]);d.playlist=[p]}return d};return s}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(8),n(14),n(172),n(173),n(43)],o=function(e,t,n,i,o){function r(t){for(var r={},s=0;s<t.childNodes.length;s++){var l=t.childNodes[s],u=c(l);if(u)switch(u.toLowerCase()){case"enclosure":r.file=e.xmlAttribute(l,"url");break;case"title":r.title=a(l);break;case"guid":r.mediaid=a(l);break;case"pubdate":r.date=a(l);break;case"description":r.description=a(l);break;case"link":r.link=a(l);break;case"category":r.tags?r.tags+=a(l):r.tags=a(l)}}return r=i(t,r),r=n(t,r),new o(r)}var a=t.textContent,s=t.getChildNode,l=t.numChildren,c=t.localName,u={};return u.parse=function(e){for(var t=[],n=0;n<l(e);n++){var i=s(e,n),o=c(i).toLowerCase();if("channel"===o)for(var a=0;a<l(i);a++){var u=s(i,a);"item"===c(u).toLowerCase()&&t.push(r(u))}}return t},u}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(14),n(65),n(2),n(4),n(3),n(1)],o=function(e,t,n,i,o,r){var a=function(){function a(o){var a=n.tryCatch(function(){var n,a=o.responseXML?o.responseXML.childNodes:null,s="";if(a){for(var u=0;u<a.length&&(s=a[u],8===s.nodeType);u++);"xml"===e.localName(s)&&(s=s.nextSibling),"rss"===e.localName(s)&&(n={playlist:t.parse(s)})}if(!n)try{var d=JSON.parse(o.responseText);if(r.isArray(d))n={playlist:d};else{if(!r.isArray(d.playlist))throw null;n=d}}catch(p){return void l("Not a valid RSS/JSON feed")}c.trigger(i.JWPLAYER_PLAYLIST_LOADED,n)});a instanceof n.Error&&l()}function s(e){l("Playlist load error: "+e)}function l(e){c.trigger(i.JWPLAYER_ERROR,{message:e?e:"Error loading file"})}var c=r.extend(this,o);this.load=function(e){n.ajax(e,a,s)},this.destroy=function(){this.off()}};return a}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(43),n(68),n(1),n(51)],o=function(e,t,n,i){function o(e,t){for(var n=0;n<e.length;n++){var i=e[n],o=t.choose(i);if(o)return i.type}return null}function r(e,t){return n.isUndefined(e)?t:e}var a=function(t){return t=n.isArray(t)?t:[t],n.compact(n.map(t,e))};a.filterPlaylist=function(e,t,i,o,a,c,u){var d=[];return n.each(e,function(e){e=n.extend({},e),e.allSources=s(e.sources,i,e.drm||o,e.preload||a,r(e.withCredentials,u)),e.sources=l(e.allSources,t),e.sources.length&&(e.file=e.sources[0].file,(e.preload||a)&&(e.preload=e.preload||a),(e.feedid||c)&&(e.feedid=e.feedid||c),d.push(e))}),d};var s=function(e,i,o,a,s){return n.compact(n.map(e,function(e){if(n.isObject(e)){void 0!==i&&null!==i&&(e.androidhls=i),(e.drm||o)&&(e.drm=e.drm||o),(e.preload||a)&&(e.preload=e.preload||a);var l=r(e.withCredentials,s);return n.isUndefined(l)||(e.withCredentials=l),t(e)}}))},l=function(e,t){t&&t.choose||(t=new i({primary:t?"flash":null}));var r=o(e,t);return n.where(e,{type:r})};return a}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(2),n(8),n(1)],o=function(e,t,n){var i={"default":!1},o=function(o){if(o&&o.file){var r=n.extend({},i,o);r.file=t.trim(""+r.file);var a=/^[^\/]+\/(?:x-)?([^\/]+)$/;if(a.test(r.type)&&(r.mimeType=r.type,r.type=r.type.replace(a,"$1")),e.isYouTube(r.file)?r.type="youtube":e.isRtmp(r.file)?r.type="rtmp":r.type||(r.type=t.extension(r.file)),r.type){switch(r.type){case"m3u8":case"vnd.apple.mpegurl":r.type="hls";break;case"dash+xml":r.type="dash";break;case"smil":r.type="rtmp";break;case"m4a":r.type="aac"}return n.each(r,function(e,t){""===e&&delete r[t]}),r}}};return o}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(2),n(34),n(4),n(3),n(22),n(1)],o=function(e,t,n,i,o,r){var a={FLASH:0,JAVASCRIPT:1,HYBRID:2},s=function(s){function l(){switch(t.getPluginPathType(s)){case t.pluginPathType.ABSOLUTE:return s;case t.pluginPathType.RELATIVE:return e.getAbsolutePath(s,window.location.href)}}function c(){r.defer(function(){m=o.loaderstatus.COMPLETE,g.trigger(n.COMPLETE)})}function u(){m=o.loaderstatus.ERROR,g.trigger(n.ERROR,{url:s})}var d,p,h,f,g=r.extend(this,i),m=o.loaderstatus.NEW;this.load=function(){if(m===o.loaderstatus.NEW){if(s.lastIndexOf(".swf")>0)return d=s,m=o.loaderstatus.COMPLETE,void g.trigger(n.COMPLETE);if(t.getPluginPathType(s)===t.pluginPathType.CDN)return m=o.loaderstatus.COMPLETE,void g.trigger(n.COMPLETE);m=o.loaderstatus.LOADING;var e=new o(l());e.on(n.COMPLETE,c),e.on(n.ERROR,u),e.load()}},this.registerPlugin=function(e,t,i,r){f&&(clearTimeout(f),f=void 0),h=t,i&&r?(d=r,p=i):"string"==typeof i?d=i:"function"==typeof i?p=i:i||r||(d=e),m=o.loaderstatus.COMPLETE,g.trigger(n.COMPLETE)},this.getStatus=function(){return m},this.getPluginName=function(){return t.getPluginName(s)},this.getFlashPath=function(){if(d)switch(t.getPluginPathType(d)){case t.pluginPathType.ABSOLUTE:return d;case t.pluginPathType.RELATIVE:return s.lastIndexOf(".swf")>0?e.getAbsolutePath(d,window.location.href):e.getAbsolutePath(d,l())}return null},this.getJS=function(){return p},this.getTarget=function(){return h},this.getPluginmode=function(){return void 0!==typeof d&&void 0!==typeof p?a.HYBRID:void 0!==typeof d?a.FLASH:void 0!==typeof p?a.JAVASCRIPT:void 0},this.getNewInstance=function(e,t,n){return new p(e,t,n)},this.getURL=function(){return s}};return s}.apply(t,i),!(void 0!==o&&(e.exports=o))},,,,,,,function(e,t,n){var i,o;i=[n(1),n(45)],o=function(e,t){function n(e){e.onload=null,e.onprogress=null,e.onreadystatechange=null,e.onerror=null,"abort"in e&&e.abort()}function i(t,i){return function(o){var r=o.currentTarget||i.xhr;if(clearTimeout(i.timeoutId),i.retryWithoutCredentials&&i.xhr.withCredentials){n(r);var a=e.extend({},i,{xhr:null,withCredentials:!1,retryWithoutCredentials:!1});return void d(a)}i.onerror(t,i.url,r)}}function o(e){return function(t){var n=t.currentTarget||e.xhr;if(4===n.readyState){if(clearTimeout(e.timeoutId),n.status>=400){var i;return i=404===n.status?"File not found":""+n.status+"("+n.statusText+")",e.onerror(i,e.url,n)}if(200===n.status)return r(e)(t)}}}function r(e){return function(n){var i=n.currentTarget||e.xhr;if(clearTimeout(e.timeoutId),e.responseType){if("json"===e.responseType)return a(i,e)}else{var o,r=i.responseXML;if(r)try{o=r.firstChild}catch(l){}if(r&&o)return s(i,r,e);if(c&&i.responseText&&!r&&(r=t.parseXML(i.responseText),r&&r.firstChild))return s(i,r,e);if(e.requireValidXML)return void e.onerror("Invalid XML",e.url,i)}e.oncomplete(i)}}function a(t,n){if(!t.response||e.isString(t.response)&&'"'!==t.responseText.substr(1))try{t=e.extend({},t,{response:JSON.parse(t.responseText)})}catch(i){return void n.onerror("Invalid JSON",n.url,t)}return n.oncomplete(t)}function s(t,n,i){var o=n.documentElement;return i.requireValidXML&&("parsererror"===o.nodeName||o.getElementsByTagName("parsererror").length)?void i.onerror("Invalid XML",i.url,t):(t.responseXML||(t=e.extend({},t,{responseXML:n})),i.oncomplete(t))}var l=function(){},c=!1,u=function(e){var t=document.createElement("a"),n=document.createElement("a");t.href=location.href;try{return n.href=e,n.href=n.href,t.protocol+"//"+t.host!=n.protocol+"//"+n.host}catch(i){}return!0},d=function(t,a,s,d){e.isObject(t)&&(d=t,t=d.url);var p,h=e.extend({xhr:null,url:t,withCredentials:!1,retryWithoutCredentials:!1,timeout:6e4,timeoutId:-1,oncomplete:a||l,onerror:s||l,mimeType:d&&!d.responseType?"text/xml":"",requireValidXML:!1,responseType:d&&d.plainText?"text":""},d);if("XDomainRequest"in window&&u(t))p=h.xhr=new window.XDomainRequest,p.onload=r(h),p.ontimeout=p.onprogress=l,c=!0;else{if(!("XMLHttpRequest"in window))return void h.onerror("",t);p=h.xhr=new window.XMLHttpRequest,p.onreadystatechange=o(h)}var f=i("Error loading file",h);p.onerror=f,"overrideMimeType"in p?h.mimeType&&p.overrideMimeType(h.mimeType):c=!0;try{t=t.replace(/#.*$/,""),p.open("GET",t,!0)}catch(g){return f(g),p}if(h.responseType)try{p.responseType=h.responseType}catch(g){}h.timeout&&(h.timeoutId=setTimeout(function(){n(p),h.onerror("Timeout",t,p)},h.timeout),p.onabort=function(){clearTimeout(h.timeoutId)});try{h.withCredentials&&"withCredentials"in p&&(p.withCredentials=!0),p.send()}catch(g){f(g)}return p};return{ajax:d,crossdomain:u}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(8),n(1),n(182)],o=function(e,t,n){var i={};i.createElement=function(e){var t=document.createElement("div");return t.innerHTML=e,t.firstChild},i.styleDimension=function(e){return e+(e.toString().indexOf("%")>0?"":"px")};var o=function(e){return t.isString(e.className)?e.className.split(" "):[]},r=function(t,n){n=e.trim(n),t.className!==n&&(t.className=n)};return i.classList=function(e){return e.classList?e.classList:o(e)},i.hasClass=n.hasClass,i.addClass=function(e,n){var i=o(e),a=t.isArray(n)?n:n.split(" ");t.each(a,function(e){t.contains(i,e)||i.push(e)}),r(e,i.join(" "))},i.removeClass=function(e,n){var i=o(e),a=t.isArray(n)?n:n.split(" ");r(e,t.difference(i,a).join(" "))},i.replaceClass=function(e,t,n){var i=e.className||"";t.test(i)?i=i.replace(t,n):n&&(i+=" "+n),r(e,i)},i.toggleClass=function(e,n,o){var r=i.hasClass(e,n);o=t.isBoolean(o)?o:!r,o!==r&&(o?i.addClass(e,n):i.removeClass(e,n))},i.emptyElement=function(e){for(;e.firstChild;)e.removeChild(e.firstChild)},i.addStyleSheet=function(e){var t=document.createElement("link");t.rel="stylesheet",t.href=e,document.getElementsByTagName("head")[0].appendChild(t)},i.empty=function(e){if(e)for(;e.childElementCount>0;)e.removeChild(e.children[0])},i.bounds=function(e){var t={left:0,right:0,width:0,height:0,top:0,bottom:0};if(!e||!document.body.contains(e))return t;var n=e.getBoundingClientRect(e),i=window.pageYOffset,o=window.pageXOffset;return n.width||n.height||n.left||n.top?(t.left=n.left+o,t.right=n.right+o,t.top=n.top+i,t.bottom=n.bottom+i,t.width=n.right-n.left,t.height=n.bottom-n.top,t):t},i}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(3),n(1)],o=function(e,t){function n(){}var i=function(e,n){var i,o=this;i=e&&t.has(e,"constructor")?e.constructor:function(){return o.apply(this,arguments)},t.extend(i,o,n);var r=function(){this.constructor=i};return r.prototype=o.prototype,i.prototype=new r,e&&t.extend(i.prototype,e),i.__super__=o.prototype,i};return n.extend=i,t.extend(n.prototype,e),n}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(28),n(1),n(46),n(45),n(31)],o=function(e,t,n,i,o){var r={};return r.repo=t.memoize(function(){var t=o.split("+")[0],i=e.repo+t+"/";return n.isHTTPS()?i.replace(/^http:/,"https:"):i}),r.versionCheck=function(e){var t=("0"+e).split(/\W/),n=o.split(/\W/),i=parseFloat(t[0]),r=parseFloat(n[0]);return!(i>r)&&!(i===r&&parseFloat("0"+t[1])>parseFloat(n[1]))},r.loadFrom=function(){return r.repo()},r}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1)],o=function(e){var t=function(){var t={},n={},i={},o={};return{start:function(n){t[n]=e.now(),i[n]=i[n]+1||1},end:function(i){if(t[i]){var o=e.now()-t[i];n[i]=n[i]+o||o}},dump:function(){return{counts:i,sums:n,events:o}},tick:function(t,n){o[t]=n||e.now()},between:function(e,t){return o[t]&&o[e]?o[t]-o[e]:-1}}};return t}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[],o=function(){return document.createElement("video")}.apply(t,i),!(void 0!==o&&(e.exports=o))},,,,function(e,t,n){var i;i=function(require,e,t){function n(e,t){o(t,r(e))}function i(e){var t=u[e];if(t){for(var n=Object.keys(t),i=0;i<n.length;i+=1)for(var o=t[n[i]],r=0;r<o.parts.length;r+=1)o.parts[r]();delete u[e]}}function o(e,t){for(var n=0;n<t.length;n++){var i=t[n],o=(u[e]||{})[i.id];if(o){for(var r=0;r<o.parts.length;r++)o.parts[r](i.parts[r]);for(;r<i.parts.length;r++)o.parts.push(l(e,i.parts[r]))}else{for(var a=[],r=0;r<i.parts.length;r++)a.push(l(e,i.parts[r]));u[e]=u[e]||{},u[e][i.id]={id:i.id,parts:a}}}}function r(e){for(var t=[],n={},i=0;i<e.length;i++){var o=e[i],r=o[0],a=o[1],s=o[2],l={css:a,media:s};n[r]?n[r].parts.push(l):t.push(n[r]={id:r,parts:[l]})}return t}function a(e){h().appendChild(e)}function s(e){var t=document.createElement("style");return t.type="text/css",t.setAttribute("data-jwplayer-id",e),a(t),t}function l(e,t){var n,i,o,r=d[e];r||(r=d[e]={element:s(e),counter:0});var a=r.counter++;return n=r.element,i=c.bind(null,n,a,!1),o=c.bind(null,n,a,!0),i(t),function(e){if(e){if(e.css===t.css&&e.media===t.media)return;i(t=e)}else o()}}function c(e,t,n,i){var o=n?"":i.css;if(e.styleSheet)e.styleSheet.cssText=f(t,o);else{var r=document.createTextNode(o),a=e.childNodes;a[t]&&e.removeChild(a[t]),a.length?e.insertBefore(r,a[t]):e.appendChild(r)}}var u={},d={},p=function(e){var t;return function(){return"undefined"==typeof t&&(t=e.apply(this,arguments)),t}},h=p(function(){return document.head||document.getElementsByTagName("head")[0]});t.exports={style:n,clear:i};var f=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}()}.call(t,n,t,e),!(void 0!==i&&(e.exports=i))},function(e,t,n){var i,o;i=[n(161),n(27),n(1)],o=function(e,t,n){var i=e.selectPlayer,o=function(){var e=i.apply(this,arguments);return e?e:{registerPlugin:function(e,n,i){"jwpsrv"!==e&&t.registerPlugin(e,n,i)}}};return n.extend(e,{selectPlayer:o})}.apply(t,i),!(void 0!==o&&(e.exports=o))},,,,,function(e,t,n){var i,o;i=[n(2),n(92),n(23)],o=function(e,t,n){var i="invalid",o="RnXcsftYjWRDA^Uy",r=function(r){function a(r){e.exists(r)||(r="");try{r=t.decrypt(r,o);var a=r.split("/");s=a[0],"pro"===s&&(s="premium");var u=n(s);if(a.length>2&&u("setup")){l=a[1];var d=parseInt(a[2]);d>0&&(c=new Date,c.setTime(d))}else s=i}catch(p){s=i}}var s,l,c;this.edition=function(){return c&&c.getTime()<(new Date).getTime()?i:s},this.token=function(){return l},this.expiration=function(){return c},a(r)};return r}.apply(t,i),!(void 0!==o&&(e.exports=o));
	},function(e,t,n){var i,o;i=[],o=function(){var e=function(e){return window.atob(e)},t=function(e){return unescape(encodeURIComponent(e))},n=function(e){try{return decodeURIComponent(escape(e))}catch(t){return e}},i=function(e){for(var t=new Array(Math.ceil(e.length/4)),n=0;n<t.length;n++)t[n]=e.charCodeAt(4*n)+(e.charCodeAt(4*n+1)<<8)+(e.charCodeAt(4*n+2)<<16)+(e.charCodeAt(4*n+3)<<24);return t},o=function(e){for(var t=new Array(e.length),n=0;n<e.length;n++)t[n]=String.fromCharCode(255&e[n],e[n]>>>8&255,e[n]>>>16&255,e[n]>>>24&255);return t.join("")};return{decrypt:function(r,a){if(r=String(r),a=String(a),0==r.length)return"";for(var s,l,c=i(e(r)),u=i(t(a).slice(0,16)),d=c.length,p=c[d-1],h=c[0],f=2654435769,g=Math.floor(6+52/d),m=g*f;0!=m;){l=m>>>2&3;for(var v=d-1;v>=0;v--)p=c[v>0?v-1:d-1],s=(p>>>5^h<<2)+(h>>>3^p<<4)^(m^h)+(u[3&v^l]^p),h=c[v]-=s;m-=f}var w=o(c);return w=w.replace(/\0+$/,""),n(w)}}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(202),n(4),n(216)],o=function(e,t,n){var i=function(i,o){var r=new e(i,o),a=r.setup;return r.setup=function(){if(a.call(this),"trial"===o.get("edition")){var e=document.createElement("div");e.className="jw-icon jw-watermark",this.element().appendChild(e)}o.on("change:skipButton",this.onSkipButton,this),o.on("change:castActive change:playlistItem",this.showDisplayIconImage,this)},r.showDisplayIconImage=function(e){var t=e.get("castActive"),n=e.get("playlistItem"),i=r.controlsContainer().getElementsByClassName("jw-display-icon-container")[0];t&&n&&n.image?(i.style.backgroundImage='url("'+n.image+'")',i.style.backgroundSize="contain"):(i.style.backgroundImage="",i.style.backgroundSize="")},r.onSkipButton=function(e,t){t?this.addSkipButton():this._skipButton&&(this._skipButton.destroy(),this._skipButton=null)},r.addSkipButton=function(){this._skipButton=new n(this.instreamModel),this._skipButton.on(t.JWPLAYER_AD_SKIPPED,function(){this.api.skipAd()},this),this.controlsContainer().appendChild(this._skipButton.element())},r};return i}.apply(t,i),!(void 0!==o&&(e.exports=o))},,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,function(e,t,n){t=e.exports=n(128)(),t.push([e.id,".jw-reset{color:inherit;background-color:transparent;padding:0;margin:0;float:none;font-family:Arial,Helvetica,sans-serif;font-size:1em;line-height:1em;list-style:none;text-align:left;text-transform:none;vertical-align:baseline;border:0;direction:ltr;font-variant:inherit;font-stretch:inherit;-webkit-tap-highlight-color:rgba(255,255,255,0)}@font-face{font-family:jw-icons;src:url("+n(130)+") format('woff'),url("+n(129)+') format(\'truetype\');font-weight:400;font-style:normal}.jw-controlbar .jw-menu .jw-option:before,.jw-icon-display,.jw-icon-inline,.jw-icon-tooltip{font-family:jw-icons;-webkit-font-smoothing:antialiased;font-style:normal;font-weight:400;text-transform:none;background-color:transparent;font-variant:normal;-webkit-font-feature-settings:"liga";-ms-font-feature-settings:"liga" 1;-o-font-feature-settings:"liga";font-feature-settings:"liga";-moz-osx-font-smoothing:grayscale}.jw-icon-audio-tracks:before{content:"\\E600"}.jw-icon-buffer:before{content:"\\E601"}.jw-icon-cast:before{content:"\\E603"}.jw-icon-cast.jw-off:before{content:"\\E602"}.jw-icon-cc:before{content:"\\E605"}.jw-icon-cue:before,.jw-icon-menu-bullet:before{content:"\\E606"}.jw-icon-error:before{content:"\\E607"}.jw-icon-fullscreen:before{content:"\\E608"}.jw-icon-fullscreen.jw-off:before{content:"\\E613"}.jw-icon-hd:before{content:"\\E60A"}.jw-rightclick-logo:before,.jw-watermark:before{content:"\\E60B"}.jw-icon-next:before{content:"\\E60C"}.jw-icon-pause:before{content:"\\E60D"}.jw-icon-play:before{content:"\\E60E"}.jw-icon-prev:before{content:"\\E60F"}.jw-icon-replay:before{content:"\\E610"}.jw-icon-volume:before{content:"\\E612"}.jw-icon-volume.jw-off:before{content:"\\E611"}.jw-icon-more:before{content:"\\E614"}.jw-icon-close:before{content:"\\E615"}.jw-icon-playlist:before{content:"\\E616"}.jwplayer{width:100%;font-size:16px;position:relative;display:block;min-height:0;overflow:hidden;box-sizing:border-box;font-family:Arial,Helvetica,sans-serif;background-color:#000;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.jwplayer *{box-sizing:inherit}.jwplayer.jw-flag-aspect-mode{height:auto!important}.jwplayer.jw-flag-aspect-mode .jw-aspect{display:block}.jwplayer .jw-aspect{display:none}.jwplayer.jw-no-focus:focus,.jwplayer .jw-swf{outline:none}.jwplayer.jw-ie:focus{outline:1px dotted #585858}.jwplayer:hover .jw-display-icon-container{background-color:#212121}.jw-controls,.jw-media,.jw-overlays,.jw-preview{position:absolute;width:100%;height:100%;top:0;left:0;bottom:0;right:0}.jw-media{overflow:hidden;cursor:pointer}.jw-overlays{cursor:auto}.jw-media.jw-media-show{visibility:visible;opacity:1}.jw-controls.jw-controls-disabled{display:none}.jw-controls .jw-controls-right{position:absolute;top:0;right:0;left:0;bottom:2.5em}.jw-text{height:1em;font-family:Arial,Helvetica,sans-serif;font-size:.75em;font-style:normal;font-weight:400;color:#fff;text-align:center;font-variant:normal;font-stretch:normal}.jw-plugin{position:absolute;bottom:2.5em}.jw-plugin .jw-banner{max-width:100%;opacity:0;cursor:pointer;position:absolute;margin:auto auto 0;left:0;right:0;bottom:0;display:block}.jw-cast-screen{width:100%;height:100%}.jw-instream{position:absolute;top:0;right:0;bottom:0;left:0;display:none}.jw-icon-playback:before{content:"\\E60E"}.jw-captions,.jw-controls,.jw-overlays,.jw-preview,.jw-title{pointer-events:none}.jw-controlbar,.jw-display-icon-container,.jw-dock,.jw-logo,.jw-media,.jw-overlays>div,.jw-skip{pointer-events:all}.jwplayer video{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;margin:auto;background:transparent}.jwplayer video::-webkit-media-controls-start-playback-button{display:none}.jwplayer.jw-stretch-uniform video{-o-object-fit:contain;object-fit:contain}.jwplayer.jw-stretch-none video{-o-object-fit:none;object-fit:none}.jwplayer.jw-stretch-fill video{-o-object-fit:cover;object-fit:cover}.jwplayer.jw-stretch-exactfit video{-o-object-fit:fill;object-fit:fill}.jw-click,.jw-preview{position:absolute;width:100%;height:100%}.jw-preview{display:none;opacity:1;visibility:visible;background:#000 no-repeat 50% 50%}.jw-error .jw-preview,.jw-stretch-uniform .jw-preview,.jwplayer .jw-preview{background-size:contain}.jw-stretch-none .jw-preview{background-size:auto auto}.jw-stretch-fill .jw-preview{background-size:cover}.jw-stretch-exactfit .jw-preview{background-size:100% 100%}.jw-display-icon-container{position:relative;top:50%;display:table;height:3.75em;width:3.75em;margin:-1.875em auto 0;cursor:pointer}.jw-display-icon-container .jw-icon-display{position:relative;display:table-cell;text-align:center;vertical-align:middle!important;background-position:50% 50%;background-repeat:no-repeat;font-size:2.5em}.jw-flag-audio-player .jw-display-icon-container,.jw-flag-dragging .jw-display-icon-container{display:none}.jw-icon{font-family:jw-icons;-webkit-font-smoothing:antialiased;font-style:normal;font-weight:400;text-transform:none;background-color:transparent;font-variant:normal;-webkit-font-feature-settings:"liga";-ms-font-feature-settings:"liga" 1;-o-font-feature-settings:"liga";font-feature-settings:"liga";-moz-osx-font-smoothing:grayscale}.jw-controlbar{display:table;position:absolute;bottom:0;height:2.5em;width:100%;padding:0 .4em}.jw-controlbar .jw-hidden{display:none}.jw-controlbar.jw-drawer-expanded .jw-controlbar-center-group,.jw-controlbar.jw-drawer-expanded .jw-controlbar-left-group{opacity:0}.jw-background-color{background-color:rgba(33,33,33,.8)}.jw-slider-horizontal{background-color:transparent}.jw-group{display:table-cell}.jw-controlbar-center-group{width:100%;padding:0 .4em}.jw-controlbar-center-group .jw-slider-time,.jw-controlbar-center-group .jw-text-alt{padding:0}.jw-controlbar-center-group .jw-text-alt{display:none}.jw-controlbar-left-group,.jw-controlbar-right-group{white-space:nowrap}.jw-icon-display:hover,.jw-icon-inline:hover,.jw-icon-tooltip:hover,.jw-knob:hover,.jw-option:before:hover{color:#fff}.jw-icon-inline,.jw-icon-tooltip,.jw-slider-horizontal,.jw-text-duration,.jw-text-elapsed{display:inline-block;height:2.5em;position:relative;line-height:2.5em;vertical-align:middle;cursor:pointer;padding:0 .4em}.jw-icon-inline,.jw-icon-tooltip{min-width:1.5625em;text-align:center}.jw-icon-playback{min-width:2.25em}.jw-icon-volume{min-width:1.75em;text-align:left}.jw-time-tip{line-height:1em;pointer-events:none}.jw-icon-cast,.jw-icon-inline.jw-icon-volume,.jw-slider-volume.jw-slider-horizontal{display:none}.jw-button-color{color:hsla(0,0%,100%,.6)}.jw-button-color:hover{color:#fff}.jw-button-color:focus{outline:none;color:#fff}.jw-toggle{color:#fff}.jw-toggle.jw-off{color:hsla(0,0%,100%,.6)}.jw-toggle:focus{outline:none;color:#fff}.jw-dock{margin:.75em;display:block;opacity:1;clear:right}.jw-dock:after{content:\'\';clear:both;display:block}.jw-dock-button{cursor:pointer;float:right;position:relative;width:2.5em;height:2.5em;margin:.5em}.jw-dock-button .jw-arrow{display:none;position:absolute;bottom:-.2em;width:.5em;height:.2em;left:50%;margin-left:-.25em}.jw-dock-button .jw-overlay{display:none;position:absolute;top:2.5em;right:0;margin-top:.25em;padding:.5em;white-space:nowrap}.jw-dock-button:hover .jw-arrow,.jw-dock-button:hover .jw-overlay{display:block}.jw-dock-image{width:100%;height:100%;background-position:50% 50%;background-repeat:no-repeat;opacity:.75}.jw-title{display:none;position:absolute;top:0;width:100%;font-size:.875em;height:8em;background:-webkit-linear-gradient(top,#000,#000 18%,transparent);background:linear-gradient(180deg,#000 0,#000 18%,transparent)}.jw-title-primary,.jw-title-secondary{padding:.75em 1.5em;min-height:2.5em;width:100%;color:#fff;white-space:nowrap;text-overflow:ellipsis;overflow-x:hidden}.jw-title-primary{font-weight:700}.jw-title-secondary{margin-top:-.5em}.jw-slider-container{height:1em;width:100%;position:relative;touch-action:none}.jw-buffer,.jw-progress,.jw-rail{position:absolute;cursor:pointer}.jw-progress{background-color:#fff}.jw-rail{background-color:hsla(0,0%,100%,.2)}.jw-buffer{background-color:hsla(0,0%,100%,.3)}.jw-cue,.jw-knob{position:absolute;cursor:pointer}.jw-cue{height:.25em;background-color:rgba(33,33,33,.9);border-radius:25%;width:.4em}.jw-knob{background-color:#fff;width:.5em;height:.5em;border-radius:.25em}.jw-slider-horizontal{height:.25em}.jw-slider-horizontal.jw-slider-volume{width:4em}.jw-slider-horizontal .jw-rail{width:100%}.jw-slider-horizontal .jw-knob{top:-.125em;margin-left:-.25em}.jw-slider-horizontal .jw-buffer,.jw-slider-horizontal .jw-progress,.jw-slider-horizontal .jw-rail{height:.25em}.jw-slider-vertical{padding:.8em .8em 0;position:absolute}.jw-slider-vertical .jw-buffer,.jw-slider-vertical .jw-progress,.jw-slider-vertical .jw-rail{bottom:0;height:100%;left:0;right:0;margin:0 auto}.jw-slider-vertical .jw-progress,.jw-slider-vertical .jw-rail,.jw-slider-vertical .jw-slider-container{width:.25em}.jw-slider-vertical .jw-slider-container{height:4em}.jw-slider-vertical .jw-knob{right:0;left:-.125em}.jw-slider-time{width:100%}.jw-tooltip-time{position:absolute}.jw-slider-volume .jw-buffer{display:none}.jw-captions{position:absolute;width:100%;height:inherit;text-align:center;display:none;max-height:81.375%;line-height:1.3em;letter-spacing:normal;word-spacing:normal;text-transform:none;text-indent:0;text-decoration:none;pointer-events:none;overflow:hidden;top:0}.jw-captions.jw-captions-enabled{display:block}.jw-captions-window{display:none;padding:.25em;border-radius:.25em}.jw-captions-text,.jw-captions-window.jw-captions-window-active{display:inline-block}.jw-captions-text{color:#fff;background-color:#000;word-wrap:normal;word-break:normal;white-space:pre-line;font-style:normal;font-weight:400;text-align:center;text-decoration:none;line-height:1.3em;padding:.1em .8em}.jw-text-track-display{font-size:inherit;line-height:1.3em}.jwplayer video::-webkit-media-controls{-webkit-box-pack:start;justify-content:flex-start}.jwplayer video::-webkit-media-text-track-container{max-height:81.375%;line-height:1.3em}.jwplayer .jw-rightclick{display:none;position:absolute;white-space:nowrap}.jwplayer .jw-rightclick.jw-open{display:block}.jwplayer .jw-rightclick ul{list-style:none;font-weight:700;border-radius:.15em;margin:0;border:1px solid #444;padding:0}.jwplayer .jw-rightclick ul li{background-color:#000;border-bottom:1px solid #444;margin:0}.jwplayer .jw-rightclick ul li .jw-rightclick-logo{font-size:2em;color:#ff0147;vertical-align:middle;padding-right:.3em;margin-right:.3em;border-right:1px solid #444}.jwplayer .jw-rightclick ul li a{color:#fff;text-decoration:none;padding:1em;display:block;font-size:.6875em;line-height:1em}.jwplayer .jw-rightclick ul li:last-child{border-bottom:none}.jwplayer .jw-rightclick ul li:hover{background-color:#1a1a1a;cursor:pointer}.jwplayer .jw-rightclick ul .jw-featured{background-color:#252525;vertical-align:middle}.jwplayer .jw-rightclick ul .jw-featured a{color:#777}.jw-logo{position:absolute;margin:.75em;cursor:pointer;pointer-events:all;background-repeat:no-repeat;background-size:contain;top:auto;right:auto;left:auto;bottom:auto}.jw-logo .jw-flag-audio-player{display:none}.jw-logo-top-right{top:0;right:0}.jw-logo-top-left{top:0;left:0}.jw-logo-bottom-left{bottom:0;left:0}.jw-logo-bottom-right,.jw-watermark{bottom:0;right:0}.jw-watermark{position:absolute;top:50%;left:0;text-align:center;font-size:14em;color:#fff;opacity:.33;pointer-events:none}.jw-icon-tooltip.jw-open .jw-overlay{opacity:1;visibility:visible}.jw-icon-tooltip.jw-hidden,.jw-icon-tooltip.jw-open-drawer:before,.jw-overlay-horizontal{display:none}.jw-icon-tooltip.jw-open-drawer .jw-overlay-horizontal{opacity:1;display:inline-block;vertical-align:top}.jw-overlay:before{position:absolute;top:0;bottom:0;left:-50%;width:100%;background-color:transparent;content:" "}.jw-slider-time .jw-overlay:before{height:1em;top:auto}.jw-menu,.jw-time-tip,.jw-volume-tip{position:relative;left:-50%;margin:0}.jw-volume-tip{width:100%;height:100%;display:block}.jw-time-tip{text-align:center;font-family:inherit;bottom:1.25em;padding:.4em;border-radius:.25em}.jw-time-tip .jw-text{color:#fff;line-height:1em}.jw-controlbar .jw-overlay{margin:0;position:absolute;bottom:2.5em;left:50%;opacity:0;visibility:hidden}.jw-controlbar .jw-overlay .jw-contents{position:relative}.jw-controlbar .jw-option{position:relative;white-space:nowrap;cursor:pointer;list-style:none;height:1.5em;font-family:inherit;line-height:1.5em;color:hsla(0,0%,100%,.6);padding:0 .5em;font-size:.8em}.jw-controlbar .jw-option:before:hover,.jw-controlbar .jw-option:hover{color:#fff}.jw-controlbar .jw-option:before{padding-right:.125em}.jw-controlbar .jw-option.jw-active-option{color:#fff}.jw-playlist-container{left:-51%}.jw-playlist-container ::-webkit-scrollbar-track{background-color:hsla(0,0%,100%,.6)}.jw-playlist-container ::-webkit-scrollbar{width:5px;border:0}.jw-playlist-container ::-webkit-scrollbar-thumb{background-color:#fff;border-radius:5px}.jw-tooltip-title{border-bottom:1px solid hsla(0,0%,100%,.6);text-align:left;padding-left:.4em}.jw-playlist{max-height:11em;min-height:4.5em;overflow-x:hidden;overflow-y:scroll;width:calc(100% - 2px)}.jw-playlist .jw-option{height:3em;color:#fff;padding-left:1em;font-size:.75em}.jw-playlist .jw-label,.jw-playlist .jw-name{display:inline-block;line-height:3em;text-align:left;overflow:hidden;white-space:nowrap}.jw-playlist .jw-label{width:1em}.jw-playlist .jw-name{width:11em}.jw-skip{cursor:default;position:absolute;float:right;display:inline-block;right:.75em;bottom:3em;padding:.4em}.jw-skip.jw-skippable{cursor:pointer}.jw-skip.jw-hidden{visibility:hidden}.jw-skip .jw-skip-icon{display:none;margin-left:-.75em}.jw-skip .jw-skip-icon:before{content:"\\E60C"}.jw-skip .jw-skip-icon,.jw-skip .jw-text{color:hsla(0,0%,100%,.6);vertical-align:middle;line-height:1.5em;font-size:.7em}.jw-skip.jw-skippable:hover{cursor:pointer}.jw-skip.jw-skippable:hover .jw-skip-icon,.jw-skip.jw-skippable:hover .jw-text{color:#fff}.jw-skip.jw-skippable .jw-skip-icon{display:inline;margin:0}.jwplayer.jw-state-paused.jw-flag-casting .jw-display-icon-container,.jwplayer.jw-state-playing.jw-flag-casting .jw-display-icon-container{display:table}.jwplayer.jw-flag-casting .jw-display-icon-container{border-radius:0;border:1px solid #fff;position:absolute;top:auto;left:.5em;right:.5em;bottom:50%;margin-bottom:-12.5%;height:50%;width:50%;padding:0;background-repeat:no-repeat;background-position:50%}.jwplayer.jw-flag-casting .jw-display-icon-container .jw-icon{font-size:3em}.jwplayer.jw-flag-casting.jw-state-complete .jw-preview{display:none}.jw-cast{position:absolute;width:100%;height:100%;background-repeat:no-repeat;background-size:auto;background-position:50% 50%}.jw-cast-label{position:absolute;left:.5em;right:.5em;bottom:75%;margin-bottom:1.5em;text-align:center}.jw-cast-name{color:#ccc}.jw-state-idle .jw-preview{display:block}.jw-state-idle .jw-icon-display:before{content:"\\E60E"}.jw-state-idle .jw-captions,.jw-state-idle .jw-controlbar{display:none}.jw-state-idle .jw-title{display:block}.jwplayer.jw-state-playing .jw-display-icon-container{display:none}.jwplayer.jw-state-playing .jw-display-icon-container .jw-icon-display:before,.jwplayer.jw-state-playing .jw-icon-playback:before{content:"\\E60D"}.jwplayer.jw-state-paused .jw-display-icon-container{display:none}.jwplayer.jw-state-paused .jw-display-icon-container .jw-icon-display:before,.jwplayer.jw-state-paused .jw-icon-playback:before{content:"\\E60E"}.jwplayer.jw-state-buffering .jw-display-icon-container .jw-icon-display{-webkit-animation:spin 2s linear infinite;animation:spin 2s linear infinite}.jwplayer.jw-state-buffering .jw-display-icon-container .jw-icon-display:before{content:"\\E601"}@-webkit-keyframes spin{to{-webkit-transform:rotate(1turn)}}@keyframes spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.jwplayer.jw-state-buffering .jw-display-icon-container .jw-text{display:none}.jwplayer.jw-state-buffering .jw-icon-playback:before{content:"\\E60D"}.jwplayer.jw-state-complete .jw-preview{display:block}.jwplayer.jw-state-complete .jw-display-icon-container .jw-icon-display:before{content:"\\E610"}.jwplayer.jw-state-complete .jw-display-icon-container .jw-text{display:none}.jwplayer.jw-state-complete .jw-icon-playback:before{content:"\\E60E"}.jwplayer.jw-state-complete .jw-captions{display:none}.jwplayer.jw-state-error .jw-title,body .jw-error .jw-title{display:block}.jwplayer.jw-state-error .jw-title .jw-title-primary,body .jw-error .jw-title .jw-title-primary{white-space:normal}.jwplayer.jw-state-error .jw-preview,body .jw-error .jw-preview{display:block}.jwplayer.jw-state-error .jw-captions,.jwplayer.jw-state-error .jw-controlbar,body .jw-error .jw-captions,body .jw-error .jw-controlbar{display:none}.jwplayer.jw-state-error:hover .jw-display-icon-container,body .jw-error:hover .jw-display-icon-container{cursor:default;color:#fff;background:#000}.jwplayer.jw-state-error .jw-icon-display,body .jw-error .jw-icon-display{cursor:default;font-family:jw-icons;-webkit-font-smoothing:antialiased;font-style:normal;font-weight:400;text-transform:none;background-color:transparent;font-variant:normal;-webkit-font-feature-settings:"liga";-ms-font-feature-settings:"liga" 1;-o-font-feature-settings:"liga";font-feature-settings:"liga";-moz-osx-font-smoothing:grayscale}.jwplayer.jw-state-error .jw-icon-display:before,body .jw-error .jw-icon-display:before{content:"\\E607"}.jwplayer.jw-state-error .jw-icon-display:hover,body .jw-error .jw-icon-display:hover{color:#fff}body .jw-error{font-size:16px;background-color:#000;color:#fff;width:100%;height:100%;display:table;opacity:1;position:relative}body .jw-error .jw-icon-container{position:absolute;width:100%;height:100%;top:0;left:0;bottom:0;right:0}.jwplayer.jw-flag-cast-available .jw-controlbar{display:table}.jwplayer.jw-flag-cast-available .jw-icon-cast{display:inline-block}.jwplayer.jw-flag-skin-loading .jw-captions,.jwplayer.jw-flag-skin-loading .jw-controls,.jwplayer.jw-flag-skin-loading .jw-title{display:none}.jwplayer.jw-flag-fullscreen{width:100%!important;height:100%!important;top:0;right:0;bottom:0;left:0;z-index:1000;margin:0;position:fixed}.jwplayer.jw-flag-live .jw-controlbar .jw-slider-time,.jwplayer.jw-flag-live .jw-controlbar .jw-text-duration,.jwplayer.jw-flag-live .jw-controlbar .jw-text-elapsed{display:none}.jwplayer.jw-flag-live .jw-controlbar .jw-text-alt{display:inline}.jwplayer.jw-flag-user-inactive.jw-state-playing .jw-controlbar,.jwplayer.jw-flag-user-inactive.jw-state-playing .jw-dock,.jwplayer.jw-flag-user-inactive.jw-state-playing .jw-logo.jw-hide{display:none}.jwplayer.jw-flag-user-inactive.jw-state-playing .jw-plugin{bottom:.5em}.jwplayer.jw-flag-user-inactive.jw-state-playing .jw-media{cursor:none;-webkit-cursor-visibility:auto-hide}.jwplayer.jw-flag-user-inactive.jw-state-playing .jw-captions{max-height:none}.jwplayer.jw-flag-user-inactive.jw-state-playing video::-webkit-media-text-track-container{max-height:none}.jwplayer.jw-flag-user-inactive.jw-state-buffering .jw-controlbar{display:none}.jwplayer.jw-flag-media-audio .jw-controlbar,.jwplayer.jw-flag-media-audio.jw-flag-user-inactive .jw-controlbar{display:table}.jwplayer.jw-flag-media-audio.jw-flag-user-inactive.jw-state-playing .jw-plugin{bottom:3em}.jwplayer.jw-flag-media-audio.jw-flag-user-inactive.jw-state-playing .jw-captions{max-height:81.375%}.jwplayer.jw-flag-media-audio.jw-flag-user-inactive.jw-state-playing video::-webkit-media-text-track-container{max-height:81.375%}.jwplayer.jw-flag-media-audio.jw-flag-user-inactive.jw-state-playing.jw-flag-touch video::-webkit-media-text-track-container{max-height:70%}.jw-flag-media-audio .jw-preview{display:block}.jwplayer.jw-flag-ads .jw-captions.jw-captions-enabled,.jwplayer.jw-flag-ads .jw-dock,.jwplayer.jw-flag-ads .jw-logo,.jwplayer.jw-flag-ads .jw-preview{display:none}.jwplayer.jw-flag-ads video::-webkit-media-text-track-container{display:none}.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-inline,.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-tooltip,.jwplayer.jw-flag-ads .jw-controlbar .jw-slider-horizontal,.jwplayer.jw-flag-ads .jw-controlbar .jw-text{display:none}.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-fullscreen,.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-playback,.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-volume,.jwplayer.jw-flag-ads .jw-controlbar .jw-slider-volume{display:inline-block}.jwplayer.jw-flag-ads .jw-controlbar .jw-text-alt{display:inline}.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-inline.jw-icon-volume,.jwplayer.jw-flag-ads .jw-controlbar .jw-slider-volume.jw-slider-horizontal{display:inline-block}.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-tooltip.jw-icon-volume{display:none}.jwplayer.jw-flag-ads-googleima .jw-controlbar{display:table;bottom:0}.jwplayer.jw-flag-ads-googleima.jw-flag-touch .jw-controlbar{font-size:1em}.jwplayer.jw-flag-ads-googleima.jw-flag-touch.jw-state-paused .jw-display-icon-container{display:none}.jwplayer.jw-flag-ads-googleima.jw-skin-seven .jw-controlbar{font-size:.9em}.jwplayer.jw-flag-ads.jw-flag-touch .jw-controlbar{display:table}.jwplayer.jw-flag-ads-vpaid .jw-controlbar,.jwplayer.jw-flag-touch.jw-flag-ads-vpaid .jw-controlbar{display:none}.jwplayer.jw-flag-ads-hide-controls .jw-controls{display:none!important}.jwplayer.jw-flag-overlay-open-related .jw-controls,.jwplayer.jw-flag-overlay-open-related .jw-title,.jwplayer.jw-flag-overlay-open-sharing .jw-controls,.jwplayer.jw-flag-overlay-open-sharing .jw-title,.jwplayer.jw-flag-overlay-open .jw-controls-right .jw-logo,.jwplayer.jw-flag-overlay-open .jw-title{display:none}.jwplayer.jw-flag-rightclick-open{overflow:visible}.jwplayer.jw-flag-rightclick-open .jw-rightclick{z-index:16777215}.jw-flag-controls-disabled .jw-controls{visibility:hidden}.jw-flag-controls-disabled .jw-logo{visibility:visible}.jw-flag-controls-disabled .jw-media{cursor:auto}.jw-flag-controls-disabled.jwplayer .jw-captions{max-height:none}.jw-flag-controls-disabled.jwplayer video::-webkit-media-text-track-container{max-height:none}body .jwplayer.jw-flag-flash-blocked .jw-title{display:block}body .jwplayer.jw-flag-flash-blocked .jw-controls,body .jwplayer.jw-flag-flash-blocked .jw-overlays,body .jwplayer.jw-flag-flash-blocked .jw-preview{display:none}.jw-flag-touch .jw-controlbar,.jw-flag-touch .jw-plugin,.jw-flag-touch .jw-skip{font-size:1.5em}.jw-flag-touch .jw-captions{bottom:4.25em}.jw-flag-touch video::-webkit-media-text-track-container{max-height:70%}.jw-flag-touch .jw-icon-tooltip.jw-open-drawer:before{display:inline;content:"\\E615"}.jw-flag-touch .jw-display-icon-container{pointer-events:none}.jw-flag-touch.jw-state-paused .jw-display-icon-container{display:table}.jw-flag-compact-player .jw-icon-playlist,.jw-flag-compact-player .jw-text-duration,.jw-flag-compact-player .jw-text-elapsed,.jw-flag-touch.jw-state-paused.jw-flag-dragging .jw-display-icon-container{display:none}.jwplayer.jw-flag-audio-player{background-color:transparent}.jwplayer.jw-flag-audio-player .jw-media{visibility:hidden}.jwplayer.jw-flag-audio-player .jw-media object{width:1px;height:1px}.jwplayer.jw-flag-audio-player .jw-display-icon-container,.jwplayer.jw-flag-audio-player .jw-preview,.jwplayer.jw-flag-audio-player .jw-title{display:none}.jwplayer.jw-flag-audio-player .jw-controlbar{vertical-align:middle;display:table;height:100%;left:0;bottom:0;margin:0;width:100%;min-width:100%}.jwplayer.jw-flag-audio-player .jw-controlbar .jw-icon-fullscreen,.jwplayer.jw-flag-audio-player .jw-controlbar .jw-icon-tooltip{display:none}.jwplayer.jw-flag-audio-player .jw-controlbar .jw-icon-inline.jw-icon-volume,.jwplayer.jw-flag-audio-player .jw-controlbar .jw-slider-volume.jw-slider-horizontal{display:inline-block}.jwplayer.jw-flag-audio-player .jw-controlbar .jw-icon-tooltip.jw-icon-volume{display:none}.jwplayer.jw-flag-audio-player.jw-flag-user-inactive .jw-controlbar{display:table}.jwplayer.jw-flag-audio-player .jw-icon-inline{height:auto;line-height:normal}.jwplayer.jw-flag-audio-player .jw-group{vertical-align:middle}.jwplayer.jw-flag-audio-player .jw-controlbar-center-group{padding-bottom:2px}.jw-skin-seven .jw-color-active,.jw-skin-seven .jw-color-active-hover:hover{color:#fff;stroke:#fff;border-color:#fff}.jw-skin-seven .jw-color-inactive,.jw-skin-seven .jw-color-inactive-hover:hover{color:#cecece;stroke:#cecece;border-color:#cecece}.jw-skin-seven .jw-active-option{background-color:hsla(0,0%,100%,.1)}.jw-skin-seven .jw-display-icon-container{display:table;font-size:20px;border-radius:3.5em}.jw-skin-seven .jw-display-icon-container:hover .jw-icon{color:#fff}.jw-skin-seven .jw-display-icon-container>.jw-icon{color:hsla(0,0%,100%,.9);font-size:1.7em}.jw-skin-seven.jw-state-idle .jw-display-icon-container>.jw-icon{padding-left:4px}.jw-skin-seven .jw-dock-button{border-radius:2.5em}.jw-skin-seven .jw-menu{padding:0}.jw-skin-seven .jw-dock .jw-overlay,.jw-skin-seven .jw-skip{border-radius:.4em}.jw-skin-seven .jw-text{text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}',""])},function(e,t){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],t=0;t<this.length;t++){var n=this[t];n[2]?e.push("@media "+n[2]+"{"+n[1]+"}"):e.push(n[1])}return e.join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var i={},o=0;o<this.length;o++){var r=this[o][0];"number"==typeof r&&(i[r]=!0)}for(o=0;o<t.length;o++){var a=t[o];"number"==typeof a[0]&&i[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),e.push(a))}},e}},function(e,t,n){e.exports=n.p+"jw-icons.ttf"},function(e,t,n){e.exports=n.p+"jw-icons.woff"},function(e,t,n){var i=n(11);e.exports=(i["default"]||i).template({compiler:[7,">= 4.0.0"],main:function(e,t,n,i,o){return'<div class="jw-skip jw-background-color jw-hidden jw-reset">\n    <span class="jw-text jw-skiptext jw-reset"></span>\n    <span class="jw-icon-inline jw-skip-icon jw-reset"></span>\n</div>'},useData:!0})},function(e,t,n){var i=n(11);e.exports=(i["default"]||i).template({compiler:[7,">= 4.0.0"],main:function(e,t,n,i,o){var r;return'<div class="jw-display-icon-container jw-background-color jw-reset">\n    <div class="jw-icon jw-icon-display jw-button-color jw-reset" role="button" tabindex="0" aria-label="'+e.escapeExpression((r=null!=(r=n.ariaLabel||(null!=t?t.ariaLabel:t))?r:n.helperMissing,"function"==typeof r?r.call(null!=t?t:{},{name:"ariaLabel",hash:{},data:o}):r))+'"></div>\n</div>\n'},useData:!0})},function(e,t,n){var i=n(11);e.exports=(i["default"]||i).template({1:function(e,t,n,i,o){var r,a,s=null!=t?t:{};return'    <div class="jw-dock-button jw-background-color jw-reset'+(null!=(r=n["if"].call(s,null!=t?t.btnClass:t,{name:"if",hash:{},fn:e.program(2,o,0),inverse:e.noop,data:o}))?r:"")+'" button="'+e.escapeExpression((a=null!=(a=n.id||(null!=t?t.id:t))?a:n.helperMissing,"function"==typeof a?a.call(s,{name:"id",hash:{},data:o}):a))+'">\n        <div class="jw-icon jw-dock-image jw-reset" '+(null!=(r=n["if"].call(s,null!=t?t.img:t,{name:"if",hash:{},fn:e.program(4,o,0),inverse:e.noop,data:o}))?r:"")+'></div>\n        <div class="jw-arrow jw-reset"></div>\n'+(null!=(r=n["if"].call(s,null!=t?t.tooltip:t,{name:"if",hash:{},fn:e.program(6,o,0),inverse:e.noop,data:o}))?r:"")+"    </div>\n"},2:function(e,t,n,i,o){var r;return" "+e.escapeExpression((r=null!=(r=n.btnClass||(null!=t?t.btnClass:t))?r:n.helperMissing,"function"==typeof r?r.call(null!=t?t:{},{name:"btnClass",hash:{},data:o}):r))},4:function(e,t,n,i,o){var r;return"style='background-image: url(\""+e.escapeExpression((r=null!=(r=n.img||(null!=t?t.img:t))?r:n.helperMissing,"function"==typeof r?r.call(null!=t?t:{},{name:"img",hash:{},data:o}):r))+"\")'"},6:function(e,t,n,i,o){var r;return'        <div class="jw-overlay jw-background-color jw-reset">\n            <span class="jw-text jw-dock-text jw-reset">'+e.escapeExpression((r=null!=(r=n.tooltip||(null!=t?t.tooltip:t))?r:n.helperMissing,"function"==typeof r?r.call(null!=t?t:{},{name:"tooltip",hash:{},data:o}):r))+"</span>\n        </div>\n"},compiler:[7,">= 4.0.0"],main:function(e,t,n,i,o){var r;return'<div class="jw-dock jw-reset">\n'+(null!=(r=n.each.call(null!=t?t:{},t,{name:"each",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o}))?r:"")+"</div>"},useData:!0})},function(e,t,n){var i=n(11);e.exports=(i["default"]||i).template({compiler:[7,">= 4.0.0"],main:function(e,t,n,i,o){var r,a=null!=t?t:{},s=n.helperMissing,l="function",c=e.escapeExpression;return'<div id="'+c((r=null!=(r=n.id||(null!=t?t.id:t))?r:s,typeof r===l?r.call(a,{name:"id",hash:{},data:o}):r))+'"class="jw-skin-'+c((r=null!=(r=n.skin||(null!=t?t.skin:t))?r:s,typeof r===l?r.call(a,{name:"skin",hash:{},data:o}):r))+' jw-error jw-reset">\n    <div class="jw-title jw-reset">\n        <div class="jw-title-primary jw-reset">'+c((r=null!=(r=n.title||(null!=t?t.title:t))?r:s,typeof r===l?r.call(a,{name:"title",hash:{},data:o}):r))+'</div>\n        <div class="jw-title-secondary jw-reset">'+c((r=null!=(r=n.body||(null!=t?t.body:t))?r:s,typeof r===l?r.call(a,{name:"body",hash:{},data:o}):r))+'</div>\n    </div>\n\n    <div class="jw-icon-container jw-reset">\n        <div class="jw-display-icon-container jw-background-color jw-reset">\n            <div class="jw-icon jw-icon-display jw-reset" aria-hidden="true"></div>\n        </div>\n    </div>\n</div>\n'},useData:!0})},function(e,t,n){var i=n(11);e.exports=(i["default"]||i).template({compiler:[7,">= 4.0.0"],main:function(e,t,n,i,o){return'<div class="jw-logo jw-reset"></div>'},useData:!0})},function(e,t,n){var i=n(11);e.exports=(i["default"]||i).template({1:function(e,t,n,i,o){var r,a=e.escapeExpression;return"        <li class='jw-text jw-option jw-item-"+a((r=null!=(r=n.index||o&&o.index)?r:n.helperMissing,"function"==typeof r?r.call(null!=t?t:{},{name:"index",hash:{},data:o}):r))+" jw-reset'>"+a(e.lambda(null!=t?t.label:t,t))+"</li>\n";
	},compiler:[7,">= 4.0.0"],main:function(e,t,n,i,o){var r;return'<ul class="jw-menu jw-background-color jw-reset">\n'+(null!=(r=n.each.call(null!=t?t:{},t,{name:"each",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o}))?r:"")+"</ul>"},useData:!0})},function(e,t,n){var i=n(11);e.exports=(i["default"]||i).template({compiler:[7,">= 4.0.0"],main:function(e,t,n,i,o){var r;return'<div id="'+e.escapeExpression((r=null!=(r=n.id||(null!=t?t.id:t))?r:n.helperMissing,"function"==typeof r?r.call(null!=t?t:{},{name:"id",hash:{},data:o}):r))+'" class="jwplayer jw-reset jw-state-idle" tabindex="0">\n    <div class="jw-aspect jw-reset"></div>\n    <div class="jw-media jw-reset"></div>\n    <div class="jw-preview jw-reset"></div>\n    <div class="jw-title jw-reset">\n        <div class="jw-title-primary jw-reset"></div>\n        <div class="jw-title-secondary jw-reset"></div>\n    </div>\n    <div class="jw-overlays jw-reset"></div>\n    <div class="jw-controls jw-reset"></div>\n</div>'},useData:!0})},function(e,t,n){var i=n(11);e.exports=(i["default"]||i).template({1:function(e,t,n,i,o){var r;return null!=(r=n["if"].call(null!=t?t:{},null!=t?t.active:t,{name:"if",hash:{},fn:e.program(2,o,0),inverse:e.program(4,o,0),data:o}))?r:""},2:function(e,t,n,i,o){var r,a=e.escapeExpression;return"                <li class='jw-option jw-text jw-active-option jw-item-"+a((r=null!=(r=n.index||o&&o.index)?r:n.helperMissing,"function"==typeof r?r.call(null!=t?t:{},{name:"index",hash:{},data:o}):r))+' jw-reset\'>\n                    <span class="jw-label jw-reset"><span class="jw-icon jw-icon-play jw-reset"></span></span>\n                    <span class="jw-name jw-reset">'+a(e.lambda(null!=t?t.title:t,t))+"</span>\n                </li>\n"},4:function(e,t,n,i,o){var r,a=e.escapeExpression,s=e.lambda;return"                <li class='jw-option jw-text jw-item-"+a((r=null!=(r=n.index||o&&o.index)?r:n.helperMissing,"function"==typeof r?r.call(null!=t?t:{},{name:"index",hash:{},data:o}):r))+' jw-reset\'>\n                    <span class="jw-label jw-reset">'+a(s(null!=t?t.label:t,t))+'</span>\n                    <span class="jw-name jw-reset">'+a(s(null!=t?t.title:t,t))+"</span>\n                </li>\n"},compiler:[7,">= 4.0.0"],main:function(e,t,n,i,o){var r;return'<div class="jw-menu jw-playlist-container jw-background-color jw-reset">\n\n    <div class="jw-tooltip-title jw-reset">\n        <span class="jw-icon jw-icon-inline jw-icon-playlist jw-reset"></span>\n        <span class="jw-text jw-reset">PLAYLIST</span>\n    </div>\n\n    <ul class="jw-playlist jw-reset">\n'+(null!=(r=n.each.call(null!=t?t:{},t,{name:"each",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o}))?r:"")+"    </ul>\n</div>"},useData:!0})},function(e,t,n){var i=n(11);e.exports=(i["default"]||i).template({1:function(e,t,n,i,o){var r,a,s=null!=t?t:{},l=n.helperMissing,c="function",u=e.escapeExpression;return'        <li class="jw-reset'+(null!=(r=n["if"].call(s,null!=t?t.featured:t,{name:"if",hash:{},fn:e.program(2,o,0),inverse:e.noop,data:o}))?r:"")+'">\n            <a href="'+u((a=null!=(a=n.link||(null!=t?t.link:t))?a:l,typeof a===c?a.call(s,{name:"link",hash:{},data:o}):a))+'" class="jw-reset" target="_top">\n'+(null!=(r=n["if"].call(s,null!=t?t.showLogo:t,{name:"if",hash:{},fn:e.program(4,o,0),inverse:e.noop,data:o}))?r:"")+"                "+u((a=null!=(a=n.title||(null!=t?t.title:t))?a:l,typeof a===c?a.call(s,{name:"title",hash:{},data:o}):a))+"\n            </a>\n        </li>\n"},2:function(e,t,n,i,o){return" jw-featured"},4:function(e,t,n,i,o){return'                <span class="jw-icon jw-rightclick-logo jw-reset"></span>\n'},compiler:[7,">= 4.0.0"],main:function(e,t,n,i,o){var r;return'<div class="jw-rightclick jw-reset">\n    <ul class="jw-reset">\n'+(null!=(r=n.each.call(null!=t?t:{},null!=t?t.items:t,{name:"each",hash:{},fn:e.program(1,o,0),inverse:e.noop,data:o}))?r:"")+"    </ul>\n</div>"},useData:!0})},function(e,t,n){var i=n(11);e.exports=(i["default"]||i).template({compiler:[7,">= 4.0.0"],main:function(e,t,n,i,o){var r,a=null!=t?t:{},s=n.helperMissing,l="function",c=e.escapeExpression;return'<div class="'+c((r=null!=(r=n.className||(null!=t?t.className:t))?r:s,typeof r===l?r.call(a,{name:"className",hash:{},data:o}):r))+" "+c((r=null!=(r=n.orientation||(null!=t?t.orientation:t))?r:s,typeof r===l?r.call(a,{name:"orientation",hash:{},data:o}):r))+' jw-reset" aria-hidden="true">\n    <div class="jw-slider-container jw-reset">\n        <div class="jw-rail jw-reset"></div>\n        <div class="jw-buffer jw-reset"></div>\n        <div class="jw-progress jw-reset"></div>\n        <div class="jw-knob jw-reset"></div>\n    </div>\n</div>'},useData:!0})},,function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{"default":e}}function o(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t["default"]=e,t}function r(){var e=new s.HandlebarsEnvironment;return h.extend(e,s),e.SafeString=c["default"],e.Exception=d["default"],e.Utils=h,e.escapeExpression=h.escapeExpression,e.VM=g,e.template=function(t){return g.template(t,e)},e}t.__esModule=!0;var a=n(63),s=o(a),l=n(156),c=i(l),u=n(26),d=i(u),p=n(12),h=o(p),f=n(155),g=o(f),m=n(154),v=i(m),w=r();w.create=r,v["default"](w),w["default"]=w,t["default"]=w,e.exports=t["default"]},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{"default":e}}function o(e){a["default"](e)}t.__esModule=!0,t.registerDefaultDecorators=o;var r=n(144),a=i(r)},function(e,t,n){"use strict";t.__esModule=!0;var i=n(12);t["default"]=function(e){e.registerDecorator("inline",function(e,t,n,o){var r=e;return t.partials||(t.partials={},r=function(o,r){var a=n.partials;n.partials=i.extend({},a,t.partials);var s=e(o,r);return n.partials=a,s}),t.partials[o.args[0]]=o.fn,r})},e.exports=t["default"]},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{"default":e}}function o(e){a["default"](e),l["default"](e),u["default"](e),p["default"](e),f["default"](e),m["default"](e),w["default"](e)}t.__esModule=!0,t.registerDefaultHelpers=o;var r=n(146),a=i(r),s=n(147),l=i(s),c=n(148),u=i(c),d=n(149),p=i(d),h=n(150),f=i(h),g=n(151),m=i(g),v=n(152),w=i(v)},function(e,t,n){"use strict";t.__esModule=!0;var i=n(12);t["default"]=function(e){e.registerHelper("blockHelperMissing",function(t,n){var o=n.inverse,r=n.fn;if(t===!0)return r(this);if(t===!1||null==t)return o(this);if(i.isArray(t))return t.length>0?(n.ids&&(n.ids=[n.name]),e.helpers.each(t,n)):o(this);if(n.data&&n.ids){var a=i.createFrame(n.data);a.contextPath=i.appendContextPath(n.data.contextPath,n.name),n={data:a}}return r(t,n)})},e.exports=t["default"]},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{"default":e}}t.__esModule=!0;var o=n(12),r=n(26),a=i(r);t["default"]=function(e){e.registerHelper("each",function(e,t){function n(t,n,r){c&&(c.key=t,c.index=n,c.first=0===n,c.last=!!r,u&&(c.contextPath=u+t)),l+=i(e[t],{data:c,blockParams:o.blockParams([e[t],t],[u+t,null])})}if(!t)throw new a["default"]("Must pass iterator to #each");var i=t.fn,r=t.inverse,s=0,l="",c=void 0,u=void 0;if(t.data&&t.ids&&(u=o.appendContextPath(t.data.contextPath,t.ids[0])+"."),o.isFunction(e)&&(e=e.call(this)),t.data&&(c=o.createFrame(t.data)),e&&"object"==typeof e)if(o.isArray(e))for(var d=e.length;s<d;s++)s in e&&n(s,s,s===e.length-1);else{var p=void 0;for(var h in e)e.hasOwnProperty(h)&&(void 0!==p&&n(p,s-1),p=h,s++);void 0!==p&&n(p,s-1,!0)}return 0===s&&(l=r(this)),l})},e.exports=t["default"]},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{"default":e}}t.__esModule=!0;var o=n(26),r=i(o);t["default"]=function(e){e.registerHelper("helperMissing",function(){if(1!==arguments.length)throw new r["default"]('Missing helper: "'+arguments[arguments.length-1].name+'"')})},e.exports=t["default"]},function(e,t,n){"use strict";t.__esModule=!0;var i=n(12);t["default"]=function(e){e.registerHelper("if",function(e,t){return i.isFunction(e)&&(e=e.call(this)),!t.hash.includeZero&&!e||i.isEmpty(e)?t.inverse(this):t.fn(this)}),e.registerHelper("unless",function(t,n){return e.helpers["if"].call(this,t,{fn:n.inverse,inverse:n.fn,hash:n.hash})})},e.exports=t["default"]},function(e,t){"use strict";t.__esModule=!0,t["default"]=function(e){e.registerHelper("log",function(){for(var t=[void 0],n=arguments[arguments.length-1],i=0;i<arguments.length-1;i++)t.push(arguments[i]);var o=1;null!=n.hash.level?o=n.hash.level:n.data&&null!=n.data.level&&(o=n.data.level),t[0]=o,e.log.apply(e,t)})},e.exports=t["default"]},function(e,t){"use strict";t.__esModule=!0,t["default"]=function(e){e.registerHelper("lookup",function(e,t){return e&&e[t]})},e.exports=t["default"]},function(e,t,n){"use strict";t.__esModule=!0;var i=n(12);t["default"]=function(e){e.registerHelper("with",function(e,t){i.isFunction(e)&&(e=e.call(this));var n=t.fn;if(i.isEmpty(e))return t.inverse(this);var o=t.data;return t.data&&t.ids&&(o=i.createFrame(t.data),o.contextPath=i.appendContextPath(t.data.contextPath,t.ids[0])),n(e,{data:o,blockParams:i.blockParams([e],[o&&o.contextPath])})})},e.exports=t["default"]},function(e,t,n){"use strict";t.__esModule=!0;var i=n(12),o={methodMap:["debug","info","warn","error"],level:"info",lookupLevel:function(e){if("string"==typeof e){var t=i.indexOf(o.methodMap,e.toLowerCase());e=t>=0?t:parseInt(e,10)}return e},log:function(e){if(e=o.lookupLevel(e),"undefined"!=typeof console&&o.lookupLevel(o.level)<=e){var t=o.methodMap[e];console[t]||(t="log");for(var n=arguments.length,i=Array(n>1?n-1:0),r=1;r<n;r++)i[r-1]=arguments[r];console[t].apply(console,i)}}};t["default"]=o,e.exports=t["default"]},function(e,t){(function(n){"use strict";t.__esModule=!0,t["default"]=function(e){var t="undefined"!=typeof n?n:window,i=t.Handlebars;e.noConflict=function(){return t.Handlebars===e&&(t.Handlebars=i),e}},e.exports=t["default"]}).call(t,function(){return this}())},function(e,t,n){"use strict";function i(e){return e&&e.__esModule?e:{"default":e}}function o(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t["default"]=e,t}function r(e){var t=e&&e[0]||1,n=v.COMPILER_REVISION;if(t!==n){if(t<n){var i=v.REVISION_CHANGES[n],o=v.REVISION_CHANGES[t];throw new m["default"]("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version ("+i+") or downgrade your runtime to an older version ("+o+").")}throw new m["default"]("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version ("+e[1]+").")}}function a(e,t){function n(n,i,o){o.hash&&(i=f.extend({},i,o.hash),o.ids&&(o.ids[0]=!0)),n=t.VM.resolvePartial.call(this,n,i,o);var r=t.VM.invokePartial.call(this,n,i,o);if(null==r&&t.compile&&(o.partials[o.name]=t.compile(n,e.compilerOptions,t),r=o.partials[o.name](i,o)),null!=r){if(o.indent){for(var a=r.split("\n"),s=0,l=a.length;s<l&&(a[s]||s+1!==l);s++)a[s]=o.indent+a[s];r=a.join("\n")}return r}throw new m["default"]("The partial "+o.name+" could not be compiled when running in runtime-only mode")}function i(t){function n(t){return""+e.main(o,t,o.helpers,o.partials,a,l,s)}var r=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],a=r.data;i._setup(r),!r.partial&&e.useData&&(a=d(t,a));var s=void 0,l=e.useBlockParams?[]:void 0;return e.useDepths&&(s=r.depths?t!==r.depths[0]?[t].concat(r.depths):r.depths:[t]),(n=p(e.main,n,o,r.depths||[],a,l))(t,r)}if(!t)throw new m["default"]("No environment passed to template");if(!e||!e.main)throw new m["default"]("Unknown template object: "+typeof e);e.main.decorator=e.main_d,t.VM.checkRevision(e.compiler);var o={strict:function(e,t){if(!(t in e))throw new m["default"]('"'+t+'" not defined in '+e);return e[t]},lookup:function(e,t){for(var n=e.length,i=0;i<n;i++)if(e[i]&&null!=e[i][t])return e[i][t]},lambda:function(e,t){return"function"==typeof e?e.call(t):e},escapeExpression:f.escapeExpression,invokePartial:n,fn:function(t){var n=e[t];return n.decorator=e[t+"_d"],n},programs:[],program:function(e,t,n,i,o){var r=this.programs[e],a=this.fn(e);return t||o||i||n?r=s(this,e,a,t,n,i,o):r||(r=this.programs[e]=s(this,e,a)),r},data:function(e,t){for(;e&&t--;)e=e._parent;return e},merge:function(e,t){var n=e||t;return e&&t&&e!==t&&(n=f.extend({},t,e)),n},noop:t.VM.noop,compilerInfo:e.compiler};return i.isTop=!0,i._setup=function(n){n.partial?(o.helpers=n.helpers,o.partials=n.partials,o.decorators=n.decorators):(o.helpers=o.merge(n.helpers,t.helpers),e.usePartial&&(o.partials=o.merge(n.partials,t.partials)),(e.usePartial||e.useDecorators)&&(o.decorators=o.merge(n.decorators,t.decorators)))},i._child=function(t,n,i,r){if(e.useBlockParams&&!i)throw new m["default"]("must pass block params");if(e.useDepths&&!r)throw new m["default"]("must pass parent depths");return s(o,t,e[t],n,0,i,r)},i}function s(e,t,n,i,o,r,a){function s(t){var o=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],s=a;return a&&t!==a[0]&&(s=[t].concat(a)),n(e,t,e.helpers,e.partials,o.data||i,r&&[o.blockParams].concat(r),s)}return s=p(n,s,e,a,i,r),s.program=t,s.depth=a?a.length:0,s.blockParams=o||0,s}function l(e,t,n){return e?e.call||n.name||(n.name=e,e=n.partials[e]):e="@partial-block"===n.name?n.data["partial-block"]:n.partials[n.name],e}function c(e,t,n){n.partial=!0,n.ids&&(n.data.contextPath=n.ids[0]||n.data.contextPath);var i=void 0;if(n.fn&&n.fn!==u&&(n.data=v.createFrame(n.data),i=n.data["partial-block"]=n.fn,i.partials&&(n.partials=f.extend({},n.partials,i.partials))),void 0===e&&i&&(e=i),void 0===e)throw new m["default"]("The partial "+n.name+" could not be found");if(e instanceof Function)return e(t,n)}function u(){return""}function d(e,t){return t&&"root"in t||(t=t?v.createFrame(t):{},t.root=e),t}function p(e,t,n,i,o,r){if(e.decorator){var a={};t=e.decorator(t,a,n,i&&i[0],o,r,i),f.extend(t,a)}return t}t.__esModule=!0,t.checkRevision=r,t.template=a,t.wrapProgram=s,t.resolvePartial=l,t.invokePartial=c,t.noop=u;var h=n(12),f=o(h),g=n(26),m=i(g),v=n(63)},function(e,t){"use strict";function n(e){this.string=e}t.__esModule=!0,n.prototype.toString=n.prototype.toHTML=function(){return""+this.string},t["default"]=n,e.exports=t["default"]},function(e,t,n){var i,o;i=[n(27),n(1)],o=function(e,t){return function(n,i){var o=["seek","skipAd","stop","playlistNext","playlistPrev","playlistItem","resize","addButton","removeButton","registerPlugin","attachMedia"];t.each(o,function(e){n[e]=function(){return i[e].apply(i,arguments),n}}),n.registerPlugin=e.registerPlugin}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1)],o=function(e){return function(t,n){var i=["buffer","controls","position","duration","fullscreen","volume","mute","item","stretching","playlist","captions"];e.each(i,function(e){var i=e.slice(0,1).toUpperCase()+e.slice(1);t["get"+i]=function(){return n._model.get(e)}});var o=["getAudioTracks","getCaptionsList","getWidth","getHeight","getCurrentAudioTrack","setCurrentAudioTrack","getCurrentCaptions","setCurrentCaptions","getCurrentQuality","setCurrentQuality","getQualityLevels","getVisualQuality","getConfig","getState","getSafeRegion","isBeforeComplete","isBeforePlay","getProvider","detachMedia"],r=["setControls","setFullscreen","setVolume","setMute","setCues","setCaptions"];e.each(o,function(e){t[e]=function(){return n[e]?n[e].apply(n,arguments):null}}),e.each(r,function(e){t[e]=function(){return n[e].apply(n,arguments),t}}),t.getPlaylistIndex=t.getItem}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(4),n(5),n(3),n(2),n(80),n(1),n(211),n(157),n(158),n(160),n(31)],o=function(e,t,n,i,o,r,a,s,l,c,u){var d=function(d,p){var h,f=this,g=!1,m={};r.extend(this,n),this.utils=i,this._=r,this.Events=n,this.version=u,this.trigger=function(e,t){return t=r.isObject(t)?r.extend({},t):{},t.type=e,window.jwplayer&&window.jwplayer.debug?n.trigger.call(f,e,t):n.triggerSafe.call(f,e,t)},this.dispatchEvent=this.trigger,this.removeEventListener=this.off.bind(this);var v=function(){h=new a(d),s(f,h),l(f,h),h.on(e.JWPLAYER_PLAYLIST_ITEM,function(){m={}}),h.on(e.JWPLAYER_MEDIA_META,function(e){r.extend(m,e.metadata)}),h.on(e.JWPLAYER_READY,function(e){g=!0,w.tick("ready"),e.setupTime=w.between("setup","ready")}),h.on("all",f.trigger)};v(),c(this),this.id=d.id;var w=this._qoe=new o;w.tick("init");var y=function(){g=!1,m={},f.off(),h&&h.off(),h&&h.playerDestroy&&h.playerDestroy()};return this.getPlugin=function(e){return f.plugins&&f.plugins[e]},this.addPlugin=function(e,t){this.plugins=this.plugins||{},this.plugins[e]=t,this.onReady(t.addToPlayer),t.resize&&this.onResize(t.resizeHandler)},this.setup=function(e){return w.tick("setup"),y(),v(),i.foreach(e.events,function(e,t){var n=f[e];"function"==typeof n&&n.call(f,t)}),e.id=f.id,h.setup(e,this),f},this.qoe=function(){var t=h.getItemQoe(),n=w.between("setup","ready"),i=t.between(e.JWPLAYER_MEDIA_PLAY_ATTEMPT,e.JWPLAYER_MEDIA_FIRST_FRAME);return{setupTime:n,firstFrame:i,player:w.dump(),item:t.dump()}},this.getContainer=function(){return h.getContainer?h.getContainer():d},this.getMeta=this.getItemMeta=function(){return m},this.getPlaylistItem=function(e){if(!i.exists(e))return h._model.get("playlistItem");var t=f.getPlaylist();return t?t[e]:null},this.getRenderingMode=function(){return"html5"},this.load=function(e){var t=this.getPlugin("vast")||this.getPlugin("googima");return t&&t.destroy(),h.load(e),f},this.play=function(e,n){if(r.isBoolean(e)||(n=e),n||(n={reason:"external"}),e===!0)return h.play(n),f;if(e===!1)return h.pause(),f;switch(e=f.getState()){case t.PLAYING:case t.BUFFERING:h.pause();break;default:h.play(n)}return f},this.pause=function(e){return r.isBoolean(e)?this.play(!e):this.play()},this.createInstream=function(){return h.createInstream()},this.castToggle=function(){h&&h.castToggle&&h.castToggle()},this.playAd=this.pauseAd=i.noop,this.remove=function(){return p(f),f.trigger("remove"),y(),f},this};return d}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1),n(4)],o=function(e,t){return function(n){var i={onBufferChange:t.JWPLAYER_MEDIA_BUFFER,onBufferFull:t.JWPLAYER_MEDIA_BUFFER_FULL,onError:t.JWPLAYER_ERROR,onSetupError:t.JWPLAYER_SETUP_ERROR,onFullscreen:t.JWPLAYER_FULLSCREEN,onMeta:t.JWPLAYER_MEDIA_META,onMute:t.JWPLAYER_MEDIA_MUTE,onPlaylist:t.JWPLAYER_PLAYLIST_LOADED,onPlaylistItem:t.JWPLAYER_PLAYLIST_ITEM,onPlaylistComplete:t.JWPLAYER_PLAYLIST_COMPLETE,onReady:t.JWPLAYER_READY,onResize:t.JWPLAYER_RESIZE,onComplete:t.JWPLAYER_MEDIA_COMPLETE,onSeek:t.JWPLAYER_MEDIA_SEEK,onTime:t.JWPLAYER_MEDIA_TIME,onVolume:t.JWPLAYER_MEDIA_VOLUME,onBeforePlay:t.JWPLAYER_MEDIA_BEFOREPLAY,onBeforeComplete:t.JWPLAYER_MEDIA_BEFORECOMPLETE,onDisplayClick:t.JWPLAYER_DISPLAY_CLICK,onControls:t.JWPLAYER_CONTROLS,onQualityLevels:t.JWPLAYER_MEDIA_LEVELS,onQualityChange:t.JWPLAYER_MEDIA_LEVEL_CHANGED,onCaptionsList:t.JWPLAYER_CAPTIONS_LIST,onCaptionsChange:t.JWPLAYER_CAPTIONS_CHANGED,onAdError:t.JWPLAYER_AD_ERROR,onAdClick:t.JWPLAYER_AD_CLICK,onAdImpression:t.JWPLAYER_AD_IMPRESSION,onAdTime:t.JWPLAYER_AD_TIME,onAdComplete:t.JWPLAYER_AD_COMPLETE,onAdCompanions:t.JWPLAYER_AD_COMPANIONS,onAdSkipped:t.JWPLAYER_AD_SKIPPED,onAdPlay:t.JWPLAYER_AD_PLAY,onAdPause:t.JWPLAYER_AD_PAUSE,onAdMeta:t.JWPLAYER_AD_META,onCast:t.JWPLAYER_CAST_SESSION,onAudioTrackChange:t.JWPLAYER_AUDIO_TRACK_CHANGED,onAudioTracks:t.JWPLAYER_AUDIO_TRACKS},o={onBuffer:"buffer",onPause:"pause",onPlay:"play",onIdle:"idle"};e.each(o,function(t,i){n[i]=e.partial(n.on,t,e)}),e.each(i,function(t,i){n[i]=e.partial(n.on,t,e)})}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(159),n(1),n(51),n(50),n(27)],o=function(e,t,n,i,o){var r=[],a=0,s=function(t){var n,i;return t?"string"==typeof t?(n=l(t),n||(i=document.getElementById(t))):"number"==typeof t?n=r[t]:t.nodeType&&(i=t,n=l(i.id)):n=r[0],n?n:i?c(new e(i,u)):{registerPlugin:o.registerPlugin}},l=function(e){for(var t=0;t<r.length;t++)if(r[t].id===e)return r[t];return null},c=function(e){return a++,e.uniqueId=a,r.push(e),e},u=function(e){for(var t=r.length;t--;)if(r[t].uniqueId===e.uniqueId){r.splice(t,1);break}},d={selectPlayer:s,registerProvider:n.registerProvider,availableProviders:i,registerPlugin:o.registerPlugin};return s.api=d,d}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(212),n(3),n(1),n(4)],o=function(e,t,n,i){var o=function(t,o,r,a){function s(){p("Setup Timeout Error","Setup took longer than "+m+" seconds to complete.")}function l(){n.each(g,function(e){e.complete!==!0&&e.running!==!0&&null!==t&&u(e.depends)&&(e.running=!0,c(e))})}function c(e){var n=function(t){t=t||{},d(e,t)};e.method(n,o,t,r,a)}function u(e){return n.all(e,function(e){return g[e].complete})}function d(e,t){"error"===t.type?p(t.msg,t.reason):"complete"===t.type?(clearTimeout(h),f.trigger(i.JWPLAYER_READY)):(e.complete=!0,l())}function p(e,t){clearTimeout(h),f.trigger(i.JWPLAYER_SETUP_ERROR,{message:e+": "+t}),f.destroy()}var h,f=this,g=e.getQueue(),m=30;this.start=function(){h=setTimeout(s,1e3*m),l()},this.destroy=function(){clearTimeout(h),this.off(),g.length=0,t=null,o=null,r=null}};return o.prototype=t,o}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[],o=function(){var e=function(e,t){function n(e){if(e.tracks.length){d=[],p={},h={},f=0;for(var t=e.tracks||[],n=0;n<t.length;n++){var i=t[n];i.label=i.label||i.name||i.language,a(i)}var o=s();this.setCaptionsList(o),l()}}function i(e,t){u=t,d=[],p={},h={},f=0}function o(e){i(t,e),t.mediaController.on("subtitlesTracks",n,this);var o=s();this.setCaptionsList(o),l()}function r(e,t){var n=null;0!==t&&(n=d[t-1]),e.set("captionsTrack",n)}function a(e){e.data=e.data||[],e.label||(e.label="Unknown CC",f++,f>1&&(e.label+=" ("+f+")")),d.push(e),p[e._id]=e}function s(){for(var e=[{id:"off",label:"Off"}],t=0;t<d.length;t++)e.push({id:d[t]._id,label:d[t].label||"Unknown CC"});return e}function l(){var e=0,n=t.get("captionLabel");if("Off"===n)return void t.set("captionsIndex",0);for(var i=0;i<d.length;i++){var o=d[i];if(n&&n===o.label){e=i+1;break}o["default"]||o.defaulttrack||"default"===o._id?e=i+1:o.autoselect}c(e)}function c(e){d.length?t.setVideoSubtitleTrack(e,d):t.set("captionsIndex",e)}t.on("change:playlistItem",i,this),t.on("change:captionsIndex",r,this),t.on("itemReady",o,this),t.mediaController.on("subtitlesTracks",n,this);var u={},d=[],p={},h={},f=0;this.getCurrentIndex=function(){return t.get("captionsIndex")},this.getCaptionsList=function(){return t.get("captionsList")},this.setCaptionsList=function(e){t.set("captionsList",e)}};return e}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(64),n(165),n(1),n(162),n(163),n(33),n(170),n(67),n(66),n(2),n(93),n(3),n(42),n(5),n(4),n(197)],o=function(e,t,n,i,o,r,a,s,l,c,u,d,p,h,f,g){function m(e){return function(){var t=Array.prototype.slice.call(arguments,0);this._model.getVideo()?this["_"+e].apply(this,t):this.eventsQueue.push([e,t])}}function v(e){return e===h.LOADING||e===h.STALLED?h.BUFFERING:e}var w=function(e){this.originalContainer=this.currentContainer=e,this.eventsQueue=[],n.extend(this,d),this._model=new r};return w.prototype={play:m("play"),pause:m("pause"),seek:m("seek"),stop:m("stop"),load:m("load"),playlistNext:m("next"),playlistPrev:m("prev"),playlistItem:m("item"),setCurrentCaptions:m("setCurrentCaptions"),setCurrentQuality:m("setCurrentQuality"),setFullscreen:m("setFullscreen"),setup:function(r,d){function g(e,t){oe.triggerAfterReady(e,t)}function m(){$=null,X.on("all",g,oe),oe.showView(X.element()),n.defer(w)}function w(){oe.trigger(f.JWPLAYER_READY,{setupTime:0}),oe.triggerAfterReady=oe.trigger;for(var e=0;e<le.length;e++){var t=le[e];oe.trigger(t.type,t.args)}te.get("autostart")&&oe.play({reason:"autostart"})}function y(e){var t=te.getProviders(),n=t.required(e);return t.load(n).then(function(){oe.getProvider()||(te.setProvider(te.get("playlistItem")),j())})}function j(){for(;oe.eventsQueue.length>0;){var e=oe.eventsQueue.shift(),t=e[0],n=e[1]||[];oe["_"+t].apply(oe,n)}}function b(e){switch(te.get("state")===h.ERROR&&te.set("state",h.IDLE),C(!0),te.get("autostart")&&te.once("itemReady",A),typeof e){case"string":E(e);break;case"object":var t=R(e);t&&I(0);break;case"number":I(e)}}function E(e){var t=new l;t.on(f.JWPLAYER_PLAYLIST_LOADED,function(e){b(e.playlist)}),t.on(f.JWPLAYER_ERROR,function(e){e.message="Error loading playlist: "+e.message,this.triggerError(e)},this),t.load(e)}function k(){return oe._instreamAdapter&&oe._instreamAdapter.getState()}function L(){var e=k();return n.isString(e)?e:te.get("state")}function A(e){var t;if(e&&te.set("playReason",e.reason),te.get("state")!==h.ERROR){var i=k();if(n.isString(i))return d.pauseAd(!1);if(te.get("state")===h.COMPLETE&&(C(!0),I(0)),!ne&&(ne=!0,oe.trigger(f.JWPLAYER_MEDIA_BEFOREPLAY,{playReason:te.get("playReason")}),ne=!1,ee))return ee=!1,void(Z=null);if(x()){if(0===te.get("playlist").length)return!1;t=c.tryCatch(function(){te.loadVideo()})}else te.get("state")===h.PAUSED&&(t=c.tryCatch(function(){te.playVideo()}));return!(t instanceof c.Error)||(oe.triggerError(t),Z=null,!1)}}function C(e){te.off("itemReady",A);var t=!e;Z=null;var n=c.tryCatch(function(){te.stopVideo()},oe);return n instanceof c.Error?(oe.triggerError(n),!1):(t&&(ie=!0),ne&&(ee=!0),!0)}function _(){Z=null;var e=k();if(n.isString(e))return d.pauseAd(!0);switch(te.get("state")){case h.ERROR:return!1;case h.PLAYING:case h.BUFFERING:var t=c.tryCatch(function(){re().pause()},this);if(t instanceof c.Error)return oe.triggerError(t),!1;break;default:ne&&(ee=!0)}return!0}function x(){var e=te.get("state");return e===h.IDLE||e===h.COMPLETE||e===h.ERROR}function P(e){te.get("state")!==h.ERROR&&(te.get("scrubbing")||te.get("state")===h.PLAYING||A(!0),re().seek(e))}function T(e,t){C(!0),I(e),A(t)}function R(e){var t=s(e);return t=s.filterPlaylist(t,te.getProviders(),te.get("androidhls"),te.get("drm"),te.get("preload"),te.get("feedid"),te.get("withCredentials")),te.set("playlist",t),n.isArray(t)&&0!==t.length?(y(t),!0):(oe.triggerError({message:"Error loading playlist: No playable sources found"}),!1)}function I(e){te.setItemIndex(e)}function M(e){T(te.get("item")-1,e||{reason:"external"})}function S(e){T(te.get("item")+1,e||{reason:"external"})}function O(){if(x()){if(ie)return void(ie=!1);Z=O;var e=te.get("item");return e===te.get("playlist").length-1?void(te.get("repeat")?S({reason:"repeat"}):(te.set("state",h.COMPLETE),oe.trigger(f.JWPLAYER_PLAYLIST_COMPLETE,{}))):void S({reason:"playlist"})}}function D(e){re()&&(e=parseInt(e,10)||0,re().setCurrentQuality(e))}function N(){return re()?re().getCurrentQuality():-1}function Y(){if(this._model)return this._model.getConfiguration()}function W(){if(this._model.mediaModel)return this._model.mediaModel.get("visualQuality");var e=F();if(e){var t=N(),i=e[t];if(i)return{level:n.extend({index:t},i),mode:"",reason:""}}return null}function F(){return re()?re().getQualityLevels():null}function J(e){re()&&(e=parseInt(e,10)||0,re().setCurrentAudioTrack(e))}function V(){return re()?re().getCurrentAudioTrack():-1}function B(){return re()?re().getAudioTracks():null}function U(e){e=parseInt(e,10)||0,te.persistVideoSubtitleTrack(e),oe.trigger(f.JWPLAYER_CAPTIONS_CHANGED,{tracks:H(),track:e})}function z(){return q.getCurrentIndex()}function H(){return q.getCaptionsList()}function G(){var e=te.getVideo();if(e){var t=e.detachMedia();if(t instanceof HTMLVideoElement)return t}return null}function K(){var e=c.tryCatch(function(){te.getVideo().attachMedia()});return e instanceof c.Error?void c.log("Error calling _attachMedia",e):void("function"==typeof Z&&Z())}function Q(e){n.isBoolean(e)||(e=!te.get("fullscreen")),te.set("fullscreen",e),this._instreamAdapter&&this._instreamAdapter._adModel&&this._instreamAdapter._adModel.set("fullscreen",e)}var X,q,$,Z,ee,te=this._model,ne=!1,ie=!1,oe=this,re=function(){return te.getVideo()},ae=new a;ae.track(te);var se=new e(r,ae),le=[];te.setup(se,ae),X=this._view=new u(d,te),q=new o(d,te),$=new i(d,te,X,R),$.on(f.JWPLAYER_READY,m,this),$.on(f.JWPLAYER_SETUP_ERROR,this.setupError,this),te.mediaController.on("all",g,this),te.mediaController.on(f.JWPLAYER_MEDIA_COMPLETE,function(){n.defer(O)}),te.mediaController.on(f.JWPLAYER_MEDIA_ERROR,this.triggerError,this),te.on("change:flashBlocked",function(e,t){if(!t)return void this._model.set("errorEvent",void 0);var n=!!e.get("flashThrottle"),i={message:n?"Click to run Flash":"Flash plugin failed to load"};n||this.trigger(f.JWPLAYER_ERROR,i),this._model.set("errorEvent",i)},this),te.on("change:state",p,this),te.on("change:castState",function(e,t){oe.trigger(f.JWPLAYER_CAST_SESSION,t)}),te.on("change:fullscreen",function(e,t){oe.trigger(f.JWPLAYER_FULLSCREEN,{fullscreen:t})}),te.on("itemReady",function(){oe.triggerAfterReady(f.JWPLAYER_PLAYLIST_ITEM,{index:te.get("item"),item:te.get("playlistItem")})}),te.on("change:playlist",function(e,t){t.length&&oe.triggerAfterReady(f.JWPLAYER_PLAYLIST_LOADED,{playlist:t})}),te.on("change:volume",function(e,t){oe.trigger(f.JWPLAYER_MEDIA_VOLUME,{volume:t})}),te.on("change:mute",function(e,t){oe.trigger(f.JWPLAYER_MEDIA_MUTE,{mute:t})}),te.on("change:controls",function(e,t){oe.trigger(f.JWPLAYER_CONTROLS,{controls:t})}),te.on("change:scrubbing",function(e,t){t?_():A()}),te.on("change:captionsList",function(e,t){try{oe.triggerAfterReady(f.JWPLAYER_CAPTIONS_LIST,{tracks:t,track:z()})}catch(n){c.log("Error with captionsList event:",n)}}),te.on("change:mediaModel",function(e){e.mediaModel.on("change:state",function(t,n){var i=v(n);e.set("state",i)})}),this.triggerAfterReady=function(e,t){le.push({type:e,args:t})},this._play=A,this._pause=_,this._seek=P,this._stop=C,this._load=b,this._next=S,this._prev=M,this._item=T,this._setCurrentCaptions=U,this._setCurrentQuality=D,this._setFullscreen=Q,this.detachMedia=G,this.attachMedia=K,this.getCurrentQuality=N,this.getQualityLevels=F,this.setCurrentAudioTrack=J,this.getCurrentAudioTrack=V,this.getAudioTracks=B,this.getCurrentCaptions=z,this.getCaptionsList=H,this.getVisualQuality=W,this.getConfig=Y,this.getState=L,this.setVolume=te.setVolume.bind(te),this.setMute=te.setMute.bind(te),this.getProvider=function(){return te.get("provider")},this.getWidth=function(){return te.get("containerWidth")},this.getHeight=function(){return te.get("containerHeight")},this.getContainer=function(){return this.currentContainer},this.resize=X.resize,this.getSafeRegion=X.getSafeRegion,this.setCues=X.addCues,this.setCaptions=X.setCaptions,this.addButton=function(e,t,i,o,r){var a={img:e,tooltip:t,callback:i,id:o,btnClass:r},s=te.get("dock");s=s?s.slice(0):[],s=n.reject(s,n.matches({id:a.id})),s.push(a),te.set("dock",s)},this.removeButton=function(e){var t=te.get("dock")||[];t=n.reject(t,n.matches({id:e})),te.set("dock",t)},this.checkBeforePlay=function(){return ne},this.getItemQoe=function(){return te._qoeItem},this.setControls=function(e){n.isBoolean(e)||(e=!te.get("controls")),te.set("controls",e);var t=te.getVideo();t&&t.setControls(e)},this.playerDestroy=function(){this.stop(),this.showView(this.originalContainer),X&&X.destroy(),te&&te.destroy(),$&&($.destroy(),$=null)},this.isBeforePlay=this.checkBeforePlay,this.isBeforeComplete=function(){return te.getVideo().checkComplete()},this.createInstream=function(){return this.instreamDestroy(),this._instreamAdapter=new t(this,te,X),this._instreamAdapter},this.skipAd=function(){this._instreamAdapter&&this._instreamAdapter.skipAd()},this.instreamDestroy=function(){oe._instreamAdapter&&oe._instreamAdapter.destroy()},$.start()},showView:function(e){(document.documentElement.contains(this.currentContainer)||(this.currentContainer=document.getElementById(this._model.get("id")),this.currentContainer))&&(this.currentContainer.parentElement&&this.currentContainer.parentElement.replaceChild(e,this.currentContainer),this.currentContainer=e)},triggerError:function(e){this._model.set("errorEvent",e),this._model.set("state",h.ERROR),
	this._model.once("change:state",function(){this._model.set("errorEvent",void 0)},this),this.trigger(f.JWPLAYER_ERROR,e)},setupError:function(e){var t=e.message,i=c.createElement(g(this._model.get("id"),this._model.get("skin"),t)),o=this._model.get("width"),r=this._model.get("height");c.style(i,{width:o.toString().indexOf("%")>0?o:o+"px",height:r.toString().indexOf("%")>0?r:r+"px"}),this.showView(i);var a=this;n.defer(function(){a.trigger(f.JWPLAYER_SETUP_ERROR,{message:t})})}},w}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(167),n(166),n(4),n(5),n(2),n(3),n(1)],o=function(e,t,n,i,o,r,a){function s(n){var i="",o=n.get("provider");return o&&(i=o.name),i.indexOf("flash")>=0?t:e}var l={skipoffset:null,tag:null},c=function(e,t,r){function c(){y._adModel.set("state","buffering"),t.set("skipButton",!1),j++;var e,n=h[j];f&&(e=f[j]),E.loadItem(n,e)}function u(e,t){"complete"!==e&&(t=t||{},b.tag&&!t.tag&&(t.tag=b.tag),this.trigger(e,t),"mediaError"!==e&&"error"!==e||h&&j+1<h.length&&c())}function d(e){y._adModel.set("duration",e.duration),y._adModel.set("position",e.position)}function p(e){var t={};b.tag&&(t.tag=b.tag),h&&j+1<h.length?(this.trigger(n.JWPLAYER_MEDIA_COMPLETE,t),c()):(e.type===n.JWPLAYER_MEDIA_COMPLETE&&(this.trigger(n.JWPLAYER_MEDIA_COMPLETE,t),this.trigger(n.JWPLAYER_PLAYLIST_COMPLETE,{})),this.destroy())}var h,f,g,m,v,w=s(t),y=new w(e,t),j=0,b={},E=this,k=a.bind(function(e){e=e||{},e.hasControls=!!t.get("controls"),this.trigger(n.JWPLAYER_INSTREAM_CLICK,e),y&&y._adModel&&(y._adModel.get("state")===i.PAUSED?e.hasControls&&y.instreamPlay():y.instreamPause())},this),L=a.bind(function(){y&&y._adModel&&y._adModel.get("state")===i.PAUSED&&t.get("controls")&&(e.setFullscreen(),e.play())},this);this.type="instream",this.init=function(){g=t.getVideo(),m=t.get("position"),v=t.get("playlist")[t.get("item")],y.on("all",u,this),y.on(n.JWPLAYER_MEDIA_TIME,d,this),y.on(n.JWPLAYER_MEDIA_COMPLETE,p,this),y.init(),g.detachMedia(),t.mediaModel.set("state",i.BUFFERING),e.checkBeforePlay()||0===m&&!g.checkComplete()?(m=0,t.set("preInstreamState","instream-preroll")):g&&g.checkComplete()||t.get("state")===i.COMPLETE?t.set("preInstreamState","instream-postroll"):t.set("preInstreamState","instream-midroll");var a=t.get("state");return a!==i.PLAYING&&a!==i.BUFFERING||g.pause(),r.setupInstream(y._adModel),y._adModel.set("state",i.BUFFERING),r.clickHandler().setAlternateClickHandlers(o.noop,null),this.setText(t.get("localization").loadingAd),this},this.loadItem=function(e,i){if(o.isAndroid(2.3))return void this.trigger({type:n.JWPLAYER_ERROR,message:"Error loading instream: Cannot play instream on Android 2.3"});var r=e;a.isArray(e)?(h=e,f=i,e=h[j],f&&(i=f[j])):r=[e];var s=this,c=t.getProviders(),u=c.required(r);t.set("hideAdsControls",!1),c.load(u).then(function(){if(null!==y){s.trigger(n.JWPLAYER_PLAYLIST_ITEM,{index:j,item:e}),b=a.extend({},l,i),y.load(e),s.addClickHandler();var o=e.skipoffset||b.skipoffset;o&&(y._adModel.set("skipMessage",b.skipMessage),y._adModel.set("skipText",b.skipText),y._adModel.set("skipOffset",o),t.set("skipButton",!0))}})},this.applyProviderListeners=function(e){y.applyProviderListeners(e),this.addClickHandler()},this.play=function(){y.instreamPlay()},this.pause=function(){y.instreamPause()},this.addClickHandler=function(){r.clickHandler().setAlternateClickHandlers(k,L),y.on(n.JWPLAYER_MEDIA_META,this.metaHandler,this)},this.skipAd=function(e){var t=n.JWPLAYER_AD_SKIPPED;this.trigger(t,e),p.call(this,{type:t})},this.metaHandler=function(e){e.width&&e.height&&r.resizeMedia()},this.destroy=function(){if(this.off(),t.set("skipButton",!1),y){r.clickHandler()&&r.clickHandler().revertAlternateClickHandlers(),y.instreamDestroy(),r.destroyInstream(),y=null,e.attachMedia();var n=t.get("preInstreamState");switch(n){case"instream-preroll":case"instream-midroll":var s=a.extend({},v);s.starttime=m,t.loadVideo(s),o.isMobile()&&t.mediaModel.get("state")===i.BUFFERING&&g.setState(i.BUFFERING),g.play();break;case"instream-postroll":case"instream-idle":g.stop()}}},this.getState=function(){return!(!y||!y._adModel)&&y._adModel.get("state")},this.setText=function(e){r.setAltText(e?e:"")},this.hide=function(){t.set("hideAdsControls",!0)}};return a.extend(c.prototype,r),c}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(3),n(33),n(42),n(4),n(5),n(2),n(1)],o=function(e,t,n,i,o,r,a){var s=function(e,i){this.model=i,this._adModel=(new t).setup({id:i.get("id"),volume:i.get("volume"),fullscreen:i.get("fullscreen"),mute:i.get("mute")}),this._adModel.on("change:state",n,this);var o=e.getContainer();this.swf=o.querySelector("object")};return s.prototype=a.extend({init:function(){if(r.isChrome()){var e=-1,t=!1;this.swf.on("throttle",function(n){if(clearTimeout(e),"resume"===n.state)t&&(t=!1,this.instreamPlay());else{var i=this;e=setTimeout(function(){i._adModel.get("state")===o.PLAYING&&(t=!0,i.instreamPause())},250)}},this)}this.swf.on("instream:state",function(e){switch(e.newstate){case o.PLAYING:this._adModel.set("state",e.newstate);break;case o.PAUSED:this._adModel.set("state",e.newstate)}},this).on("instream:time",function(e){this._adModel.set("position",e.position),this._adModel.set("duration",e.duration),this.trigger(i.JWPLAYER_MEDIA_TIME,e)},this).on("instream:complete",function(e){this.trigger(i.JWPLAYER_MEDIA_COMPLETE,e)},this).on("instream:error",function(e){this.trigger(i.JWPLAYER_MEDIA_ERROR,e)},this),this.swf.triggerFlash("instream:init"),this.applyProviderListeners=function(e){this.model.on("change:volume",function(t,n){e.volume(n)},this),this.model.on("change:mute",function(t,n){e.mute(n)},this)}},instreamDestroy:function(){this._adModel&&(this.off(),this.swf.off(null,null,this),this.swf.triggerFlash("instream:destroy"),this.swf=null,this._adModel.off(),this._adModel=null,this.model=null)},load:function(e){this.swf.triggerFlash("instream:load",e)},instreamPlay:function(){this.swf.triggerFlash("instream:play")},instreamPause:function(){this.swf.triggerFlash("instream:pause")}},e),s}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1),n(3),n(42),n(4),n(5),n(33)],o=function(e,t,n,i,o,r){var a=function(a,s){function l(t){var o=t||p.getVideo();if(h!==o){if(h=o,!o)return;o.off(),o.on("all",function(t,n){n=e.extend({},n,{type:t}),this.trigger(t,n)},f),o.on(i.JWPLAYER_MEDIA_BUFFER_FULL,d),o.on(i.JWPLAYER_PLAYER_STATE,c),o.attachMedia(),o.volume(s.get("volume")),o.mute(s.get("mute")),p.on("change:state",n,f)}}function c(e){switch(e.newstate){case o.PLAYING:p.set("state",e.newstate);break;case o.PAUSED:p.set("state",e.newstate)}}function u(e){s.trigger(e.type,e),f.trigger(i.JWPLAYER_FULLSCREEN,{fullscreen:e.jwstate})}function d(){p.getVideo().play()}var p,h,f=e.extend(this,t);return a.on(i.JWPLAYER_FULLSCREEN,function(e){this.trigger(i.JWPLAYER_FULLSCREEN,e)},f),this.init=function(){p=(new r).setup({id:s.get("id"),volume:s.get("volume"),fullscreen:s.get("fullscreen"),mute:s.get("mute"),instreamMode:!0}),p.on("fullscreenchange",u),this._adModel=p},f.load=function(e){p.set("item",0),p.set("playlistItem",e),p.setActiveItem(e),l(),p.off(i.JWPLAYER_ERROR),p.on(i.JWPLAYER_ERROR,function(e){this.trigger(i.JWPLAYER_ERROR,e)},f),p.loadVideo(e)},f.applyProviderListeners=function(e){l(e),e.off(i.JWPLAYER_ERROR),e.on(i.JWPLAYER_ERROR,function(e){this.trigger(i.JWPLAYER_ERROR,e)},f),s.on("change:volume",function(e,t){h.volume(t)},f),s.on("change:mute",function(e,t){h.mute(t)},f)},this.instreamDestroy=function(){p&&(p.off(),this.off(),h&&(h.detachMedia(),h.off(),p.getVideo()&&h.destroy()),p=null,a.off(null,null,this),a=null)},f.instreamPlay=function(){p.getVideo()&&p.getVideo().play(!0)},f.instreamPause=function(){p.getVideo()&&p.getVideo().pause(!0)},f};return a}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(80),n(4),n(1)],o=function(e,t,n){function i(e){e.mediaController.off(t.JWPLAYER_MEDIA_PLAY_ATTEMPT,e._onPlayAttempt),e.mediaController.off(t.JWPLAYER_PROVIDER_FIRST_FRAME,e._triggerFirstFrame),e.mediaController.off(t.JWPLAYER_MEDIA_TIME,e._onTime)}function o(e){i(e),e._triggerFirstFrame=n.once(function(){var n=e._qoeItem;n.tick(t.JWPLAYER_MEDIA_FIRST_FRAME);var o=n.between(t.JWPLAYER_MEDIA_PLAY_ATTEMPT,t.JWPLAYER_MEDIA_FIRST_FRAME);e.mediaController.trigger(t.JWPLAYER_MEDIA_FIRST_FRAME,{loadTime:o}),i(e)}),e._onTime=a(e._triggerFirstFrame),e._onPlayAttempt=function(){e._qoeItem.tick(t.JWPLAYER_MEDIA_PLAY_ATTEMPT)},e.mediaController.on(t.JWPLAYER_MEDIA_PLAY_ATTEMPT,e._onPlayAttempt),e.mediaController.once(t.JWPLAYER_PROVIDER_FIRST_FRAME,e._triggerFirstFrame),e.mediaController.on(t.JWPLAYER_MEDIA_TIME,e._onTime)}function r(n){function i(n,i,r){n._qoeItem&&r&&n._qoeItem.end(r.get("state")),n._qoeItem=new e,n._qoeItem.tick(t.JWPLAYER_PLAYLIST_ITEM),n._qoeItem.start(i.get("state")),o(n),i.on("change:state",function(e,t,i){n._qoeItem.end(i),n._qoeItem.start(t)})}n.on("change:mediaModel",i)}var a=function(e){var t=Number.MIN_VALUE;return function(n){n.position>t&&e(),t=n.position}};return{model:r}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(27),n(66),n(22),n(28),n(1),n(2),n(4)],o=function(e,t,i,o,r,a,s){function l(){var e={LOAD_PROMISE_POLYFILL:{method:c,depends:[]},LOAD_BASE64_POLYFILL:{method:u,depends:[]},LOAD_VTTCUE_POLYFILL:{method:d,depends:[]},LOADED_POLYFILLS:{method:p,depends:["LOAD_PROMISE_POLYFILL","LOAD_BASE64_POLYFILL","LOAD_VTTCUE_POLYFILL"]},LOAD_PLUGINS:{method:h,depends:["LOADED_POLYFILLS"]},INIT_PLUGINS:{method:f,depends:["LOAD_PLUGINS","SETUP_VIEW"]},LOAD_SKIN:{method:b,depends:["LOADED_POLYFILLS"]},LOAD_PLAYLIST:{method:m,depends:["LOADED_POLYFILLS"]},FILTER_PLAYLIST:{method:v,depends:["LOAD_PLAYLIST"]},SETUP_VIEW:{method:E,depends:["LOAD_SKIN"]},SET_ITEM:{method:k,depends:["INIT_PLUGINS","FILTER_PLAYLIST"]},SEND_READY:{method:L,depends:["SETUP_VIEW","SET_ITEM"]}};return e}function c(e){window.Promise?e():n.e(9,function(require){n(71),e()})}function u(e){window.btoa&&window.atob?e():n.e(10,function(require){n(70),e()})}function d(e){window.VTTCue?e():n.e(7,function(require){n(73),e()})}function p(e){e()}function h(t,n){C=e.loadPlugins(n.get("id"),n.get("plugins")),C.on(s.COMPLETE,t),C.on(s.ERROR,r.partial(g,t)),C.load()}function f(e,t,n){C.setupPlugins(n,t),e()}function g(e,t){A(e,"Could not load plugin",t.message)}function m(e,n){var i=n.get("playlist");r.isString(i)?(_=new t,_.on(s.JWPLAYER_PLAYLIST_LOADED,function(t){n.set("playlist",t.playlist),n.set("feedid",t.feedid),e()}),_.on(s.JWPLAYER_ERROR,r.partial(w,e)),_.load(i)):e()}function v(e,t,n,i,o){var r=t.get("playlist"),a=o(r);a?e():w(e)}function w(e,t){t&&t.message?A(e,"Error loading playlist",t.message):A(e,"Error loading player","No playable sources found")}function y(e,t){if(r.contains(o.SkinsLoadable,e))return t+"skins/"+e+".css"}function j(e){for(var t=document.styleSheets,n=0,i=t.length;n<i;n++)if(t[n].href===e)return!0;return!1}function b(e,t){var n=t.get("skin"),a=t.get("skinUrl");if(r.contains(o.SkinsIncluded,n))return void e();if(a||(a=y(n,t.get("base"))),r.isString(a)&&!j(a)){t.set("skin-loading",!0);var l=!0,c=new i(a,l);c.addEventListener(s.COMPLETE,function(){t.set("skin-loading",!1)}),c.addEventListener(s.ERROR,function(){t.set("skin","seven"),t.set("skin-loading",!1)}),c.load()}r.defer(function(){e()})}function E(e,t,n,i){i.setup(),e()}function k(e,t){t.once("itemReady",e),t.setItemIndex(t.get("item"))}function L(e){e({type:"complete"})}function A(e,t,n){e({type:"error",msg:t,reason:n})}var C,_;return{getQueue:l,error:A}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1),n(2)],o=function(e,t){function n(e){return"jwplayer."+e}function i(){return e.reduce(this.persistItems,function(e,i){var o=c[n(i)];return o&&(e[i]=t.serialize(o)),e},{})}function o(e,t){try{c[n(e)]=t}catch(i){l&&l.debug&&console.error(i)}}function r(){e.each(this.persistItems,function(e){c.removeItem(n(e))})}function a(){this.persistItems=["volume","mute","captionLabel","qualityLabel"]}function s(t){e.each(this.persistItems,function(e){t.on("change:"+e,function(t,n){o(e,n)})})}var l=window.jwplayer,c={removeItem:t.noop};try{c=window.localStorage}catch(u){}return e.extend(a.prototype,{getAllItems:i,track:s,clear:r}),a}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(86),n(2)],o=function(e,t){return n.p=t.loadFrom(),e.selectPlayer}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(14),n(8),n(2)],o=function(e,t,n){var i="jwplayer",o=function(o,r){for(var a=[],s=[],l=t.xmlAttribute,c="default",u="label",d="file",p="type",h=0;h<o.childNodes.length;h++){var f=o.childNodes[h];if(f.prefix===i){var g=e.localName(f);"source"===g?(delete r.sources,a.push({file:l(f,d),"default":l(f,c),label:l(f,u),type:l(f,p)})):"track"===g?(delete r.tracks,s.push({file:l(f,d),"default":l(f,c),kind:l(f,"kind"),label:l(f,u)})):(r[g]=n.serialize(e.textContent(f)),"file"===g&&r.sources&&delete r.sources)}r[d]||(r[d]=r.link)}if(a.length)for(r.sources=[],h=0;h<a.length;h++)a[h].file.length>0&&(a[h][c]="true"===a[h][c],a[h].label.length||delete a[h].label,r.sources.push(a[h]));if(s.length)for(r.tracks=[],h=0;h<s.length;h++)s[h].file.length>0&&(s[h][c]="true"===s[h][c],s[h].kind=s[h].kind.length?s[h].kind:"captions",s[h].label.length||delete s[h].label,r.tracks.push(s[h]));return r};return o}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(14),n(8),n(2)],o=function(e,t,n){function i(e){for(var t=[],n=0;n<s(e);n++){var i=e.childNodes[n];"jwplayer"===i.prefix&&"mediatypes"===r(i).toLowerCase()&&t.push(a(i))}return t}var o=t.xmlAttribute,r=e.localName,a=e.textContent,s=e.numChildren,l="media",c=function(e,t){function u(e){var t={zh:"Chinese",nl:"Dutch",en:"English",fr:"French",de:"German",it:"Italian",ja:"Japanese",pt:"Portuguese",ru:"Russian",es:"Spanish"};return t[e]?t[e]:e}var d,p,h="tracks",f=[];for(p=0;p<s(e);p++)if(d=e.childNodes[p],d.prefix===l){if(!r(d))continue;switch(r(d).toLowerCase()){case"content":if(o(d,"duration")&&(t.duration=n.seconds(o(d,"duration"))),o(d,"url")){t.sources||(t.sources=[]);var g={file:o(d,"url"),type:o(d,"type"),width:o(d,"width"),label:o(d,"label")},m=i(d);m.length&&(g.mediaTypes=m),t.sources.push(g)}s(d)>0&&(t=c(d,t));break;case"title":t.title=a(d);break;case"description":t.description=a(d);break;case"guid":t.mediaid=a(d);break;case"thumbnail":t.image||(t.image=o(d,"url"));break;case"player":break;case"group":c(d,t);break;case"subtitle":var v={};v.file=o(d,"url"),v.kind="captions",o(d,"lang").length>0&&(v.label=u(o(d,"lang"))),f.push(v)}}for(t.hasOwnProperty(h)||(t[h]=[]),p=0;p<f.length;p++)t[h].push(f[p]);return t};return c}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1)],o=function(e){var t={kind:"captions","default":!1},n=function(n){if(n&&n.file)return e.extend({},t,n)};return n}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(34),n(2),n(4),n(3),n(1),n(22)],o=function(e,t,n,i,o,r){function a(e,t,n){return function(){var i=e.getContainer().getElementsByClassName("jw-overlays")[0];i&&(i.appendChild(n),n.left=i.style.left,n.top=i.style.top,t.displayArea=i)}}function s(e){function t(){var t=e.displayArea;t&&e.resize(t.clientWidth,t.clientHeight)}return function(){t(),setTimeout(t,400)}}var l=function(l,c){function u(){m||(m=!0,g=r.loaderstatus.COMPLETE,f.trigger(n.COMPLETE))}function d(){if(!w&&(c&&0!==o.keys(c).length||u(),!m)){var i=l.getPlugins();h=o.after(v,u),o.each(c,function(o,a){var s=e.getPluginName(a),l=i[s],c=l.getJS(),u=l.getTarget(),d=l.getStatus();d!==r.loaderstatus.LOADING&&d!==r.loaderstatus.NEW&&(c&&!t.versionCheck(u)&&f.trigger(n.ERROR,{message:"Incompatible player version"}),h())})}}function p(e){if(!w){var i="File not found";e.url&&t.log(i,e.url),this.off(),this.trigger(n.ERROR,{message:i}),d()}}var h,f=o.extend(this,i),g=r.loaderstatus.NEW,m=!1,v=o.size(c),w=!1;this.setupPlugins=function(n,i){var r=[],c=l.getPlugins(),u=i.get("plugins");o.each(u,function(i,l){var d=e.getPluginName(l),p=c[d],h=p.getFlashPath(),f=p.getJS(),g=p.getURL();if(h){var m=o.extend({name:d,swf:h,pluginmode:p.getPluginmode()},i);r.push(m)}var v=t.tryCatch(function(){if(f&&u[g]){var e=document.createElement("div");e.id=n.id+"_"+d,e.className="jw-plugin jw-reset";var t=o.extend({},u[g]),i=p.getNewInstance(n,t,e);i.addToPlayer=a(n,i,e),i.resizeHandler=s(i),n.addPlugin(d,i,e)}});v instanceof t.Error&&t.log("ERROR: Failed to load "+d+".")}),i.set("flashPlugins",r)},this.load=function(){if(t.exists(c)&&"object"!==t.typeOf(c))return void d();g=r.loaderstatus.LOADING,o.each(c,function(e,i){if(t.exists(i)){var o=l.addPlugin(i);o.on(n.COMPLETE,d),o.on(n.ERROR,p)}});var e=l.getPlugins();o.each(e,function(e){e.load()}),d()},this.destroy=function(){w=!0,this.off()},this.getStatus=function(){return g}};return l}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(34),n(69)],o=function(e,t){var n=function(n){this.addPlugin=function(i){var o=e.getPluginName(i);return n[o]||(n[o]=new t(i)),n[o]},this.getPlugins=function(){return n}};return n}.apply(t,i),!(void 0!==o&&(e.exports=o))},,function(e,t,n){var i,o;i=[],o=function(){return{}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(2),n(1),n(81)],o=function(e,t,n){function i(t){if("hls"===t.type)if(t.androidhls!==!1){var n=e.isAndroidNative;if(n(2)||n(3)||n("4.0"))return!1;if(e.isAndroid())return!0}else if(e.isAndroid())return!1;return null}var o=[{name:"youtube",supports:function(t){return e.isYouTube(t.file,t.type)}},{name:"html5",supports:function(t){var o={aac:"audio/mp4",mp4:"video/mp4",f4v:"video/mp4",m4v:"video/mp4",mov:"video/mp4",mp3:"audio/mpeg",mpeg:"audio/mpeg",ogv:"video/ogg",ogg:"video/ogg",oga:"video/ogg",vorbis:"video/ogg",webm:"video/webm",f4a:"video/aac",m3u8:"application/vnd.apple.mpegurl",m3u:"application/vnd.apple.mpegurl",hls:"application/vnd.apple.mpegurl"},r=t.file,a=t.type,s=i(t);if(null!==s)return s;if(e.isRtmp(r,a))return!1;if(!o[a])return!1;if(n.canPlayType){var l=n.canPlayType(o[a]);return!!l}return!1}},{name:"flash",supports:function(n){var i={flv:"video",f4v:"video",mov:"video",m4a:"video",m4v:"video",mp4:"video",aac:"video",f4a:"video",mp3:"sound",mpeg:"sound",smil:"rtmp"},o=t.keys(i);if(!e.isFlashSupported())return!1;var r=n.file,a=n.type;return!!e.isRtmp(r,a)||t.contains(o,a)}}];return o}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(20),n(50),n(178),n(1)],o=function(e,t,i,o){function r(e){this.providers=t.slice(),this.config=e||{},this.reorderProviders()}r.loaders={html5:function(e){n.e(4,function(require){var t=n(89);a(t),e(t)})},flash:function(e){n.e(5,function(require){var t=n(74);a(t),e(t)})},youtube:function(e){n.e(6,function(require){var t=n(75);a(t),e(t)})}};var a=r.registerProvider=function(n){var r=n.getName().name;if(!i[r]){if(!o.find(t,o.matches({name:r}))){if(!o.isFunction(n.supports))throw{message:"Tried to register a provider with an invalid object"};t.unshift({name:r,supports:n.supports})}var a=function(){};a.prototype=e,n.prototype=new a,i[r]=n}};return o.extend(r.prototype,{load:function(e){return Promise.all(o.map(e,function(e){return new Promise(function(t){var n=r.loaders[e.name];n?n(t):t()})}))},reorderProviders:function(){if("flash"===this.config.primary){var e=o.indexOf(this.providers,o.findWhere(this.providers,{name:"flash"})),t=this.providers.splice(e,1)[0],n=o.indexOf(this.providers,o.findWhere(this.providers,{name:"html5"}));this.providers.splice(n,0,t)}},providerSupports:function(e,t){return e.supports(t)},required:function(e){var t=this;return e=e.slice(),o.compact(o.map(this.providers,function(n){for(var i=!1,o=e.length;o--;){var r=e[o],a=t.providerSupports(n,r.sources[0]);a&&e.splice(o,1),i=i||a}if(i)return n}))},choose:function(e){e=o.isObject(e)?e:{};for(var t=this.providers.length,n=0;n<t;n++){var r=this.providers[n];if(this.providerSupports(r,e)){var a=t-n-1;return{priority:a,name:r.name,type:e.type,provider:i[r.name]}}}return null}}),r}.apply(t,i),!(void 0!==o&&(e.exports=o))},,function(e,t,n){var i,o;i=[],o=function(){return{hasClass:function(e,t){var n=" "+t+" ";return 1===e.nodeType&&(" "+e.className+" ").replace(/[\t\r\n\f]/g," ").indexOf(n)>=0}}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1),n(3)],o=function(e,t){var n=e.extend({get:function(e){return this.attributes=this.attributes||{},this.attributes[e]},set:function(e,t){if(this.attributes=this.attributes||{},this.attributes[e]!==t){var n=this.attributes[e];this.attributes[e]=t,this.trigger("change:"+e,this,t,n)}},clone:function(){return e.clone(this.attributes)}},t);return n}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[],o=function(){var e=function(e,n,i){if(n=n||this,i=i||[],window.jwplayer&&window.jwplayer.debug)return e.apply(n,i);try{return e.apply(n,i)}catch(o){return new t(e.name,o)}},t=function(e,t){this.name=e,this.message=t.message||t.toString(),this.error=t};return{tryCatch:e,Error:t}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(2),n(29),n(5),n(1),n(30)],o=function(e,t,i,o,r){var a=t.style,s={back:!0,fontSize:14,fontFamily:"Arial,sans-serif",fontOpacity:100,color:"#FFF",backgroundColor:"#000",backgroundOpacity:100,edgeStyle:null,windowColor:"#FFF",windowOpacity:0,preprocessor:o.identity},l=function(l){function c(e,n,i){if(t.css("#"+e+" .jw-text-track-display",n,e),t.css("#"+e+" .jw-text-track-cue",i,e),t.css("#"+e+" .jw-video::-webkit-media-text-track-display",n,e),t.css("#"+e+" .jw-video::cue",i,e),i.backgroundColor){var o="{background-color: "+i.backgroundColor+" !important;}";t.css("#"+e+" .jw-video::-webkit-media-text-track-display-backdrop",o,e)}}function u(e,n,i){var o=t.hexToRgba("#000000",i);"dropshadow"===e?n.textShadow="0 2px 1px "+o:"raised"===e?n.textShadow="0 0 5px "+o+", 0 1px 5px "+o+", 0 2px 5px "+o:"depressed"===e?n.textShadow="0 -2px 1px "+o:"uniform"===e&&(n.textShadow="-2px 0 1px "+o+",2px 0 1px "+o+",0 -2px 1px "+o+",0 2px 1px "+o+",-1px 1px 1px "+o+",1px 1px 1px "+o+",1px -1px 1px "+o+",1px 1px 1px "+o)}function d(e){g=e,this.selectCues(h,g)}function p(){r(l.get("provider").name)||n.e(8,function(require){y=n(72)})}var h,f,g,m,v,w,y,j={};m=document.createElement("div"),m.className="jw-captions jw-reset",this.show=function(){m.className="jw-captions jw-captions-enabled jw-reset"},this.hide=function(){m.className="jw-captions jw-reset"},this.populate=function(e){return f=[],h=e,e?void this.selectCues(e,g):(f=[],void this.renderCues())},this.resize=function(){var e=m.clientWidth,t=Math.pow(e/400,.6);if(t){var n=j.fontSize*t;a(m,{fontSize:Math.floor(2*n)/2+"px"})}this.renderCues(!0)},this.renderCues=function(e){e=!!e,y&&y.WebVTT.processCues(window,f,m,e)},this.selectCues=function(e,t){var n,i;e&&e.data&&t&&(i=this.getAlignmentPosition(e,t),i!==!1&&(n=this.getCurrentCues(e.data,i),this.updateCurrentCues(n),this.renderCues(!0)))},this.getCurrentCues=function(e,t){return o.filter(e,function(e){return t>=e.startTime&&(!e.endTime||t<=e.endTime)})},this.updateCurrentCues=function(e){return e.length?o.difference(e,f).length&&(v.className="jw-captions-window jw-reset jw-captions-window-active",f=e):f=[],f},this.getAlignmentPosition=function(e,t){var n=e.source,i=t.metadata;return n?!(!i||!o.isNumber(i[n]))&&i[n]:t.position},this.clear=function(){e.empty(m)},this.setContainerHeight=function(e){a(m,{height:e})},this.setup=function(e,n){v=document.createElement("div"),w=document.createElement("span"),v.className="jw-captions-window jw-reset",w.className="jw-captions-text jw-reset",j=o.extend({},s,n);var i=j.fontOpacity,r=j.windowOpacity,d=j.edgeStyle,p=j.backgroundColor,h={},f={color:t.hexToRgba(j.color,i),fontFamily:j.fontFamily,fontStyle:j.fontStyle,fontWeight:j.fontWeight,textDecoration:j.textDecoration};r&&(h.backgroundColor=t.hexToRgba(j.windowColor,r)),u(d,f,i),j.back?f.backgroundColor=t.hexToRgba(p,j.backgroundOpacity):null===d&&u("uniform",f),a(v,h),a(w,f),c(e,h,f),v.appendChild(w),m.appendChild(v),this.populate(l.get("captionsTrack")),l.set("captions",j)},this.element=function(){return m},l.on("change:playlistItem",function(){g=null,f=[]},this),l.on("change:captionsTrack",function(e,t){this.populate(t)},this),l.mediaController.on("seek",function(){f=[]},this),l.mediaController.on("time seek",d,this),l.mediaController.on("subtitlesTrackData",function(){this.selectCues(h,g)},this),l.on("change:state",function(e,t){switch(t){case i.IDLE:case i.ERROR:case i.COMPLETE:this.hide();break;default:this.show()}},this),l.on("itemReady",p,this)};return l}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(9),n(4),n(3),n(1)],o=function(e,t,n,i){var o=function(o,r,a){function s(e){if(!o.get("flashBlocked"))return u?void u(e):void f.trigger(e.type===t.touchEvents.CLICK?"click":"tap")}function l(){return d?void d():void f.trigger("doubleClick")}var c,u,d,p={enableDoubleTap:!0,useMove:!0};i.extend(this,n),c=r,this.element=function(){return c};var h=new e(c,i.extend(p,a));h.on("click tap",s),h.on("doubleClick doubleTap",l),h.on("move",function(){f.trigger("move")}),h.on("over",function(){f.trigger("over")}),h.on("out",function(){f.trigger("out")}),this.clickHandler=s;var f=this;this.setAlternateClickHandlers=function(e,t){u=e,d=t||null},this.revertAlternateClickHandlers=function(){u=null,d=null}};return o}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1),n(2),n(19)],o=function(e,t,n){function i(e,t){this.time=e,this.text=t,this.el=document.createElement("div"),this.el.className="jw-cue jw-reset"}e.extend(i.prototype,{align:function(e){if("%"===this.time.toString().slice(-1))this.pct=this.time;else{var t=this.time/e*100;this.pct=t+"%"}this.el.style.left=this.pct}});var o={loadChapters:function(e){t.ajax(e,this.chaptersLoaded.bind(this),this.chaptersFailed,{plainText:!0})},chaptersLoaded:function(t){var i=n(t.responseText);e.isArray(i)&&(e.each(i,this.addCue,this),this.drawCues())},chaptersFailed:function(){},addCue:function(e){this.cues.push(new i(e.begin,e.text))},drawCues:function(){var t=this._model.mediaModel.get("duration");if(!t||t<=0)return void this._model.mediaModel.once("change:duration",this.drawCues,this);var n=this;e.each(this.cues,function(e){e.align(t),e.el.addEventListener("mouseover",function(){n.activeCue=e}),e.el.addEventListener("mouseout",function(){n.activeCue=null}),n.elementRail.appendChild(e.el)})},resetChapters:function(){e.each(this.cues,function(e){e.el.parentNode&&e.el.parentNode.removeChild(e.el)},this),this.cues=[]}};return o}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(32),n(2),n(1),n(9)],o=function(e,t,n,i){var o=e.extend({constructor:function(t,n){e.call(this,t,n),this.container.className="jw-overlay-horizontal jw-reset",this.openClass="jw-open-drawer",this.componentType="drawer"},setup:function(e,o){this.iconUI||(this.iconUI=new i(this.el,{useHover:!0,directSelect:!0}),this.toggleOpenStateListener=this.toggleOpenState.bind(this),this.openTooltipListener=this.openTooltip.bind(this),this.closeTooltipListener=this.closeTooltip.bind(this)),this.reset(),e=n.isArray(e)?e:[],this.activeContents=n.filter(e,function(e){return e.isActive}),t.toggleClass(this.el,"jw-hidden",!o||this.activeContents.length<2),o&&this.activeContents.length>1&&(t.removeClass(this.el,"jw-off"),this.iconUI.on("tap",this.toggleOpenStateListener).on("over",this.openTooltipListener).on("out",this.closeTooltipListener),n.each(e,function(e){this.container.appendChild(e.el)},this))},reset:function(){t.addClass(this.el,"jw-off"),this.iconUI.off(),this.contentUI&&this.contentUI.off().destroy(),this.removeContent()}});return o}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(32),n(2),n(1),n(9),n(136)],o=function(e,t,n,i,o){var r=e.extend({setup:function(e,r,a){a=a||{},this.iconUI||(this.iconUI=new i(this.el,{useHover:!0,directSelect:!0}),this.toggleValueListener=this.toggleValue.bind(this),this.toggleOpenStateListener=this.toggleOpenState.bind(this),this.openTooltipListener=this.openTooltip.bind(this),this.closeTooltipListener=this.closeTooltip.bind(this),this.selectListener=this.select.bind(this)),this.reset(),e=n.isArray(e)?e:[],t.toggleClass(this.el,"jw-hidden",e.length<2);var s=e.length>2||2===e.length&&a&&a.toggle===!1,l=!s&&2===e.length;if(t.toggleClass(this.el,"jw-toggle",l||!!a.isToggle),t.toggleClass(this.el,"jw-button-color",!l),this.isActive=s||l,s){t.removeClass(this.el,"jw-off"),this.iconUI.on("tap",this.toggleOpenStateListener).on("over",this.openTooltipListener).on("out",this.closeTooltipListener);var c=o(e),u=t.createElement(c);this.addContent(u),this.contentUI=new i(this.content).on("click tap",this.selectListener)}else l&&this.iconUI.on("click tap",this.toggleValueListener);this.selectItem(r)},toggleValue:function(){this.trigger("toggleValue")},select:function(e){if(e.target.parentElement===this.content){var i=t.classList(e.target),o=n.find(i,function(e){return 0===e.indexOf("jw-item")});o&&(this.trigger("select",parseInt(o.split("-")[2])),this.closeTooltipListener())}},selectItem:function(e){if(this.content)for(var n=0;n<this.content.children.length;n++)t.toggleClass(this.content.children[n],"jw-active-option",e===n);t.toggleClass(this.el,"jw-off",0===e)},reset:function(){t.addClass(this.el,"jw-off"),this.iconUI.off(),this.contentUI&&this.contentUI.off().destroy(),this.removeContent()}});return r}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(2),n(1),n(32),n(9),n(138)],o=function(e,t,n,i,o){var r=n.extend({setup:function(n,o){if(this.iconUI||(this.iconUI=new i(this.el,{useHover:!0}),this.toggleOpenStateListener=this.toggleOpenState.bind(this),this.openTooltipListener=this.openTooltip.bind(this),this.closeTooltipListener=this.closeTooltip.bind(this),this.selectListener=this.onSelect.bind(this)),this.reset(),n=t.isArray(n)?n:[],e.toggleClass(this.el,"jw-hidden",n.length<2),n.length>=2){this.iconUI=new i(this.el,{useHover:!0}).on("tap",this.toggleOpenStateListener).on("over",this.openTooltipListener).on("out",this.closeTooltipListener);var r=this.menuTemplate(n,o),a=e.createElement(r);this.addContent(a),this.contentUI=new i(this.content),this.contentUI.on("click tap",this.selectListener)}this.originalList=n},menuTemplate:function(n,i){var r=t.map(n,function(t,n){var o=t.title?e.createElement(t.title).textContent:"";return{active:n===i,label:n+1+".",title:o}});return o(r)},onSelect:function(n){var i=n.target;if("UL"!==i.tagName){"LI"!==i.tagName&&(i=i.parentElement);var o=e.classList(i),r=t.find(o,function(e){return 0===e.indexOf("jw-item")});r&&(this.trigger("select",parseInt(r.split("-")[2])),this.closeTooltip())}},selectItem:function(e){this.setup(this.originalList,e)},reset:function(){this.iconUI.off(),this.contentUI&&this.contentUI.off().destroy(),this.removeContent()}});return r}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1),n(2),n(19)],o=function(e,t,n){function i(e){this.begin=e.begin,this.end=e.end,this.img=e.text}var o={loadThumbnails:function(e){e&&(this.vttPath=e.split("?")[0].split("/").slice(0,-1).join("/"),this.individualImage=null,t.ajax(e,this.thumbnailsLoaded.bind(this),this.thumbnailsFailed.bind(this),{plainText:!0}))},thumbnailsLoaded:function(t){var o=n(t.responseText);e.isArray(o)&&(e.each(o,function(e){this.thumbnails.push(new i(e))},this),this.drawCues())},thumbnailsFailed:function(){},chooseThumbnail:function(t){var n=e.sortedIndex(this.thumbnails,{end:t},e.property("end"));n>=this.thumbnails.length&&(n=this.thumbnails.length-1);var i=this.thumbnails[n].img;return i.indexOf("://")<0&&(i=this.vttPath?this.vttPath+"/"+i:i),i},loadThumbnail:function(t){var n=this.chooseThumbnail(t),i={display:"block",margin:"0 auto",backgroundPosition:"0 0"},o=n.indexOf("#xywh");if(o>0)try{var r=/(.+)\#xywh=(\d+),(\d+),(\d+),(\d+)/.exec(n);n=r[1],i.backgroundPosition=r[2]*-1+"px "+r[3]*-1+"px",i.width=r[4],i.height=r[5]}catch(a){return}else this.individualImage||(this.individualImage=new Image,this.individualImage.onload=e.bind(function(){this.individualImage.onload=null,
	this.timeTip.image({width:this.individualImage.width,height:this.individualImage.height})},this),this.individualImage.src=n);return i.backgroundImage='url("'+n+'")',i},showThumbnail:function(e){this.thumbnails.length<1||this.timeTip.image(this.loadThumbnail(e))},resetThumbnails:function(){this.timeTip.image({backgroundImage:"",width:0,height:0}),this.thumbnails=[]}};return o}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1),n(2),n(28),n(47),n(32),n(187),n(191)],o=function(e,t,n,i,o,r,a){var s=o.extend({setup:function(){this.text=document.createElement("span"),this.text.className="jw-text jw-reset",this.img=document.createElement("div"),this.img.className="jw-reset";var e=document.createElement("div");e.className="jw-time-tip jw-background-color jw-reset",e.appendChild(this.img),e.appendChild(this.text),t.removeClass(this.el,"jw-hidden"),this.addContent(e)},image:function(e){t.style(this.img,e)},update:function(e){this.text.innerHTML=e}}),l=i.extend({constructor:function(t,n){this._model=t,this._api=n,this.timeTip=new s("jw-tooltip-time"),this.timeTip.setup(),this.cues=[],this.seekThrottled=e.throttle(this.performSeek,400),this._model.on("change:playlistItem",this.onPlaylistItem,this).on("change:position",this.onPosition,this).on("change:duration",this.onDuration,this).on("change:buffer",this.onBuffer,this),i.call(this,"jw-slider-time","horizontal")},setup:function(){i.prototype.setup.apply(this,arguments),this._model.get("playlistItem")&&this.onPlaylistItem(this._model,this._model.get("playlistItem")),this.elementRail.appendChild(this.timeTip.element()),this.el.addEventListener("mousemove",this.showTimeTooltip.bind(this),!1),this.el.addEventListener("mouseout",this.hideTimeTooltip.bind(this),!1)},limit:function(i){if(this.activeCue&&e.isNumber(this.activeCue.pct))return this.activeCue.pct;var o=this._model.get("duration"),r=t.adaptiveType(o);if("DVR"===r){var a=(1-i/100)*o,s=this._model.get("position"),l=Math.min(a,Math.max(n.dvrSeekLimit,s)),c=100*l/o;return 100-c}return i},update:function(e){this.seekTo=e,this.seekThrottled(),i.prototype.update.apply(this,arguments)},dragStart:function(){this._model.set("scrubbing",!0),i.prototype.dragStart.apply(this,arguments)},dragEnd:function(){i.prototype.dragEnd.apply(this,arguments),this._model.set("scrubbing",!1)},onSeeked:function(){this._model.get("scrubbing")&&this.performSeek()},onBuffer:function(e,t){this.updateBuffer(t)},onPosition:function(e,t){this.updateTime(t,e.get("duration"))},onDuration:function(e,t){this.updateTime(e.get("position"),t)},updateTime:function(e,n){var i=0;if(n){var o=t.adaptiveType(n);"DVR"===o?i=(n-e)/n*100:"VOD"===o&&(i=e/n*100)}this.render(i)},onPlaylistItem:function(t,n){this.reset(),t.mediaModel.on("seeked",this.onSeeked,this);var i=n.tracks;e.each(i,function(e){e&&e.kind&&"thumbnails"===e.kind.toLowerCase()?this.loadThumbnails(e.file):e&&e.kind&&"chapters"===e.kind.toLowerCase()&&this.loadChapters(e.file)},this)},performSeek:function(){var e,n=this.seekTo,i=this._model.get("duration"),o=t.adaptiveType(i);0===i?this._api.play():"DVR"===o?(e=(100-n)/100*i,this._api.seek(e)):(e=n/100*i,this._api.seek(Math.min(e,i-.25)))},showTimeTooltip:function(e){var i=this._model.get("duration");if(0!==i){var o=t.bounds(this.elementRail),r=e.pageX?e.pageX-o.left:e.x;r=t.between(r,0,o.width);var a=r/o.width,s=i*a;i<0&&(s=i-s);var l;if(this.activeCue)l=this.activeCue.text;else{var c=!0;l=t.timeFormat(s,c),i<0&&s>n.dvrSeekLimit&&(l="Live")}this.timeTip.update(l),this.showThumbnail(s),t.addClass(this.timeTip.el,"jw-open"),this.timeTip.el.style.left=100*a+"%"}},hideTimeTooltip:function(){t.removeClass(this.timeTip.el,"jw-open")},reset:function(){this.resetChapters(),this.resetThumbnails()}});return e.extend(l.prototype,r,a),l}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(32),n(47),n(9),n(2)],o=function(e,t,n,i){var o=e.extend({constructor:function(o,r,a){this._model=o,e.call(this,r,a,!0),this.volumeSlider=new t("jw-slider-volume jw-volume-tip","vertical"),this.addContent(this.volumeSlider.element()),this.volumeSlider.on("update",function(e){this.trigger("update",e)},this),i.removeClass(this.el,"jw-hidden"),new n(this.el,{useHover:!0,directSelect:!0}).on("click",this.toggleValue,this).on("tap",this.toggleOpenState,this).on("over",this.openTooltip,this).on("out",this.closeTooltip,this),this._model.on("change:volume",this.onVolume,this)},toggleValue:function(){this.trigger("toggleValue")}});return o}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(2),n(1),n(3),n(28),n(9),n(47),n(192),n(189),n(190),n(193),n(188)],o=function(e,t,n,i,o,r,a,s,l,c,u){function d(e,t,n){var i=document.createElement("div");return i.className="jw-icon jw-icon-inline jw-button-color jw-reset "+e,i.setAttribute("role","button"),i.setAttribute("tabindex","0"),n&&i.setAttribute("aria-label",n),i.style.display="none",t&&new o(i).on("click tap",function(){t()}),{element:function(){return i},toggle:function(e){e?this.show():this.hide()},show:function(){i.style.display=""},hide:function(){i.style.display="none"}}}function p(e,t){var n=document.createElement("span");return n.className="jw-text jw-reset "+e,t&&n.setAttribute("role",t),n}function h(e,t){var n=new s(e,t);return n}function f(e,n){var i=document.createElement("div");return i.className="jw-group jw-controlbar-"+e+"-group jw-reset",t.each(n,function(e){e.element&&(e=e.element()),i.appendChild(e)}),i}function g(t,n){this._api=t,this._model=n,this._isMobile=e.isMobile(),this._compactModeMaxSize=400,this._maxCompactWidth=-1,this._localization=this._model.get("localization"),this.setup()}return t.extend(g.prototype,n,{setup:function(){this.build(),this.initialize()},build:function(){var e,n,i,o,s=new a(this._model,this._api),g=new u("jw-icon-more",this._localization.more);this._model.get("visualplaylist")!==!1&&(e=new l("jw-icon-playlist",this._localization.playlist));var m=this._localization.play,v=this._localization.prev,w=this._localization.next,y=this._localization.volume;this._isMobile||(o=d("jw-icon-volume",this._api.setMute,y),n=new r("jw-slider-volume","horizontal"),i=new c(this._model,"jw-icon-volume",y)),this.elements={alt:p("jw-text-alt","status"),play:d("jw-icon-playback",this._api.play.bind(this,{reason:"interaction"}),m),prev:d("jw-icon-prev",this._api.playlistPrev.bind(this,{reason:"interaction"}),v),next:d("jw-icon-next",this._api.playlistNext.bind(this,{reason:"interaction"}),w),playlist:e,elapsed:p("jw-text-elapsed","timer"),time:s,duration:p("jw-text-duration","timer"),drawer:g,hd:h("jw-icon-hd",this._localization.hd),cc:h("jw-icon-cc",this._localization.cc),audiotracks:h("jw-icon-audio-tracks",this._localization.audioTracks),mute:o,volume:n,volumetooltip:i,cast:d("jw-icon-cast jw-off",this._api.castToggle,this._localization.cast),fullscreen:d("jw-icon-fullscreen",this._api.setFullscreen,this._localization.fullscreen)},this.layout={left:[this.elements.play,this.elements.prev,this.elements.playlist,this.elements.next,this.elements.elapsed],center:[this.elements.time,this.elements.alt],right:[this.elements.duration,this.elements.hd,this.elements.cc,this.elements.audiotracks,this.elements.drawer,this.elements.mute,this.elements.cast,this.elements.volume,this.elements.volumetooltip,this.elements.fullscreen],drawer:[this.elements.hd,this.elements.cc,this.elements.audiotracks]},this.menus=t.compact([this.elements.playlist,this.elements.hd,this.elements.cc,this.elements.audiotracks,this.elements.volumetooltip]),this.layout.left=t.compact(this.layout.left),this.layout.center=t.compact(this.layout.center),this.layout.right=t.compact(this.layout.right),this.layout.drawer=t.compact(this.layout.drawer),this.el=document.createElement("div"),this.el.className="jw-controlbar jw-background-color jw-reset",this.elements.left=f("left",this.layout.left),this.elements.center=f("center",this.layout.center),this.elements.right=f("right",this.layout.right),this.el.appendChild(this.elements.left),this.el.appendChild(this.elements.center),this.el.appendChild(this.elements.right)},initialize:function(){this.elements.play.show(),this.elements.fullscreen.show(),this.elements.mute&&this.elements.mute.show(),this.onVolume(this._model,this._model.get("volume")),this.onPlaylist(this._model,this._model.get("playlist")),this.onPlaylistItem(this._model,this._model.get("playlistItem")),this.onMediaModel(this._model,this._model.get("mediaModel")),this.onCastAvailable(this._model,this._model.get("castAvailable")),this.onCastActive(this._model,this._model.get("castActive")),this.onCaptionsList(this._model,this._model.get("captionsList")),this._model.on("change:volume",this.onVolume,this),this._model.on("change:mute",this.onMute,this),this._model.on("change:playlist",this.onPlaylist,this),this._model.on("change:playlistItem",this.onPlaylistItem,this),this._model.on("change:mediaModel",this.onMediaModel,this),this._model.on("change:castAvailable",this.onCastAvailable,this),this._model.on("change:castActive",this.onCastActive,this),this._model.on("change:duration",this.onDuration,this),this._model.on("change:position",this.onElapsed,this),this._model.on("change:fullscreen",this.onFullscreen,this),this._model.on("change:captionsList",this.onCaptionsList,this),this._model.on("change:captionsIndex",this.onCaptionsIndex,this),this._model.on("change:compactUI",this.onCompactUI,this),this.elements.volume&&this.elements.volume.on("update",function(e){var t=e.percentage;this._api.setVolume(t)},this),this.elements.volumetooltip&&(this.elements.volumetooltip.on("update",function(e){var t=e.percentage;this._api.setVolume(t)},this),this.elements.volumetooltip.on("toggleValue",function(){this._api.setMute()},this)),this.elements.playlist&&this.elements.playlist.on("select",function(e){this._model.once("itemReady",function(){this._api.play({reason:"interaction"})},this),this._api.load(e)},this),this.elements.hd.on("select",function(e){this._model.getVideo().setCurrentQuality(e)},this),this.elements.hd.on("toggleValue",function(){this._model.getVideo().setCurrentQuality(0===this._model.getVideo().getCurrentQuality()?1:0)},this),this.elements.cc.on("select",function(e){this._api.setCurrentCaptions(e)},this),this.elements.cc.on("toggleValue",function(){var e=this._model.get("captionsIndex");this._api.setCurrentCaptions(e?0:1)},this),this.elements.audiotracks.on("select",function(e){this._model.getVideo().setCurrentAudioTrack(e)},this),new o(this.elements.duration).on("click tap",function(){if("DVR"===e.adaptiveType(this._model.get("duration"))){var t=this._model.get("position");this._api.seek(Math.max(i.dvrSeekLimit,t))}},this),new o(this.el).on("click tap drag",function(){this.trigger("userAction")},this),this.elements.drawer.on("open-drawer close-drawer",function(t,n){e.toggleClass(this.el,"jw-drawer-expanded",n.isOpen),n.isOpen||this.closeMenus()},this),t.each(this.menus,function(e){e.on("open-tooltip",this.closeMenus,this)},this)},onCaptionsList:function(e,t){var n=e.get("captionsIndex");this.elements.cc.setup(t,n,{isToggle:!0}),this.clearCompactMode()},onCaptionsIndex:function(e,t){this.elements.cc.selectItem(t)},onPlaylist:function(e,t){var n=t.length>1;this.elements.next.toggle(n),this.elements.prev.toggle(n),this.elements.playlist&&this.elements.playlist.setup(t,e.get("item"))},onPlaylistItem:function(e){this.elements.time.updateBuffer(0),this.elements.time.render(0),this.elements.duration.innerHTML="00:00",this.elements.elapsed.innerHTML="00:00",this.clearCompactMode();var t=e.get("item");this.elements.playlist&&this.elements.playlist.selectItem(t),this.elements.audiotracks.setup()},onMediaModel:function(n,i){i.on("change:levels",function(e,t){this.elements.hd.setup(t,e.get("currentLevel")),this.clearCompactMode()},this),i.on("change:currentLevel",function(e,t){this.elements.hd.selectItem(t)},this),i.on("change:audioTracks",function(e,n){var i=t.map(n,function(e){return{label:e.name}});this.elements.audiotracks.setup(i,e.get("currentAudioTrack"),{toggle:!1}),this.clearCompactMode()},this),i.on("change:currentAudioTrack",function(e,t){this.elements.audiotracks.selectItem(t)},this),i.on("change:state",function(t,n){"complete"===n&&(this.elements.drawer.closeTooltip(),e.removeClass(this.el,"jw-drawer-expanded"))},this)},onVolume:function(e,t){this.renderVolume(e.get("mute"),t)},onMute:function(e,t){this.renderVolume(t,e.get("volume"))},renderVolume:function(t,n){this.elements.mute&&e.toggleClass(this.elements.mute.element(),"jw-off",t),this.elements.volume&&this.elements.volume.render(t?0:n),this.elements.volumetooltip&&(this.elements.volumetooltip.volumeSlider.render(t?0:n),e.toggleClass(this.elements.volumetooltip.element(),"jw-off",t))},onCastAvailable:function(e,t){this.elements.cast.toggle(t),this.clearCompactMode()},onCastActive:function(t,n){e.toggleClass(this.elements.cast.element(),"jw-off",!n)},onElapsed:function(t,n){var i,o=t.get("duration");i="DVR"===e.adaptiveType(o)?"-"+e.timeFormat(-o):e.timeFormat(n),this.elements.elapsed.innerHTML=i},onDuration:function(t,n){var i;"DVR"===e.adaptiveType(n)?(i="Live",this.clearCompactMode()):i=e.timeFormat(n),this.elements.duration.innerHTML=i},onFullscreen:function(t,n){e.toggleClass(this.elements.fullscreen.element(),"jw-off",n)},element:function(){return this.el},getVisibleBounds:function(){var t,n=this.el,i=getComputedStyle?getComputedStyle(n):n.currentStyle;return"table"===i.display?e.bounds(n):(n.style.visibility="hidden",n.style.display="table",t=e.bounds(n),n.style.visibility=n.style.display="",t)},setAltText:function(e){this.elements.alt.innerHTML=e},addCues:function(e){this.elements.time&&(t.each(e,function(e){this.elements.time.addCue(e)},this),this.elements.time.drawCues())},closeMenus:function(e){t.each(this.menus,function(t){e&&e.target===t.el||t.closeTooltip(e)})},hideComponents:function(){this.closeMenus(),this.elements.drawer.closeTooltip(),e.removeClass(this.el,"jw-drawer-expanded")},clearCompactMode:function(){this._maxCompactWidth=-1,this._model.set("compactUI",!1),this._containerWidth&&this.checkCompactMode(this._containerWidth)},setCompactModeBounds:function(){if(this.element().offsetWidth>0){var t=this.elements.left.offsetWidth+this.elements.right.offsetWidth;if("LIVE"===e.adaptiveType(this._model.get("duration")))this._maxCompactWidth=t+this.elements.alt.offsetWidth;else{var n=t+(this.elements.center.offsetWidth-this.elements.time.el.offsetWidth),i=.2;this._maxCompactWidth=n/(1-i)}}},checkCompactMode:function(e){this._maxCompactWidth===-1&&this.setCompactModeBounds(),this._containerWidth=e,this._maxCompactWidth!==-1&&(e>=this._compactModeMaxSize&&e>this._maxCompactWidth?this._model.set("compactUI",!1):(e<this._compactModeMaxSize||e<=this._maxCompactWidth)&&this._model.set("compactUI",!0))},onCompactUI:function(n,i){e.removeClass(this.el,"jw-drawer-expanded"),this.elements.drawer.setup(this.layout.drawer,i),(!i||this.elements.drawer.activeContents.length<2)&&t.each(this.layout.drawer,function(e){this.elements.right.insertBefore(e.el,this.elements.drawer.el)},this)}}),g}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(2),n(3),n(9),n(132),n(1)],o=function(e,t,n,i,o){var r=function(r){o.extend(this,t),this.model=r,this.el=e.createElement(i({ariaLabel:this.model.get("localization").playback}));var a=this;this.iconUI=new n(this.el).on("click tap",function(e){a.trigger(e.type)}),this.model.on("change:state",function(e,t){var n=a.el.getElementsByClassName("jw-icon-display");if(n.length){var i=a.model.get("localization"),o=i.playback;switch(t){case"buffering":o=i.buffer;break;case"playing":o=i.pause;break;case"complete":o=i.replay;break;case"error":o=""}""===o?n[0].removeAttribute("aria-label"):n[0].setAttribute("aria-label",o)}})};return o.extend(r.prototype,{element:function(){return this.el}}),r}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(133),n(2),n(1),n(9)],o=function(e,t,n,i){var o=function(e){this.model=e,this.setup(),this.model.on("change:dock",this.render,this)};return n.extend(o.prototype,{setup:function(){var n=this.model.get("dock"),o=this.click.bind(this),r=e(n);this.el=t.createElement(r),new i(this.el).on("click tap",o)},getDockButton:function(e){return t.hasClass(e.target,"jw-dock-button")?e.target:t.hasClass(e.target,"jw-dock-text")?e.target.parentElement.parentElement:e.target.parentElement},click:function(e){var t=this.getDockButton(e),i=t.getAttribute("button"),o=this.model.get("dock"),r=n.findWhere(o,{id:i});r&&r.callback&&r.callback(e)},render:function(){var n=this.model.get("dock"),i=e(n),o=t.createElement(i);this.el.innerHTML=o.innerHTML},element:function(){return this.el}}),o}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(134)],o=function(e){function t(t,n,i,o){return e({id:t,skin:n,title:i,body:o})}return t}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(9),n(2),n(4),n(1),n(3),n(135)],o=function(e,t,n,i,o,r){var a=t.style,s={linktarget:"_blank",margin:8,hide:!1,position:"top-right"},l=function(l){var c,u,d=new Image,p=i.extend({},l.get("logo"));return i.extend(this,o),this.setup=function(o){if(u=i.extend({},s,p),u.hide="true"===u.hide.toString(),c=t.createElement(r()),u.file){u.hide&&t.addClass(c,"jw-hide"),t.addClass(c,"jw-logo-"+(u.position||s.position)),"top-right"===u.position&&(l.on("change:dock",this.topRight,this),l.on("change:controls",this.topRight,this),this.topRight(l)),l.set("logo",u),d.onload=function(){var e={backgroundImage:'url("'+this.src+'")',width:this.width,height:this.height};if(u.margin!==s.margin){var t=/(\w+)-(\w+)/.exec(u.position);3===t.length&&(e["margin-"+t[1]]=u.margin,e["margin-"+t[2]]=u.margin)}a(c,e),l.set("logoWidth",e.width)},d.src=u.file;var h=new e(c);h.on("click tap",function(e){t.exists(e)&&e.stopPropagation&&e.stopPropagation(),this.trigger(n.JWPLAYER_LOGO_CLICK,{link:u.link,linktarget:u.linktarget})},this),o.appendChild(c)}},this.topRight=function(e){var t=e.get("controls"),n=e.get("dock"),i=t&&(n&&n.length||e.get("sharing")||e.get("related"));a(c,{top:i?"3.5em":0})},this.element=function(){return c},this.position=function(){return u.position},this.destroy=function(){d.onload=null},this};return l}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1),n(2)],o=function(e,t){function n(e,t){t.off("change:mediaType",null,this),t.on("change:mediaType",function(t,n){"audio"===n&&this.setImage(e.get("playlistItem").image)},this)}function i(e,n){var i=e.get("autostart")&&!t.isMobile()||e.get("item")>0;return i?(this.setImage(null),e.off("change:state",null,this),void e.on("change:state",function(e,t){"complete"!==t&&"idle"!==t&&"error"!==t||(this.setImage(n.image),this.resize(null,null,e.get("stretching")))},this)):void this.setImage(n.image)}var o=function(e){this.model=e,e.on("change:playlistItem",i,this),e.on("change:mediaModel",n,this)};return e.extend(o.prototype,{setup:function(e){this.el=e;var t=this.model.get("playlistItem");t&&this.setImage(t.image)},setImage:function(n){var i=this.image;i&&(i.onload=null,this.image=null),this.model.off("change:state",null,this);var o="";e.isString(n)&&(o='url("'+n+'")',i=this.image=new Image,i.src=n),t.style(this.el,{backgroundImage:o})},resize:function(e,n,i){if("uniform"===i){if(e&&(this.playerAspectRatio=e/n),!this.playerAspectRatio)return;var o=this.image,r=null;if(o){if(0===o.width){var a=this;return void(o.onload=function(){a.resize(e,n,i)})}var s=o.width/o.height;Math.abs(this.playerAspectRatio-s)<.09&&(r="cover")}t.style(this.el,{backgroundSize:r})}},element:function(){return this.el}}),o}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(2),n(139),n(1),n(9),n(31)],o=function(e,t,n,i,o){var r=function(){};return n.extend(r.prototype,{buildArray:function(){var t=o.split("+"),n=t[0],i={items:[{title:"Powered by JW Player "+n,featured:!0,showLogo:!0,link:"https://jwplayer.com/learn-more"}]},r=n.indexOf("-")>0,a=t[1];if(r&&a){var s=a.split(".");i.items.push({title:"build: ("+s[0]+"."+s[1]+")",link:"#"})}var l=this.model.get("provider");if(l&&l.name.indexOf("flash")>=0){var c="Flash Version "+e.flashVersion();i.items.push({title:c,link:"http://www.adobe.com/software/flash/about/"})}return i},buildMenu:function(){var n=this.buildArray();return e.createElement(t(n))},updateHtml:function(){this.el.innerHTML=this.buildMenu().innerHTML},rightClick:function(e){return this.lazySetup(),!this.mouseOverContext&&(this.hideMenu(),this.showMenu(e),!1)},getOffset:function(e){for(var t=e.target,n=e.offsetX||e.layerX,i=e.offsetY||e.layerY;t!==this.playerElement;)n+=t.offsetLeft,i+=t.offsetTop,t=t.parentNode;return{x:n,y:i}},showMenu:function(t){var n=this.getOffset(t);return this.el.style.left=n.x+"px",this.el.style.top=n.y+"px",e.addClass(this.playerElement,"jw-flag-rightclick-open"),e.addClass(this.el,"jw-open"),!1},hideMenu:function(){this.mouseOverContext||(e.removeClass(this.playerElement,"jw-flag-rightclick-open"),e.removeClass(this.el,"jw-open"))},lazySetup:function(){this.el||(this.el=this.buildMenu(),this.layer.appendChild(this.el),this.hideMenuHandler=this.hideMenu.bind(this),this.addOffListener(this.playerElement),this.addOffListener(document),this.model.on("change:provider",this.updateHtml,this),this.elementUI=new i(this.el,{useHover:!0}).on("over",function(){this.mouseOverContext=!0},this).on("out",function(){this.mouseOverContext=!1},this))},setup:function(e,t,n){this.playerElement=t,this.model=e,this.mouseOverContext=!1,this.layer=n,t.oncontextmenu=this.rightClick.bind(this)},addOffListener:function(e){e.addEventListener("mousedown",this.hideMenuHandler),e.addEventListener("touchstart",this.hideMenuHandler),e.addEventListener("pointerdown",this.hideMenuHandler)},removeOffListener:function(e){e.removeEventListener("mousedown",this.hideMenuHandler),e.removeEventListener("touchstart",this.hideMenuHandler),e.removeEventListener("pointerdown",this.hideMenuHandler)},destroy:function(){this.el&&(this.hideMenu(),this.elementUI.off(),this.removeOffListener(this.playerElement),this.removeOffListener(document),this.hideMenuHandler=null,this.el=null),this.playerElement&&(this.playerElement.oncontextmenu=null,this.playerElement=null),this.model&&(this.model.off("change:provider",this.updateHtml),this.model=null)}}),r}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(1),n(2)],o=function(e,t){var n=function(e){this.model=e,this.model.on("change:playlistItem",this.playlistItem,this)};return e.extend(n.prototype,{hide:function(){this.el.style.display="none"},show:function(){this.el.style.display=""},setup:function(e){this.el=e;var t=this.el.getElementsByTagName("div");this.title=t[0],this.description=t[1],this.model.get("playlistItem")&&this.playlistItem(this.model,this.model.get("playlistItem")),this.model.on("change:logoWidth",this.update,this),this.model.on("change:dock",this.update,this)},update:function(e){var n={paddingLeft:0,paddingRight:0},i=e.get("controls"),o=e.get("dock"),r=e.get("logo");if(r){var a=1*(""+r.margin).replace("px",""),s=e.get("logoWidth")+(isNaN(a)?0:a);"top-left"===r.position?n.paddingLeft=s:"top-right"===r.position&&(n.paddingRight=s)}if(i&&o&&o.length){var l=56*o.length;n.paddingRight=Math.max(n.paddingRight,l)}t.style(this.el,n)},playlistItem:function(e,t){if(e.get("displaytitle")||e.get("displaydescription")){var n="",i="";t.title&&e.get("displaytitle")&&(n=t.title),t.description&&e.get("displaydescription")&&(i=t.description),this.updateText(n,i)}else this.hide()},updateText:function(e,t){this.title.innerHTML=e,this.description.innerHTML=t,this.title.firstChild||this.description.firstChild?this.show():this.hide()},element:function(){return this.el}}),n}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(2),n(4),n(3),n(28),n(5),n(185),n(186),n(195),n(196),n(198),n(194),n(199),n(217),n(201),n(1),n(137)],o=function(e,t,i,o,r,a,s,l,c,u,d,p,h,f,g,m){var v=e.style,w=e.bounds,y=e.isMobile(),j=["fullscreenchange","webkitfullscreenchange","mozfullscreenchange","MSFullscreenChange"],b=function(b,E){function k(t){var n=0,i=E.get("duration"),r=E.get("position");"DVR"===e.adaptiveType(i)&&(n=i,i=Math.max(r,o.dvrSeekLimit));var a=e.between(r+t,n,i);b.seek(a)}function L(t){var n=e.between(E.get("volume")+t,0,100);b.setVolume(n)}function A(e){return!e.ctrlKey&&!e.metaKey&&!!E.get("controls")}function C(e){if(!A(e))return!0;switch(Ne||oe(),e.keyCode){case 27:b.setFullscreen(!1);break;case 13:case 32:b.play({reason:"interaction"});break;case 37:Ne||k(-5);break;case 39:Ne||k(5);break;case 38:L(10);break;case 40:L(-10);break;case 67:var t=b.getCaptionsList(),n=t.length;if(n){var i=(b.getCurrentCaptions()+1)%n;b.setCurrentCaptions(i)}break;case 77:b.setMute();break;case 70:b.setFullscreen();break;default:if(e.keyCode>=48&&e.keyCode<=59){var o=e.keyCode-48,r=o/10*E.get("duration");b.seek(r)}}return/13|32|37|38|39|40/.test(e.keyCode)?(e.preventDefault(),!1):void 0}function _(){ze=!1,e.removeClass(fe,"jw-no-focus")}function x(e){e.target&&e.target.blur&&e.target.blur()}function P(){ze=!0,e.addClass(fe,"jw-no-focus")}function T(){ze||_(),Ne||oe()}function R(){var e=w(fe),n=Math.round(e.width),i=Math.round(e.height);Ve(Fe),n&&i&&(n!==ve||i!==we)&&(ve=n,we=i,clearTimeout(We),We=setTimeout(Z,50),E.set("containerWidth",n),E.set("containerHeight",i),He.trigger(t.JWPLAYER_RESIZE,{width:n,height:i}))}function I(){document.body.contains(fe)&&(Ve(Fe),Fe=Je(R))}function M(t,n,i){var o={color:t,borderColor:t,stroke:t},r={color:n,borderColor:n,stroke:n};e.css("#"+i+" .jw-color-active",o,i),e.css("#"+i+" .jw-color-active-hover:hover",o,i),e.css("#"+i+" .jw-color-inactive",r,i),e.css("#"+i+" .jw-color-inactive-hover:hover",r,i)}function S(t,n){n=n||!1,e.toggleClass(fe,"jw-flag-casting",n)}function O(t,n){e.toggleClass(fe,"jw-flag-cast-available",n),e.toggleClass(ge,"jw-flag-cast-available",n)}function D(t,n){e.replaceClass(fe,/jw-stretch-\S+/,"jw-stretch-"+n)}function N(t,n){e.toggleClass(fe,"jw-flag-compact-player",n)}function Y(e){e&&!y&&(e.element().addEventListener("mousemove",J,!1),e.element().addEventListener("mouseout",V,!1))}function W(){E.get("state")!==r.IDLE&&E.get("state")!==r.COMPLETE&&E.get("state")!==r.PAUSED||!E.get("controls")||b.play({reason:"interaction"}),Ye?ie():oe()}function F(e){e.link?(b.pause(!0),b.setFullscreen(!1),window.open(e.link,e.linktarget)):E.get("controls")&&b.play({reason:"interaction"})}function J(){clearTimeout(Se)}function V(){oe()}function B(e){He.trigger(e.type,e)}function U(t,n){n?(Pe&&Pe.destroy(),e.addClass(fe,"jw-flag-flash-blocked")):(Pe&&Pe.setup(E,fe,fe),e.removeClass(fe,"jw-flag-flash-blocked"))}function z(){E.get("controls")&&b.setFullscreen()}function H(){var n=fe.getElementsByClassName("jw-overlays")[0];n.addEventListener("mousemove",oe),Ee=new s(E,me,{useHover:!0}),Ee.on("click",function(){B({type:t.JWPLAYER_DISPLAY_CLICK}),E.get("controls")&&b.play({reason:"interaction"})}),Ee.on("tap",function(){B({type:t.JWPLAYER_DISPLAY_CLICK}),W()}),Ee.on("doubleClick",z),Ee.on("move",oe),Ee.on("over",oe);var i=new l(E);i.on("click",function(){B({type:t.JWPLAYER_DISPLAY_CLICK}),b.play({reason:"interaction"})}),i.on("tap",function(){B({type:t.JWPLAYER_DISPLAY_CLICK}),W()}),e.isChrome()&&i.el.addEventListener("mousedown",function(){var e=E.getVideo(),t=e&&0===e.getName().name.indexOf("flash");if(t){var n=function(){document.removeEventListener("mouseup",n),i.el.style.pointerEvents="auto"};this.style.pointerEvents="none",document.addEventListener("mouseup",n)}}),ge.appendChild(i.element()),Le=new c(E),Ae=new u(E),Ae.on(t.JWPLAYER_LOGO_CLICK,F);var o=document.createElement("div");o.className="jw-controls-right jw-reset",Ae.setup(o),o.appendChild(Le.element()),ge.appendChild(o),_e=new a(E),_e.setup(fe.id,E.get("captions")),ge.parentNode.insertBefore(_e.element(),Ce.element());var r=E.get("height");y&&("string"==typeof r||r>=1.5*De)?e.addClass(fe,"jw-flag-touch"):(Pe=new h,Pe.setup(E,fe,fe)),je=new d(b,E),je.on(t.JWPLAYER_USER_ACTION,oe),E.on("change:scrubbing",K),E.on("change:compactUI",N),ge.appendChild(je.element()),fe.addEventListener("focus",T),fe.addEventListener("blur",_),fe.addEventListener("keydown",C),fe.onmousedown=P,fe.onmouseup=x}function G(t){return t.get("state")===r.PAUSED?void t.once("change:state",G):void(t.get("scrubbing")===!1&&e.removeClass(fe,"jw-flag-dragging"))}function K(t,n){t.off("change:state",G),n?e.addClass(fe,"jw-flag-dragging"):G(t)}function Q(t,n,i){var o,r=fe.className;i=!!i,i&&(r=r.replace(/\s*aspectMode/,""),fe.className!==r&&(fe.className=r),v(fe,{display:"block"},i)),e.exists(t)&&e.exists(n)&&(E.set("width",t),E.set("height",n)),o={width:t},e.hasClass(fe,"jw-flag-aspect-mode")||(o.height=n),E.get("aspectratio")&&he(),v(fe,o,!0),X(n),Z(t,n)}function X(t){if(xe=q(t),je&&!xe){var n=Ne?ye:E;pe(n,n.get("state"))}e.toggleClass(fe,"jw-flag-audio-player",xe)}function q(e){if(E.get("aspectratio"))return!1;if(g.isString(e)&&e.indexOf("%")>-1)return!1;var t=g.isNumber(e)?e:E.get("containerHeight");return $(t)}function $(e){return e&&e<=De*(y?1.75:1)}function Z(t,n){if(!t||isNaN(Number(t))){if(!me)return;t=me.clientWidth}if(!n||isNaN(Number(n))){if(!me)return;n=me.clientHeight}be&&be.resize(t,n,E.get("stretching")),e.isMSIE(9)&&document.all&&!window.atob&&(t=n="100%");var i=E.getVideo();if(i){var o=i.resize(t,n,E.get("stretching"));o&&(clearTimeout(We),We=setTimeout(Z,250)),E.get("aspectratio")&&he(),_e.resize(),je.checkCompactMode(t)}}function ee(){if(Ue){var e=document.fullscreenElement||document.webkitCurrentFullScreenElement||document.mozFullScreenElement||document.msFullscreenElement;return!(!e||e.id!==E.get("id"))}return Ne?ye.getVideo().getFullScreen():E.getVideo().getFullScreen()}function te(e){var t=E.get("fullscreen"),n=void 0!==e.jwstate?e.jwstate:ee();t!==n&&E.set("fullscreen",n),clearTimeout(We),We=setTimeout(Z,200)}function ne(t,n){n?(e.addClass(t,"jw-flag-fullscreen"),v(document.body,{"overflow-y":"hidden"}),oe()):(e.removeClass(t,"jw-flag-fullscreen"),v(document.body,{"overflow-y":""})),Z()}function ie(){Ye=!1,clearTimeout(Se),je.hideComponents(),e.addClass(fe,"jw-flag-user-inactive"),_e.renderCues(!0)}function oe(){Ye||(e.removeClass(fe,"jw-flag-user-inactive"),je.checkCompactMode(me.clientWidth),_e.renderCues(!0)),Ye=!0,clearTimeout(Se),Se=setTimeout(ie,Oe)}function re(){b.setFullscreen(!1)}function ae(){ke&&ke.setState(E.get("state")),se(E,E.mediaModel.get("mediaType")),E.mediaModel.on("change:mediaType",se,this)}function se(t,n){var i="audio"===n,o=E.getVideo(),r=o&&0===o.getName().name.indexOf("flash");e.toggleClass(fe,"jw-flag-media-audio",i),i&&!r?fe.insertBefore(be.el,me):fe.insertBefore(be.el,_e.element())}function le(t,n){var i="LIVE"===e.adaptiveType(n);e.toggleClass(fe,"jw-flag-live",i),He.setAltText(i?t.get("localization").liveBroadcast:"")}function ce(e,t){return t?void(t.name?Ce.updateText(t.name,t.message):Ce.updateText(t.message,"")):void Ce.playlistItem(e,e.get("playlistItem"))}function ue(){var e=E.getVideo();return!!e&&e.isCaster}function de(){e.replaceClass(fe,/jw-state-\S+/,"jw-state-"+Te)}function pe(t,n){if(Te=n,clearTimeout(Be),n===r.COMPLETE||n===r.IDLE?Be=setTimeout(de,100):de(),ue())return void e.addClass(me,"jw-media-show");switch(n){case r.PLAYING:Z();break;case r.PAUSED:oe()}}function he(){var e=fe.getElementsByClassName("jw-aspect")[0];_e.setContainerHeight(e.offsetHeight)}var fe,ge,me,ve,we,ye,je,be,Ee,ke,Le,Ae,Ce,_e,xe,Pe,Te,Re,Ie,Me,Se=-1,Oe=y?4e3:2e3,De=40,Ne=!1,Ye=!1,We=-1,Fe=-1,Je=window.requestAnimationFrame||function(e){return window.setTimeout(e,17)},Ve=window.cancelAnimationFrame||window.clearTimeout,Be=-1,Ue=!1,ze=!1,He=g.extend(this,i);window.webpackJsonpjwplayer&&n(204),this.model=E,this.api=b,fe=e.createElement(m({id:E.get("id")})),e.isIE()&&e.addClass(fe,"jw-ie");var Ge=E.get("width"),Ke=E.get("height");v(fe,{width:Ge.toString().indexOf("%")>0?Ge:Ge+"px",height:Ke.toString().indexOf("%")>0?Ke:Ke+"px"}),Ie=fe.requestFullscreen||fe.webkitRequestFullscreen||fe.webkitRequestFullScreen||fe.mozRequestFullScreen||fe.msRequestFullscreen,Me=document.exitFullscreen||document.webkitExitFullscreen||document.webkitCancelFullScreen||document.mozCancelFullScreen||document.msExitFullscreen,
	Ue=Ie&&Me,this.onChangeSkin=function(t,n){e.replaceClass(fe,/jw-skin-\S+/,n?"jw-skin-"+n:"")},this.handleColorOverrides=function(){function t(t,i,o){if(o){t=e.prefix(t,"#"+n+" ");var r={};r[i]=o,e.css(t.join(", "),r,n)}}var n=E.get("id"),i=E.get("skinColorActive"),o=E.get("skinColorInactive"),r=E.get("skinColorBackground");t([".jw-toggle",".jw-button-color:hover"],"color",i),t([".jw-active-option",".jw-progress",".jw-playlist-container .jw-option.jw-active-option",".jw-playlist-container .jw-option:hover"],"background",i),t([".jw-text",".jw-option",".jw-button-color",".jw-toggle.jw-off",".jw-tooltip-title",".jw-skip .jw-skip-icon",".jw-playlist-container .jw-icon"],"color",o),t([".jw-cue",".jw-knob"],"background",o),t([".jw-playlist-container .jw-option"],"border-bottom-color",o),t([".jw-background-color",".jw-tooltip-title",".jw-playlist",".jw-playlist-container .jw-option"],"background",r),t([".jw-playlist-container ::-webkit-scrollbar"],"border-color",r),M(i,o,n)},this.setup=function(){this.handleColorOverrides(),E.get("skin-loading")===!0&&(e.addClass(fe,"jw-flag-skin-loading"),E.once("change:skin-loading",function(){e.removeClass(fe,"jw-flag-skin-loading")})),this.onChangeSkin(E,E.get("skin"),""),E.on("change:skin",this.onChangeSkin,this),me=fe.getElementsByClassName("jw-media")[0],ge=fe.getElementsByClassName("jw-controls")[0];var n=fe.getElementsByClassName("jw-preview")[0];be=new p(E),be.setup(n);var i=fe.getElementsByClassName("jw-title")[0];Ce=new f(E),Ce.setup(i),H(),oe(),E.set("mediaContainer",me),E.mediaController.on("fullscreenchange",te);for(var o=j.length;o--;)document.addEventListener(j[o],te,!1);window.removeEventListener("resize",I),window.addEventListener("resize",I,!1),y&&(window.removeEventListener("orientationchange",I),window.addEventListener("orientationchange",I,!1)),E.on("change:errorEvent",ce),E.on("change:controls",Qe),Qe(E,E.get("controls")),E.on("change:state",pe),E.on("change:duration",le,this),E.on("change:flashBlocked",U),U(E,E.get("flashBlocked")),b.onPlaylistComplete(re),b.onPlaylistItem(ae),E.on("change:castAvailable",O),O(E,E.get("castAvailable")),E.on("change:castActive",S),S(E,E.get("castActive")),E.on("change:hideAdsControls",function(t,n){e.toggleClass(fe,"jw-flag-ads-hide-controls",n)}),E.get("stretching")&&D(E,E.get("stretching")),E.on("change:stretching",D),pe(E,r.IDLE),E.on("change:fullscreen",Xe),Y(je),Y(Ae);var a=E.get("aspectratio");if(a){e.addClass(fe,"jw-flag-aspect-mode");var s=fe.getElementsByClassName("jw-aspect")[0];v(s,{paddingTop:a})}b.on(t.JWPLAYER_READY,function(){R(),Q(E.get("width"),E.get("height"))})};var Qe=function(t,n){if(n){var i=Ne?ye.get("state"):E.get("state");pe(t,i)}e.toggleClass(fe,"jw-flag-controls-disabled",!n)},Xe=function(t,n){var i=E.getVideo();Ue?(n?Ie.apply(fe):Me.apply(document),ne(fe,n)):e.isIE()?ne(fe,n):(ye&&ye.getVideo()&&ye.getVideo().setFullscreen(n),i.setFullscreen(n)),i&&0===i.getName().name.indexOf("flash")&&i.setFullscreen(n)};this.resize=function(e,t){var n=!0;Q(e,t,n),R()},this.resizeMedia=Z,this.reset=function(){document.contains(fe)&&fe.parentNode.replaceChild(Re,fe),e.emptyElement(fe)},this.setupInstream=function(t){this.instreamModel=ye=t,ye.on("change:controls",Qe,this),ye.on("change:state",pe,this),Ne=!0,e.addClass(fe,"jw-flag-ads"),oe()},this.setAltText=function(e){je.setAltText(e)},this.destroyInstream=function(){if(Ne=!1,ye&&(ye.off(null,null,this),ye=null),this.setAltText(""),e.removeClass(fe,["jw-flag-ads","jw-flag-ads-hide-controls"]),E.set("hideAdsControls",!1),E.getVideo){var t=E.getVideo();t.setContainer(me)}le(E,E.get("duration")),Ee.revertAlternateClickHandlers()},this.addCues=function(e){je&&je.addCues(e)},this.clickHandler=function(){return Ee},this.controlsContainer=function(){return ge},this.getContainer=this.element=function(){return fe},this.getSafeRegion=function(t){var n={x:0,y:0,width:E.get("containerWidth")||0,height:E.get("containerHeight")||0},i=E.get("dock");return i&&i.length&&E.get("controls")&&(n.y=Le.element().clientHeight,n.height-=n.y),t=t||!e.exists(t),t&&E.get("controls")&&(n.height-=je.element().clientHeight),n},this.setCaptions=function(e){_e.clear(),_e.setup(E.get("id"),e),_e.resize()},this.destroy=function(){window.removeEventListener("resize",I),window.removeEventListener("orientationchange",I);for(var t=j.length;t--;)document.removeEventListener(j[t],te,!1);E.mediaController&&E.mediaController.off("fullscreenchange",te),fe.removeEventListener("keydown",C,!1),Pe&&Pe.destroy(),ke&&(E.off("change:state",ke.statusDelegate),ke.destroy(),ke=null),Ne&&this.destroyInstream(),Ae&&Ae.destroy(),e.clearCss(E.get("id"))}};return b}.apply(t,i),!(void 0!==o&&(e.exports=o))},,function(e,t,n){var i=n(127);"string"==typeof i&&(i=[["all-players",i,""]]),n(85).style(i,"all-players"),i.locals&&(e.exports=i.locals)},,function(e,t,n){var i,o;i=[n(86),n(1),n(31),n(2),n(8),n(9),n(91),n(22),n(92),n(81),n(4),n(5),n(67),n(43),n(35),n(65),n(27)],o=function(e,t,n,i,o,r,a,s,l,c,u,d,p,h,f,g,m){var v={};return v.api=e,v._=t,v.version=n,v.utils=t.extend(i,o,{canCast:f.available,key:a,extend:t.extend,scriptloader:s,rssparser:g,tea:l,UI:r}),v.utils.css.style=v.utils.style,v.vid=c,v.events=t.extend({},u,{state:d}),v.playlist=t.extend({},p,{item:h}),v.plugins=m,v.cast=f,v}.apply(t,i),!(void 0!==o&&(e.exports=o))},,,,,function(e,t,n){var i,o;i=[n(164),n(23),n(215)],o=function(e,t,i){var o=e.prototype.setup;return e.prototype.setup=function(e,r){e.analytics&&(e.sdkplatform=e.sdkplatform||e.analytics.sdkplatform),o.apply(this,arguments);var a=this._model.get("edition"),s=t(a),l=this._model.get("cast"),c=this;s("casting")&&l&&l.appid&&n.e(3,function(require){var e=n(87);c._castController=new e(c,c._model),c.castToggle=c._castController.castToggle.bind(c._castController)});var u=i.setup();this.once("ready",u.onReady,this),r.getAdBlock=u.checkAdBlock},e}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(91),n(23),n(1),n(2),n(79),n(169),n(49)],o=function(e,t,i,o,r,a,s){function l(e,t,n){if(t){var i=t.client;delete t.client,/\.(js|swf)$/.test(i||"")||(i=r.repo()+n),e[i]=t}}function c(e,n){var o=i.clone(n.get("plugins"))||{},a=n.get("edition"),s=t(a),c=/^(vast|googima)$/,u=/\.(js|swf)$/,d=r.repo(),p=i.clone(n.get("advertising"));if(s("ads")&&p&&(u.test(p.client)?o[p.client]=p:c.test(p.client)&&(o[d+p.client+".js"]=p),delete p.client),s("jwpsrv")){var h=n.get("analytics");i.isObject(h)||(h={}),l(o,h,"jwpsrv.js")}l(o,n.get("ga"),"gapro.js"),l(o,n.get("sharing"),"sharing.js"),l(o,n.get("related"),"related.js"),n.set("plugins",o),e()}function u(t,i){var s=i.get("key")||window.jwplayer&&window.jwplayer.key,l=new e(s),c=l.edition();if(i.set("key",s),i.set("edition",c),"unlimited"===c){var u=o.getScriptPath("jwplayer.js");if(!u)return void a.error(t,"Error setting up player","Could not locate jwplayer.js script tag");n.p=u,o.repo=r.repo=r.loadFrom=function(){return u}}i.updateProviders(),"invalid"===c?a.error(t,"Error setting up player",(void 0===s?"Missing":"Invalid")+" license key"):t()}function d(e,t){s.containsDrm(t)?s.probe(e,t.get("edition")):e()}function p(){var e=a.getQueue();return e.CHECK_KEY={method:u,depends:["LOADED_POLYFILLS"]},e.PROBE_DRM_SUPPORT={method:d,depends:["CHECK_KEY"]},e.FILTER_PLUGINS={method:c,depends:["CHECK_KEY"]},e.FILTER_PLAYLIST.depends.push("PROBE_DRM_SUPPORT"),e.LOAD_PLUGINS.depends.push("FILTER_PLUGINS"),e.SETUP_VIEW.depends.push("CHECK_KEY"),e}return{getQueue:p}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(171),n(206),n(1)],o=function(e,t,n){return window.jwplayer?window.jwplayer:n.extend(e,t)}.apply(t,i),!(void 0!==o&&(e.exports=o))},,function(e,t,n){var i,o;i=[],o=function(){function e(){var e=document.createElement("div");return e.className=n,e.innerHTML="&nbsp;",e.style.width="1px",e.style.height="1px",e.style.position="absolute",e.style.background="transparent",e}function t(){function t(){var e=this,t=e._view.element();t.appendChild(a),o=!0,i()&&e.trigger("adBlock")}function i(){return!!o&&(!!r||(""!==a.innerHTML&&a.className===n&&null!==a.offsetParent&&0!==a.clientHeight||(r=!0),r))}var o=!1,r=!1,a=e();return{onReady:t,checkAdBlock:i}}var n="afs_ads";return{setup:t}}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(2),n(4),n(9),n(3),n(1),n(131)],o=function(e,t,n,i,o,r){var a=function(e){this.model=e,this.setup()};return o.extend(a.prototype,i,{setup:function(){this.destroy(),this.skipMessage=this.model.get("skipText"),this.skipMessageCountdown=this.model.get("skipMessage"),this.setWaitTime(this.model.get("skipOffset"));var t=r();this.el=e.createElement(t),this.skiptext=this.el.getElementsByClassName("jw-skiptext")[0],this.skipAdOnce=o.once(this.skipAd.bind(this)),new n(this.el).on("click tap",o.bind(function(){this.skippable&&this.skipAdOnce()},this)),this.model.on("change:duration",this.onChangeDuration,this),this.model.on("change:position",this.onChangePosition,this),this.onChangeDuration(this.model,this.model.get("duration")),this.onChangePosition(this.model,this.model.get("position"))},updateMessage:function(e){this.skiptext.innerHTML=e},updateCountdown:function(e){this.updateMessage(this.skipMessageCountdown.replace(/xx/gi,Math.ceil(this.waitTime-e)))},onChangeDuration:function(t,n){if(n){if(this.waitPercentage){if(!n)return;this.itemDuration=n,this.setWaitTime(this.waitPercentage),delete this.waitPercentage}e.removeClass(this.el,"jw-hidden")}},onChangePosition:function(t,n){this.waitTime-n>0?this.updateCountdown(n):(this.updateMessage(this.skipMessage),this.skippable=!0,e.addClass(this.el,"jw-skippable"))},element:function(){return this.el},setWaitTime:function(t){if(o.isString(t)&&"%"===t.slice(-1)){var n=parseFloat(t);return void(this.itemDuration&&!isNaN(n)?this.waitTime=this.itemDuration*n/100:this.waitPercentage=t)}o.isNumber(t)?this.waitTime=t:"string"===e.typeOf(t)?this.waitTime=e.seconds(t):isNaN(Number(t))?this.waitTime=0:this.waitTime=Number(t)},skipAd:function(){this.trigger(t.JWPLAYER_AD_SKIPPED)},destroy:function(){this.el&&(this.el.removeEventListener("click",this.skipAdOnce),this.el.parentElement&&this.el.parentElement.removeChild(this.el)),delete this.skippable,delete this.itemDuration,delete this.waitPercentage}}),a}.apply(t,i),!(void 0!==o&&(e.exports=o))},function(e,t,n){var i,o;i=[n(200),n(1)],o=function(e,t){var n=function(){};return t.extend(n.prototype,e.prototype,{buildArray:function(){var t=e.prototype.buildArray.apply(this,arguments);if(this.model.get("abouttext")){t.items[0].showLogo=!1,t.items.push(t.items.shift());var n={title:this.model.get("abouttext"),link:this.model.get("aboutlink")||t.items[0].link};t.items.unshift(n)}return t}}),n}.apply(t,i),!(void 0!==o&&(e.exports=o))}])});

/***/ },
/* 13 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 15 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAArCAYAAABmbJjGAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Q0Q1NjlGRkQ1RUVCMTFFNUEyQkI4MzUwQkVCRUZBNEIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Q0Q1NjlGRkU1RUVCMTFFNUEyQkI4MzUwQkVCRUZBNEIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpDRDU2OUZGQjVFRUIxMUU1QTJCQjgzNTBCRUJFRkE0QiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpDRDU2OUZGQzVFRUIxMUU1QTJCQjgzNTBCRUJFRkE0QiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PjEOMJwAAAHqSURBVHja7JdPKARRHMdn1ywRbQ5q90DJyUlxUOIibpxYlD8HOSApJzn5k0QpnPwpSnJY/y5uZi7+5OTARRQXDuRPyd9aNL6v3mja1ux7M+/tQfurT9vOzuxn5r33+/3meTRNUzgjFdSALZ6LvAp/zIAwqJApagOdQAVrIChDVARmLd8D9Ml8IkV+sAkyoo6T4ZsQJfKAFVDwx+99ICRCNABq45yzCArdiKrBCMPNZNGhzXQiygWrIIVxHskTLfGKSFKugxzO5R+ic8YsmgalirMgq7CcRdQKuhTn4aPJHLATkaScU9xHkMrUWCI/nZd0YAiADN+4+eeqJSmHwBs4UcRFJagCuikqA4+8pZ8xSsCxSp/mTpLkd4o8hmEoiQivkqBIipKifyxSdV0nn9kgTaLn2ax1xSBfkoSUnl1TdAiaQJ4E0Ta4MEUfYBLs2b3JOIgjsGDtRyTOQQ/tjCLiHrSASKxVRzrslADJN2gG13bLux8cuBQNAi1eHn2CBnDrYvLHWBP2hsq+OCWXdA9l8FSGfTqMrPEO6sGTkxJEFsYGo6ibvIQ4rXVkCNrBWZzz5sGy26L6AurAq01S9oqq3qegI8bxB3oTEZFtIkx3GdFJeSWjH1mTeRjsyGp8ZIga6c5ulOfCHwEGAKfFafdrWPotAAAAAElFTkSuQmCC"

/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(13)();
	// imports
	
	
	// module
	exports.push([module.id, "#cmy-overlay{display:none;z-index:5000;position:relative}#cmy-overlay .cmy-close{background-color:#fff;border:4px solid #505050;border-radius:20px 20px 20px 20px;box-shadow:1px 0 8px -4px #242424;color:#505050;font-size:24px;font-weight:700;height:19px;padding:6px 6px 6px 8px;width:19px;cursor:pointer;margin-top:-30px;right:-30px;position:absolute;z-index:99;font-family:Verdana;box-sizing:content-box}#cmy-overlay .cmy-close:hover{text-decoration:none}#cmy-overlay .cmy-close>div{line-height:80%;margin-left:-1px}", ""]);
	
	// exports


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(13)();
	// imports
	
	
	// module
	exports.push([module.id, "#cmy-overlay{transition:left .1s ease-in-out}#storyboard,#storyboard-controls,#storyboard-iframe-overlay,#storyboard-overlay{font-family:HelveticaNeueW01-Thin,Verdana}#storyboard *,#storyboard-controls *,#storyboard-overlay *{line-height:120%}#storyboard-iframe-overlay>a,#storyboard-overlay>a{line-height:150%}#storyboard{position:relative;padding:0;background-color:#000;transition:width .2s ease-in-out,height .2s ease-in-out,margin-left .2s ease-in-out}#storyboard #sb-sel{position:absolute;left:0;top:0;overflow:hidden}#storyboard #sb-sel a{cursor:pointer;color:#fff;float:left;margin-right:20px}#storyboard #sb-sel a:hover .title{color:#e99000}#storyboard #sb-sel a .title{color:#fff;text-align:center}#storyboard #sb-sel a .image{background-repeat:no-repeat;background-size:contain}#storyboard-iframe-overlay{font-size:20px}#storyboard-iframe-overlay .sb-back-to-main{z-index:10;padding:8px 0 0 34px;border-radius:0;width:25%;height:30px;color:#5b5b5c;background-image:url(" + __webpack_require__(16) + ");background-size:auto 50%;background-repeat:no-repeat;background-position:10px 10px;text-align:left;width:100%;cursor:pointer;transition:all .25s ease-in-out}#storyboard-iframe-overlay .sb-back-to-main:hover{box-shadow:inset 0 -4px 3px -3px #e99000;color:#e99000}#storyboard-iframe-overlay iframe{border:0 none;bottom:0;margin-top:30px;padding-bottom:30px}#storyboard-controls{background-color:#fff;box-shadow:inset 0 8px 8px -10px #606060,inset 0 -8px 8px -8px #606060,inset 12px 4px 5px -13px #606060,inset -12px 4px 4px -13px #606060;transition:width .2s ease-in-out,height .2s ease-in-out,margin-left .2s ease-in-out}#storyboard-controls .sb-control{box-sizing:border-box;text-align:center;position:relative}#storyboard-controls .sb-control *{box-sizing:border-box}#storyboard-controls .sb-control.sb-button{padding:0 1%;width:24%;height:100%;color:#5b5b5c}#storyboard-controls .sb-control.sb-button>*{cursor:pointer;height:100%;background-repeat:no-repeat;position:relative;transition:all .25s ease-in-out}#storyboard-controls .sb-control.sb-button>:hover{box-shadow:inset 0 -4px 3px -3px #e99000;color:#e99000}#storyboard-controls .sb-control.sb-button .sb-back-to-main{background-image:url(" + __webpack_require__(16) + ");text-align:left;width:100%}#storyboard-controls .sb-control.sb-button .sb-skip-intermediate{background-image:url(" + __webpack_require__(38) + ");display:block;text-align:left}#storyboard-controls .sb-control.sb-button .sb-replay{background-image:url(" + __webpack_require__(39) + ");text-align:right}#storyboard-controls .sb-control.sb-button .sb-qualities{display:block;margin-left:auto;margin-right:auto;width:100%;background-repeat:no-repeat}#storyboard-controls .sb-control.sb-button .sb-qualities.sb-quality-hd{background-image:url(" + __webpack_require__(36) + ")}#storyboard-controls .sb-control.sb-button .sb-qualities.sb-quality-sd{background-image:url(" + __webpack_require__(37) + ")}#storyboard-controls .sb-control.sb-select{width:40%;margin-left:1%;margin-right:1%;height:100%;transition:all .2s ease-in-out;white-space:nowrap;cursor:pointer}#storyboard-controls .sb-control.sb-select.toggling-disabled:hover{box-shadow:none}#storyboard-controls .sb-control.sb-select.closed{overflow:hidden}#storyboard-controls .sb-control.sb-select.closed .sb-select-chapter-message{background-image:none!important;padding-right:8px!important}#storyboard-controls .sb-control.sb-select.closed .sb-select-chapter-message:after{content:\":\";display:inline}#storyboard-controls .sb-control.sb-select.closed.side-by-side .sb-select-chapter-message{display:inline-block}#storyboard-controls .sb-control.sb-select.closed.above-and-below{padding-top:8px}#storyboard-controls .sb-control.sb-select.closed.above-and-below .sb-select-chapter-message{display:block}#storyboard-controls .sb-control.sb-select.open.toggling-disabled .sb-select-chapter-message{display:none}#storyboard-controls .sb-control.sb-select .open .sb-chapter{color:#5b5b5c}#storyboard-controls .sb-control.sb-select .open .sb-chapter:hover{color:#e99000}#storyboard-controls .sb-control.sb-select:hover{box-shadow:inset 0 -4px 3px -3px #e99000}#storyboard-controls .sb-control.sb-select .sb-chapters.current,#storyboard-controls .sb-control.sb-select:hover .sb-chapters.closed,#storyboard-controls .sb-control.sb-select:hover .sb-chapters.closed .sb-chapter.selected,#storyboard-controls .sb-control.sb-select:hover .sb-select-chapter-message{color:#e99000}#storyboard-controls .sb-control.sb-select .sb-select-chapter-message{cursor:pointer;display:inline-block;background-image:url(" + __webpack_require__(15) + ");background-position:100% 0;min-height:44px;padding-right:35px;padding-top:2px;background-repeat:no-repeat;color:#e99000;transition:color .25s ease-in-out}#storyboard-controls .sb-control.sb-select .sb-chapters{margin-top:-6px;cursor:pointer;transition:width .2s ease-in-out,height .2s ease-in-out}#storyboard-controls .sb-control.sb-select .sb-chapters .sb-toggle-button{display:inline-block;background-image:url(" + __webpack_require__(15) + ");background-repeat:no-repeat;background-position:top;margin-bottom:-20px;width:26px}#storyboard-controls .sb-control.sb-select .sb-chapters.left-side.open{font-size:13px;width:0;border-bottom:20px solid hsla(0,0%,100%,0);border-top:20px solid hsla(0,0%,100%,0);padding:0 20px}#storyboard-controls .sb-control.sb-select .sb-chapters.left-side.open>div.sb-chapter{padding:2px}#storyboard-controls .sb-control.sb-select .sb-chapters.left-side.open>div.sb-chapter.selected{background-color:#e99000;color:#fff}#storyboard-controls .sb-control.sb-select .sb-chapters.closed{display:inline;margin-top:-8px}#storyboard-controls .sb-control.sb-select .sb-chapters.closed .sb-chapter.selected{color:#5b5b5c;transition:color .25s ease-in-out}#storyboard-controls .sb-control.sb-select .sb-chapters.open{margin-top:0;background-color:hsla(0,0%,100%,.9);position:fixed;top:0;overflow-y:scroll;overflow-x:hidden;padding:20px}#storyboard-controls .sb-control.sb-select .sb-chapters.open>div{text-align:left}#storyboard-controls .sb-control.sb-select .sb-chapters.open>div.sb-chapter{padding:2px;display:block!important}#storyboard-controls .sb-control.sb-select .sb-chapters.open>div.sb-chapter.main{font-family:HelveticaNeueW01-75Bold,Verdana}#storyboard-controls .sb-control.sb-select .sb-chapters.open>div.sb-chapter.sub{padding-left:10px}#storyboard-controls .sb-control.sb-select .sb-chapters.open>div.sb-chapter.selected{background-color:#e99000;color:#fff}#storyboard-controls .sb-control.sb-select .sb-chapters.open>div.sb-toggle-button,#storyboard-controls .sb-control.sb-select .sb-chapters>div.sb-chapter{display:none}#storyboard-controls .sb-control.sb-select .sb-chapters>div.sb-chapter.selected{display:inline}#storyboard-controls .sb-control.sb-select .sb-chapters .selected{color:inherit}#storyboard-controls .sb-control.sb-left{float:left}#storyboard-controls .sb-control.sb-left>*{background-position:0}#storyboard-controls .sb-control.sb-right{float:right}#storyboard-controls .sb-control.sb-right>*{background-position:100%}#storyboard-controls .sb-control.sb-full{display:inline-block;float:none;width:100%;height:auto}#storyboard-controls .sb-control.sb-full:before{clear:both;content:\" \";display:block}#storyboard.large #sb-sel a{font-size:26px}#storyboard.large #sb-sel a .image{box-shadow:15px 15px 26px -5px rgba(0,0,0,.75)}#storyboard.large #sb-sel a .image .sb-play-clip-button{background-size:auto 70px}#storyboard.large #sb-sel a .title.above{margin-top:-52px;margin-bottom:20px}#storyboard.large #sb-sel a .title.below{margin-top:20px}#storyboard.small #sb-sel a{font-size:13px}#storyboard.small #sb-sel a .image{box-shadow:7.5px 7.5px 13px -2.5px rgba(0,0,0,.75)}#storyboard.small #sb-sel a .image .sb-play-clip-button{background-size:auto 35px}#storyboard.small #sb-sel a .title.above{margin-top:-26px;margin-bottom:10px}#storyboard.small #sb-sel a .title.below{margin-top:10px}#storyboard-controls.large,#storyboard-controls.small{height:51px}#storyboard-controls.large .sb-control.sb-button>*,#storyboard-controls.small .sb-control.sb-button>*{font-size:13px;padding-top:17px}#storyboard-controls.large .sb-control.sb-select,#storyboard-controls.small .sb-control.sb-select{font-size:13px;padding-top:13px}#storyboard-controls.large .sb-control.sb-select.closed.side-by-side,#storyboard-controls.small .sb-control.sb-select.closed.side-by-side{padding-top:13px}#storyboard-controls.large .sb-control.sb-select.closed.above-and-below,#storyboard-controls.small .sb-control.sb-select.closed.above-and-below{padding-top:4px}#storyboard-controls.large .sb-control.sb-select.closed.above-and-below .sb-chapters,#storyboard-controls.small .sb-control.sb-select.closed.above-and-below .sb-chapters{top:-24px;position:relative}#storyboard-controls.large .sb-control.sb-select.closed .sb-select-chapter-message,#storyboard-controls.small .sb-control.sb-select.closed .sb-select-chapter-message{padding-right:4px!important}#storyboard-controls.large .sb-control.sb-select .sb-select-chapter-message,#storyboard-controls.small .sb-control.sb-select .sb-select-chapter-message{background-size:8%;padding-right:18px;line-height:140%;background-repeat:no-repeat}#storyboard-controls.large .sb-control.sb-select .sb-chapters .sb-toggle-button,#storyboard-controls.small .sb-control.sb-select .sb-chapters .sb-toggle-button{background-size:auto 21.5px;height:36px;margin-left:2px}#storyboard-controls.large .sb-control .sb-back-to-main,#storyboard-controls.large .sb-control .sb-skip-intermediate,#storyboard-controls.small .sb-control .sb-back-to-main,#storyboard-controls.small .sb-control .sb-skip-intermediate{background-size:auto 30px;padding-left:38px}#storyboard-controls.large .sb-control .sb-replay,#storyboard-controls.small .sb-control .sb-replay{background-size:auto 30px;padding-right:42px}#storyboard-controls.large .sb-control .sb-qualities,#storyboard-controls.small .sb-control .sb-qualities{padding-top:33px;padding-bottom:18px;width:54px;height:22.5px;background-size:contain}#storyboard-controls.large .sb-control.sb-button{width:20%}#storyboard>.jwplayer *{line-height:233%}.jwplayer.jw-skin-no-fullscreen .jw-icon-fullscreen{display:none;visibility:hidden}", ""]);
	
	// exports


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * EvEmitter v1.0.3
	 * Lil' event emitter
	 * MIT License
	 */
	
	/* jshint unused: true, undef: true, strict: true */
	
	( function( global, factory ) {
	  // universal module definition
	  /* jshint strict: false */ /* globals define, module, window */
	  if ( true ) {
	    // AMD - RequireJS
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS - Browserify, Webpack
	    module.exports = factory();
	  } else {
	    // Browser globals
	    global.EvEmitter = factory();
	  }
	
	}( typeof window != 'undefined' ? window : this, function() {
	
	"use strict";
	
	function EvEmitter() {}
	
	var proto = EvEmitter.prototype;
	
	proto.on = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // set events hash
	  var events = this._events = this._events || {};
	  // set listeners array
	  var listeners = events[ eventName ] = events[ eventName ] || [];
	  // only add once
	  if ( listeners.indexOf( listener ) == -1 ) {
	    listeners.push( listener );
	  }
	
	  return this;
	};
	
	proto.once = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // add event
	  this.on( eventName, listener );
	  // set once flag
	  // set onceEvents hash
	  var onceEvents = this._onceEvents = this._onceEvents || {};
	  // set onceListeners object
	  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
	  // set flag
	  onceListeners[ listener ] = true;
	
	  return this;
	};
	
	proto.off = function( eventName, listener ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  var index = listeners.indexOf( listener );
	  if ( index != -1 ) {
	    listeners.splice( index, 1 );
	  }
	
	  return this;
	};
	
	proto.emitEvent = function( eventName, args ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  var i = 0;
	  var listener = listeners[i];
	  args = args || [];
	  // once stuff
	  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];
	
	  while ( listener ) {
	    var isOnce = onceListeners && onceListeners[ listener ];
	    if ( isOnce ) {
	      // remove listener
	      // remove before trigger to prevent recursion
	      this.off( eventName, listener );
	      // unset once flag
	      delete onceListeners[ listener ];
	    }
	    // trigger listener
	    listener.apply( this, args );
	    // get next listener
	    i += isOnce ? 0 : 1;
	    listener = listeners[i];
	  }
	
	  return this;
	};
	
	return EvEmitter;
	
	}));


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(2);
	var $ = __webpack_require__(2);
	
	/**
	 * @license 
	 * jQuery Tools @VERSION Overlay - Overlay base. Extend it.
	 * 
	 * NO COPYRIGHTS OR LICENSES. DO WHAT YOU LIKE.
	 * 
	 * http://flowplayer.org/tools/overlay/
	 *
	 * Since: March 2008
	 * Date: @DATE 
	 */
	(function($) { 
	
		// static constructs
		$.tools = $.tools || {version: '@VERSION'};
		
		$.tools.overlay = {
			
			addEffect: function(name, loadFn, closeFn) {
				effects[name] = [loadFn, closeFn];	
			},
		
			conf: {  
				close: null,	
				closeOnClick: true,
				closeOnEsc: true,			
				closeSpeed: 'fast',
				effect: 'default',
				
				// since 1.2. fixed positioning not supported by IE6
				fixed: !$.browser.msie || $.browser.version > 6, 
				
				left: 'center',		
				load: false, // 1.2
				mask: null,  
				oneInstance: true,
				speed: 'normal',
				target: null, // target element to be overlayed. by default taken from [rel]
				top: '10%'
			}
		};
	
		
		var instances = [], effects = {};
			
		// the default effect. nice and easy!
		$.tools.overlay.addEffect('default', 
			
			/* 
				onLoad/onClose functions must be called otherwise none of the 
				user supplied callback methods won't be called
			*/
			function(pos, onLoad) {
				
				var conf = this.getConf(),
					 w = $(window);				 
					
				if (!conf.fixed)  {
					pos.top += w.scrollTop();
					pos.left += w.scrollLeft();
				} 
					
				pos.position = conf.fixed ? 'fixed' : 'absolute';
				this.getOverlay().css(pos).fadeIn(conf.speed, onLoad); 
				
			}, function(onClose) {
				this.getOverlay().fadeOut(this.getConf().closeSpeed, onClose); 			
			}		
		);		
	
		
		function Overlay(trigger, conf) {		
			
			// private variables
			var self = this,
				 fire = trigger.add(self),
				 w = $(window), 
				 closers,            
				 overlay,
				 opened,
				 maskConf = $.tools.expose && (conf.mask || conf.expose),
				 uid = Math.random().toString().slice(10);		
			
				 
			// mask configuration
			if (maskConf) {			
				if (typeof maskConf == 'string') { maskConf = {color: maskConf}; }
				maskConf.closeOnClick = maskConf.closeOnEsc = false;
			}			 
			 
			// get overlay and trigger
			var jq = conf.target || trigger.attr("rel");
			overlay = jq ? $(jq) : null || trigger;	
			
			// overlay not found. cannot continue
			if (!overlay.length) { throw "Could not find Overlay: " + jq; }
			
			// trigger's click event
			if (trigger && trigger.index(overlay) == -1) {
				trigger.click(function(e) {				
					self.load(e);
					return e.preventDefault();
				});
			}   			
			
			// API methods  
			$.extend(self, {
	
				load: function(e) {
					
					// can be opened only once
					if (self.isOpened()) { return self; }
					
					// find the effect
			 		var eff = effects[conf.effect];
			 		if (!eff) { throw "Overlay: cannot find effect : \"" + conf.effect + "\""; }
					
					// close other instances?
					if (conf.oneInstance) {
						$.each(instances, function() {
							this.close(e);
						});
					}
					
					// onBeforeLoad
					e = e || $.Event();
					e.type = "onBeforeLoad";
					fire.trigger(e);				
					if (e.isDefaultPrevented()) { return self; }				
	
					// opened
					opened = true;
					
					// possible mask effect
					if (maskConf) { $(overlay).expose(maskConf); }				
					
					// position & dimensions 
					var top = conf.top,					
						 left = conf.left,
						 oWidth = overlay.outerWidth({margin:true}),
						 oHeight = overlay.outerHeight({margin:true}); 
					
					if (typeof top == 'string')  {
						top = top == 'center' ? Math.max((w.height() - oHeight) / 2, 0) : 
							parseInt(top, 10) / 100 * w.height();			
					}				
					
					if (left == 'center') { left = Math.max((w.width() - oWidth) / 2, 0); }
	
					
			 		// load effect  		 		
					eff[0].call(self, {top: top, left: left}, function() {					
						if (opened) {
							e.type = "onLoad";
							fire.trigger(e);
						}
					}); 				
	
					// mask.click closes overlay
					if (maskConf && conf.closeOnClick) {
						$.mask.getMask().one("click", self.close); 
					}
					
					// when window is clicked outside overlay, we close
					if (conf.closeOnClick) {
						$(document).on("click." + uid, function(e) { 
							if (!$(e.target).parents(overlay).length) { 
								self.close(e); 
							}
						});						
					}						
				
					// keyboard::escape
					if (conf.closeOnEsc) { 
	
						// one callback is enough if multiple instances are loaded simultaneously
						$(document).on("keydown." + uid, function(e) {
							if (e.keyCode == 27) { 
								self.close(e);	 
							}
						});			
					}
	
					
					return self; 
				}, 
				
				close: function(e) {
	
					if (!self.isOpened()) { return self; }
					
					e = e || $.Event();
					e.type = "onBeforeClose";
					fire.trigger(e);				
					if (e.isDefaultPrevented()) { return; }				
					
					opened = false;
					
					// close effect
					effects[conf.effect][1].call(self, function() {
						e.type = "onClose";
						fire.trigger(e); 
					});
					
					// unbind the keyboard / clicking actions
					$(document).off("click." + uid + " keydown." + uid);		  
					
					if (maskConf) {
						$.mask.close();		
					}
					 
					return self;
				}, 
				
				getOverlay: function() {
					return overlay;	
				},
				
				getTrigger: function() {
					return trigger;	
				},
				
				getClosers: function() {
					return closers;	
				},			
	
				isOpened: function()  {
					return opened;
				},
				
				// manipulate start, finish and speeds
				getConf: function() {
					return conf;	
				}			
				
			});
			
			// callbacks	
			$.each("onBeforeLoad,onStart,onLoad,onBeforeClose,onClose".split(","), function(i, name) {
					
				// configuration
				if ($.isFunction(conf[name])) { 
					$(self).on(name, conf[name]); 
				}
	
				// API
				self[name] = function(fn) {
					if (fn) { $(self).on(name, fn); }
					return self;
				};
			});
			
			// close button
			closers = overlay.find(conf.close || ".close");		
			
			if (!closers.length && !conf.close) {
				closers = $('<a class="close"></a>');
				overlay.prepend(closers);	
			}		
			
			closers.click(function(e) { 
				self.close(e);  
			});	
			
			// autoload
			if (conf.load) { self.load(); }
			
		}
		
		// jQuery plugin initialization
		$.fn.overlay = function(conf) {   
			
			// already constructed --> return API
			var el = this.data("overlay");
			if (el) { return el; }	  		 
			
			if ($.isFunction(conf)) {
				conf = {onBeforeLoad: conf};	
			}
	
			conf = $.extend(true, {}, $.tools.overlay.conf, conf);
			
			this.each(function() {		
				el = new Overlay($(this), conf);
				instances.push(el);
				$(this).data("overlay", el);	
			});
			
			return conf.api ? el: this;		
		}; 
		
	})(jQuery);
	
	


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(2);
	var $ = __webpack_require__(2);
	
	/**
	 * @license 
	 * jQuery Tools @VERSION / Expose - Dim the lights
	 * 
	 * NO COPYRIGHTS OR LICENSES. DO WHAT YOU LIKE.
	 * 
	 * http://flowplayer.org/tools/toolbox/expose.html
	 *
	 * Since: Mar 2010
	 * Date: @DATE 
	 */
	(function($) { 	
	
		// static constructs
		$.tools = $.tools || {version: '@VERSION'};
		
		var tool;
		
		tool = $.tools.expose = {
			
			conf: {	
				maskId: 'exposeMask',
				loadSpeed: 'slow',
				closeSpeed: 'fast',
				closeOnClick: true,
				closeOnEsc: true,
				
				// css settings
				zIndex: 9998,
				opacity: 0.8,
				startOpacity: 0,
				color: '#fff',
				
				// callbacks
				onLoad: null,
				onClose: null
			}
		};
	
		/* one of the greatest headaches in the tool. finally made it */
		function viewport() {
					
			// the horror case
			if ($.browser.msie) {
				
				// if there are no scrollbars then use window.height
				var d = $(document).height(), w = $(window).height();
				
				return [
					window.innerWidth || 							// ie7+
					document.documentElement.clientWidth || 	// ie6  
					document.body.clientWidth, 					// ie6 quirks mode
					d - w < 20 ? w : d
				];
			} 
			
			// other well behaving browsers
			return [$(document).width(), $(document).height()]; 
		} 
		
		function call(fn) {
			if (fn) { return fn.call($.mask); }
		}
		
		var mask, exposed, loaded, config, overlayIndex;		
		
		
		$.mask = {
			
			load: function(conf, els) {
				
				// already loaded ?
				if (loaded) { return this; }			
				
				// configuration
				if (typeof conf == 'string') {
					conf = {color: conf};	
				}
				
				// use latest config
				conf = conf || config;
				
				config = conf = $.extend($.extend({}, tool.conf), conf);
	
				// get the mask
				mask = $("#" + conf.maskId);
					
				// or create it
				if (!mask.length) {
					mask = $('<div/>').attr("id", conf.maskId);
					$("body").append(mask);
				}
				
				// set position and dimensions 			
				var size = viewport();
					
				mask.css({				
					position:'absolute', 
					top: 0, 
					left: 0,
					width: size[0],
					height: size[1],
					display: 'none',
					opacity: conf.startOpacity,					 		
					zIndex: conf.zIndex 
				});
				
				if (conf.color) {
					mask.css("backgroundColor", conf.color);	
				}			
				
				// onBeforeLoad
				if (call(conf.onBeforeLoad) === false) {
					return this;
				}
				
				// esc button
				if (conf.closeOnEsc) {						
					$(document).on("keydown.mask", function(e) {							
						if (e.keyCode == 27) {
							$.mask.close(e);	
						}		
					});			
				}
				
				// mask click closes
				if (conf.closeOnClick) {
					mask.on("click.mask", function(e)  {
						$.mask.close(e);		
					});					
				}			
				
				// resize mask when window is resized
				$(window).on("resize.mask", function() {
					$.mask.fit();
				});
				
				// exposed elements
				if (els && els.length) {
					
					overlayIndex = els.eq(0).css("zIndex");
	
					// make sure element is positioned absolutely or relatively
					$.each(els, function() {
						var el = $(this);
						if (!/relative|absolute|fixed/i.test(el.css("position"))) {
							el.css("position", "relative");		
						}					
					});
				 
					// make elements sit on top of the mask
					exposed = els.css({ zIndex: Math.max(conf.zIndex + 1, overlayIndex == 'auto' ? 0 : overlayIndex)});			
				}	
				
				// reveal mask
				mask.css({display: 'block'}).fadeTo(conf.loadSpeed, conf.opacity, function() {
					$.mask.fit(); 
					call(conf.onLoad);
					loaded = "full";
				});
				
				loaded = true;			
				return this;				
			},
			
			close: function() {
				if (loaded) {
					
					// onBeforeClose
					if (call(config.onBeforeClose) === false) { return this; }
						
					mask.fadeOut(config.closeSpeed, function()  {					
						call(config.onClose);					
						if (exposed) {
							exposed.css({zIndex: overlayIndex});						
						}				
						loaded = false;
					});				
					
					// unbind various event listeners
					$(document).off("keydown.mask");
					mask.off("click.mask");
					$(window).off("resize.mask");  
				}
				
				return this; 
			},
			
			fit: function() {
				if (loaded) {
					var size = viewport();				
					mask.css({width: size[0], height: size[1]});
				}				
			},
			
			getMask: function() {
				return mask;	
			},
			
			isLoaded: function(fully) {
				return fully ? loaded == 'full' : loaded;	
			}, 
			
			getConf: function() {
				return config;	
			},
			
			getExposed: function() {
				return exposed;	
			}		
		};
		
		$.fn.mask = function(conf) {
			$.mask.load(conf);
			return this;		
		};			
		
		$.fn.expose = function(conf) {
			$.mask.load(conf, this);
			return this;			
		};
	
	
	})(jQuery);
	


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery Browser Plugin 0.1.0
	 * https://github.com/gabceb/jquery-browser-plugin
	 *
	 * Original jquery-browser code Copyright 2005, 2015 jQuery Foundation, Inc. and other contributors
	 * http://jquery.org/license
	 *
	 * Modifications Copyright 2015 Gabriel Cebrian
	 * https://github.com/gabceb
	 *
	 * Released under the MIT license
	 *
	 * Date: 05-07-2015
	 */
	/*global window: false */
	
	(function (factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
	      return factory($);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && typeof module.exports === 'object') {
	    // Node-like environment
	    module.exports = factory(require('jquery'));
	  } else {
	    // Browser globals
	    factory(window.jQuery);
	  }
	}(function(jQuery) {
	  "use strict";
	
	  function uaMatch( ua ) {
	    // If an UA is not provided, default to the current browser UA.
	    if ( ua === undefined ) {
	      ua = window.navigator.userAgent;
	    }
	    ua = ua.toLowerCase();
	
	    var match = /(edge)\/([\w.]+)/.exec( ua ) ||
	        /(opr)[\/]([\w.]+)/.exec( ua ) ||
	        /(chrome)[ \/]([\w.]+)/.exec( ua ) ||
	        /(iemobile)[\/]([\w.]+)/.exec( ua ) ||
	        /(version)(applewebkit)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec( ua ) ||
	        /(webkit)[ \/]([\w.]+).*(version)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec( ua ) ||
	        /(webkit)[ \/]([\w.]+)/.exec( ua ) ||
	        /(opera)(?:.*version|)[ \/]([\w.]+)/.exec( ua ) ||
	        /(msie) ([\w.]+)/.exec( ua ) ||
	        ua.indexOf("trident") >= 0 && /(rv)(?::| )([\w.]+)/.exec( ua ) ||
	        ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec( ua ) ||
	        [];
	
	    var platform_match = /(ipad)/.exec( ua ) ||
	        /(ipod)/.exec( ua ) ||
	        /(windows phone)/.exec( ua ) ||
	        /(iphone)/.exec( ua ) ||
	        /(kindle)/.exec( ua ) ||
	        /(silk)/.exec( ua ) ||
	        /(android)/.exec( ua ) ||
	        /(win)/.exec( ua ) ||
	        /(mac)/.exec( ua ) ||
	        /(linux)/.exec( ua ) ||
	        /(cros)/.exec( ua ) ||
	        /(playbook)/.exec( ua ) ||
	        /(bb)/.exec( ua ) ||
	        /(blackberry)/.exec( ua ) ||
	        [];
	
	    var browser = {},
	        matched = {
	          browser: match[ 5 ] || match[ 3 ] || match[ 1 ] || "",
	          version: match[ 2 ] || match[ 4 ] || "0",
	          versionNumber: match[ 4 ] || match[ 2 ] || "0",
	          platform: platform_match[ 0 ] || ""
	        };
	
	    if ( matched.browser ) {
	      browser[ matched.browser ] = true;
	      browser.version = matched.version;
	      browser.versionNumber = parseInt(matched.versionNumber, 10);
	    }
	
	    if ( matched.platform ) {
	      browser[ matched.platform ] = true;
	    }
	
	    // These are all considered mobile platforms, meaning they run a mobile browser
	    if ( browser.android || browser.bb || browser.blackberry || browser.ipad || browser.iphone ||
	      browser.ipod || browser.kindle || browser.playbook || browser.silk || browser[ "windows phone" ]) {
	      browser.mobile = true;
	    }
	
	    // These are all considered desktop platforms, meaning they run a desktop browser
	    if ( browser.cros || browser.mac || browser.linux || browser.win ) {
	      browser.desktop = true;
	    }
	
	    // Chrome, Opera 15+ and Safari are webkit based browsers
	    if ( browser.chrome || browser.opr || browser.safari ) {
	      browser.webkit = true;
	    }
	
	    // IE11 has a new token so we will assign it msie to avoid breaking changes
	    if ( browser.rv || browser.iemobile) {
	      var ie = "msie";
	
	      matched.browser = ie;
	      browser[ie] = true;
	    }
	
	    // Edge is officially known as Microsoft Edge, so rewrite the key to match
	    if ( browser.edge ) {
	      delete browser.edge;
	      var msedge = "msedge";
	
	      matched.browser = msedge;
	      browser[msedge] = true;
	    }
	
	    // Blackberry browsers are marked as Safari on BlackBerry
	    if ( browser.safari && browser.blackberry ) {
	      var blackberry = "blackberry";
	
	      matched.browser = blackberry;
	      browser[blackberry] = true;
	    }
	
	    // Playbook browsers are marked as Safari on Playbook
	    if ( browser.safari && browser.playbook ) {
	      var playbook = "playbook";
	
	      matched.browser = playbook;
	      browser[playbook] = true;
	    }
	
	    // BB10 is a newer OS version of BlackBerry
	    if ( browser.bb ) {
	      var bb = "blackberry";
	
	      matched.browser = bb;
	      browser[bb] = true;
	    }
	
	    // Opera 15+ are identified as opr
	    if ( browser.opr ) {
	      var opera = "opera";
	
	      matched.browser = opera;
	      browser[opera] = true;
	    }
	
	    // Stock Android browsers are marked as Safari on Android.
	    if ( browser.safari && browser.android ) {
	      var android = "android";
	
	      matched.browser = android;
	      browser[android] = true;
	    }
	
	    // Kindle browsers are marked as Safari on Kindle
	    if ( browser.safari && browser.kindle ) {
	      var kindle = "kindle";
	
	      matched.browser = kindle;
	      browser[kindle] = true;
	    }
	
	     // Kindle Silk browsers are marked as Safari on Kindle
	    if ( browser.safari && browser.silk ) {
	      var silk = "silk";
	
	      matched.browser = silk;
	      browser[silk] = true;
	    }
	
	    // Assign the name and platform variable
	    browser.name = matched.browser;
	    browser.platform = matched.platform;
	    return browser;
	  }
	
	  // Run the matching process, also assign the function to the returned object
	  // for manual, jQuery-free use if desired
	  window.jQBrowser = uaMatch( window.navigator.userAgent );
	  window.jQBrowser.uaMatch = uaMatch;
	
	  // Only assign to jQuery.browser if jQuery is loaded
	  if ( jQuery ) {
	    jQuery.browser = window.jQBrowser;
	  }
	
	  return window.jQBrowser;
	}));


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	   'use strict';
	
	   module.exports = AssetCoreAudio;
	   var AssetCoreMedia = __webpack_require__(8);
	   var logger = new (__webpack_require__(3))("ACMediaAudio").setColor("goldenrod").setDebug(true);
	
	  function AssetCoreAudio(detailJson){
	    AssetCoreMedia.call(this, detailJson); // call super constructor.
	    logger.debug("creating AssetCoreAudio with defaultQuality '"+this.defaultQualityName()+"' from json:", detailJson);
	  }
	
	  // subclass extends superclass
	  AssetCoreAudio.prototype = Object.create(AssetCoreMedia.prototype);
	  AssetCoreAudio.prototype.constructor = AssetCoreMedia;
	
	  AssetCoreAudio.prototype.url = function(){
	    return this._defaultQuality().detail.url;
	  };
	
	  AssetCoreAudio.prototype.durationMs = function(){
	    return this._defaultQuality().detail.durationMs;
	  };
	
	}());


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	   'use strict';
	
	   module.exports = AssetCoreImage;
	   var AssetCoreMedia = __webpack_require__(8);
	   var helper = __webpack_require__(1);
	   var logger = new (__webpack_require__(3))("ACMediaImage").setColor("goldenrod").setDebug(true);
	
	  function AssetCoreImage(detailJson){
	    AssetCoreMedia.call(this, detailJson); // call super constructor.
	    logger.debug("creating AssetCoreImage with defaultQuality '"+this.defaultQualityName()+"' from json:", detailJson);
	  }
	
	  // subclass extends superclass
	  AssetCoreImage.prototype = Object.create(AssetCoreMedia.prototype);
	  AssetCoreImage.prototype.constructor = AssetCoreMedia;
	
	  AssetCoreImage.prototype.width = function(quality){
	    if (helper.undefOrNull(quality)){
	      return this._defaultQuality().detail.width;
	    } else {
	      return this._getQuality(quality).detail.width;
	    }
	  };
	  AssetCoreImage.prototype.height = function(quality){
	    if (helper.undefOrNull(quality)){
	      return this._defaultQuality().detail.height;
	    } else {
	      return this._getQuality(quality).detail.height;
	    }
	  };
	
	  AssetCoreImage.prototype.ratio = function(qualityName){
	    var height = this.height(qualityName);
	    var width = this.width(qualityName);
	    return width / height;
	  };
	
	  AssetCoreImage.prototype._standardQuality = function(){
	    return this._getQuality("SQ");
	  };
	  AssetCoreImage.prototype._highQuality = function(){
	    return this._getQuality("HQ");
	  };
	
	  // returns the correct url depending on the devices pixel ratio
	  AssetCoreImage.prototype.dppxUrl = function(){
	    var dppx = helper.getDppx();
	    var url = null;
	    if (dppx<=1){
	      url = this.url();
	    } else {
	      url = this.retinaUrl() !== null ? this.retinaUrl() : this.url(); //fallback to SQ if no HQ available
	    }
	    return url;
	  };
	
	  AssetCoreImage.prototype.url = function(){
	    return this._defaultQuality().detail.url;
	  };
	
	  AssetCoreImage.prototype.retinaUrl = function(){
	    return this._highQuality() !== null ? this._highQuality().detail.url : null;
	  };
	
	}());


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	(function(){
	  'use strict';
	
	  var jwplayer = __webpack_require__(12);
	
	  var logger = new (__webpack_require__(3))("AudioPlayer").setColor("#6f97f0").setDebug(true);
	  var helper = __webpack_require__(1);
	  var jquery = __webpack_require__(2);
	  var Overlay = __webpack_require__(10);
	
	  module.exports = AudioPlayer;
	
	  var defaultOptions = {
	    width: '100%'
	  };
	
	  function AudioPlayer(mediaInstance, inline, container, options){
	    var self = this;
	    this.media = mediaInstance;
	    this.inline = inline;
	    this.baseContainer = jquery(container);
	    this.baseContainer.data("cmy-audioplayer", this);
	
	    this.options = jquery.extend(true, {}, defaultOptions);
	
	    if(!helper.undefOrNull(options)){
	      this.options = jquery.extend( true, this.options, options );
	    }
	
	    logger.debug("initting jwplayer-audio " + (inline? "inline" : "for overlay"));
	
	    if (inline){
	      var playerContainer = jquery("<div></div>");
	      container.append(playerContainer);
	      self.container = playerContainer;
	      self._containerId = "ply-" + new Date().getTime(); //jwPlayer needs individual IDs to be able to display more than one instance at a time
	      self.container.attr("id", self._containerId);
	      var player = self._initJwPlayer();
	      player.on('ready', function(){
	        var css = {
	          minWidth: '40px',
	          display: 'inline-block'
	        };
	
	        if (isNaN(self.options.width)){ //should contain unit
	          css.width = self.options.width;
	        } else {
	          css.width = self.options.width + 'px';
	        }
	
	        $("#"+self._containerId).css(css);
	      });
	
	
	    } else {
	      throw "AudioPlayer: Overlay-Mode is not yet implemented";
	      //TODO: Started development but was told that we do not need an overlay-player yet
	      /*
	      jquery(container).append("<span class='cmy-play-audio-in-overlay-button'>Play in Overlay<span>").click(function(){
	        self.container = $("<div id='overlay-audio-player'></div>");
	        self.overlay = new Overlay(self.container).show();
	        self.overlay.addRemovalCallback(function(){
	          if (!helper.undefOrNull(self.player)){
	            self.player.stop().remove();
	          }
	        });
	        self._initJwPlayer();
	      });
	      */
	    }
	
	  }
	
	  // subclass extends superclass
	  AudioPlayer.prototype = {
	    _onComplete: function onComplete(){
	      if (!this.inline){
	        this.player.stop().remove();
	        this.overlay.close();
	      }
	    },
	    _play: function _play(){
	      var container = this.container;
	      var player = this.player;
	      player.onReady(function(evt){ //play when initted
	        logger.debug("jwplayer playing audio", container);
	        player.play();
	      });
	    },
	
	    _getAsJwSource: function _getAsJwSource(url, type){
	      var sources = [];
	      if (!helper.undefOrNull(url)){
	        var src = { file: url, type: type, 'default': true };
	        sources.push(src);
	      }
	      return sources;
	    },
	
	    _getPlayerConfig: function _getPlayerConfig(){
	        var ap = this;
	        var jwSetup = {
	          height: 40, /* height of 40px puts jwPlayer into audio-only mode */
	          width: this.options.width,
	          ga: {},
	          autostart: false,
	          events: {
	            onComplete: function(){
	              ap._onComplete();
	            }
	          },
	          sources: ap._getAsJwSource(ap.media.url(), 'audio/aac')
	        };
	
	        logger.debug("Player-Config: ", jwSetup);
	        return jwSetup;
	    },
	    _initJwPlayer: function _initJwPlayer(){
	      var container = this.container instanceof jquery ? this.container[0] : this.container;
	      var jwSetup = this._getPlayerConfig();
	      this.player = jwplayer(container).setup(jwSetup);
	      return this.player;
	    }
	  };
	
	}());


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	   'use strict';
	
	   var logger = new (__webpack_require__(3))("AduioPlayer Initializer").setColor("#212157");
	   var helper = __webpack_require__(1);
	   var acHelper = __webpack_require__(7);
	   var ACAudio = __webpack_require__(9);
	   var ACClient = __webpack_require__(5);
	   var AudioPlayer = __webpack_require__(25);
	   var jquery = __webpack_require__(2);
	
	   module.exports = {
	     fromData: fromData,
	     fromMediaOrUrl: fromMediaOrUrl
	  };
	
	  var client = null;
	  function lazyInitClient(){
	    if (helper.undefOrNull(client)){
	      client = new ACClient();
	    }
	    return client;
	  }
	
	  function fromUrl(url, inline, container, options){
	    var acMediaData = acHelper.generateMediaData("audio", defaultQuality, "url", url);
	    acMedia = new ACAudio(acMediaData);
	    return new AudioPlayer(acMedia, inline, container, options);
	  }
	
	  function fromMediaOrUrl(acMediaOrUrl, inline, container, options){
	    if (inline && helper.undefOrNull(container)){
	      throw "You must supply a container if you want to play the audio inline!";
	    }
	    if (helper.undefOrNull(acMediaOrUrl)){
	      throw "Could not instantiate AudioPlayer. Data was " + acMediaOrUrl;
	    }
	
	    if (helper.undefOrNull(acMediaOrUrl.type)){
	      if (typeof acMediaOrUrl == "string" && acMediaOrUrl.includes("/")){ //is not an url
	        return fromUrl(acMediaOrUrl, inline, container, options);
	      } else {
	        throw "Only ACMedia or URLs are allowed for acMediaOrUrl; The current String is no url: " + acMediaOrUrl;
	      }
	    } else {
	      return new AudioPlayer(acMediaOrUrl, inline, container, options);
	    }
	  }
	
	  function fromData(element, options){
	    var $element = $(element);
	
	    var audioCodeOrUrl = $element.data("audio");
	    var overlay = $element.data("overlay");
	    var width = $element.data("width");
	    var inline = helper.undefOrNull(overlay) || overlay===false || overlay==='false';
	    var deferredPlayer = jquery.Deferred();
	
	    if (helper.undefOrNull(options)){
	      options = {};
	    }
	
	    if (helper.undefOrNull(options.width) && !helper.undefOrNull(width)){
	      options.width = parseInt(width);
	    }
	
	    if (!helper.undefOrNull(audioCodeOrUrl)){ // load media from assetCore
	      var audioMedia = lazyInitClient().getMediaPromise(audioCodeOrUrl);
	      audioMedia.done(function( acAudioData ){
	        var player = fromMediaOrUrl(acAudioData, inline, $element, options);
	        deferredPlayer.resolve(player, acAudioData);
	      }).fail(function( message ){
	        deferredPlayer.reject( message );
	      });
	    } else {
	      deferredPlayer.reject("no correct media data given");
	    }
	
	    return deferredPlayer.promise();
	  }
	
	}());


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	   'use strict';
	
	   var VPJw = __webpack_require__(29);
	   var VPYoutube = __webpack_require__(31);
	   var VPSmartMovie = __webpack_require__(30);
	   var acHelper = __webpack_require__(7);
	   var ACVideo = __webpack_require__(9);
	   var logger = new (__webpack_require__(3))("VideoPlayer Helper").setColor("#82cc60").setDebug(true);
	
	   var helper = __webpack_require__(1);
	
	   module.exports = {
	     fromMediaOrUrl: fromMediaOrUrl,
	     fromSmartmovieUrl: fromSmartmovieUrl
	  };
	
	  function fromMediaOrUrl(acMediaOrUrl, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage){
	    if (inline && helper.undefOrNull(container)){
	      throw "You must supply a container if you want to play the video inline!";
	    }
	    if (helper.undefOrNull(acMediaOrUrl)){
	      throw "Could not instantiate VideoPlayer. Data was " + acMediaOrUrl;
	    }
	
	    if (helper.undefOrNull(acMediaOrUrl.type)){
	      if (typeof acMediaOrUrl == "string" && acMediaOrUrl.includes("/")){ //is not an url
	        return fromClipUrl(acMediaOrUrl, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage);
	      } else {
	        throw "Only ACMedia or URLs are allowed for acMediaOrUrl; The current String is no url: " + acMediaOrUrl;
	      }
	    } else {
	      return fromMedia(acMediaOrUrl, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage);
	    }
	  }
	
	  // generated Media data to be used for constructing ACMedia for cases where no assetcore code is available
	  function generateAcVideo(type, quality, provider, url){
	    var acm = acHelper.generateMediaData(type, quality, provider, url);
	    return new ACVideo(acm);
	  }
	
	  function fromClipUrl(url, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage){
	    var acMedia = generateAcVideo("video", defaultQuality, "url", url);
	    return fromMedia(acMedia, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage);
	  }
	
	  function fromSmartmovieUrl(smartmovieUrl, $element, posterMediaImage, defaultQuality, optionsOverride, playButtonImage, playButtonHoverImage){
	    var acMedia = generateAcVideo("smartmovie", defaultQuality, "url", smartmovieUrl);
	    return new VPSmartMovie(acMedia, false, $element, posterMediaImage, defaultQuality, optionsOverride, playButtonImage, playButtonHoverImage);
	  }
	
	  function fromMedia(acMedia, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage){
	    if (acMedia.type() == "video" && acMedia.provider() != "youtube"){
	      return new VPJw(acMedia, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage);
	    } else if (acMedia.provider() == "youtube"){
	      return new VPYoutube(acMedia, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage);
	    } else if (acMedia.type() == "smartmovie"){
	      return new VPSmartMovie(acMedia, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage);
	    } else {
	      throw "unsupported video type: '"+acMedia.type()+"'/'"+acMedia.provider()+"'";
	    }
	  }
	
	}());


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	   'use strict';
	
	   var logger = new (__webpack_require__(3))("VideoPlayer Initializer").setColor("#212157");
	   var helper = __webpack_require__(1);
	   var videoHelper = __webpack_require__(27);
	   var ACClient = __webpack_require__(5);
	   var jquery = __webpack_require__(2);
	
	   module.exports = {
	     videoFromData: videoFromData,
	     videoWithOverlay: videoWithOverlay,
	     smartmovieFromUrl: smartmovieFromUrl
	  };
	
	  var client = null;
	  function lazyInitClient(){
	    if (helper.undefOrNull(client)){
	      client = new ACClient();
	    }
	    return client;
	  }
	
	  function _getPromise(mediaCodeOrUrl){
	    return lazyInitClient().getMediaPromise(mediaCodeOrUrl);
	  }
	
	  function _getPromises(videoCode, posterCodeOrUrl){
	    var posterPromise = _getPromise(posterCodeOrUrl);
	    var videoPromise = _getPromise(videoCode);
	    return jquery.when(videoPromise, posterPromise);
	  }
	
	  function smartmovieFromUrl(storyboardUrl, container, defaultQuality, options){
	    return videoHelper.fromSmartmovieUrl(storyboardUrl, container, null, defaultQuality, options);
	  }
	
	  function videoWithOverlay(videoCode, container, posterCodeOrUrl, options){
	    var deferredPlayer = jquery.Deferred();
	    var videoAndPosterMedia = _getPromises(videoCode, posterCodeOrUrl);
	    videoAndPosterMedia.done(function( video, poster ){
	      var player = videoHelper.fromMediaOrUrl(video, false, container, poster, null, options, null, null);
	      deferredPlayer.resolve(player, player.getMedia());
	    }).fail(function(msg){
	      deferredPlayer.reject(msg);
	    });
	    return deferredPlayer;
	  }
	
	  function videoFromData(element, options){
	    // var inline=true; createVideoPlayerForElement( inline, element );
	    var $element = $(element);
	
	    var poster = $element.data("poster");
	    var forcePosterDimensions = $element.data("forcePosterDimensions");
	    var omitPosterElement = $element.data("omitPosterElement");
	    var videoCode = $element.data("video");
	    var smartmovieUrl = $element.data("smartmovie");
	    var defaultQuality = $element.data("quality");
	    var overlay = $element.data("overlay");
	    var play = $element.data("play");
	    var playHover = $element.data("playHover");
	    var inheritMaxWidthFrom = $element.data("inheritMaxWidthFrom");
	
	    var inline = helper.undefOrNull(overlay) || overlay===false || overlay==='false';
	    var deferredPlayer = jquery.Deferred();
	
	    if (helper.undefOrNull(options)){
	      options = {};
	    }
	
	    if (!helper.undefOrNull(forcePosterDimensions)){
	      $.extend( true, options, { forcePosterDimensions: forcePosterDimensions } );
	    }
	    if (!helper.undefOrNull(omitPosterElement)){
	      $.extend( true, options, { omitPosterElement: omitPosterElement } );
	    }
	    if (!helper.undefOrNull(inheritMaxWidthFrom)){
	      $.extend( true, options, { inheritMaxWidthFrom: inheritMaxWidthFrom } );
	    }
	
	    if (!helper.undefOrNull(videoCode)){ // load media from assetCore
	      var videoAndPosterMedia = _getPromises(videoCode, poster);
	      videoAndPosterMedia.done(function( video, poster ){
	        var player = videoHelper.fromMediaOrUrl(video, inline, $element, poster, defaultQuality, options, play, playHover);
	        if (!inline){
	          $element.css({ cursor: 'pointer' });
	          $element.click(function(){
	            player.play();
	          });
	        }
	        deferredPlayer.resolve(player, player.getMedia());
	      }).fail(function( message ){
	        deferredPlayer.reject( message );
	      });
	    } else if (!helper.undefOrNull(smartmovieUrl)){
	      var posterPromise = _getPromise(poster);
	      jquery.when(posterPromise).done(function( poster ){
	        var player = videoHelper.fromSmartmovieUrl(smartmovieUrl, $element, poster, defaultQuality, options, play, playHover);
	        $element.css({ cursor: 'pointer' });
	        $element.click(function(){
	          player.play();
	        });
	        deferredPlayer.resolve(player, player.getMedia());
	      }).fail(function(msg){
	        deferredPlayer.reject(msg);
	      });
	    } else {
	      deferredPlayer.reject("no correct media data given");
	    }
	
	    return deferredPlayer.promise();
	  }
	
	}());


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	* NOTE: To use multiple jwPlayer-Instances at the same time, be sure that you create an individual container (e.g. own id)!
	**/
	(function(){
	  'use strict';
	
	  var jwplayer = __webpack_require__(12);
	
	  var logger = new (__webpack_require__(3))("VPJw").setColor("#0B7EF4").setDebug(true);
	  var VideoPlayer = __webpack_require__(11);
	  var helper = __webpack_require__(1);
	  var settings = __webpack_require__(4);
	
	  module.exports = VPJw;
	
	  var defaults = {
	  };
	
	  function VPJw(mediaInstance, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage){
	    VideoPlayer.call(this, mediaInstance, inline, container, posterMediaImage, defaultQuality, defaults, options, playButtonImage, playButtonHoverImage);
	    /*
	    if (helper.undefOrNull(global.jwplayer)){
	      global.jwplayer = {};
	    }
	    */
	    logger.debug("initting jwplayer " + (inline? "inline" : "for overlay"));
	
	    if (helper.undefOrNull(posterMediaImage) || this.options.omitPosterElement){ //otherwise init on play
	      if (inline){
	        this._initJwPlayer();
	      }
	    } else {
	      this._initPoster();
	    }
	  }
	
	  // subclass extends superclass
	  VPJw.prototype = Object.create(VideoPlayer.prototype);
	  VPJw.prototype.constructor = VideoPlayer;
	
	  VPJw.prototype._getPlayerSources = function _getPlayerSources(){
	    var sources = [];
	    var defaultQuality = !helper.undefOrNull(this.defaultQuality) ? this.defaultQuality : this.media.defaultQualityName();
	    var qualities = this.media.qualities();
	    for (var i=0; i<qualities.length; i++){
	      var qName = qualities[i];
	      var url = this.media.qualityUrl(qName);
	      if (!helper.undefOrNull(url)){
	      // defaultQuality always needs to be the first element in the list or it needs a property 'default' set to true, so the 'HD'-Button will be grey when an SD-Video is played (if HD-Vid comes first the button would be inverted!)
	      // NOTE: although we are setting a defaultQuality here, the played quality may differ as jwPlayer remembers the button state for all instances
	        var isDefault = qName==defaultQuality;
	        var src = { file: url, type: 'video/mp4', label: qName, 'default': isDefault };
	        if (isDefault){
	          logger.debug("adding default source", src);
	          sources.unshift(src);
	        } else {
	          logger.debug("adding source", src);
	          sources.push(src);
	        }
	      }
	    }
	    logger.debug("sources:", sources);
	    return sources;
	  };
	  VPJw.prototype._getPlayerConfig = function _getPlayerConfig(){
	      var vp = this;
	      var jwSetup = {
	        height: vp.media.height(vp.defaultQuality),
	        width: vp.media.width(vp.defaultQuality),
	        ga: {},
	        autostart: false,
	        provider: 'video',
	        events: { //resize player according to video file
	          onComplete: function(){
	            vp._onVideoComplete();
	          }
	        },
	        sources: vp._getPlayerSources()
	      };
	
	      if (this.inline && this.container.width() > 50 && this.container.height() > 50){ //dimensions of less than 50 are not supported for jwPlayer
	        jwSetup.height = this.container.height();
	        jwSetup.width = this.container.width();
	      }
	      if (!helper.undefOrNull(this.posterUrl)){
	        jwSetup.image = this.posterUrl();
	      }
	      if (!this.inline){
	        jwSetup.events.onMeta = function onMeta(event) {
	          var metadata = event.metadata;
	          if (!helper.undefOrNull(metadata) && !helper.undefOrNull(metadata.width) && !helper.undefOrNull(metadata.height)){ // Firefox
	            doResize(metadata);
	          } else if (!helper.undefOrNull(event.width) && !helper.undefOrNull(event.height)){ //Safari
	            doResize(event);
	          }
	          function doResize(data){
	            var width = data.width;
	            var height = data.height;
	            var dimensionsSet = !helper.undefOrNull(width) && !helper.undefOrNull(height);
	            var dimensionsOk = width > 0 && height > 0;
	            var dimensionsChanged = helper.undefOrNull(vp.width) || helper.undefOrNull(vp.height) || vp.width != width || vp.height != height;
	            if(dimensionsSet && dimensionsOk && dimensionsChanged) {
	              vp.width = width;
	              vp.height = height;
	              vp._onResize(width, height);
	            }
	          }
	        };
	      }
	
	      logger.debug("Player-Config: ", jwSetup);
	      return jwSetup;
	  };
	
	
	  // if playing in overlay or if a poster is displayed, the player needs to be initialized first
	  // afterwards we can trigger the play command
	  VPJw.prototype._play = function _play(){
	    var self = this;
	    var container = this.container;
	
	    if (!this.inline || this.hasPoster()){ // init before play
	      this._initJwPlayer();
	    }
	    var player = this.player;
	    player.onReady(function(evt){ //play when initted
	      logger.debug("jwplayer playing", container);
	      player.play();
	    });
	  };
	
	  // As we override the close method but do not want to copy the method body from
	  // 'parent prototype', we just call it from here
	  VPJw.prototype._onClose = function _onClose(){
	    this.player.stop().remove();
	    VideoPlayer.prototype._onClose.call(this);
	    logger.debug("JWPlayer destroyed!");
	  };
	
	  VPJw.prototype._initJwPlayer = function _initJwPlayer(){
	    var container = this.container instanceof __webpack_require__(2) ? this.container[0] : this.container;
	    var jwSetup = this._getPlayerConfig();
	    this.player = jwplayer(container).setup(jwSetup);
	  };
	
	  // When Video has reached its end
	  VPJw.prototype._onVideoComplete = function _onVideoComplete(){
	    if (this.inline && !helper.undefOrNull(this.poster) && !this.options.omitPosterElement){ // if playing inline and a poster was set on an own element, reset the container to the poster image
	        logger.debug("jwplayer finished; Removing Player and displaying poster");
	        this.player.stop().remove();
	        this._initPoster();
	    }
	  };
	
	  VPJw.prototype.resize = function resize(width, height){
	    if (!helper.undefOrNull(this.player)){
	      this.player.resize(width, height);
	    }
	  };
	
	  VPJw.prototype.resizeForOverlay = function resizeForOverlay(width, height){
	    if (!this.inline && !helper.undefOrNull(this.player)){
	      this.player.resize(width, height);
	    }
	  };
	
	  VPJw.prototype.resizeForInheritation = function resizeForInheritation(width, height){
	    $(this.baseContainer).css({width: width+'px', height: height+'px'});
	    if (this.inline){
	      if (!helper.undefOrNull(this.player)){
	        this.player.resize(width, height);
	      } else {
	        this.container.css({width: width+'px', height: height+'px'});
	      }
	    }
	  };
	
	}());


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*jshint multistr: true */
	
	/************************************************************************************************************
	 * VPSmartMovie v0.9.0
	 * Author: Benny Menzel, mackoy consulting, bmenzel@mackoy.de
	 * Markup: <div id="containerId"></div><div id="controlsContainerId">[...]</div>
	 * Usage: new VPSmartMovie("containerId", 'controlsContainerId', 'qualityNameAsDefinedInJson', true, "/storyboards/definition1.json");
	 * Definition: A definition is loaded from JSON
	 * Instance-Properties:
	 * 		- containerId: main-storyboard-container html-id
	 * 		- definition: the storyboard definition (clips, chapters, timings, videos)
	 * 		- width: width of the video
	 * 		- height: height of the video
	 * 		- player: the jwPlayer instance used to display the main movie
	 *		- skin: (optional) the name of a skin; The jwPlayer-Skin-CSS must be included into the page header; 'no-fullscreen' is already available by including the storyboard.css-file
	 * 		- l10n: (optional) an object containing translations for the controls:
	 *				{ controls:{backToMain: "Back to main movie", skipIntermediate: "skip", replay: "replay", selectChapter: "Please select a chapter"} }
	 ************************************************************************************************************/
	/**
	TODO:
	-----
	- ?  Rename default 'Please select Chapter' and within the smart movie definitions?
	
	
	
	CHANGELOG:
	----------
	v0.9.0 (2017-01-20)
	- moved VPSmartMovie into Celemony Tools Webpack v0.0.1; from now on you will find the changes in the general changelog
	
	v0.8.3 (2016-09-29)
	- updated jwPlayer to version 7.6.1
	- Skins are now referenced by name (not by url); You must include the skin-css by yourself (NOTE that 'no-fullscreen'-skin is already available via storyboard.css)
	- some Fixes (clip is now paused when iframe is opened, when clip was playing and you selected a main-chapter the back-to-main-button is now removed correctly)
	- NOTE: ga.js is not supported any more! To send events to google analytics, you must load the newer analytics.js
	
	v0.8.2
	- When low quality is active (e.g. width < 1000), we permanently display the chapter selector to the left of the video; HD-Versions stay the same
	
	v0.8.1
	- added 'ga'-configuration-Object to jwPlayer-Config to push events to GoogleAnalytics (if ga.js has been loaded)
	
	v0.8.0
	- Tested with jQuery 2.0.3
	- FIX: When you click the 'continue'-button to jump to the next main chapter and you click 'repeat' right after, the wrong anchor is selected (as currentPlayTime is not updated and contains the value from the previous video)
	
	**/
	
	(function(){
	  'use strict';
	  __webpack_require__(35);
	
	  var $ = __webpack_require__(2);
	  var jQuery = __webpack_require__(2);
	  var logger = new (__webpack_require__(3))("VPSmartMovie").setColor("#0bf4a0");
	  var helper = __webpack_require__(1);
	  var VideoPlayer = __webpack_require__(11);
	
	  module.exports = VPSmartMovie;
	
	  VPSmartMovie.ID_STORYBOARD = "storyboard";
	  VPSmartMovie.ID_MOVIE_PLAYER = "sb-ply1";
	  VPSmartMovie.ID_CLIP_PLAYER = "sb-ply2";
	  VPSmartMovie.ID_SELECTOR = "sb-sel";
	  VPSmartMovie.ID_OVERLAY = "storyboard-iframe-overlay";
	  VPSmartMovie.CLASS_QUALITIES = "sb-qualities";
	  VPSmartMovie.CLASS_CHAPTERS = "sb-chapters";
	  VPSmartMovie.CLASS_SKIP_INTERMEDIATE = "sb-skip-intermediate";
	  VPSmartMovie.CLASS_BACK_TO_MAIN = "sb-back-to-main";
	  VPSmartMovie.CLASS_IMAGE_PRELOADER = "sb-image-preloader";
	  VPSmartMovie.CLASS_REPLAY = "sb-replay";
	  VPSmartMovie.MS_FADE_INTERMEDIATE = 800;
	  VPSmartMovie.MS_FADE_BUTTON = 200;
	  VPSmartMovie.MS_ANIMATE_ELEMENT_CONTAINER_IN = 500;
	  VPSmartMovie.MS_ANIMATE_ELEMENT_CONTAINER_OUT = 500;
	
	  VPSmartMovie.LINK_TYPE_VIDEO = "video";
	  VPSmartMovie.LINK_TYPE_IFRAME = "iframe";
	
	  VPSmartMovie.SEL_QUALITIES = "." + VPSmartMovie.CLASS_QUALITIES;
	  VPSmartMovie.SEL_CHAPTERS = "." + VPSmartMovie.CLASS_CHAPTERS;
	  VPSmartMovie.SEL_SKIP_INTERMEDIATE = "." + VPSmartMovie.CLASS_SKIP_INTERMEDIATE;
	  VPSmartMovie.SEL_BACK_TO_MAIN = "." + VPSmartMovie.CLASS_BACK_TO_MAIN;
	  VPSmartMovie.SEL_IMAGE_PRELOADER = "." + VPSmartMovie.CLASS_IMAGE_PRELOADER;
	  VPSmartMovie.SEL_REPLAY = "." + VPSmartMovie.CLASS_REPLAY;
	
	  VPSmartMovie.events = {
	  	QUALITY_SET: 'VPSmartMovie.QualitySet'	// issued every time a quality is set (first time on init and every time the user changes quality)
	  };
	
	  /*
	
	  Container-Positions x/y
	  When positioning containers via Strings (e.g. "position":"BR")
	
	  - x/y: horizontal/vertical position
	  - startMarginX/startMarginY: Animation 'From'-Value; Will be moved from that value to a margin of 0 or marginY (see below)
	  - marginY: a margin from the top or bottom (using minus sign)
	
	  0/0 		 0.5/0 		 		1/0 (TR)
	   *--------*--------*
	   |								 |
	   |	VIDEO-Player	 * 	1/0.5 (MR)
	   |								 |
	   *--------*--------*
	  0/1			 0.5/1				1/1 (BR)
	
	  */
	
	  VPSmartMovie.buttonPosition = {
	  	TL: {x:0.0, y:0.0, startMarginX:-1,	startMarginY:0, marginY:0.024}, // top left;
	  	TC: {x:0.5, y:0.0, startMarginX:0,	startMarginY:-1}, // top center
	  	TR: {x:1.0, y:0.0, startMarginX:1,	startMarginY:0, marginY:0.024}, // top right
	
	  	ML: {x:0.0, y:0.5, startMarginX:-1,	startMarginY:0}, // middle left
	  	/*MC: {x:0.5, y:0.5, startMarginX:0, startMarginY:0}, // middle center*/
	  	MR: {x:1.0, y:0.5, startMarginX:1,	startMarginY:0},	// middle right
	
	  	BL: {x:0.0, y:1.0, startMarginX:-1,	startMarginY:0, marginY:-0.024}, // bottom left
	  	BC: {x:0.5, y:1.0, startMarginX:0,	startMarginY:1}, // bottom center
	  	BR: {x:1.0, y:1.0, startMarginX:1,	startMarginY:0, marginY:-0.024}, // bottom right
	  };
	
	  var defaults = {
	    overlayAutoScale: false,
	    l10n:{
	      controls:{
	        backToMain: "Back to main movie",
	        skipIntermediate: "skip",
	        replay: "replay",
	        selectChapter: "Please select a chapter"
	      }
	    }
	  };
	
	  function VPSmartMovie(mediaInstance, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage){
	    VideoPlayer.call(this, mediaInstance, inline, container, posterMediaImage, defaultQuality, defaults, options, playButtonImage, playButtonHoverImage); // call super constructor.
	    logger.debug("initting smartMovie player " + (helper.undefOrNull(options)?"":"with options"), options);
	    if (inline){
	      throw "You may not instantiate a SmartMovie Inline! SmartMovies may only be opened within an overlay!";
	    }
	    if (helper.undefOrNull(global.jwplayer)){
	      global.jwplayer = {};
	    }
	  }
	
	  // subclass extends superclass
	  VPSmartMovie.prototype = Object.create(VideoPlayer.prototype);
	  VPSmartMovie.prototype.constructor = VideoPlayer;
	
	  VPSmartMovie.prototype._play = function _play(container){
	    var id = VPSmartMovie.ID_STORYBOARD;
	
	    if ($("#"+id).length>0){
	      $('#'+id).remove();
	    }
	    var $storyboard = $("<div id='"+id+"'></div>");
	    var $controls = $("<div id='storyboard-controls'></div>");
	    container.append($storyboard);
	    container.append($controls);
	
	    var useTwoPlayers = true;
	    var skin = "no-fullscreen";
	    var quality = !helper.undefOrNull(this.defaultQuality) ? this.defaultQuality : this.media.defaultQualityName();
	    logger.debug("Playing Smartmovie");
	    this._init($storyboard, $controls, quality, useTwoPlayers, this.media.url(), skin);
	  };
	
	  VPSmartMovie.prototype._resize = function _resize(width, height){
	    // we do nothing on resize as content is already centered automatically via CMY.Overlay
	  };
	
	  // As we override the close method but do not want to copy the method body from
	  // 'parent prototype', we just call it from here
	  VPSmartMovie.prototype._onClose = function _onClose(){
	    this.ready = false;
	    if (!helper.undefOrNull(this.players.movie)){
	      this.players.movie.stop().remove();
	    }
	    if (this.players.movie !== this.players.clip){
	      this.players.clip.stop().remove();
	    }
	    logger.debug("JWPlayer(s) destroyed!");
	    this.container.css("marginLeft", 0);
	    this.container.children().off().empty().remove();
	    this.container.off().empty().remove();
	
	    $("#"+VPSmartMovie.ID_STORYBOARD).off().empty().remove();
	
	    logger.debug("DOM Elements destroyed!");
	    VideoPlayer.prototype._onClose.call(this);
	  };
	
	  VPSmartMovie.prototype._initStoryboard = function _initStoryboard(){
	    //add elements
	    var elMoviePlayer = $("<div id='"+VPSmartMovie.ID_MOVIE_PLAYER+"'></div>");
	    var elClipPlayer = $("<div id='"+VPSmartMovie.ID_CLIP_PLAYER+"'></div>");
	    var elSelector = $("<div id='"+VPSmartMovie.ID_SELECTOR+"'></div>");
	    var container = this.container;
	    container.removeClass();
	
	    container.append(elMoviePlayer);
	    if (this.players.twoPlayerMode){
	      container.append(elClipPlayer);
	    }
	    container.append(elSelector);
	
	    // set dimensions and classes according to quality-setting
	    container.addClass(this._getQualityCssClass(this.quality));
	    var elSetDimension = [container, elMoviePlayer, elClipPlayer, elSelector];
	    for (var i=0; i<elSetDimension.length; i++){
	      elSetDimension[i].css({ width: this.quality.width, height: this.quality.height});
	    }
	
	    // hide selector and buttons at begin
	    $('#'+VPSmartMovie.ID_SELECTOR).hide();
	  };
	
	  VPSmartMovie.prototype.resize = function resize(width, height){
	    throw "Resizing of SmartMovie not supported!";
	  };
	
	  VPSmartMovie.prototype._init = function _init(containerOrId, controlsContainerOrId, qualityName, twoPlayerMode, jsonUrl, skin){
	    /********************************************************/
	  	/*											VARIABLES												*/
	  	/********************************************************/
	  	this.container = containerOrId instanceof jQuery ? containerOrId : $("#"+containerOrId);
	  	this.controls = controlsContainerOrId instanceof jQuery ? controlsContainerOrId : $("#"+controlsContainerOrId);
	
	  	this.skin = skin;
	  	this.ready = false;
	  	this.players = {
	  		current: null,
	  		movie: null,
	  		clip: null,
	  		currentVideoType: "movie", //or clip
	  		twoPlayerMode: twoPlayerMode
	  	};
	  	this.mainMovie = null;
	  	this.currentClip = null;
	  	this.mainMovieIndex = -1;
	  	this.chapters = [];
	  	this.configuration = {}; //loaded from json
	  	this.quality = null;
	
	    /********************************************************/
	    /*											INITIALIZE											*/
	    /********************************************************/
	
	    // load definition
	    var self = this;
	    $.getJSON(jsonUrl, function(data){
	      var conf = data.configuration;
	      self.configuration = conf;
	      self.definition = data.clips;
	
	      // if l10n was not set as parameter of the storyboard and the configuration contains an l10n part - then take it!
	      if (typeof conf.l10n !== "undefined" && conf.l10n !== null){
	        logger.debug("JSON contains L10N; using it");
	        self.l10n = conf.l10n;
	      }
	
	      var qual = self._getQuality(qualityName);
	      self._initWithQuality( qual );
	      self._playMainMovie(0, self.definition[0]);
	
	      self.ready = true;
	      logger.debug("smartMovie definition loaded from '"+jsonUrl+"'!");
	    }).fail(function(jqXHR, textStatus, errorThrown){
	      self.overlay.remove();
	      throw "Error loading VPSmartMovie definition from " + jsonUrl + ": " + textStatus + " / " + errorThrown;
	    });
	
	  };
	
	  VPSmartMovie.prototype._initWithQuality = function _initWithQuality(qualityDef){
	    this.quality = qualityDef;
	    this.chapters = this._getChapters(this.definition);
	
	    // init VPSmartMovie
	    if (typeof this.players.movie != "undefined" && this.players.movie !== null){
	      this.players.movie.stop();
	      this.players.movie.remove();
	      logger.debug("removed movie player");
	    }
	    if (typeof this.players.clip != "undefined" && this.players.clip !== null){
	      this.players.movie.stop();
	      this.players.clip.remove();
	      logger.debug("removed clip player");
	    }
	    this.container.css('minHeight', qualityDef.height);
	    this.container.children().off().remove();
	    this._initStoryboard();
	
	    // init players
	    this._initJwPlayers(this.definition);
	
	    // init controls
	    this.controls.children().off().remove();
	    this._initControls(this.controls, this.container, this.configuration.qualities, qualityDef, this.chapters, this._getL10n(this.l10n));
	
	    // trigger 'VPSmartMovie.QualitySet'-Event
	    $(this.container).trigger(VPSmartMovie.events.QUALITY_SET, [qualityDef]);
	  };
	
	  VPSmartMovie.prototype._getQuality = function _getQuality(name){
			var qual = null;
			for (var q=0; q<this.configuration.qualities.length; q++){
				if (this.configuration.qualities[q].name==name){
					qual = this.configuration.qualities[q];
					break;
				}
			}
			if (qual===null){
				logger.error("Quality '"+name+"' is not defined within JSON-File; Please either change JSON or HTML-Template!");
			}
			return qual;
		};
	
	
	  VPSmartMovie.prototype._getChapters = function _getChapters(mainDef){
	    // chapter: clip, clipIndex, start, title
	  	var chapters = [];
	    var chapter;
	    var self = this;
	  	for (var i=0; i<mainDef.length; i++){
	  		if (typeof mainDef[i].chapters === "undefined" || mainDef[i].chapters === null || mainDef[i].chapters.length < 1){
	  			chapter = {};
	  			chapter.clip = self._getClipUrl(mainDef[i]);
	  			chapter.clipIndex = i;
	  			chapter.start = 0;
	  			chapter.title = null;
	  			chapter.isMainChapter = true;
	  			chapters.push(chapter);
	  		} else {
	  			for (var c=0; c<mainDef[i].chapters.length; c++){
	  				chapter = {};
	  				chapter.clip = self._getClipUrl(mainDef[i]);
	  				chapter.clipIndex = i;
	  				chapter.start = mainDef[i].chapters[c].start;
	  				if (typeof mainDef[i].chapters[c].title !== "undefined"){
	  					chapter.title = mainDef[i].chapters[c].title;
	  				} else {
	  					chapter.title = null;
	  				}
	  				chapter.isMainChapter = true;
	  				chapters.push(chapter);
	  			}
	  		}
	
	  		//TODO: CHECK: Currently we add all sub-chapters after the main-chapters; no matter if the intermediate comes in between or before those chapters; is that ok?
	  		var subChapters = getSubChapters(mainDef[i], i);
	  		for (var ch=0; ch<subChapters.length; ch++){
	  			chapters.push(subChapters[ch]);
	  		}
	  	}
	  	return chapters;
	
	
	  	function getSubChapters(singleDef, mainClipIndex){
	  		var subChapters = [];
	  		var intermediates = singleDef.intermediates;
	  		var sortByStart = function(a, b) {
	  		  return (a.start) - (b.start);
	  		};
	  		intermediates.sort(sortByStart);
	  		// Walk structure: singleDef > intermediates > containers > elements > chapterTitle
	  		for (var i=0; i<intermediates.length; i++){
	  			var containers = intermediates[i].containers;
	  			containers.sort(sortByStart);
	  			for (var c=0; c<containers.length; c++){
	  				var elements = containers[c].elements;
	  				elements.sort(function(a, b) {
	  						return (a.showTime) - (b.showTime);
	  				});
	  				for (var l=0;l<elements.length;l++){
	  					var displayChapter = !elements[l].hideChapter;
	  					if (displayChapter){
	  						var chapter = {};
	  						chapter.clip = elements[l].type==VPSmartMovie.LINK_TYPE_VIDEO? self._getClipUrl(elements[l]) : self._getIframeUrl(elements[l].url);
	  						chapter.clipIndex = mainClipIndex;
	  						chapter.start = 0;
	
	  						chapter.title = "";
	  						if (typeof elements[l].chapterTitle !== "undefined" && elements[l].chapterTitle!==null && elements[l].chapterTitle.length){
	  							chapter.title += elements[l].chapterTitle;
	  						} else if (typeof elements[l].button.title !== "undefined" && elements[l].button.title !== null && elements[l].button.title.length){
	  							chapter.title += elements[l].button.title;
	  						}
	
	  						chapter.isMainChapter = false;
	  						chapter.linkDef = elements[l];
	  						chapter.mainDef = singleDef;
	  						chapter.intermediateDef = intermediates[i];
	  						subChapters.push(chapter);
	  					}
	  				}
	  			}
	  		}
	  		return subChapters;
	  	}
	  };
	
	  VPSmartMovie.prototype._initJwPlayers = function _initJwPlayers(def){
	    var self = this;
	
	    // init JWPlayer(s) and play main-movie
	    self.players.movie = jwplayer(VPSmartMovie.ID_MOVIE_PLAYER);
	    if (self.players.twoPlayerMode){
	      self.players.clip = jwplayer(VPSmartMovie.ID_CLIP_PLAYER);
	    } else {
	      self.players.clip = self.players.movie;
	    }
	    self.players.current = self.players.movie;
	    //self._playMainMovie(0, def[0]);
	
	    var elStoryboard = $('#'+VPSmartMovie.ID_SELECTOR);
	    elStoryboard.click(function(e){
	      //only pause/continue playback if the user clicked on the storyboard (not if clicked on a storyboard-child, which could define their own click-events)
	      if($(e.target).is(elStoryboard)){
	        pause(self);
	      }
	    });
	    function pause(self){
	      if (self.players.currentVideoType == "movie"){
	        self.players.movie.pause();
	      } else {
	        self.players.clip.pause();
	      }
	    }
	
	    this.mainMovieIndex = 0;
	  };
	
	  VPSmartMovie.prototype._switchQuality = function _switchQuality(quality){
	    /*
	    var changeLocation = false;
	
	    if (changeLocation){
	      var currentUrl = window.location.href;
	      var currentQualityName = this.quality.name.toLowerCase();
	      var newUrl = currentUrl.replace(currentQualityName, quality.name.toLowerCase());
	      window.location.href = newUrl; // e.g. index234_en_hd.html -> index234_en_sd.html NOTE: WATCH_OUT!: index_sdcard_qual_sd.html would change to index_hdcard_qual_sd.html
	    } else {
	    */
	    var currentPosition = this.players.current.getPosition();
	    var currentClipDef = this.currentClip ? this.currentClip.def : null;
	    var currentMovieIndex = this.mainMovieIndex ? this.mainMovieIndex : 0;
	    var curDef = this.definition[currentMovieIndex];
	
	    // reset mainMovie and clip values
	    if (this.currentClip){
	      this.currentClip.def = null;
	    }
	    this.mainMovieIndex = 0;
	
	    this._initWithQuality(quality);
	    for (var i=0; i<curDef.intermediates.length; i++){
	      this._cleanupIntermediate(curDef.intermediates[i]);
	    }
	
	    if (currentClipDef !== null){
	      this._playMainMovie(0, curDef, true);
	      var onPlayEvent = true;
	      this.players.movie.on('ready', function(){
	        this.players.movie.on('play', function(){
	          if (onPlayEvent){
	            onPlayEvent = false;
	            this.players.movie.off('ready');
	            this.players.movie.off('play');
	            var mainDef = this._getMainDef(currentClipDef);
	            if (!mainDef){
	              mainDef = curDef;
	            }
	            this._playClip(currentPosition, currentClipDef, null, mainDef);
	          }
	        });
	      });
	    } else {
	      this._playMainMovie(currentMovieIndex, curDef, true);
	      this._returnToMainMovie(currentPosition, curDef);
	    }
	  //}
	  };
	
	  VPSmartMovie.prototype._initControls = function _initControls(controls, storyboardContainer, qualities, quality, chapters, l10n){
	    controls.removeClass();
	    controls.append( this._getControlsHtml(qualities, l10n) );
	    controls.addClass( this._getQualityCssClass(quality) );
	    controls.find(VPSmartMovie.SEL_BACK_TO_MAIN).hide();
	    controls.find(VPSmartMovie.SEL_SKIP_INTERMEDIATE).hide();
	    controls.css("width", this.quality.width);
	    initQualitySelector(this.quality, qualities);
	    var self = this;
	
	    $( window ).resize(function() {
	      updateChapterDisplay(controls, storyboardContainer, chapters, self.quality, true, self);
	    });
	
	    updateChapterDisplay(controls, storyboardContainer, chapters, this.quality, false, self);
	    initReplay(controls, self);
	
	    function initQualitySelector(currentQuality, qualities){
	      var elQualities = controls.find(VPSmartMovie.SEL_QUALITIES);
	      var qualityClassPrefix = "sb-quality-";
	      var qualityClass = qualityClassPrefix + currentQuality.name.toLowerCase();
	      elQualities.addClass(qualityClass);
	      elQualities.click(function(){
	        elQualities.removeClass(qualityClass);
	        var currentQualityName = currentQuality.name;
	        elQualities.removeClass(qualityClassPrefix + currentQualityName.toLowerCase());
	        var newQualityName = null;
	        if (currentQualityName == "HD"){
	          newQualityName = "SD";
	        } else {
	          newQualityName = "HD";
	        }
	        elQualities.addClass(qualityClassPrefix + newQualityName.toLowerCase());
	
	        var qualityDef = self._getQuality(newQualityName);
	        self._switchQuality(qualityDef);
	      });
	
	    }
	
	    function updateChapterDisplay(controls, storyboardContainer, chapters, quality, triggeredByResizeEvent, self){
	      var elChapters = storyboardContainer.parent().find(VPSmartMovie.SEL_CHAPTERS);
	      var showChaptersOnTheLeft = true;
	      var leftChapterSelectorWidth = 256;
	
	      // We want to display the chapter selector either on the left or at the bottom
	      // this is decided via the available viewport
	      var extraWidth = 60; // width that is added for checking the needed width (e.g. for close button)
	      var availWidth = $( window ).width();
	      var fullWidth = quality.width + leftChapterSelectorWidth;
	      if (availWidth < (fullWidth + extraWidth)){
	        showChaptersOnTheLeft = false;
	      }
	
	      var chapterObj;
	      if (showChaptersOnTheLeft){
	        self.chaptersLeft = true;
	        chapterObj = initBottomChapterSelector(false);
	        chapterObj.open().done(function(){
	          modifyBottomToLeftChapterSelector(chapterObj, leftChapterSelectorWidth).done(function(){
	          });
	          self.overlay.resizeContent(fullWidth, self.overlay.height());
	          self.overlay.centerContent();
	        });
	      } else {
	        self.chaptersLeft = false;
	        chapterObj = initBottomChapterSelector(true);
	        chapterObj.close().done(function(){
	        });
	        self.overlay.resizeContent(quality.width, self.overlay.height());
	        self.overlay.centerContent();
	      }
	
	
	      function modifyBottomToLeftChapterSelector(chapterObj, listWidth){
	        elChapters.addClass("left-side");
	        var listMargin = {
	            marginLeft: listWidth + "px"
	        };
	
	        var clone = controls.clone(); //we need a clone here as the original element may currently animate the height and return the wrong value
	        elChapters.append(clone); //additionally we need to add it temporarily for safari browser to get the correct height (is 0 otherwise)
	        var controlBarHeight = clone.height();
	        clone.remove(); //remove the clone after measuring height
	        var elChapterHeight = quality.height + controlBarHeight;
	
	        storyboardContainer.css(listMargin);
	        controls.css(listMargin);
	        elChapters.css({
	          left: 0,
	          width: listWidth + "px",
	          height: elChapterHeight + "px"
	        });
	        return $.when( elChapters.promise('fx'), controls.promise('fx'), storyboardContainer.promise('fx') );
	      }
	
	      function initBottomChapterSelector(allowToggling){
	        elChapters.removeClass("left-side");
	        storyboardContainer.css("marginLeft", "inherit");
	        controls.css("marginLeft", "inherit");
	        elChapters.css({
	          left: "inherit",
	          maxWidth: "inherit"
	        });
	
	        var clsSingleChapter = "sb-chapter";
	        if (elChapters.children("."+clsSingleChapter).length <= 0){
	          _prepareChapters(clsSingleChapter);
	        }
	        _setSelectMessage(elChapters.data('selectMessage'));
	        _setChapterToggling(allowToggling);
	        _setChapterSelection();
	
	        function _prepareChapters(clsSingleChapter){
	          var toggle = elChapters.children(".sb-toggle-button");
	          //elChapters.children("."+clsSingleChapter).remove(); // remove previous chapters if the list was re-initted
	          for (var c=0; c<chapters.length; c++){
	            var title = chapters[c].title;
	            var isMain = chapters[c].isMainChapter;
	            var cls = isMain ? 'main' : 'sub';
	            //var chapterName = title!=null ? ((c+1)+": "+title) : (c+1);
	            var chapterName = title!==null ? (title) : "";
	            var option = $("<div class='"+clsSingleChapter+" "+cls+"' data-value='"+c+"'>"+chapterName+"</div>");
	
	            option.insertBefore(toggle);
	          }
	        }
	        function _setChapterSelection(){
	          elChapters.children().click(function(){
	            //only change chapter, if elChapters is '.open'
	            var elChapter = $(this);
	            if (!elChapter.hasClass("selected") && !elChapter.hasClass("sb-toggle-button")){
	              var chapterIdx = elChapter.data("value");
	              var chapter = chapters[chapterIdx];
	              elChapters.children().removeClass("selected");
	              elChapter.addClass("selected");
	              if (chapter.isMainChapter){
	                self._returnToMainMovie(chapter.start, self.definition[chapter.clipIndex]);
	              } else {
	                self._openOrPlayElement(chapter.linkDef, chapter.intermediateDef, chapter.mainDef);
	              }
	            }
	          });
	        }
	        function _setChapterToggling(allowToggling){
	          elChapters.parent().unbind("click"); //unbind previous click events
	          if (allowToggling){
	            elChapters.parent().removeClass("toggling-disabled");
	            elChapters.parent().click(function(evt){ //when clicking the elChapters-container, we toggle the 'open' class; styled via css!
	              if (elChapters.hasClass("open")){
	                closeList();
	                if (typeof evt != "undefined" && evt !== null){
	                  evt.stopPropagation(); // stop propagation of the click event
	                }
	              } else if (elChapters.hasClass("closed") || !elChapters.hasClass("open")) {
	                showList();
	              }
	            });
	          } else {
	            elChapters.parent().addClass("toggling-disabled");
	            elChapters.parent().children(".current").remove();
	          }
	        }
	        function _setSelectMessage(txt){
	          var cls = "sb-select-chapter-message";
	          if ($("."+cls).length <= 0){
	            var elSelectMessage = $("<div></div>")
	              //.addClass(VPSmartMovie.CLASS_CHAPTERS)
	              //.addClass("current")
	              .addClass(cls)
	              .text(txt);
	            elChapters.parent().prepend(elSelectMessage);
	          }
	        }
	        function closeList(){
	          elChapters.parent().removeClass("open");
	          elChapters.parent().addClass("closed");
	          elChapters.removeClass("open");
	          elChapters.addClass("closed");
	          elChapters.parent().removeAttr("style");
	          elChapters.removeAttr("style");
	          self._checkChapterSelectorDimensions();
	          return elChapters.promise('fx');
	        }
	        function showList(){
	          elChapters.parent().removeClass("closed");
	          elChapters.parent().addClass("open");
	          elChapters.removeClass("closed");
	          elChapters.addClass("open");
	
	          var posTop = storyboardContainer.position().top;
	          var height = storyboardContainer.height();
	          var width = elChapters.parent().innerWidth();
	          elChapters.css({
	            top: posTop,
	            height: height,
	            width: width,
	            position: 'absolute'
	          });
	          elChapters.parent().css("position", "inherit");
	          return elChapters.promise('fx');
	        }
	
	        return {
	          open: showList,
	          close: closeList
	        };
	      }
	    }
	
	    function initReplay(controls, self){
	      var elReplay = controls.find(VPSmartMovie.SEL_REPLAY);
	      elReplay.click(function(){
	        var targetSeconds;
	        if (self.players.currentVideoType == 'clip'){
	          targetSeconds = self._getCurrentAnchorTime(self.currentClip.def);
	          self._playClip(targetSeconds, self.currentClip.def, null, self.mainMovie.def);
	        } else {
	          targetSeconds = self._getCurrentAnchorTime(self.mainMovie.def);
	          self._playMainMovie(targetSeconds, self.mainMovie.def);
	        }
	      });
	    }
	
	  }; /* END function initControls() */
	
	  VPSmartMovie.prototype._playMainMovie = function _playMainMovie(targetSeconds, singleDef, reInitialize){
	    function prepareForMovie(self){
	      //Clean-up left-over Buttons, etc.
	      self._cleanupIntermediates();
	      self.players.clip.pause(true);
	      if (self.players.twoPlayerMode){
	        $("#"+VPSmartMovie.ID_CLIP_PLAYER).hide();
	        $("#"+VPSmartMovie.ID_MOVIE_PLAYER).show();
	      }
	      self.currentClip = null;
	      self.players.current = self.players.movie;
	      self.players.currentVideoType = 'movie';
	      self._preloadImages(singleDef, self.quality.name, self.container);
	    }
	
	    // if the main movie finishes playing within a second start the next movie right away
	    var currentDuration = this.players.movie.getDuration();
	    var alreadyPlayed = currentDuration > 0; // if movie already has been played
	    var onlySecondLeft = targetSeconds >= (currentDuration-1);
	    prepareForMovie(this);
	    var self = this;
	    if (alreadyPlayed && onlySecondLeft){
	      this._onMainClipComplete();
	    } else {
	      // If mainMovie is not initialized or some other definition currently plays or if a clip is running we load the movie-file
	      // if not, we just jump to the given targetSeconds
	      var clipIsRunning = this.players.currentVideoType === 'clip';
	      var wasInitialized = false;
	      if (reInitialize || this.mainMovie === null || this.mainMovie.def != singleDef || (!this.players.twoPlayerMode && clipIsRunning)){
	        this.players.movie = this.players.movie.setup( this._getJwPlayerConfig( this._getClipUrl(singleDef), true) );
	        this.players.movie.on('time', function(timeEvent){
	          self._checkMainTimeEvent(timeEvent.position, singleDef);
	        });
	        this.players.movie.on('complete', function(){
	          self._onMainClipComplete();
	        });
	
	        //logger.debug("Setting mainMovie.def to", this.mainMovie);
	        this.mainMovie = {};
	        this.mainMovie.def = singleDef;
	        for (var i=0; i<this.definition.length; i++){
	          if (this.definition[i]==singleDef){
	            this.mainMovieIndex = i;
	            break;
	          }
	        }
	        wasInitialized=true;
	      }
	
	      // replace current jwPlayer with the movie-player (which could contain some other jwPlayer instance if the above if resolved to true)
	      if (this.players.current !== this.players.movie){
	        this.players.current = this.players.movie;
	      }
	      this.mainMovie.targetSeconds = targetSeconds;
	      if (!wasInitialized){
	        this.players.movie.seek(this.mainMovie.targetSeconds);
	      } else {
	        this.players.movie.on('ready', function(){
	          this.players.movie.seek(this.mainMovie.targetSeconds);
	        });
	      }
	    }
	
	    var fullWidth = this.quality.width;
	    if (!self.chaptersLeft){
	      self.overlay.resizeContent(fullWidth, self.overlay.height());
	      self.overlay.centerContent();
	    } else {
	      var elChapters = self.controls.parent().find(VPSmartMovie.SEL_CHAPTERS);
	      window.setTimeout(function(){
	        var outer = elChapters.outerWidth();
	        fullWidth = fullWidth + outer;
	        self.overlay.resizeContent(fullWidth, self.overlay.height());
	        self.overlay.centerContent();
	      }, 300); // CSS-Animation is set to 200 seconds; We need to wait for this before getting the width
	      //TODO: We could optimize this by transferring the css animation into a jquery-animation; That way we can wait for
	      //the elements promise() until we get its css values
	    }
	  };
	
		VPSmartMovie.prototype._playClip = function _playClip(targetSeconds, elementDef, intermediate, singleDef){
	    var self = this;
			if (this.players.currentVideoType !== 'clip'){
				this._initClipPlayer();
			}
			this.players.currentVideoType = 'clip';
			this._findAndSelectChapter(elementDef);
	
			if (intermediate !== null){
				this._cleanupIntermediate(intermediate);
			} else {
				this._cleanupIntermediates();
			}
			if (this.currentClip === null){
				this.currentClip = {};
			}
			this.currentClip.targetSeconds = targetSeconds;
			$(document).off('click', VPSmartMovie.SEL_BACK_TO_MAIN);
			$(VPSmartMovie.SEL_BACK_TO_MAIN).show();
			$(document).on('click', VPSmartMovie.SEL_BACK_TO_MAIN, function(e){
				self._returnToMainMovie(elementDef.returnTimeClipCancelled, singleDef);
			});
	
			if (this.currentClip.def !== elementDef){ //should we play some other clip? then load it!
				this.currentClip.def = elementDef;
	
				var player = this.players.clip.setup( this._getJwPlayerConfig( this._getClipUrl(elementDef), true) );
				this.players.clip = player;
				this.players.current = player;
				player.on('ready', function(){
					self.players.clip.seek(targetSeconds);
	
					player.on('complete', function(){
						self._returnToMainMovie(elementDef.returnTimeClipFinished, singleDef);
					});
					player.on('error', function(message){
						logger.error("Clip error: '"+message+"' - should return to main movie");
						returnToMainMovie(elementDef.returnTimeClipCancelled, singleDef);
					});
				});
			} else { // we just want to seek, as the clip is the same clip as before
				self.players.clip.seek(targetSeconds);
			}
		}; /* END function playClip() */
	
	  VPSmartMovie.prototype._initClipPlayer = function _initClipPlayer(){
			//Clean-up left-over Buttons, etc.
			this._cleanupIntermediates();
	
			this.players.movie.pause(true);
			//logger.debug("paused movie player");
			if (this.players.twoPlayerMode){
				$("#"+VPSmartMovie.ID_MOVIE_PLAYER).hide();
				$("#"+VPSmartMovie.ID_CLIP_PLAYER).show();
			}
			this.players.current = this.players.clip;
			//logger.debug("current player is now clip-player");
		};
	
		VPSmartMovie.prototype._returnToMainMovie = function _returnToMainMovie(targetSeconds, singleDef){
			//logger.debug("returning to main movie");
			$(VPSmartMovie.SEL_BACK_TO_MAIN).hide();
			this._playMainMovie(targetSeconds, singleDef);
		};
	
	
	  VPSmartMovie.prototype._cleanupIntermediates = function _cleanupIntermediates(){
	    var elStoryboard = $('#'+VPSmartMovie.ID_SELECTOR);
	    var fadeOutTime = VPSmartMovie.MS_FADE_INTERMEDIATE;
	
	    elStoryboard.fadeOut(fadeOutTime, function(){
	      elStoryboard.empty();
	    });
	
	    //re-enable controls like the seeking-bar
	    if (typeof this.players.current.getControls() != "undefined"){
	      this.players.current.setControls(true);
	    }
	
	    // hide skip-intermediate-button
	    this.controls.find(VPSmartMovie.SEL_SKIP_INTERMEDIATE).hide();
	  };
	
	  VPSmartMovie.prototype._onMainClipComplete = function _onMainClipComplete(){
	    //logger.debug("Finished playing main clip #" + (this.mainMovieIndex+1));
	    var def = this.definition;
	    var nextMainClip = def[this.mainMovieIndex+1];
	    if (typeof nextMainClip !== "undefined" && nextMainClip !== null){
	      //logger.debug("starting next main clip #" + (this.mainMovieIndex+2));
	      this._playMainMovie(0, def[this.mainMovieIndex+1]);
	    } else {
	      //logger.debug("no next main clip available; moving to first one and stopping playback");
	      this._playMainMovie(0, def[0]);
	      this.players.movie.stop();
	    }
	  };
	
	  /********************************************************/
	  /*											URL-METHODS											*/
	  /********************************************************/
	
	
	  VPSmartMovie.prototype._getImageUrl = function _getImageUrl(containerOrElementDef){
	    var imageDef = containerOrElementDef;
	    var imageUrl = null;
	    if (typeof imageDef.image == 'undefined' || imageDef.image===null){
	      imageUrl = null;
	    } else if (typeof imageDef.image === 'string' || imageDef.image instanceof String){ //old or singleResolution version
	      imageUrl = imageDef.image;
	    } else { //SD or HD?
	      imageUrl = imageDef.image[this.quality.name];
	    }
	    var url = this._getUrl(imageUrl);
	    return url;
	  };
	
	  /**
	  * Returns an URL for the given URL; Checks if url needs to be transformed and returns the correct url;
	  * Method should be used whenever a clip- or image-url is needed/given;
	  * If no BaseUrl is set within this.configuration.baseUrl, the Url is ALWAYS returned as is
	  * Examples with BaseUrl set to http://example.com/:
	  * - http://www.google.de -> http://www.google.de
	  * - test/something -> http://example.com/test/something
	  * - /test/something -> http://example.com//test/something
	  */
	  VPSmartMovie.prototype._getUrl = function _getUrl(fullUrlOrPart){
	    if (typeof fullUrlOrPart == "undefined" || fullUrlOrPart === null || fullUrlOrPart.length < 1){
	      return null;
	    }
	    var startsWithHttp = fullUrlOrPart.slice(0,4) == "http";
	    var completeUrl = fullUrlOrPart;
	    if (!startsWithHttp){
	      var baseUrl = this.configuration.baseUrl;
	      var baseSet = typeof baseUrl != "undefined" && baseUrl !== null && baseUrl.slice(0,4) == "http";
	      if (baseSet){
	        completeUrl = baseUrl + fullUrlOrPart;
	      }
	    }
	    return completeUrl;
	  };
	
	
		VPSmartMovie.prototype._getIframeUrl = function _getIframeUrl(url){
			return this._getUrl(url);
		};
	
	  VPSmartMovie.prototype._getClipUrl = function _getClipUrl(mainOrElementDef){
			var clipUrl = null;
			if (typeof mainOrElementDef.clip == 'undefined' || mainOrElementDef.clip===null){
				clipUrl = null;
			} else if (typeof mainOrElementDef.clip === 'string' || mainOrElementDef.clip instanceof String){ //old or singleResolution version
				clipUrl = mainOrElementDef.clip;
			} else { //SD or HD?
				clipUrl = mainOrElementDef.clip[this.quality.name];
			}
			return this._getUrl(clipUrl);
	  };
	
	  VPSmartMovie.prototype._updateChapterSelection = function _updateChapterSelection(newIndex){
	    var chapterSelector = this.controls.find(VPSmartMovie.SEL_CHAPTERS);
	    if (chapterSelector.children(".selected").index() != newIndex && !chapterSelector.is(":focus")){
	      //chapterSelector[0].selectedIndex = newIndex;
	      chapterSelector.children().removeClass("selected");
	      $(chapterSelector.children()[newIndex]).addClass("selected");
	      this._checkChapterSelectorDimensions();
	    }
	  };
	
	  VPSmartMovie.prototype._checkChapterSelectorDimensions = function _checkChapterSelectorDimensions(){
	    var chapterSelector = this.controls.find(VPSmartMovie.SEL_CHAPTERS).parent();
	    chapterSelector.removeClass("side-by-side");
	    chapterSelector.removeClass("above-and-below");
	
	    var childWidth = 0;
	    chapterSelector.children().each(function(){
	      childWidth += $(this).outerWidth();
	    });
	
	    if (chapterSelector.innerWidth() < childWidth){
	      chapterSelector.addClass("above-and-below");
	    } else {
	      chapterSelector.addClass("side-by-side");
	    }
	  };
	
		VPSmartMovie.prototype._findAndSelectChapter = function _findAndSelectChapter(linkDef){
			//logger.debug("finding and selecting chapter", linkDef);
			for (var i=0; i<this.chapters.length; i++){
				var chapter = this.chapters[i];
				//logger.debug(chapter.linkDef);
				if (!chapter.isMainChapter && chapter.linkDef==linkDef){
					this._updateChapterSelection(i);
					break;
				}
			}
		};
	
	  VPSmartMovie.prototype._cleanupIntermediate = function _cleanupIntermediate(intermediate){
	    this._cleanupIntermediates();
	
	    this.controls.find(VPSmartMovie.SEL_SKIP_INTERMEDIATE).hide();
	    intermediate.active = false;
	    $.each(intermediate.containers, function(index, container){
	      container.active = false;
	      $.each(container.elements, function(ind2, element){
	        element.active = false;
	      });
	    });
	  };
	
	  VPSmartMovie.prototype._checkMainTimeEvent = function _checkMainTimeEvent(second, singleDef){
			var elStoryboard = $('#'+VPSmartMovie.ID_SELECTOR);
	    var self = this;
			checkIntermediates(second, singleDef.intermediates, self);
			checkChapters(second, self);
	
			function checkChapters(second, self){
	  			//find possible Chapters
	  			var possibleChapters = [];
	  			for (var c=0; c<self.chapters.length; c++){
	  				var chapter = self.chapters[c];
	  				if (chapter.isMainChapter && chapter.clipIndex == self.mainMovieIndex){
	  					if (chapter.start <= second){
	  						possibleChapters.push( {'chapter':chapter, 'idx':c} );
	  					}
	  				}
	  			}
	
	  			//find the current chapter
	  			var currentChapterIdx = possibleChapters[0].idx;
	  			if (possibleChapters.length>1){
	  				var startTime = 0;
	  				for (var i=0; i<possibleChapters.length; i++){
	  					//get chapter with latest start-time (as it is still before 'second')
	  					if (possibleChapters[i].chapter.start >= startTime){
	  						startTime = possibleChapters[i].chapter.start;
	  						currentChapterIdx = possibleChapters[i].idx;
	  					}
	  				}
	  			}
	
	  			var currentChapter = self.chapters[currentChapterIdx];
	  			self.mainMovie.targetSeconds = currentChapter.start;
	  			self._updateChapterSelection(currentChapterIdx);
			} /* END function checkChapters() */
	
			function checkIntermediates(second, intermediates, self){
	  			$.each(intermediates, function(index, intermediate){ //TODO: Maye we can optimize this, so that we do not need to iterate on every event
	  				if (typeof intermediate.active == "undefined" || !intermediate.active){
	  					//logger.debug("having intermediate @ " + intermediate.start);
	  					if (second >= intermediate.start && second <= intermediate.end){ //make intermediate active
	  						// Exit HTML5-Fullscreen if active
	  						self._jwExitFullscreen();
	
	  						elStoryboard.fadeIn(VPSmartMovie.MS_FADE_INTERMEDIATE);
	  						intermediate.active = true;
	
	  						//disable controls like the seeking-bar
	  						self.players.current.setControls(false);
	
	  						var button = self.controls.find(VPSmartMovie.SEL_SKIP_INTERMEDIATE);
	  						button.parent().show();
	  						button.show();
	  						button.unbind("click"); //unbind previous click-events
	  						//logger.debug("Showing Intermediate ("+intermediate.start+"s -> "+intermediate.end+"s) ...");
	
	  						button.click(function(event){
	  							self._playMainMovie(intermediate.end, self.mainMovie.def);
	  							button.hide();
	  						});
	  						//TODO: Check: can't we break here?
	  					}
	  				} else {
	  					if (second >= intermediate.end-0.5 || second < intermediate.start){ //hide intermediate
	  						self._cleanupIntermediate(intermediate);
	  					} else { //intermediate is still active; lets see if there are containers to be shown or hidden
	  						checkContainers(second, intermediate, self.quality, elStoryboard);
	  					}
	  				}
	  			}); /* END $each */
	
	        function checkContainers(second, intermediate, qualitySetting, containerTarget){
	          function animateIn(containerEl, posType, callback){
	            // e.g. animate TL from '-width' to '0'
	            containerEl.animate({'marginLeft':0, 'marginTop':0}, VPSmartMovie.MS_ANIMATE_ELEMENT_CONTAINER_IN, function(){
	              if (typeof callback !== "undefined" && callback !== null && typeof callback == "function"){
	                callback();
	              }
	            });
	          }
	          function animateOut(containerEl, posType, callback){
	            // e.g. animate TL from '0' to -width
	            var left = posType.startMarginX * containerEl.width();
	            var top = posType.startMarginY * containerEl.height();
	            containerEl.animate({'marginLeft':left, 'marginTop':top}, VPSmartMovie.MS_ANIMATE_ELEMENT_CONTAINER_OUT, function(){
	              if (typeof callback !== "undefined" && callback !== null && typeof callback == "function"){
	                callback(containerEl);
	              }
	            });
	          }
	          function removeAfterAnimation(el){
	            el.remove();
	          }
	          for(var i=0; i<intermediate.containers.length; i++){
	            var containerDef = intermediate.containers[i];
	            var containerStart = intermediate.start + containerDef.start;
	            var containerEnd = intermediate.start + containerDef.end;
	            var atStart = second >= (containerStart - (VPSmartMovie.MS_ANIMATE_ELEMENT_CONTAINER_OUT/1000));
	            var beforeEnd = second < (containerEnd - (VPSmartMovie.MS_ANIMATE_ELEMENT_CONTAINER_OUT/1000));
	            var afterEnd = second > (containerEnd - (VPSmartMovie.MS_ANIMATE_ELEMENT_CONTAINER_OUT/1000));
	            var posType;
	            if (typeof containerDef.active == "undefined" || !containerDef.active){
	              if (atStart && beforeEnd){
	                var containerEl = self._createElementContainer(intermediate, i, qualitySetting);
	                containerDef.domElement = containerEl;
	
	                // ANIMATE-IN
	                posType = VPSmartMovie.buttonPosition[containerDef.position];
	                animateIn(containerEl, posType);
	                containerTarget.append(containerEl);
	                containerDef.active = true;
	              }
	            } else if (afterEnd){
	              containerDef.active = false;
	              if (typeof containerDef.domElement!="undefined" && containerDef.domElement !== null){
	                // ANIMATE-OUT
	                posType = VPSmartMovie.buttonPosition[containerDef.position];
	                var el = containerDef.domElement;
	                delete containerDef.domElement;
	                animateOut(el, posType, removeAfterAnimation);
	/*
	                animateOut(el, posType, function(){
	                  el.remove();
	                });
	                */
	              }
	            }
	          }
	        }/* END function checkContainers */
			} /* END function checkIntermediates */
		}; /* END function checkMainTimeEvent */
	
		VPSmartMovie.prototype._createElementContainer = function _createElementContainer(intermediateDef, containerIndex, qualitySetting){
			var containerDef = intermediateDef.containers[containerIndex];
			var elContainer = this._getContainerHtml(containerDef, qualitySetting);
	    var self = this;
			$.each(containerDef.elements, function(_index, elementDef){
				var elButton = self._getButtonHtml(_index, elementDef, qualitySetting);
				elButton.hide();
				elButton.click(function(){
					self._openOrPlayElement(elementDef, intermediateDef, self.mainMovie.def);
				});
				elButton.hover(function(){
					var imageUrl = self._getImageUrl( elementDef );
					elContainer.css('backgroundImage', "url("+imageUrl+")");
				}, function(){
					var imageUrl = self._getImageUrl( containerDef );
					elContainer.css('backgroundImage', "url("+imageUrl+")");
				});
				elContainer.append(elButton);
				elButton.fadeIn(VPSmartMovie.MS_FADE_BUTTON);
				elementDef.active = true;
			});
			return elContainer;
		};
	
		VPSmartMovie.prototype._openOrPlayElement = function _openOrPlayElement(elementDef, intermediateDef, singleDef){
			if (elementDef.type==VPSmartMovie.LINK_TYPE_VIDEO){
				this._playClip(0, elementDef, intermediateDef, singleDef);
			} else if (elementDef.type==VPSmartMovie.LINK_TYPE_IFRAME){
				this._showIframe(elementDef, intermediateDef, singleDef);
			} else {
				logger.error("undefined Container-Element-Type");
			}
		};
	
		/********************************************************/
		/*											JW-SPECIFIC											*/
		/********************************************************/
	
		VPSmartMovie.prototype._getJwPlayerConfig = function _getJwPlayerConfig(clipUrl, autostart, controls){
			if (typeof(autostart)==='undefined') autostart = true;
			if (typeof(controls)==='undefined') controls = true;
	    var jwSetup = {
				file: clipUrl,
				width: this.quality.width,
				height: this.quality.height,
		    provider: 'video',
				controls: controls,
				ga: {},
				autostart: autostart	//NOTE: Does not work on mobile Devices
	    };
			if (typeof this.skin !== "undefined" && typeof this.skin !== null){
				jwSetup.skin=this.skin; //NOTE: Altough the Fullscreen-Button is removed, some Browsers still allow going into fullscreen via doublelick; it seems that there is no way to prevent this
			}
			return jwSetup;
		};
	
	
		// Exit HTML5-Fullscreen if active
		VPSmartMovie.prototype._jwExitFullscreen = function _jwExitFullscreen(){
			if(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement){
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.webkitExitFullscreen) {
					document.webkitExitFullscreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				}
			}
		};
	
	  /********************************************************/
	  /*									HTML GENERATORS											*/
	  /********************************************************/
	
	  VPSmartMovie.prototype._showIframe = function _showIFrame(linkDef, intermediate, singleDef){
	    this._findAndSelectChapter(linkDef);
	    this.players.current.pause(true);
	    this._cleanupIntermediate(intermediate);
	    var self = this;
	
	    // OVERLAY
	    var overlay = $("<div id='"+VPSmartMovie.ID_OVERLAY+"'></div>").css({
	      'position':'fixed',
	      'z-index':self._getMaxZ()+10,
	      'top':'0',
	      'left':'0',
	      'display':'block',
	      'overflow':'hidden'
	    });
	
	    // Set overflow:hidden for body, to prevent scrolling invisible content on the Mac while iframe is opened
	    // will be reverted, when back-button is clicked
	    var overflow = $("body").css('overflow');
	    $("body").css('overflow', 'hidden');
	
	    // BACK-BUTTON
	    var l10n = self._getL10n(this.l10n);
	    var backbutton = $("<a class='btn "+VPSmartMovie.CLASS_BACK_TO_MAIN+"'>"+l10n.controls.backToMain+"</div>");
	    backbutton.addClass(VPSmartMovie.CLASS_BACK_TO_MAIN);
	    backbutton.click(function(){
	      $("body").css('overflow', overflow);
	      overlay.remove();
	      self._returnToMainMovie(linkDef.returnTime, singleDef);
	      self.players.movie.pause(false);
	    });
	    backbutton.css({
	      'backgroundColor':'white',
	      'position':'fixed',
	      'width':'100%',
	      'cursor':'pointer'
	    });
	
	    // IFRAME
	    var iframe = $("<iframe src='"+linkDef.url+"' width='100%' height='100%'></iframe>");
	
	    updateOverlaySizes();
	    iframe.on('load', updateOverlaySizes);
	    $(window).resize(updateOverlaySizes);
	
	    overlay.append( backbutton );
	    overlay.append( iframe );
	    $("body").prepend(overlay);
	
	    function updateOverlaySizes(){
	      var h = $(window).height();
	      var w = $(window).width();
	      overlay.height(h);
	      overlay.width(w);
	      overlay.children("iframe").attr('height', h+'px').attr('width', w);
	    }
	  };
	
	  VPSmartMovie.prototype._getControlsHtml = function _getControlsHtml(qualities, l10n){
	    l10n = this._getL10n(l10n);
	    /*
	    var qualitiesHtml = "";
	    for (var i=0; i<qualities.length;i++){
	      var quality = qualities[i];
	      qualitiesHtml += '<div class="sb-quality" data-index="'+i+'">'+quality.name+'<div>';
	    }
	    */
	    var qualitiesHtml = '';
	    var html = ' \
	      <div class="sb-control sb-button sb-left"> \
	        <div class="'+VPSmartMovie.CLASS_BACK_TO_MAIN+'">'+l10n.controls.backToMain+'</div> \
	        <div class="'+VPSmartMovie.CLASS_SKIP_INTERMEDIATE+'">'+l10n.controls.skipIntermediate+'</div> \
	      </div> \
	      <div class="sb-control sb-button sb-right"> \
	        <div class="'+VPSmartMovie.CLASS_REPLAY+'">'+l10n.controls.replay+'</div> \
	      </div> \
	      <div class="sb-control sb-button sb-right" style="max-width: 10%"> \
	        <div class="'+VPSmartMovie.CLASS_QUALITIES+'"> \
	        '+qualitiesHtml+' \
	        </div> \
	      </div> \
	      <div class="sb-control sb-select sb-right"> \
	        <div class="'+VPSmartMovie.CLASS_CHAPTERS+'" data-select-message="'+l10n.controls.selectChapter+'"><div class="sb-toggle-button"></div></div> \
	      </div> \
	      ';
	    return html;
	  };
	
	  VPSmartMovie.prototype._getContainerHtml = function _getContainerHtml(containerDef, qualitySetting){
	    var el = $("<div class='sb-container'></a>");
	    // position may be defined via a value from VPSmartMovie.buttonPosition
	    var self = this;
	    var width = containerDef.width * qualitySetting.ratio;
	    var height = containerDef.height * qualitySetting.ratio;
	    var fullWidth = qualitySetting.width;
	    var fullHeight = qualitySetting.height;
	    var pos = VPSmartMovie.buttonPosition[containerDef.position];
	    var moveLeft = width * pos.x;  // if pos.x is 1 the element should be displayed on the right and as the position-anchor is on the top left, we need to move the button to the left by it's full width
	    var moveUp = height * pos.y; // same here; if element should be placed at bottom (pos.y=1) we need to substract the elements height as it's anchor is on the top left
	    var startMarginLeft = pos.startMarginX * width;
	    var startMarginTop = pos.startMarginY * height;
	    var marginY = (typeof pos.marginY != "undefined" && pos.marginY !== null)? Math.round(fullWidth * pos.marginY) : 0;
	    var marginX = (typeof pos.marginX != "undefined" && pos.marginX !== null)? Math.round(fullWidth * pos.marginX) : 0;
	    var xPos = fullWidth*pos.x - moveLeft + marginX;
	    var yPos = fullHeight*pos.y - moveUp + marginY;
	
	    el.css({
	      "position":"absolute",
	      "left":xPos,
	      "top":yPos,
	      "width":width,
	      "height":height,
	      "marginLeft":startMarginLeft,
	      "marginTop":startMarginTop,
	      "backgroundImage": "url("+self._getImageUrl(containerDef)+")"
	    });
	
	    return el;
	  };
	
	  VPSmartMovie.prototype._getButtonHtml = function _getButtonHtml(index, containerElementDef, qualitySetting){
	    var ratio = qualitySetting.ratio;
	    var buttonDef = containerElementDef.button;
	    var width = buttonDef.width * ratio;
	    var height = buttonDef.height * ratio;
	    var xPos = buttonDef.x * ratio;
	    var yPos = buttonDef.y * ratio;
	
	    //prepare outer link Element
	    var linkEl = $("<a class='sb-button'></a>");
	    linkEl.css({
	      "position":"absolute",
	      "left":xPos,
	      "top":yPos,
	      "width":width,
	      "height":height
	    });
	    linkEl.data('clip', this._getClipUrl(containerElementDef));
	    linkEl.data('index', index);
	
	    //return link-element
	    return linkEl;
	  };
	
	
	  /********************************************************/
	  /*										HELPERS, ETC											*/
	  /********************************************************/
	
	  VPSmartMovie.prototype._getCurrentAnchorTime = function _getCurrentAnchorTime(movieOrClipDef){
	    function getCurrentStart(anchorOrChapter, currentPlayTime){
	      var currentStart = 0;
	      var candidates = [];
	      for (var i=0; i<anchorOrChapter.length; i++){
	        var anchor = anchorOrChapter[i];
	        if (anchor.start<=currentPlayTime){
	          candidates.push(anchor.start);
	        }
	      }
	      if (candidates.length>0){
	        currentStart = Math.max.apply(Math, candidates);
	      }
	      return currentStart;
	    }
	
	    var anchorTime = 0;
	    //Try anchors first
	    if (typeof movieOrClipDef.anchors !== "undefined" && movieOrClipDef.anchors !== null && movieOrClipDef.anchors.length>0){
	      anchorTime = getCurrentStart(movieOrClipDef.anchors, this.players.current.getPosition());
	      //logger.debug("anchorTime", anchorTime);
	    }
	    /*
	    //if no anchors, try chapters
	    else if (typeof movieOrClipDef.chapters !== "undefined" && movieOrClipDef.chapters != null && movieOrClipDef.chapters.length>0){
	      anchorTime = getCurrentStart(movieOrClipDef.chapters, current);
	    }
	    */
	    //logger.debug("currentAnchorTime is " + anchorTime + " after "+ current +" seconds of the video have been played");
	    return anchorTime;
	  };
	
	  VPSmartMovie.prototype._getQualityCssClass = function _getQualityCssClass(quality){
	    var classname="large";
	    if (this._isLowWidthQuality(quality)){
	      classname="small";
	    }
	    return classname;
	  };
	
	  VPSmartMovie.prototype._isLowWidthQuality = function _isLowWidthQuality(quality){
	    return quality.width < 1000;
	  };
	
	  // return the documents max z-index
	  VPSmartMovie.prototype._getMaxZ = function _getMaxZ(){
	    return Math.max.apply(null,$.map(jQuery('body > *'), function(e,n){
	      if(jQuery(e).css('position')=='absolute' || jQuery(e).css('position')=='static' || jQuery(e).css('position')=='fixed'){
	        var zIndex = jQuery(e).css('z-index');
	        return parseInt(zIndex) || 1 ;
	      }
	    }));
	  };
	
	  //check if the given l10n is undefined or null and return a default l10n in that case
	  VPSmartMovie.prototype._getL10n = function _getL10n(l10n){
	    if (typeof l10n=="undefined" || l10n===null){
	      l10n = this.options.l10n;
	    }
	    return l10n;
	  };
	
	  VPSmartMovie.prototype._getMainDef = function _getMainDef(clipDef){
	    var def = null;
	    for (var d=0; d<this.definition.length; d++){
	      var someDef = this.definition[d];
	      for (var i=0; i<someDef.intermediates.length; i++){
	        var intermediate = someDef.intermediates[i];
	        for (var c=0; c<intermediate.containers.length; c++){
	          var container = intermediate.containers[c];
	          for (var e=0; e<container.elements.length; e++){
	            var element = container.elements[e];
	            if (element == clipDef){
	              def = someDef;
	              break;
	            }
	          }
	        }
	      }
	    }
	    return def;
	  };
	
	  VPSmartMovie.prototype._preloadImages = function _preloadImages(singleDef, qualityName, targetContainer){
	    function preload(url, target){
	      var imageDiv = jQuery("<img src='"+url+"' />");
	      var css = {
	        'backgroundImage': 'url('+url+')',
	        'display': 'block'
	      };
	      imageDiv.css(css);
	      target.append(imageDiv);
	    }
	    try {
	      var imageUrls = [];
	      var intermediates = singleDef.intermediates;
	      var target = targetContainer.children(VPSmartMovie.SEL_IMAGE_PRELOADER);
	      if (!target.length){
	        target = jQuery("<div class='"+VPSmartMovie.CLASS_IMAGE_PRELOADER+"'></div>");
	        var css = {
	            'visibility':'hidden',
	            'overflow':'hidden',
	            'width':0,
	            'height':0,
	            'zIndex':0
	        };
	        target.css(css);
	        targetContainer.append(target);
	      }
	      for (var i=0; i<intermediates.length; i++){
	        var intermediate = intermediates[i];
	        for (var c=0; c<intermediate.containers.length; c++){
	          var container = intermediate.containers[c];
	          var containerImageUrl = this._getImageUrl(container, qualityName);
	          imageUrls.push(containerImageUrl);
	          for (var e=0; e<container.elements.length; e++){
	            var element = container.elements[e];
	            var elementImageUrl = this._getImageUrl(element, qualityName);
	            imageUrls.push(elementImageUrl);
	          }
	        }
	      }
	      for (var u=0; u<imageUrls.length; u++){
	        var url = imageUrls[u];
	        //logger.debug("Preloading Image " + url);
	        preload(url, target);
	      }
	    }
	    catch(err) {
	      logger.error("could not preload all images! ", err);
	      //IGNORE
	    }
	  };
	
	  /*
	  DEFINITION-EXAMPLE-JSON:
	  NOTE: showTime and hideTime are both relative to their parents 'start'
	  NOTE: This is an old version (which should still work), please see json-file for further properties
	  NOTE: you can set a string for clip and image to use the url for all qualities or define an url for each quality (e.g. clip:{sd:"http...", hd:"http..."}, image:{sd{url:"", hoverUrl:""}})
	  NOTE: button-definitions may either contain 'x'- and 'y'-coordinates or a 'position'-String; if 'x' and 'y' are defined they have precedence over 'position'; See VPSmartMovie.buttonPosition for position-strings
	  */
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	(function(){
	  'use strict';
	
	  var logger = new (__webpack_require__(3))("VPYoutube").setColor("darkred");
	  var VideoPlayer = __webpack_require__(11);
	  var $script = __webpack_require__(40);
	  var helper = __webpack_require__(1);
	  $script("//www.youtube.com/iframe_api", 'YT');
	
	  module.exports = VPYoutube;
	
	  var defaults = {
	  };
	
	  function VPYoutube(mediaInstance, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage){
	    var self = this;
	    self.scriptReady = false;
	    // NOTE: We cannot use global.onYouTubeIframeAPIReady here as it may already been called; Waiting for $script to be ready seems to work
	    $script.ready('YT', function(){
	      if(self._onScriptReady instanceof Function) {
	          self._onScriptReady();
	      }
	      self.scriptReady = true;
	    });
	
	    this.autoplay = false;
	    VideoPlayer.call(this, mediaInstance, inline, container, posterMediaImage, defaultQuality, defaults, options, playButtonImage, playButtonHoverImage);
	    this.modifyOptionsWith(defaults); //merge the parents default options with the default options in this subclass
	    this.modifyOptionsWith(options); //then merge the given options to overwrite the defaults
	
	    //if (inline){
	      if (helper.undefOrNull(posterMediaImage) || this.options.omitPosterElement){ //otherwise init on play
	        logger.debug("should init without poster element");
	        if (inline){
	          this._initPlayer();
	        } else {
	          this.baseContainer.click(function(){
	            self._play();
	          });
	        }
	      } else {
	        logger.debug("should init poster: ", posterMediaImage);
	        this._initPoster();
	      }
	    //}
	  }
	
	  // subclass extends superclass
	  VPYoutube.prototype = Object.create(VideoPlayer.prototype);
	  VPYoutube.prototype.constructor = VideoPlayer;
	
	
	  VPYoutube.prototype._initPlayer = function _initPlayer(){
	    var vp = this;
	    var media = vp.media;
	    var autoplay = vp.autoplay;
	    if (autoplay instanceof Boolean){
	      autoplay = autoplay ? 1 : 0;
	    }
	    var container = (vp.container instanceof HTMLElement || vp.container.constructor.name == "HTMLDivElement") ? vp.container : vp.container[0]; //player needs native html element, not jquery; NOTE: both checks are needed for different browsers!
	
	    var height = media.height(vp.defaultQuality);
	    var width = media.width(vp.defaultQuality);
	    if (vp.container.height > 0 && vp.container.width > 0){
	      height = vp.container.height;
	      width = vp.container.width;
	    }
	
	    var createPlayerOnApiReady = function(){
	      logger.debug("script ready, waiting for API to become ready...");
	      if (helper.undefOrNull(YT.Player)){ // API not yet ready; API will call window.onYouTubeIframeAPIReady when ready
	        window.onYouTubeIframeAPIReady = onApiReady;
	        logger.debug("...API will become ready through onYouTubeIframeAPIReady-callback!");
	      } else { // API already is ready; directly call onApiReady
	        logger.debug("...API was already ready!");
	        onApiReady();
	      }
	
	      function onApiReady(){
	        var ytOptions = {
	          height: height,
	          width: width,
	          videoId: media.reference(),
	          playerVars: { 'autoplay':autoplay },
	          events: {
	            'onStateChange': function(evt){
	              vp._onStateChange(evt);
	            }
	          }
	        };
	        vp.player = new YT.Player(container, ytOptions);
	        // NOTE: When initializing YT.Player on the container, the container
	        // gets replaced by an iframe; So if you want to change the 'containers'
	        // style, for example, you cannot use this.container; For that use:
	        // $("#"+vp._containerId)
	        logger.debug("Youtube API is ready....", ytOptions);
	        window.onYouTubeIframeAPIReady = null;
	      }
	    };
	
	    if(this.scriptReady) {
	      createPlayerOnApiReady();
	    } else {
	      logger.debug("player NOT YET ready");
	      this._onScriptReady = createPlayerOnApiReady;
	    }
	
	  };
	
	  VPYoutube.prototype._onStateChange = function _onStateChange(evt){
	    if (helper.undefOrNull(this._recentStates)){
	      this._recentStates = [];
	    } else {
	      this._recentStates.length = 2; //just keep the last 5 states
	    }
	
	    var state = evt.data;
	    var shouldDisplayPoster = false;
	    if (!helper.undefOrNull(this.poster) && state === 0){ // ENDED
	      for (var i=0; i<this._recentStates.length; i++){
	        if (this._recentStates[i] > 0){ //video did already play at some time (so state was not just ENDED)
	          shouldDisplayPoster = true;
	          break;
	        }
	      }
	    }
	
	    if (this.inline && shouldDisplayPoster && !this.options.omitPosterElement){
	      this._recentStates = null;
	
	      this._onClose();
	      this._initPoster();
	    } else {
	      this._recentStates.unshift(state);
	    }
	
	  };
	
	  VPYoutube.prototype._play = function _play(container){
	    if (!this.inline){
	      logger.debug("init for overlay (autoplay)");
	      this.autoplay = true;
	      this._initPlayer();
	    } else {
	      logger.debug("playing inline");
	      this.autoplay = !helper.undefOrNull(this.poster); //only autoplay if poster was set
	      if (!helper.undefOrNull(this.poster) && !this.options.omitPosterElement){
	        this._initPlayer();
	      }
	    }
	    if (!self.scriptReady){
	      self.autoplay = true;
	    } else {
	      vp.player.playVideo();
	    }
	  };
	
	  VPYoutube.prototype._onClose = function _onClose(){
	    if (!helper.undefOrNull(this.player)){
	      this.player.destroy();
	    }
	    VideoPlayer.prototype._onClose.call(this);
	    logger.debug("Youtube Player destroyed!");
	  };
	
	  VPYoutube.prototype._resizeIFrame = function resizeIFrame(width, height){
	    var iframe = $("#"+this._containerId);
	    if (iframe.length){
	      iframe.attr("width", width);
	      iframe.attr("height", height);
	      iframe.css("width", width+'px');
	      iframe.css("height", height+'px');
	      iframe.css("max-width", width+'px');
	      iframe.css("max-height", height+'px');
	    }
	    return this;
	  };
	
	  VPYoutube.prototype.resize = function resize(width, height){
	    this._resizeIFrame(width, height);
	  };
	
	  VPYoutube.prototype.resizeForOverlay = function resizeForOverlay(width, height){
	    if (!this.inline && !helper.undefOrNull(this.player)){
	      this._resizeIFrame(width, height);
	    }
	    return this;
	  };
	
	  VPYoutube.prototype.resizeForInheritation = function resizeForInheritation(width, height){
	    $(this.baseContainer).css({width: width+'px', height: height+'px'});
	    if (this.inline){
	      //changing this value seems to affect the player:
	      this.container.css({width: width+'px', height: height+'px'});
	      this._resizeIFrame(width, height);
	    }
	    return this;
	  };
	
	}());


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * This Function should override the original imagesloaded-function;
	 * If images have size-attributes (width & height), we should not wait for the image to be loaded
	 * if an images in the set has not both size-attributes, the original imagesloaded-function shall be called
	 * - may be optimized dramatically ;-)
	 */
	 (function () {
	  'use strict';
	
		var original = __webpack_require__(6);
		var helper = __webpack_require__(1);
		var logger = new (__webpack_require__(3))("ImagesLoadedOrDimensionsSet").setColor("#ABABAB").setDebug(true);
	  var jquery = __webpack_require__(2);
	
	  function ImagesLoadedOrDimensionsSet( elem, options, onAlways ) {
	    original.call(this, elem, options, onAlways); // call ImagesLoaded constructor.
	  }
	
		ImagesLoadedOrDimensionsSet.prototype = Object.create(original.prototype);
	  ImagesLoadedOrDimensionsSet.prototype.constructor = original;
		ImagesLoadedOrDimensionsSet.makeJQueryPlugin = function( jquery ) {
		  jquery = jquery || window.jquery;
		  if ( !jquery ) {
		    return;
		  }
		  jquery.fn.imagesLoadedOrDimensionsSet = function( options, callback ) {
		    var instance = new ImagesLoadedOrDimensionsSet( this, options, callback );
		    return instance.jqDeferred.promise( $(this) );
		  };
		};
		// try making plugin
		ImagesLoadedOrDimensionsSet.makeJQueryPlugin(jquery);
	
		ImagesLoadedOrDimensionsSet.prototype.check = function check(){
			var _this = this;
			this.progressedCount = 0;
			this.hasAnyBroken = false;
			// complete if no images
			if ( !this.images.length ) {
				this.complete();
				return;
			}
	
		  function onProgress( image, elem, message ) {
		    // HACK - Chrome triggers event before object properties have changed. #83
		    setTimeout( function() {
		      _this.progress( image, elem, message );
		    });
		  }
	
			this.images.forEach( function( loadingImage ) {
				var width = loadingImage.img.width;
				var height = loadingImage.img.height;
				var hasWidthSet = !helper.undefOrNull(width) && width > 0;
				var hasHeightSet = !helper.undefOrNull(height) && height > 0;
				loadingImage.once( 'progress', onProgress );
				if (hasWidthSet && hasHeightSet){
					logger.debug("Resolving image via dimensions", loadingImage.img);
					loadingImage.confirm( true, 'givenDimensions' );
				} else {
					logger.debug("Resolving image via original check", loadingImage.img);
					loadingImage.check();
				}
			});
		};
	
		module.exports = ImagesLoadedOrDimensionsSet;
	
	}());


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	   'use strict';
	
	   var logger = new (__webpack_require__(3))("Image Initializer").setColor("#212157");
	   var helper = __webpack_require__(1);
	   var ACClient = __webpack_require__(5);
	   var jquery = __webpack_require__(2);
	
	   module.exports = {
	     bgImageFromData: bgImageFromData,
	     imageFromData: imageFromData
	  };
	
	  function inheritMaxWidth($element, selector, media){
	    function checkSizeAndApply($element, media, enlarge){
	      var elWidth = $elForInheritation.width();
	      var ratio = media.ratio();
	      var height = elWidth / ratio;
	      if (elWidth > 0 && !isNaN(ratio) && ((height <= media.height() && elWidth <= media.width()) || enlarge)){
	        applySize($element, elWidth, height);
	        //logger.debug("applied "+elWidth+"x"+height+" on element", $element);
	      } else {
	        applySize($element, media.width(), media.height());
	        //logger.debug("applied original media dimensions on element", $element);
	      }
	    }
	    function applySize($element, width, height){
	      if (!helper.undefOrNull($element.data("asset"))){ //image
	        $element.attr("width", width);
	        $element.attr("height", height);
	      } else { //background-image (bgAsset)
	        $element.css({
	          width: width,
	          height: height
	        });
	      }
	    }
	    var $elForInheritation = $(selector);
	    if (helper.undefOrNull($elForInheritation)){
	      logger.debug("wont' inherit container width as $elForInheritation with selector ("+selector+") was not found");
	    } else {
	      $(window).on('resize', function(){ checkSizeAndApply($element, media, false); });
	      checkSizeAndApply($element, media, false);
	    }
	  }
	
	
	
	  function bgImageFromData($el){
	    var deferred = jquery.Deferred();
	
	    var code = $el.data("bgAsset");
	    var inheritMaxWidthFrom = $el.data("inheritMaxWidthFrom");
	    lazyInitClient().detailsForCode(code).done(function(media){
	      $el.css({
	        backgroundImage: 'url("'+media.dppxUrl()+'")',
	        backgroundPosition: 'center center',
	        backgroundSize: 'contain',
	        backgroundRepeat: 'no-repeat',
	        width: media.width()+'px ',
	        height: media.height() + 'px '
	      });
	      if(!helper.undefOrNull(inheritMaxWidthFrom)){
	        inheritMaxWidth($el, inheritMaxWidthFrom, media);
	      }
	      deferred.resolve($el, media);
	    }).fail(function(){
	      logger.error("ACClient: Error fetching media data for code '"+code+"'");
	      deferred.reject();
	    });
	
	    return deferred.promise();
	  }
	
	  function imageFromData($img){
	    var deferred = jquery.Deferred();
	    var code = $img.data("asset");
	    var inheritMaxWidthFrom = $img.data("inheritMaxWidthFrom");
	    lazyInitClient().detailsForCode(code).done(function(media){
	      $img.attr('src', media.dppxUrl());
	      if (!$img.attr('width') && !$img.attr('height')){
	        $img.attr('width', media.width());
	        $img.attr('height', media.height());
	      }
	      if(!helper.undefOrNull(inheritMaxWidthFrom)){
	        inheritMaxWidth($img, inheritMaxWidthFrom, media);
	      }
	      deferred.resolve($img, media);
	    }).fail(function(){
	      logger.error("ACClient: Error fetching media data for code '"+code+"'");
	      deferred.reject();
	    });
	
	    return deferred.promise();
	  }
	
	  var client = null;
	  function lazyInitClient(){
	    if (helper.undefOrNull(client)){
	      client = new ACClient();
	    }
	    return client;
	  }
	
	}());


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(17);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(14)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/less-loader/index.js!./main.less", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/less-loader/index.js!./main.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(18);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(14)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/less-loader/index.js!./smart-movie.less", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/less-loader/index.js!./smart-movie.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 36 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 37 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 38 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 39 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * $script.js JS loader & dependency manager
	  * https://github.com/ded/script.js
	  * (c) Dustin Diaz 2014 | License MIT
	  */
	
	(function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else this[name] = definition()
	})('$script', function () {
	  var doc = document
	    , head = doc.getElementsByTagName('head')[0]
	    , s = 'string'
	    , f = false
	    , push = 'push'
	    , readyState = 'readyState'
	    , onreadystatechange = 'onreadystatechange'
	    , list = {}
	    , ids = {}
	    , delay = {}
	    , scripts = {}
	    , scriptpath
	    , urlArgs
	
	  function every(ar, fn) {
	    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
	    return 1
	  }
	  function each(ar, fn) {
	    every(ar, function (el) {
	      fn(el)
	      return 1
	    })
	  }
	
	  function $script(paths, idOrDone, optDone) {
	    paths = paths[push] ? paths : [paths]
	    var idOrDoneIsDone = idOrDone && idOrDone.call
	      , done = idOrDoneIsDone ? idOrDone : optDone
	      , id = idOrDoneIsDone ? paths.join('') : idOrDone
	      , queue = paths.length
	    function loopFn(item) {
	      return item.call ? item() : list[item]
	    }
	    function callback() {
	      if (!--queue) {
	        list[id] = 1
	        done && done()
	        for (var dset in delay) {
	          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
	        }
	      }
	    }
	    setTimeout(function () {
	      each(paths, function loading(path, force) {
	        if (path === null) return callback()
	        
	        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
	          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
	        }
	        
	        if (scripts[path]) {
	          if (id) ids[id] = 1
	          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
	        }
	
	        scripts[path] = 1
	        if (id) ids[id] = 1
	        create(path, callback)
	      })
	    }, 0)
	    return $script
	  }
	
	  function create(path, fn) {
	    var el = doc.createElement('script'), loaded
	    el.onload = el.onerror = el[onreadystatechange] = function () {
	      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
	      el.onload = el[onreadystatechange] = null
	      loaded = 1
	      scripts[path] = 2
	      fn()
	    }
	    el.async = 1
	    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
	    head.insertBefore(el, head.lastChild)
	  }
	
	  $script.get = create
	
	  $script.order = function (scripts, id, done) {
	    (function callback(s) {
	      s = scripts.shift()
	      !scripts.length ? $script(s, id, done) : $script(s, callback)
	    }())
	  }
	
	  $script.path = function (p) {
	    scriptpath = p
	  }
	  $script.urlArgs = function (str) {
	    urlArgs = str;
	  }
	  $script.ready = function (deps, ready, req) {
	    deps = deps[push] ? deps : [deps]
	    var missing = [];
	    !each(deps, function (dep) {
	      list[dep] || missing[push](dep);
	    }) && every(deps, function (dep) {return list[dep]}) ?
	      ready() : !function (key) {
	      delay[key] = delay[key] || []
	      delay[key][push](ready)
	      req && req(missing)
	    }(deps.join('|'))
	    return $script
	  }
	
	  $script.done = function (idOrDone) {
	    $script([null], idOrDone)
	  }
	
	  return $script
	});


/***/ }
/******/ ]);


// WEBPACK FOOTER //
// cmy-tools.js